import * as Types from './operations';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"fetchPolicy":"no-cache"} as const;

export const AddAcademicYearDocument = gql`
    mutation addAcademicYear($name: String!, $start_date: String, $end_date: String, $program_id: uuid) {
  insert_academic_year(
    objects: [{name: $name, start_date: $start_date, end_date: $end_date, program_id: $program_id}]
    on_conflict: {constraint: academic_year_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      academic_year_id
      end_date
      name
      program_id
      start_date
      tags {
        academic_year_tag_id
        tag {
          tag_id
          name
          type
        }
      }
      requirements {
        academic_year_requirement_id
        requirement {
          requirement_id
          name
          type
          description
        }
      }
    }
  }
}
    `;
export type AddAcademicYearMutationFn = Apollo.MutationFunction<Types.AddAcademicYearMutation, Types.AddAcademicYearMutationVariables>;

/**
 * __useAddAcademicYearMutation__
 *
 * To run a mutation, you first call `useAddAcademicYearMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAcademicYearMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAcademicYearMutation, { data, loading, error }] = useAddAcademicYearMutation({
 *   variables: {
 *      name: // value for 'name'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      program_id: // value for 'program_id'
 *   },
 * });
 */
export function useAddAcademicYearMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddAcademicYearMutation, Types.AddAcademicYearMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddAcademicYearMutation, Types.AddAcademicYearMutationVariables>(AddAcademicYearDocument, options);
      }
export type AddAcademicYearMutationHookResult = ReturnType<typeof useAddAcademicYearMutation>;
export type AddAcademicYearMutationResult = Apollo.MutationResult<Types.AddAcademicYearMutation>;
export type AddAcademicYearMutationOptions = Apollo.BaseMutationOptions<Types.AddAcademicYearMutation, Types.AddAcademicYearMutationVariables>;
export const UpdateAcademicYearDocument = gql`
    mutation updateAcademicYear($id: uuid!, $academicYear: academic_year_set_input!) {
  update_academic_year(where: {academic_year_id: {_eq: $id}}, _set: $academicYear) {
    affected_rows
  }
}
    `;
export type UpdateAcademicYearMutationFn = Apollo.MutationFunction<Types.UpdateAcademicYearMutation, Types.UpdateAcademicYearMutationVariables>;

/**
 * __useUpdateAcademicYearMutation__
 *
 * To run a mutation, you first call `useUpdateAcademicYearMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAcademicYearMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAcademicYearMutation, { data, loading, error }] = useUpdateAcademicYearMutation({
 *   variables: {
 *      id: // value for 'id'
 *      academicYear: // value for 'academicYear'
 *   },
 * });
 */
export function useUpdateAcademicYearMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateAcademicYearMutation, Types.UpdateAcademicYearMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateAcademicYearMutation, Types.UpdateAcademicYearMutationVariables>(UpdateAcademicYearDocument, options);
      }
export type UpdateAcademicYearMutationHookResult = ReturnType<typeof useUpdateAcademicYearMutation>;
export type UpdateAcademicYearMutationResult = Apollo.MutationResult<Types.UpdateAcademicYearMutation>;
export type UpdateAcademicYearMutationOptions = Apollo.BaseMutationOptions<Types.UpdateAcademicYearMutation, Types.UpdateAcademicYearMutationVariables>;
export const DeleteAcademicYearDocument = gql`
    mutation deleteAcademicYear($id: uuid!) {
  delete_academic_year(where: {academic_year_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteAcademicYearMutationFn = Apollo.MutationFunction<Types.DeleteAcademicYearMutation, Types.DeleteAcademicYearMutationVariables>;

/**
 * __useDeleteAcademicYearMutation__
 *
 * To run a mutation, you first call `useDeleteAcademicYearMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAcademicYearMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAcademicYearMutation, { data, loading, error }] = useDeleteAcademicYearMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAcademicYearMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteAcademicYearMutation, Types.DeleteAcademicYearMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteAcademicYearMutation, Types.DeleteAcademicYearMutationVariables>(DeleteAcademicYearDocument, options);
      }
export type DeleteAcademicYearMutationHookResult = ReturnType<typeof useDeleteAcademicYearMutation>;
export type DeleteAcademicYearMutationResult = Apollo.MutationResult<Types.DeleteAcademicYearMutation>;
export type DeleteAcademicYearMutationOptions = Apollo.BaseMutationOptions<Types.DeleteAcademicYearMutation, Types.DeleteAcademicYearMutationVariables>;
export const GetAcademicYearsDocument = gql`
    query getAcademicYears {
  academic_year {
    academic_year_id
    end_date
    name
    program_id
    start_date
    tags {
      academic_year_tag_id
      tag {
        tag_id
        name
        type
      }
    }
  }
}
    `;

/**
 * __useGetAcademicYearsQuery__
 *
 * To run a query within a React component, call `useGetAcademicYearsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcademicYearsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcademicYearsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAcademicYearsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAcademicYearsQuery, Types.GetAcademicYearsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAcademicYearsQuery, Types.GetAcademicYearsQueryVariables>(GetAcademicYearsDocument, options);
      }
export function useGetAcademicYearsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAcademicYearsQuery, Types.GetAcademicYearsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAcademicYearsQuery, Types.GetAcademicYearsQueryVariables>(GetAcademicYearsDocument, options);
        }
// @ts-ignore
export function useGetAcademicYearsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearsQuery, Types.GetAcademicYearsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAcademicYearsQuery, Types.GetAcademicYearsQueryVariables>;
export function useGetAcademicYearsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearsQuery, Types.GetAcademicYearsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAcademicYearsQuery | undefined, Types.GetAcademicYearsQueryVariables>;
export function useGetAcademicYearsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearsQuery, Types.GetAcademicYearsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAcademicYearsQuery, Types.GetAcademicYearsQueryVariables>(GetAcademicYearsDocument, options);
        }
export type GetAcademicYearsQueryHookResult = ReturnType<typeof useGetAcademicYearsQuery>;
export type GetAcademicYearsLazyQueryHookResult = ReturnType<typeof useGetAcademicYearsLazyQuery>;
export type GetAcademicYearsSuspenseQueryHookResult = ReturnType<typeof useGetAcademicYearsSuspenseQuery>;
export type GetAcademicYearsQueryResult = Apollo.QueryResult<Types.GetAcademicYearsQuery, Types.GetAcademicYearsQueryVariables>;
export const GetAcademicYearsTemplateDocument = gql`
    query getAcademicYearsTemplate {
  academic_year(where: {program_id: {_is_null: true}}) {
    academic_year_id
    end_date
    name
    program_id
    start_date
    tags {
      academic_year_tag_id
      tag {
        tag_id
        name
        type
      }
    }
    requirements {
      academic_year_requirement_id
      requirement {
        requirement_id
        name
        type
        description
        domains {
          relation
          domain {
            requirement_domain_id
            name
            code
            color_hex
            sort_order
          }
        }
        competencies {
          competency {
            requirement_id
            domains {
              relation
              domain {
                requirement_domain_id
                name
                code
                color_hex
                sort_order
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAcademicYearsTemplateQuery__
 *
 * To run a query within a React component, call `useGetAcademicYearsTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcademicYearsTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcademicYearsTemplateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAcademicYearsTemplateQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAcademicYearsTemplateQuery, Types.GetAcademicYearsTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAcademicYearsTemplateQuery, Types.GetAcademicYearsTemplateQueryVariables>(GetAcademicYearsTemplateDocument, options);
      }
export function useGetAcademicYearsTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAcademicYearsTemplateQuery, Types.GetAcademicYearsTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAcademicYearsTemplateQuery, Types.GetAcademicYearsTemplateQueryVariables>(GetAcademicYearsTemplateDocument, options);
        }
// @ts-ignore
export function useGetAcademicYearsTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearsTemplateQuery, Types.GetAcademicYearsTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAcademicYearsTemplateQuery, Types.GetAcademicYearsTemplateQueryVariables>;
export function useGetAcademicYearsTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearsTemplateQuery, Types.GetAcademicYearsTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAcademicYearsTemplateQuery | undefined, Types.GetAcademicYearsTemplateQueryVariables>;
export function useGetAcademicYearsTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearsTemplateQuery, Types.GetAcademicYearsTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAcademicYearsTemplateQuery, Types.GetAcademicYearsTemplateQueryVariables>(GetAcademicYearsTemplateDocument, options);
        }
export type GetAcademicYearsTemplateQueryHookResult = ReturnType<typeof useGetAcademicYearsTemplateQuery>;
export type GetAcademicYearsTemplateLazyQueryHookResult = ReturnType<typeof useGetAcademicYearsTemplateLazyQuery>;
export type GetAcademicYearsTemplateSuspenseQueryHookResult = ReturnType<typeof useGetAcademicYearsTemplateSuspenseQuery>;
export type GetAcademicYearsTemplateQueryResult = Apollo.QueryResult<Types.GetAcademicYearsTemplateQuery, Types.GetAcademicYearsTemplateQueryVariables>;
export const GetAcademicYearsByIdDocument = gql`
    query getAcademicYearsById($academic_year_id: uuid!) {
  academic_year_by_pk(academic_year_id: $academic_year_id) {
    academic_year_id
    end_date
    name
    program_id
    start_date
    tags {
      academic_year_tag_id
      tag {
        tag_id
        name
        type
      }
    }
    requirements {
      academic_year_requirement_id
      requirement {
        requirement_id
        name
        type
        description
        domains {
          relation
          domain {
            requirement_domain_id
            name
            code
            color_hex
            sort_order
          }
        }
        competencies {
          competency {
            requirement_id
            domains {
              relation
              domain {
                requirement_domain_id
                name
                code
                color_hex
                sort_order
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAcademicYearsByIdQuery__
 *
 * To run a query within a React component, call `useGetAcademicYearsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcademicYearsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcademicYearsByIdQuery({
 *   variables: {
 *      academic_year_id: // value for 'academic_year_id'
 *   },
 * });
 */
export function useGetAcademicYearsByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetAcademicYearsByIdQuery, Types.GetAcademicYearsByIdQueryVariables> & ({ variables: Types.GetAcademicYearsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAcademicYearsByIdQuery, Types.GetAcademicYearsByIdQueryVariables>(GetAcademicYearsByIdDocument, options);
      }
export function useGetAcademicYearsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAcademicYearsByIdQuery, Types.GetAcademicYearsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAcademicYearsByIdQuery, Types.GetAcademicYearsByIdQueryVariables>(GetAcademicYearsByIdDocument, options);
        }
// @ts-ignore
export function useGetAcademicYearsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearsByIdQuery, Types.GetAcademicYearsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAcademicYearsByIdQuery, Types.GetAcademicYearsByIdQueryVariables>;
export function useGetAcademicYearsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearsByIdQuery, Types.GetAcademicYearsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAcademicYearsByIdQuery | undefined, Types.GetAcademicYearsByIdQueryVariables>;
export function useGetAcademicYearsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearsByIdQuery, Types.GetAcademicYearsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAcademicYearsByIdQuery, Types.GetAcademicYearsByIdQueryVariables>(GetAcademicYearsByIdDocument, options);
        }
export type GetAcademicYearsByIdQueryHookResult = ReturnType<typeof useGetAcademicYearsByIdQuery>;
export type GetAcademicYearsByIdLazyQueryHookResult = ReturnType<typeof useGetAcademicYearsByIdLazyQuery>;
export type GetAcademicYearsByIdSuspenseQueryHookResult = ReturnType<typeof useGetAcademicYearsByIdSuspenseQuery>;
export type GetAcademicYearsByIdQueryResult = Apollo.QueryResult<Types.GetAcademicYearsByIdQuery, Types.GetAcademicYearsByIdQueryVariables>;
export const GetAcademicYearsByOrgDocument = gql`
    query GetAcademicYearsByOrg($orgId: uuid!) {
  program(where: {org_id: {_eq: $orgId}}) {
    program_id
    academic_years {
      academic_year_id
      end_date
      name
      program_id
      start_date
      tags {
        academic_year_tag_id
        tag {
          tag_id
          name
          type
        }
      }
      requirements {
        academic_year_requirement_id
        requirement {
          requirement_id
          name
          type
          description
          domains {
            relation
            domain {
              requirement_domain_id
              name
              code
              color_hex
              sort_order
            }
          }
          competencies {
            competency {
              requirement_id
              domains {
                relation
                domain {
                  requirement_domain_id
                  name
                  code
                  color_hex
                  sort_order
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAcademicYearsByOrgQuery__
 *
 * To run a query within a React component, call `useGetAcademicYearsByOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcademicYearsByOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcademicYearsByOrgQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetAcademicYearsByOrgQuery(baseOptions: Apollo.QueryHookOptions<Types.GetAcademicYearsByOrgQuery, Types.GetAcademicYearsByOrgQueryVariables> & ({ variables: Types.GetAcademicYearsByOrgQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAcademicYearsByOrgQuery, Types.GetAcademicYearsByOrgQueryVariables>(GetAcademicYearsByOrgDocument, options);
      }
export function useGetAcademicYearsByOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAcademicYearsByOrgQuery, Types.GetAcademicYearsByOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAcademicYearsByOrgQuery, Types.GetAcademicYearsByOrgQueryVariables>(GetAcademicYearsByOrgDocument, options);
        }
// @ts-ignore
export function useGetAcademicYearsByOrgSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearsByOrgQuery, Types.GetAcademicYearsByOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAcademicYearsByOrgQuery, Types.GetAcademicYearsByOrgQueryVariables>;
export function useGetAcademicYearsByOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearsByOrgQuery, Types.GetAcademicYearsByOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAcademicYearsByOrgQuery | undefined, Types.GetAcademicYearsByOrgQueryVariables>;
export function useGetAcademicYearsByOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearsByOrgQuery, Types.GetAcademicYearsByOrgQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAcademicYearsByOrgQuery, Types.GetAcademicYearsByOrgQueryVariables>(GetAcademicYearsByOrgDocument, options);
        }
export type GetAcademicYearsByOrgQueryHookResult = ReturnType<typeof useGetAcademicYearsByOrgQuery>;
export type GetAcademicYearsByOrgLazyQueryHookResult = ReturnType<typeof useGetAcademicYearsByOrgLazyQuery>;
export type GetAcademicYearsByOrgSuspenseQueryHookResult = ReturnType<typeof useGetAcademicYearsByOrgSuspenseQuery>;
export type GetAcademicYearsByOrgQueryResult = Apollo.QueryResult<Types.GetAcademicYearsByOrgQuery, Types.GetAcademicYearsByOrgQueryVariables>;
export const AddAcademicYearRequirementDocument = gql`
    mutation addAcademicYearRequirement($objects: [academic_year_requirement_insert_input!]!) {
  insert_academic_year_requirement(
    objects: $objects
    on_conflict: {constraint: academic_year_requirement_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddAcademicYearRequirementMutationFn = Apollo.MutationFunction<Types.AddAcademicYearRequirementMutation, Types.AddAcademicYearRequirementMutationVariables>;

/**
 * __useAddAcademicYearRequirementMutation__
 *
 * To run a mutation, you first call `useAddAcademicYearRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAcademicYearRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAcademicYearRequirementMutation, { data, loading, error }] = useAddAcademicYearRequirementMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddAcademicYearRequirementMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddAcademicYearRequirementMutation, Types.AddAcademicYearRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddAcademicYearRequirementMutation, Types.AddAcademicYearRequirementMutationVariables>(AddAcademicYearRequirementDocument, options);
      }
export type AddAcademicYearRequirementMutationHookResult = ReturnType<typeof useAddAcademicYearRequirementMutation>;
export type AddAcademicYearRequirementMutationResult = Apollo.MutationResult<Types.AddAcademicYearRequirementMutation>;
export type AddAcademicYearRequirementMutationOptions = Apollo.BaseMutationOptions<Types.AddAcademicYearRequirementMutation, Types.AddAcademicYearRequirementMutationVariables>;
export const DeleteAcademicYearRequirementDocument = gql`
    mutation deleteAcademicYearRequirement($id: uuid!) {
  delete_academic_year_requirement(
    where: {academic_year_requirement_id: {_eq: $id}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteAcademicYearRequirementMutationFn = Apollo.MutationFunction<Types.DeleteAcademicYearRequirementMutation, Types.DeleteAcademicYearRequirementMutationVariables>;

/**
 * __useDeleteAcademicYearRequirementMutation__
 *
 * To run a mutation, you first call `useDeleteAcademicYearRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAcademicYearRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAcademicYearRequirementMutation, { data, loading, error }] = useDeleteAcademicYearRequirementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAcademicYearRequirementMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteAcademicYearRequirementMutation, Types.DeleteAcademicYearRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteAcademicYearRequirementMutation, Types.DeleteAcademicYearRequirementMutationVariables>(DeleteAcademicYearRequirementDocument, options);
      }
export type DeleteAcademicYearRequirementMutationHookResult = ReturnType<typeof useDeleteAcademicYearRequirementMutation>;
export type DeleteAcademicYearRequirementMutationResult = Apollo.MutationResult<Types.DeleteAcademicYearRequirementMutation>;
export type DeleteAcademicYearRequirementMutationOptions = Apollo.BaseMutationOptions<Types.DeleteAcademicYearRequirementMutation, Types.DeleteAcademicYearRequirementMutationVariables>;
export const GetAcademicYearRequirementDocument = gql`
    query getAcademicYearRequirement {
  academic_year_requirement {
    academic_year_requirement_id
    requirement_id
    academic_year_id
  }
}
    `;

/**
 * __useGetAcademicYearRequirementQuery__
 *
 * To run a query within a React component, call `useGetAcademicYearRequirementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcademicYearRequirementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcademicYearRequirementQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAcademicYearRequirementQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAcademicYearRequirementQuery, Types.GetAcademicYearRequirementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAcademicYearRequirementQuery, Types.GetAcademicYearRequirementQueryVariables>(GetAcademicYearRequirementDocument, options);
      }
export function useGetAcademicYearRequirementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAcademicYearRequirementQuery, Types.GetAcademicYearRequirementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAcademicYearRequirementQuery, Types.GetAcademicYearRequirementQueryVariables>(GetAcademicYearRequirementDocument, options);
        }
// @ts-ignore
export function useGetAcademicYearRequirementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearRequirementQuery, Types.GetAcademicYearRequirementQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAcademicYearRequirementQuery, Types.GetAcademicYearRequirementQueryVariables>;
export function useGetAcademicYearRequirementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearRequirementQuery, Types.GetAcademicYearRequirementQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAcademicYearRequirementQuery | undefined, Types.GetAcademicYearRequirementQueryVariables>;
export function useGetAcademicYearRequirementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearRequirementQuery, Types.GetAcademicYearRequirementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAcademicYearRequirementQuery, Types.GetAcademicYearRequirementQueryVariables>(GetAcademicYearRequirementDocument, options);
        }
export type GetAcademicYearRequirementQueryHookResult = ReturnType<typeof useGetAcademicYearRequirementQuery>;
export type GetAcademicYearRequirementLazyQueryHookResult = ReturnType<typeof useGetAcademicYearRequirementLazyQuery>;
export type GetAcademicYearRequirementSuspenseQueryHookResult = ReturnType<typeof useGetAcademicYearRequirementSuspenseQuery>;
export type GetAcademicYearRequirementQueryResult = Apollo.QueryResult<Types.GetAcademicYearRequirementQuery, Types.GetAcademicYearRequirementQueryVariables>;
export const GetAcademicYearRequirementByAcademicYearIdDocument = gql`
    query getAcademicYearRequirementByAcademicYearId($academic_year_id: uuid!) {
  academic_year_requirement(where: {academic_year_id: {_eq: $academic_year_id}}) {
    academic_year_requirement_id
    requirement {
      name
      requirement_id
      type
    }
  }
}
    `;

/**
 * __useGetAcademicYearRequirementByAcademicYearIdQuery__
 *
 * To run a query within a React component, call `useGetAcademicYearRequirementByAcademicYearIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcademicYearRequirementByAcademicYearIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcademicYearRequirementByAcademicYearIdQuery({
 *   variables: {
 *      academic_year_id: // value for 'academic_year_id'
 *   },
 * });
 */
export function useGetAcademicYearRequirementByAcademicYearIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetAcademicYearRequirementByAcademicYearIdQuery, Types.GetAcademicYearRequirementByAcademicYearIdQueryVariables> & ({ variables: Types.GetAcademicYearRequirementByAcademicYearIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAcademicYearRequirementByAcademicYearIdQuery, Types.GetAcademicYearRequirementByAcademicYearIdQueryVariables>(GetAcademicYearRequirementByAcademicYearIdDocument, options);
      }
export function useGetAcademicYearRequirementByAcademicYearIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAcademicYearRequirementByAcademicYearIdQuery, Types.GetAcademicYearRequirementByAcademicYearIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAcademicYearRequirementByAcademicYearIdQuery, Types.GetAcademicYearRequirementByAcademicYearIdQueryVariables>(GetAcademicYearRequirementByAcademicYearIdDocument, options);
        }
// @ts-ignore
export function useGetAcademicYearRequirementByAcademicYearIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearRequirementByAcademicYearIdQuery, Types.GetAcademicYearRequirementByAcademicYearIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAcademicYearRequirementByAcademicYearIdQuery, Types.GetAcademicYearRequirementByAcademicYearIdQueryVariables>;
export function useGetAcademicYearRequirementByAcademicYearIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearRequirementByAcademicYearIdQuery, Types.GetAcademicYearRequirementByAcademicYearIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAcademicYearRequirementByAcademicYearIdQuery | undefined, Types.GetAcademicYearRequirementByAcademicYearIdQueryVariables>;
export function useGetAcademicYearRequirementByAcademicYearIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearRequirementByAcademicYearIdQuery, Types.GetAcademicYearRequirementByAcademicYearIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAcademicYearRequirementByAcademicYearIdQuery, Types.GetAcademicYearRequirementByAcademicYearIdQueryVariables>(GetAcademicYearRequirementByAcademicYearIdDocument, options);
        }
export type GetAcademicYearRequirementByAcademicYearIdQueryHookResult = ReturnType<typeof useGetAcademicYearRequirementByAcademicYearIdQuery>;
export type GetAcademicYearRequirementByAcademicYearIdLazyQueryHookResult = ReturnType<typeof useGetAcademicYearRequirementByAcademicYearIdLazyQuery>;
export type GetAcademicYearRequirementByAcademicYearIdSuspenseQueryHookResult = ReturnType<typeof useGetAcademicYearRequirementByAcademicYearIdSuspenseQuery>;
export type GetAcademicYearRequirementByAcademicYearIdQueryResult = Apollo.QueryResult<Types.GetAcademicYearRequirementByAcademicYearIdQuery, Types.GetAcademicYearRequirementByAcademicYearIdQueryVariables>;
export const AddAcademicYearTagDocument = gql`
    mutation addAcademicYearTag($academicYearId: uuid!, $tagId: uuid) {
  insert_academic_year_tag(
    objects: [{academic_year_id: $academicYearId, tag_id: $tagId}]
    on_conflict: {constraint: academic_year_tag_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddAcademicYearTagMutationFn = Apollo.MutationFunction<Types.AddAcademicYearTagMutation, Types.AddAcademicYearTagMutationVariables>;

/**
 * __useAddAcademicYearTagMutation__
 *
 * To run a mutation, you first call `useAddAcademicYearTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAcademicYearTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAcademicYearTagMutation, { data, loading, error }] = useAddAcademicYearTagMutation({
 *   variables: {
 *      academicYearId: // value for 'academicYearId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useAddAcademicYearTagMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddAcademicYearTagMutation, Types.AddAcademicYearTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddAcademicYearTagMutation, Types.AddAcademicYearTagMutationVariables>(AddAcademicYearTagDocument, options);
      }
export type AddAcademicYearTagMutationHookResult = ReturnType<typeof useAddAcademicYearTagMutation>;
export type AddAcademicYearTagMutationResult = Apollo.MutationResult<Types.AddAcademicYearTagMutation>;
export type AddAcademicYearTagMutationOptions = Apollo.BaseMutationOptions<Types.AddAcademicYearTagMutation, Types.AddAcademicYearTagMutationVariables>;
export const DeleteAcademicYearTagDocument = gql`
    mutation deleteAcademicYearTag($id: uuid!) {
  delete_academic_year_tag(where: {academic_year_tag_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteAcademicYearTagMutationFn = Apollo.MutationFunction<Types.DeleteAcademicYearTagMutation, Types.DeleteAcademicYearTagMutationVariables>;

/**
 * __useDeleteAcademicYearTagMutation__
 *
 * To run a mutation, you first call `useDeleteAcademicYearTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAcademicYearTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAcademicYearTagMutation, { data, loading, error }] = useDeleteAcademicYearTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAcademicYearTagMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteAcademicYearTagMutation, Types.DeleteAcademicYearTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteAcademicYearTagMutation, Types.DeleteAcademicYearTagMutationVariables>(DeleteAcademicYearTagDocument, options);
      }
export type DeleteAcademicYearTagMutationHookResult = ReturnType<typeof useDeleteAcademicYearTagMutation>;
export type DeleteAcademicYearTagMutationResult = Apollo.MutationResult<Types.DeleteAcademicYearTagMutation>;
export type DeleteAcademicYearTagMutationOptions = Apollo.BaseMutationOptions<Types.DeleteAcademicYearTagMutation, Types.DeleteAcademicYearTagMutationVariables>;
export const DeleteAcademicYearTagByTagAndResourceDocument = gql`
    mutation deleteAcademicYearTagByTagAndResource($academicYearId: uuid!, $tagId: uuid!) {
  delete_academic_year_tag(
    where: {academic_year_id: {_eq: $academicYearId}, tag_id: {_eq: $tagId}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteAcademicYearTagByTagAndResourceMutationFn = Apollo.MutationFunction<Types.DeleteAcademicYearTagByTagAndResourceMutation, Types.DeleteAcademicYearTagByTagAndResourceMutationVariables>;

/**
 * __useDeleteAcademicYearTagByTagAndResourceMutation__
 *
 * To run a mutation, you first call `useDeleteAcademicYearTagByTagAndResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAcademicYearTagByTagAndResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAcademicYearTagByTagAndResourceMutation, { data, loading, error }] = useDeleteAcademicYearTagByTagAndResourceMutation({
 *   variables: {
 *      academicYearId: // value for 'academicYearId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useDeleteAcademicYearTagByTagAndResourceMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteAcademicYearTagByTagAndResourceMutation, Types.DeleteAcademicYearTagByTagAndResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteAcademicYearTagByTagAndResourceMutation, Types.DeleteAcademicYearTagByTagAndResourceMutationVariables>(DeleteAcademicYearTagByTagAndResourceDocument, options);
      }
export type DeleteAcademicYearTagByTagAndResourceMutationHookResult = ReturnType<typeof useDeleteAcademicYearTagByTagAndResourceMutation>;
export type DeleteAcademicYearTagByTagAndResourceMutationResult = Apollo.MutationResult<Types.DeleteAcademicYearTagByTagAndResourceMutation>;
export type DeleteAcademicYearTagByTagAndResourceMutationOptions = Apollo.BaseMutationOptions<Types.DeleteAcademicYearTagByTagAndResourceMutation, Types.DeleteAcademicYearTagByTagAndResourceMutationVariables>;
export const GetAcademicYearTagsDocument = gql`
    query getAcademicYearTags {
  academic_year_tag {
    academic_year_tag_id
    tag_id
    academic_year_id
  }
}
    `;

/**
 * __useGetAcademicYearTagsQuery__
 *
 * To run a query within a React component, call `useGetAcademicYearTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcademicYearTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcademicYearTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAcademicYearTagsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAcademicYearTagsQuery, Types.GetAcademicYearTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAcademicYearTagsQuery, Types.GetAcademicYearTagsQueryVariables>(GetAcademicYearTagsDocument, options);
      }
export function useGetAcademicYearTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAcademicYearTagsQuery, Types.GetAcademicYearTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAcademicYearTagsQuery, Types.GetAcademicYearTagsQueryVariables>(GetAcademicYearTagsDocument, options);
        }
// @ts-ignore
export function useGetAcademicYearTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearTagsQuery, Types.GetAcademicYearTagsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAcademicYearTagsQuery, Types.GetAcademicYearTagsQueryVariables>;
export function useGetAcademicYearTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearTagsQuery, Types.GetAcademicYearTagsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAcademicYearTagsQuery | undefined, Types.GetAcademicYearTagsQueryVariables>;
export function useGetAcademicYearTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearTagsQuery, Types.GetAcademicYearTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAcademicYearTagsQuery, Types.GetAcademicYearTagsQueryVariables>(GetAcademicYearTagsDocument, options);
        }
export type GetAcademicYearTagsQueryHookResult = ReturnType<typeof useGetAcademicYearTagsQuery>;
export type GetAcademicYearTagsLazyQueryHookResult = ReturnType<typeof useGetAcademicYearTagsLazyQuery>;
export type GetAcademicYearTagsSuspenseQueryHookResult = ReturnType<typeof useGetAcademicYearTagsSuspenseQuery>;
export type GetAcademicYearTagsQueryResult = Apollo.QueryResult<Types.GetAcademicYearTagsQuery, Types.GetAcademicYearTagsQueryVariables>;
export const GetAcademicYearTagsByAcademicYearIdDocument = gql`
    query getAcademicYearTagsByAcademicYearId($academic_year_id: uuid!) {
  academic_year_tag(where: {academic_year_id: {_eq: $academic_year_id}}) {
    academic_year_tag_id
    tag {
      name
      tag_id
      type
    }
  }
}
    `;

/**
 * __useGetAcademicYearTagsByAcademicYearIdQuery__
 *
 * To run a query within a React component, call `useGetAcademicYearTagsByAcademicYearIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcademicYearTagsByAcademicYearIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcademicYearTagsByAcademicYearIdQuery({
 *   variables: {
 *      academic_year_id: // value for 'academic_year_id'
 *   },
 * });
 */
export function useGetAcademicYearTagsByAcademicYearIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetAcademicYearTagsByAcademicYearIdQuery, Types.GetAcademicYearTagsByAcademicYearIdQueryVariables> & ({ variables: Types.GetAcademicYearTagsByAcademicYearIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAcademicYearTagsByAcademicYearIdQuery, Types.GetAcademicYearTagsByAcademicYearIdQueryVariables>(GetAcademicYearTagsByAcademicYearIdDocument, options);
      }
export function useGetAcademicYearTagsByAcademicYearIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAcademicYearTagsByAcademicYearIdQuery, Types.GetAcademicYearTagsByAcademicYearIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAcademicYearTagsByAcademicYearIdQuery, Types.GetAcademicYearTagsByAcademicYearIdQueryVariables>(GetAcademicYearTagsByAcademicYearIdDocument, options);
        }
// @ts-ignore
export function useGetAcademicYearTagsByAcademicYearIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearTagsByAcademicYearIdQuery, Types.GetAcademicYearTagsByAcademicYearIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAcademicYearTagsByAcademicYearIdQuery, Types.GetAcademicYearTagsByAcademicYearIdQueryVariables>;
export function useGetAcademicYearTagsByAcademicYearIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearTagsByAcademicYearIdQuery, Types.GetAcademicYearTagsByAcademicYearIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAcademicYearTagsByAcademicYearIdQuery | undefined, Types.GetAcademicYearTagsByAcademicYearIdQueryVariables>;
export function useGetAcademicYearTagsByAcademicYearIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAcademicYearTagsByAcademicYearIdQuery, Types.GetAcademicYearTagsByAcademicYearIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAcademicYearTagsByAcademicYearIdQuery, Types.GetAcademicYearTagsByAcademicYearIdQueryVariables>(GetAcademicYearTagsByAcademicYearIdDocument, options);
        }
export type GetAcademicYearTagsByAcademicYearIdQueryHookResult = ReturnType<typeof useGetAcademicYearTagsByAcademicYearIdQuery>;
export type GetAcademicYearTagsByAcademicYearIdLazyQueryHookResult = ReturnType<typeof useGetAcademicYearTagsByAcademicYearIdLazyQuery>;
export type GetAcademicYearTagsByAcademicYearIdSuspenseQueryHookResult = ReturnType<typeof useGetAcademicYearTagsByAcademicYearIdSuspenseQuery>;
export type GetAcademicYearTagsByAcademicYearIdQueryResult = Apollo.QueryResult<Types.GetAcademicYearTagsByAcademicYearIdQuery, Types.GetAcademicYearTagsByAcademicYearIdQueryVariables>;
export const AddAddressDocument = gql`
    mutation addAddress($address_line_1: String!, $address_line_2: String, $city: String, $state: String, $country: String, $zip_code: String) {
  insert_address(
    objects: [{address_line_1: $address_line_1, address_line_2: $address_line_2, city: $city, state: $state, country: $country, zip_code: $zip_code}]
    on_conflict: {constraint: address_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      address_id
      address_line_1
      address_line_2
      city
      state
      country
      zip_code
    }
  }
}
    `;
export type AddAddressMutationFn = Apollo.MutationFunction<Types.AddAddressMutation, Types.AddAddressMutationVariables>;

/**
 * __useAddAddressMutation__
 *
 * To run a mutation, you first call `useAddAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAddressMutation, { data, loading, error }] = useAddAddressMutation({
 *   variables: {
 *      address_line_1: // value for 'address_line_1'
 *      address_line_2: // value for 'address_line_2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      country: // value for 'country'
 *      zip_code: // value for 'zip_code'
 *   },
 * });
 */
export function useAddAddressMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddAddressMutation, Types.AddAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddAddressMutation, Types.AddAddressMutationVariables>(AddAddressDocument, options);
      }
export type AddAddressMutationHookResult = ReturnType<typeof useAddAddressMutation>;
export type AddAddressMutationResult = Apollo.MutationResult<Types.AddAddressMutation>;
export type AddAddressMutationOptions = Apollo.BaseMutationOptions<Types.AddAddressMutation, Types.AddAddressMutationVariables>;
export const UpdateAddressDocument = gql`
    mutation updateAddress($id: uuid!, $address: address_set_input!) {
  update_address(where: {address_id: {_eq: $id}}, _set: $address) {
    affected_rows
  }
}
    `;
export type UpdateAddressMutationFn = Apollo.MutationFunction<Types.UpdateAddressMutation, Types.UpdateAddressMutationVariables>;

/**
 * __useUpdateAddressMutation__
 *
 * To run a mutation, you first call `useUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressMutation, { data, loading, error }] = useUpdateAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useUpdateAddressMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateAddressMutation, Types.UpdateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateAddressMutation, Types.UpdateAddressMutationVariables>(UpdateAddressDocument, options);
      }
export type UpdateAddressMutationHookResult = ReturnType<typeof useUpdateAddressMutation>;
export type UpdateAddressMutationResult = Apollo.MutationResult<Types.UpdateAddressMutation>;
export type UpdateAddressMutationOptions = Apollo.BaseMutationOptions<Types.UpdateAddressMutation, Types.UpdateAddressMutationVariables>;
export const DeleteAddressDocument = gql`
    mutation deleteAddress($id: uuid!) {
  delete_address(where: {address_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteAddressMutationFn = Apollo.MutationFunction<Types.DeleteAddressMutation, Types.DeleteAddressMutationVariables>;

/**
 * __useDeleteAddressMutation__
 *
 * To run a mutation, you first call `useDeleteAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAddressMutation, { data, loading, error }] = useDeleteAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAddressMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteAddressMutation, Types.DeleteAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteAddressMutation, Types.DeleteAddressMutationVariables>(DeleteAddressDocument, options);
      }
export type DeleteAddressMutationHookResult = ReturnType<typeof useDeleteAddressMutation>;
export type DeleteAddressMutationResult = Apollo.MutationResult<Types.DeleteAddressMutation>;
export type DeleteAddressMutationOptions = Apollo.BaseMutationOptions<Types.DeleteAddressMutation, Types.DeleteAddressMutationVariables>;
export const GetAddressesDocument = gql`
    query getAddresses {
  address {
    address_id
    address_line_1
    address_line_2
    city
    state
    country
    zip_code
  }
}
    `;

/**
 * __useGetAddressesQuery__
 *
 * To run a query within a React component, call `useGetAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAddressesQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAddressesQuery, Types.GetAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAddressesQuery, Types.GetAddressesQueryVariables>(GetAddressesDocument, options);
      }
export function useGetAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAddressesQuery, Types.GetAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAddressesQuery, Types.GetAddressesQueryVariables>(GetAddressesDocument, options);
        }
// @ts-ignore
export function useGetAddressesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAddressesQuery, Types.GetAddressesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAddressesQuery, Types.GetAddressesQueryVariables>;
export function useGetAddressesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAddressesQuery, Types.GetAddressesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAddressesQuery | undefined, Types.GetAddressesQueryVariables>;
export function useGetAddressesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAddressesQuery, Types.GetAddressesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAddressesQuery, Types.GetAddressesQueryVariables>(GetAddressesDocument, options);
        }
export type GetAddressesQueryHookResult = ReturnType<typeof useGetAddressesQuery>;
export type GetAddressesLazyQueryHookResult = ReturnType<typeof useGetAddressesLazyQuery>;
export type GetAddressesSuspenseQueryHookResult = ReturnType<typeof useGetAddressesSuspenseQuery>;
export type GetAddressesQueryResult = Apollo.QueryResult<Types.GetAddressesQuery, Types.GetAddressesQueryVariables>;
export const GetAddressByIdDocument = gql`
    query getAddressById($addressId: uuid!) {
  address_by_pk(address_id: $addressId) {
    address_id
    address_line_1
    address_line_2
    city
    state
    country
    zip_code
  }
}
    `;

/**
 * __useGetAddressByIdQuery__
 *
 * To run a query within a React component, call `useGetAddressByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressByIdQuery({
 *   variables: {
 *      addressId: // value for 'addressId'
 *   },
 * });
 */
export function useGetAddressByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetAddressByIdQuery, Types.GetAddressByIdQueryVariables> & ({ variables: Types.GetAddressByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAddressByIdQuery, Types.GetAddressByIdQueryVariables>(GetAddressByIdDocument, options);
      }
export function useGetAddressByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAddressByIdQuery, Types.GetAddressByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAddressByIdQuery, Types.GetAddressByIdQueryVariables>(GetAddressByIdDocument, options);
        }
// @ts-ignore
export function useGetAddressByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAddressByIdQuery, Types.GetAddressByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAddressByIdQuery, Types.GetAddressByIdQueryVariables>;
export function useGetAddressByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAddressByIdQuery, Types.GetAddressByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAddressByIdQuery | undefined, Types.GetAddressByIdQueryVariables>;
export function useGetAddressByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAddressByIdQuery, Types.GetAddressByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAddressByIdQuery, Types.GetAddressByIdQueryVariables>(GetAddressByIdDocument, options);
        }
export type GetAddressByIdQueryHookResult = ReturnType<typeof useGetAddressByIdQuery>;
export type GetAddressByIdLazyQueryHookResult = ReturnType<typeof useGetAddressByIdLazyQuery>;
export type GetAddressByIdSuspenseQueryHookResult = ReturnType<typeof useGetAddressByIdSuspenseQuery>;
export type GetAddressByIdQueryResult = Apollo.QueryResult<Types.GetAddressByIdQuery, Types.GetAddressByIdQueryVariables>;
export const AddAnswerDocument = gql`
    mutation addAnswer($answer: String!, $questionId: uuid!, $optionId: uuid, $userId: uuid, $createdAt: timestamptz) {
  insert_answer(
    objects: [{answer: $answer, question_id: $questionId, option_id: $optionId, user_id: $userId, created_at: $createdAt}]
    on_conflict: {constraint: answer_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      answer_id
    }
  }
}
    `;
export type AddAnswerMutationFn = Apollo.MutationFunction<Types.AddAnswerMutation, Types.AddAnswerMutationVariables>;

/**
 * __useAddAnswerMutation__
 *
 * To run a mutation, you first call `useAddAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAnswerMutation, { data, loading, error }] = useAddAnswerMutation({
 *   variables: {
 *      answer: // value for 'answer'
 *      questionId: // value for 'questionId'
 *      optionId: // value for 'optionId'
 *      userId: // value for 'userId'
 *      createdAt: // value for 'createdAt'
 *   },
 * });
 */
export function useAddAnswerMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddAnswerMutation, Types.AddAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddAnswerMutation, Types.AddAnswerMutationVariables>(AddAnswerDocument, options);
      }
export type AddAnswerMutationHookResult = ReturnType<typeof useAddAnswerMutation>;
export type AddAnswerMutationResult = Apollo.MutationResult<Types.AddAnswerMutation>;
export type AddAnswerMutationOptions = Apollo.BaseMutationOptions<Types.AddAnswerMutation, Types.AddAnswerMutationVariables>;
export const UpdateAnswerDocument = gql`
    mutation updateAnswer($id: uuid!, $answer: answer_set_input!) {
  update_answer(where: {answer_id: {_eq: $id}}, _set: $answer) {
    affected_rows
  }
}
    `;
export type UpdateAnswerMutationFn = Apollo.MutationFunction<Types.UpdateAnswerMutation, Types.UpdateAnswerMutationVariables>;

/**
 * __useUpdateAnswerMutation__
 *
 * To run a mutation, you first call `useUpdateAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnswerMutation, { data, loading, error }] = useUpdateAnswerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      answer: // value for 'answer'
 *   },
 * });
 */
export function useUpdateAnswerMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateAnswerMutation, Types.UpdateAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateAnswerMutation, Types.UpdateAnswerMutationVariables>(UpdateAnswerDocument, options);
      }
export type UpdateAnswerMutationHookResult = ReturnType<typeof useUpdateAnswerMutation>;
export type UpdateAnswerMutationResult = Apollo.MutationResult<Types.UpdateAnswerMutation>;
export type UpdateAnswerMutationOptions = Apollo.BaseMutationOptions<Types.UpdateAnswerMutation, Types.UpdateAnswerMutationVariables>;
export const DeleteAnswerDocument = gql`
    mutation deleteAnswer($id: uuid!) {
  delete_answer(where: {answer_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteAnswerMutationFn = Apollo.MutationFunction<Types.DeleteAnswerMutation, Types.DeleteAnswerMutationVariables>;

/**
 * __useDeleteAnswerMutation__
 *
 * To run a mutation, you first call `useDeleteAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnswerMutation, { data, loading, error }] = useDeleteAnswerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAnswerMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteAnswerMutation, Types.DeleteAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteAnswerMutation, Types.DeleteAnswerMutationVariables>(DeleteAnswerDocument, options);
      }
export type DeleteAnswerMutationHookResult = ReturnType<typeof useDeleteAnswerMutation>;
export type DeleteAnswerMutationResult = Apollo.MutationResult<Types.DeleteAnswerMutation>;
export type DeleteAnswerMutationOptions = Apollo.BaseMutationOptions<Types.DeleteAnswerMutation, Types.DeleteAnswerMutationVariables>;
export const GetAnswersDocument = gql`
    query getAnswers {
  answer {
    answer_id
    answer
    option_id
    question_id
    user_id
    created_at
    option {
      option_id
      order
      question_id
      text
    }
    question {
      question_id
      title
      type
      body
      order
    }
    user {
      user_id
      name
      email
      picture_url
    }
  }
}
    `;

/**
 * __useGetAnswersQuery__
 *
 * To run a query within a React component, call `useGetAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnswersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAnswersQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAnswersQuery, Types.GetAnswersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAnswersQuery, Types.GetAnswersQueryVariables>(GetAnswersDocument, options);
      }
export function useGetAnswersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAnswersQuery, Types.GetAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAnswersQuery, Types.GetAnswersQueryVariables>(GetAnswersDocument, options);
        }
// @ts-ignore
export function useGetAnswersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAnswersQuery, Types.GetAnswersQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAnswersQuery, Types.GetAnswersQueryVariables>;
export function useGetAnswersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAnswersQuery, Types.GetAnswersQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAnswersQuery | undefined, Types.GetAnswersQueryVariables>;
export function useGetAnswersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAnswersQuery, Types.GetAnswersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAnswersQuery, Types.GetAnswersQueryVariables>(GetAnswersDocument, options);
        }
export type GetAnswersQueryHookResult = ReturnType<typeof useGetAnswersQuery>;
export type GetAnswersLazyQueryHookResult = ReturnType<typeof useGetAnswersLazyQuery>;
export type GetAnswersSuspenseQueryHookResult = ReturnType<typeof useGetAnswersSuspenseQuery>;
export type GetAnswersQueryResult = Apollo.QueryResult<Types.GetAnswersQuery, Types.GetAnswersQueryVariables>;
export const GetAnswerByIdDocument = gql`
    query getAnswerById($answerId: uuid!) {
  answer_by_pk(answer_id: $answerId) {
    answer_id
    answer
    option_id
    question_id
    user_id
    created_at
    option {
      option_id
      order
      question_id
      text
    }
    question {
      question_id
      title
      type
      body
      order
    }
    user {
      user_id
      name
      email
      picture_url
    }
  }
}
    `;

/**
 * __useGetAnswerByIdQuery__
 *
 * To run a query within a React component, call `useGetAnswerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnswerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnswerByIdQuery({
 *   variables: {
 *      answerId: // value for 'answerId'
 *   },
 * });
 */
export function useGetAnswerByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetAnswerByIdQuery, Types.GetAnswerByIdQueryVariables> & ({ variables: Types.GetAnswerByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAnswerByIdQuery, Types.GetAnswerByIdQueryVariables>(GetAnswerByIdDocument, options);
      }
export function useGetAnswerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAnswerByIdQuery, Types.GetAnswerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAnswerByIdQuery, Types.GetAnswerByIdQueryVariables>(GetAnswerByIdDocument, options);
        }
// @ts-ignore
export function useGetAnswerByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAnswerByIdQuery, Types.GetAnswerByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAnswerByIdQuery, Types.GetAnswerByIdQueryVariables>;
export function useGetAnswerByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAnswerByIdQuery, Types.GetAnswerByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAnswerByIdQuery | undefined, Types.GetAnswerByIdQueryVariables>;
export function useGetAnswerByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAnswerByIdQuery, Types.GetAnswerByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAnswerByIdQuery, Types.GetAnswerByIdQueryVariables>(GetAnswerByIdDocument, options);
        }
export type GetAnswerByIdQueryHookResult = ReturnType<typeof useGetAnswerByIdQuery>;
export type GetAnswerByIdLazyQueryHookResult = ReturnType<typeof useGetAnswerByIdLazyQuery>;
export type GetAnswerByIdSuspenseQueryHookResult = ReturnType<typeof useGetAnswerByIdSuspenseQuery>;
export type GetAnswerByIdQueryResult = Apollo.QueryResult<Types.GetAnswerByIdQuery, Types.GetAnswerByIdQueryVariables>;
export const GetAnswersByQuestionIdDocument = gql`
    query getAnswersByQuestionId($questionId: uuid!) {
  answer(where: {question_id: {_eq: $questionId}}) {
    answer_id
    answer
    option_id
    question_id
    user_id
    created_at
    option {
      option_id
      order
      question_id
      text
    }
    question {
      question_id
      title
      type
      body
      order
    }
    user {
      user_id
      name
      email
      picture_url
    }
  }
}
    `;

/**
 * __useGetAnswersByQuestionIdQuery__
 *
 * To run a query within a React component, call `useGetAnswersByQuestionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnswersByQuestionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnswersByQuestionIdQuery({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useGetAnswersByQuestionIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetAnswersByQuestionIdQuery, Types.GetAnswersByQuestionIdQueryVariables> & ({ variables: Types.GetAnswersByQuestionIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAnswersByQuestionIdQuery, Types.GetAnswersByQuestionIdQueryVariables>(GetAnswersByQuestionIdDocument, options);
      }
export function useGetAnswersByQuestionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAnswersByQuestionIdQuery, Types.GetAnswersByQuestionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAnswersByQuestionIdQuery, Types.GetAnswersByQuestionIdQueryVariables>(GetAnswersByQuestionIdDocument, options);
        }
// @ts-ignore
export function useGetAnswersByQuestionIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAnswersByQuestionIdQuery, Types.GetAnswersByQuestionIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAnswersByQuestionIdQuery, Types.GetAnswersByQuestionIdQueryVariables>;
export function useGetAnswersByQuestionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAnswersByQuestionIdQuery, Types.GetAnswersByQuestionIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAnswersByQuestionIdQuery | undefined, Types.GetAnswersByQuestionIdQueryVariables>;
export function useGetAnswersByQuestionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAnswersByQuestionIdQuery, Types.GetAnswersByQuestionIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAnswersByQuestionIdQuery, Types.GetAnswersByQuestionIdQueryVariables>(GetAnswersByQuestionIdDocument, options);
        }
export type GetAnswersByQuestionIdQueryHookResult = ReturnType<typeof useGetAnswersByQuestionIdQuery>;
export type GetAnswersByQuestionIdLazyQueryHookResult = ReturnType<typeof useGetAnswersByQuestionIdLazyQuery>;
export type GetAnswersByQuestionIdSuspenseQueryHookResult = ReturnType<typeof useGetAnswersByQuestionIdSuspenseQuery>;
export type GetAnswersByQuestionIdQueryResult = Apollo.QueryResult<Types.GetAnswersByQuestionIdQuery, Types.GetAnswersByQuestionIdQueryVariables>;
export const GetAnswersByUserAndQuestionIdsDocument = gql`
    query getAnswersByUserAndQuestionIds($userId: uuid!, $questionIds: [uuid!]!) {
  answer(where: {user_id: {_eq: $userId}, question_id: {_in: $questionIds}}) {
    answer_id
    question_id
    user_id
    created_at
  }
}
    `;

/**
 * __useGetAnswersByUserAndQuestionIdsQuery__
 *
 * To run a query within a React component, call `useGetAnswersByUserAndQuestionIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnswersByUserAndQuestionIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnswersByUserAndQuestionIdsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      questionIds: // value for 'questionIds'
 *   },
 * });
 */
export function useGetAnswersByUserAndQuestionIdsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetAnswersByUserAndQuestionIdsQuery, Types.GetAnswersByUserAndQuestionIdsQueryVariables> & ({ variables: Types.GetAnswersByUserAndQuestionIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAnswersByUserAndQuestionIdsQuery, Types.GetAnswersByUserAndQuestionIdsQueryVariables>(GetAnswersByUserAndQuestionIdsDocument, options);
      }
export function useGetAnswersByUserAndQuestionIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAnswersByUserAndQuestionIdsQuery, Types.GetAnswersByUserAndQuestionIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAnswersByUserAndQuestionIdsQuery, Types.GetAnswersByUserAndQuestionIdsQueryVariables>(GetAnswersByUserAndQuestionIdsDocument, options);
        }
// @ts-ignore
export function useGetAnswersByUserAndQuestionIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAnswersByUserAndQuestionIdsQuery, Types.GetAnswersByUserAndQuestionIdsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAnswersByUserAndQuestionIdsQuery, Types.GetAnswersByUserAndQuestionIdsQueryVariables>;
export function useGetAnswersByUserAndQuestionIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAnswersByUserAndQuestionIdsQuery, Types.GetAnswersByUserAndQuestionIdsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAnswersByUserAndQuestionIdsQuery | undefined, Types.GetAnswersByUserAndQuestionIdsQueryVariables>;
export function useGetAnswersByUserAndQuestionIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAnswersByUserAndQuestionIdsQuery, Types.GetAnswersByUserAndQuestionIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAnswersByUserAndQuestionIdsQuery, Types.GetAnswersByUserAndQuestionIdsQueryVariables>(GetAnswersByUserAndQuestionIdsDocument, options);
        }
export type GetAnswersByUserAndQuestionIdsQueryHookResult = ReturnType<typeof useGetAnswersByUserAndQuestionIdsQuery>;
export type GetAnswersByUserAndQuestionIdsLazyQueryHookResult = ReturnType<typeof useGetAnswersByUserAndQuestionIdsLazyQuery>;
export type GetAnswersByUserAndQuestionIdsSuspenseQueryHookResult = ReturnType<typeof useGetAnswersByUserAndQuestionIdsSuspenseQuery>;
export type GetAnswersByUserAndQuestionIdsQueryResult = Apollo.QueryResult<Types.GetAnswersByUserAndQuestionIdsQuery, Types.GetAnswersByUserAndQuestionIdsQueryVariables>;
export const AddBadgeDocument = gql`
    mutation addBadge($name: String!, $description: String, $icon_url: String, $criteria_type: String!, $criteria_value: Int!) {
  insert_badge(
    objects: [{name: $name, description: $description, icon_url: $icon_url, criteria_type: $criteria_type, criteria_value: $criteria_value}]
  ) {
    affected_rows
    returning {
      badge_id
    }
  }
}
    `;
export type AddBadgeMutationFn = Apollo.MutationFunction<Types.AddBadgeMutation, Types.AddBadgeMutationVariables>;

/**
 * __useAddBadgeMutation__
 *
 * To run a mutation, you first call `useAddBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBadgeMutation, { data, loading, error }] = useAddBadgeMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      icon_url: // value for 'icon_url'
 *      criteria_type: // value for 'criteria_type'
 *      criteria_value: // value for 'criteria_value'
 *   },
 * });
 */
export function useAddBadgeMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddBadgeMutation, Types.AddBadgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddBadgeMutation, Types.AddBadgeMutationVariables>(AddBadgeDocument, options);
      }
export type AddBadgeMutationHookResult = ReturnType<typeof useAddBadgeMutation>;
export type AddBadgeMutationResult = Apollo.MutationResult<Types.AddBadgeMutation>;
export type AddBadgeMutationOptions = Apollo.BaseMutationOptions<Types.AddBadgeMutation, Types.AddBadgeMutationVariables>;
export const UpdateBadgeDocument = gql`
    mutation updateBadge($id: uuid!, $badge: badge_set_input!) {
  update_badge(where: {badge_id: {_eq: $id}}, _set: $badge) {
    affected_rows
  }
}
    `;
export type UpdateBadgeMutationFn = Apollo.MutationFunction<Types.UpdateBadgeMutation, Types.UpdateBadgeMutationVariables>;

/**
 * __useUpdateBadgeMutation__
 *
 * To run a mutation, you first call `useUpdateBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBadgeMutation, { data, loading, error }] = useUpdateBadgeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      badge: // value for 'badge'
 *   },
 * });
 */
export function useUpdateBadgeMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateBadgeMutation, Types.UpdateBadgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateBadgeMutation, Types.UpdateBadgeMutationVariables>(UpdateBadgeDocument, options);
      }
export type UpdateBadgeMutationHookResult = ReturnType<typeof useUpdateBadgeMutation>;
export type UpdateBadgeMutationResult = Apollo.MutationResult<Types.UpdateBadgeMutation>;
export type UpdateBadgeMutationOptions = Apollo.BaseMutationOptions<Types.UpdateBadgeMutation, Types.UpdateBadgeMutationVariables>;
export const DeleteBadgeDocument = gql`
    mutation deleteBadge($id: uuid!) {
  delete_badge(where: {badge_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteBadgeMutationFn = Apollo.MutationFunction<Types.DeleteBadgeMutation, Types.DeleteBadgeMutationVariables>;

/**
 * __useDeleteBadgeMutation__
 *
 * To run a mutation, you first call `useDeleteBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBadgeMutation, { data, loading, error }] = useDeleteBadgeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBadgeMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteBadgeMutation, Types.DeleteBadgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteBadgeMutation, Types.DeleteBadgeMutationVariables>(DeleteBadgeDocument, options);
      }
export type DeleteBadgeMutationHookResult = ReturnType<typeof useDeleteBadgeMutation>;
export type DeleteBadgeMutationResult = Apollo.MutationResult<Types.DeleteBadgeMutation>;
export type DeleteBadgeMutationOptions = Apollo.BaseMutationOptions<Types.DeleteBadgeMutation, Types.DeleteBadgeMutationVariables>;
export const AddUserBadgeDocument = gql`
    mutation addUserBadge($user_id: uuid!, $badge_id: uuid!) {
  insert_user_badge(
    objects: [{user_id: $user_id, badge_id: $badge_id}]
    on_conflict: {constraint: user_badge_user_id_badge_id_key, update_columns: []}
  ) {
    affected_rows
    returning {
      user_badge_id
    }
  }
}
    `;
export type AddUserBadgeMutationFn = Apollo.MutationFunction<Types.AddUserBadgeMutation, Types.AddUserBadgeMutationVariables>;

/**
 * __useAddUserBadgeMutation__
 *
 * To run a mutation, you first call `useAddUserBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserBadgeMutation, { data, loading, error }] = useAddUserBadgeMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      badge_id: // value for 'badge_id'
 *   },
 * });
 */
export function useAddUserBadgeMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddUserBadgeMutation, Types.AddUserBadgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddUserBadgeMutation, Types.AddUserBadgeMutationVariables>(AddUserBadgeDocument, options);
      }
export type AddUserBadgeMutationHookResult = ReturnType<typeof useAddUserBadgeMutation>;
export type AddUserBadgeMutationResult = Apollo.MutationResult<Types.AddUserBadgeMutation>;
export type AddUserBadgeMutationOptions = Apollo.BaseMutationOptions<Types.AddUserBadgeMutation, Types.AddUserBadgeMutationVariables>;
export const GetBadgesDocument = gql`
    query getBadges {
  badge {
    badge_id
    name
    description
    icon_url
    criteria_type
    criteria_value
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetBadgesQuery__
 *
 * To run a query within a React component, call `useGetBadgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBadgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBadgesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBadgesQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetBadgesQuery, Types.GetBadgesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetBadgesQuery, Types.GetBadgesQueryVariables>(GetBadgesDocument, options);
      }
export function useGetBadgesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetBadgesQuery, Types.GetBadgesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetBadgesQuery, Types.GetBadgesQueryVariables>(GetBadgesDocument, options);
        }
// @ts-ignore
export function useGetBadgesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetBadgesQuery, Types.GetBadgesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetBadgesQuery, Types.GetBadgesQueryVariables>;
export function useGetBadgesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetBadgesQuery, Types.GetBadgesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetBadgesQuery | undefined, Types.GetBadgesQueryVariables>;
export function useGetBadgesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetBadgesQuery, Types.GetBadgesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetBadgesQuery, Types.GetBadgesQueryVariables>(GetBadgesDocument, options);
        }
export type GetBadgesQueryHookResult = ReturnType<typeof useGetBadgesQuery>;
export type GetBadgesLazyQueryHookResult = ReturnType<typeof useGetBadgesLazyQuery>;
export type GetBadgesSuspenseQueryHookResult = ReturnType<typeof useGetBadgesSuspenseQuery>;
export type GetBadgesQueryResult = Apollo.QueryResult<Types.GetBadgesQuery, Types.GetBadgesQueryVariables>;
export const GetBadgeByIdDocument = gql`
    query getBadgeById($badgeId: uuid!) {
  badge_by_pk(badge_id: $badgeId) {
    badge_id
    name
    description
    icon_url
    criteria_type
    criteria_value
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetBadgeByIdQuery__
 *
 * To run a query within a React component, call `useGetBadgeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBadgeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBadgeByIdQuery({
 *   variables: {
 *      badgeId: // value for 'badgeId'
 *   },
 * });
 */
export function useGetBadgeByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetBadgeByIdQuery, Types.GetBadgeByIdQueryVariables> & ({ variables: Types.GetBadgeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetBadgeByIdQuery, Types.GetBadgeByIdQueryVariables>(GetBadgeByIdDocument, options);
      }
export function useGetBadgeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetBadgeByIdQuery, Types.GetBadgeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetBadgeByIdQuery, Types.GetBadgeByIdQueryVariables>(GetBadgeByIdDocument, options);
        }
// @ts-ignore
export function useGetBadgeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetBadgeByIdQuery, Types.GetBadgeByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetBadgeByIdQuery, Types.GetBadgeByIdQueryVariables>;
export function useGetBadgeByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetBadgeByIdQuery, Types.GetBadgeByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetBadgeByIdQuery | undefined, Types.GetBadgeByIdQueryVariables>;
export function useGetBadgeByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetBadgeByIdQuery, Types.GetBadgeByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetBadgeByIdQuery, Types.GetBadgeByIdQueryVariables>(GetBadgeByIdDocument, options);
        }
export type GetBadgeByIdQueryHookResult = ReturnType<typeof useGetBadgeByIdQuery>;
export type GetBadgeByIdLazyQueryHookResult = ReturnType<typeof useGetBadgeByIdLazyQuery>;
export type GetBadgeByIdSuspenseQueryHookResult = ReturnType<typeof useGetBadgeByIdSuspenseQuery>;
export type GetBadgeByIdQueryResult = Apollo.QueryResult<Types.GetBadgeByIdQuery, Types.GetBadgeByIdQueryVariables>;
export const GetUserBadgesDocument = gql`
    query getUserBadges($userId: uuid!) {
  user_badge(where: {user_id: {_eq: $userId}}) {
    user_badge_id
    badge_id
    user_id
    badge {
      badge_id
      name
      description
      icon_url
      criteria_type
      criteria_value
    }
  }
}
    `;

/**
 * __useGetUserBadgesQuery__
 *
 * To run a query within a React component, call `useGetUserBadgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserBadgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserBadgesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserBadgesQuery(baseOptions: Apollo.QueryHookOptions<Types.GetUserBadgesQuery, Types.GetUserBadgesQueryVariables> & ({ variables: Types.GetUserBadgesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetUserBadgesQuery, Types.GetUserBadgesQueryVariables>(GetUserBadgesDocument, options);
      }
export function useGetUserBadgesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUserBadgesQuery, Types.GetUserBadgesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetUserBadgesQuery, Types.GetUserBadgesQueryVariables>(GetUserBadgesDocument, options);
        }
// @ts-ignore
export function useGetUserBadgesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetUserBadgesQuery, Types.GetUserBadgesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUserBadgesQuery, Types.GetUserBadgesQueryVariables>;
export function useGetUserBadgesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUserBadgesQuery, Types.GetUserBadgesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUserBadgesQuery | undefined, Types.GetUserBadgesQueryVariables>;
export function useGetUserBadgesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUserBadgesQuery, Types.GetUserBadgesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetUserBadgesQuery, Types.GetUserBadgesQueryVariables>(GetUserBadgesDocument, options);
        }
export type GetUserBadgesQueryHookResult = ReturnType<typeof useGetUserBadgesQuery>;
export type GetUserBadgesLazyQueryHookResult = ReturnType<typeof useGetUserBadgesLazyQuery>;
export type GetUserBadgesSuspenseQueryHookResult = ReturnType<typeof useGetUserBadgesSuspenseQuery>;
export type GetUserBadgesQueryResult = Apollo.QueryResult<Types.GetUserBadgesQuery, Types.GetUserBadgesQueryVariables>;
export const AddCampaignDocument = gql`
    mutation addCampaign($name: String, $audience_roles: [String!]!, $end_ts: timestamptz!, $frequency: String!, $org_id: uuid, $should_send_email: Boolean!, $start_ts: timestamptz!) {
  insert_campaign(
    objects: [{name: $name, audience_roles: $audience_roles, end_ts: $end_ts, frequency: $frequency, org_id: $org_id, should_send_email: $should_send_email, start_ts: $start_ts}]
  ) {
    affected_rows
    returning {
      campaign_id
    }
  }
}
    `;
export type AddCampaignMutationFn = Apollo.MutationFunction<Types.AddCampaignMutation, Types.AddCampaignMutationVariables>;

/**
 * __useAddCampaignMutation__
 *
 * To run a mutation, you first call `useAddCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCampaignMutation, { data, loading, error }] = useAddCampaignMutation({
 *   variables: {
 *      name: // value for 'name'
 *      audience_roles: // value for 'audience_roles'
 *      end_ts: // value for 'end_ts'
 *      frequency: // value for 'frequency'
 *      org_id: // value for 'org_id'
 *      should_send_email: // value for 'should_send_email'
 *      start_ts: // value for 'start_ts'
 *   },
 * });
 */
export function useAddCampaignMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddCampaignMutation, Types.AddCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddCampaignMutation, Types.AddCampaignMutationVariables>(AddCampaignDocument, options);
      }
export type AddCampaignMutationHookResult = ReturnType<typeof useAddCampaignMutation>;
export type AddCampaignMutationResult = Apollo.MutationResult<Types.AddCampaignMutation>;
export type AddCampaignMutationOptions = Apollo.BaseMutationOptions<Types.AddCampaignMutation, Types.AddCampaignMutationVariables>;
export const UpdateCampaignDocument = gql`
    mutation updateCampaign($campaign_id: uuid!, $name: String, $audience_roles: [String!]!, $end_ts: timestamptz!, $frequency: String!, $should_send_email: Boolean!, $start_ts: timestamptz!) {
  update_campaign(
    where: {campaign_id: {_eq: $campaign_id}}
    _set: {name: $name, audience_roles: $audience_roles, end_ts: $end_ts, frequency: $frequency, should_send_email: $should_send_email, start_ts: $start_ts}
  ) {
    affected_rows
  }
}
    `;
export type UpdateCampaignMutationFn = Apollo.MutationFunction<Types.UpdateCampaignMutation, Types.UpdateCampaignMutationVariables>;

/**
 * __useUpdateCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignMutation, { data, loading, error }] = useUpdateCampaignMutation({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *      name: // value for 'name'
 *      audience_roles: // value for 'audience_roles'
 *      end_ts: // value for 'end_ts'
 *      frequency: // value for 'frequency'
 *      should_send_email: // value for 'should_send_email'
 *      start_ts: // value for 'start_ts'
 *   },
 * });
 */
export function useUpdateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCampaignMutation, Types.UpdateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCampaignMutation, Types.UpdateCampaignMutationVariables>(UpdateCampaignDocument, options);
      }
export type UpdateCampaignMutationHookResult = ReturnType<typeof useUpdateCampaignMutation>;
export type UpdateCampaignMutationResult = Apollo.MutationResult<Types.UpdateCampaignMutation>;
export type UpdateCampaignMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCampaignMutation, Types.UpdateCampaignMutationVariables>;
export const DeleteCampaignDocument = gql`
    mutation deleteCampaign($campaign_id: uuid!) {
  delete_campaign(where: {campaign_id: {_eq: $campaign_id}}) {
    affected_rows
  }
}
    `;
export type DeleteCampaignMutationFn = Apollo.MutationFunction<Types.DeleteCampaignMutation, Types.DeleteCampaignMutationVariables>;

/**
 * __useDeleteCampaignMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignMutation, { data, loading, error }] = useDeleteCampaignMutation({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useDeleteCampaignMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCampaignMutation, Types.DeleteCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCampaignMutation, Types.DeleteCampaignMutationVariables>(DeleteCampaignDocument, options);
      }
export type DeleteCampaignMutationHookResult = ReturnType<typeof useDeleteCampaignMutation>;
export type DeleteCampaignMutationResult = Apollo.MutationResult<Types.DeleteCampaignMutation>;
export type DeleteCampaignMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCampaignMutation, Types.DeleteCampaignMutationVariables>;
export const AddCampaignUsersDocument = gql`
    mutation addCampaignUsers($campaign_users: [campaign_user_insert_input!]!) {
  insert_campaign_user(objects: $campaign_users) {
    affected_rows
  }
}
    `;
export type AddCampaignUsersMutationFn = Apollo.MutationFunction<Types.AddCampaignUsersMutation, Types.AddCampaignUsersMutationVariables>;

/**
 * __useAddCampaignUsersMutation__
 *
 * To run a mutation, you first call `useAddCampaignUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCampaignUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCampaignUsersMutation, { data, loading, error }] = useAddCampaignUsersMutation({
 *   variables: {
 *      campaign_users: // value for 'campaign_users'
 *   },
 * });
 */
export function useAddCampaignUsersMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddCampaignUsersMutation, Types.AddCampaignUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddCampaignUsersMutation, Types.AddCampaignUsersMutationVariables>(AddCampaignUsersDocument, options);
      }
export type AddCampaignUsersMutationHookResult = ReturnType<typeof useAddCampaignUsersMutation>;
export type AddCampaignUsersMutationResult = Apollo.MutationResult<Types.AddCampaignUsersMutation>;
export type AddCampaignUsersMutationOptions = Apollo.BaseMutationOptions<Types.AddCampaignUsersMutation, Types.AddCampaignUsersMutationVariables>;
export const DeleteCampaignUsersDocument = gql`
    mutation deleteCampaignUsers($campaign_id: uuid!) {
  delete_campaign_user(where: {campaign_id: {_eq: $campaign_id}}) {
    affected_rows
  }
}
    `;
export type DeleteCampaignUsersMutationFn = Apollo.MutationFunction<Types.DeleteCampaignUsersMutation, Types.DeleteCampaignUsersMutationVariables>;

/**
 * __useDeleteCampaignUsersMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignUsersMutation, { data, loading, error }] = useDeleteCampaignUsersMutation({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useDeleteCampaignUsersMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCampaignUsersMutation, Types.DeleteCampaignUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCampaignUsersMutation, Types.DeleteCampaignUsersMutationVariables>(DeleteCampaignUsersDocument, options);
      }
export type DeleteCampaignUsersMutationHookResult = ReturnType<typeof useDeleteCampaignUsersMutation>;
export type DeleteCampaignUsersMutationResult = Apollo.MutationResult<Types.DeleteCampaignUsersMutation>;
export type DeleteCampaignUsersMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCampaignUsersMutation, Types.DeleteCampaignUsersMutationVariables>;
export const AddCampaignSurveysDocument = gql`
    mutation addCampaignSurveys($campaign_surveys: [campaign_survey_insert_input!]!) {
  insert_campaign_survey(objects: $campaign_surveys) {
    affected_rows
  }
}
    `;
export type AddCampaignSurveysMutationFn = Apollo.MutationFunction<Types.AddCampaignSurveysMutation, Types.AddCampaignSurveysMutationVariables>;

/**
 * __useAddCampaignSurveysMutation__
 *
 * To run a mutation, you first call `useAddCampaignSurveysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCampaignSurveysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCampaignSurveysMutation, { data, loading, error }] = useAddCampaignSurveysMutation({
 *   variables: {
 *      campaign_surveys: // value for 'campaign_surveys'
 *   },
 * });
 */
export function useAddCampaignSurveysMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddCampaignSurveysMutation, Types.AddCampaignSurveysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddCampaignSurveysMutation, Types.AddCampaignSurveysMutationVariables>(AddCampaignSurveysDocument, options);
      }
export type AddCampaignSurveysMutationHookResult = ReturnType<typeof useAddCampaignSurveysMutation>;
export type AddCampaignSurveysMutationResult = Apollo.MutationResult<Types.AddCampaignSurveysMutation>;
export type AddCampaignSurveysMutationOptions = Apollo.BaseMutationOptions<Types.AddCampaignSurveysMutation, Types.AddCampaignSurveysMutationVariables>;
export const DeleteCampaignSurveysDocument = gql`
    mutation deleteCampaignSurveys($campaign_id: uuid!) {
  delete_campaign_survey(where: {campaign_id: {_eq: $campaign_id}}) {
    affected_rows
  }
}
    `;
export type DeleteCampaignSurveysMutationFn = Apollo.MutationFunction<Types.DeleteCampaignSurveysMutation, Types.DeleteCampaignSurveysMutationVariables>;

/**
 * __useDeleteCampaignSurveysMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignSurveysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignSurveysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignSurveysMutation, { data, loading, error }] = useDeleteCampaignSurveysMutation({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useDeleteCampaignSurveysMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCampaignSurveysMutation, Types.DeleteCampaignSurveysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCampaignSurveysMutation, Types.DeleteCampaignSurveysMutationVariables>(DeleteCampaignSurveysDocument, options);
      }
export type DeleteCampaignSurveysMutationHookResult = ReturnType<typeof useDeleteCampaignSurveysMutation>;
export type DeleteCampaignSurveysMutationResult = Apollo.MutationResult<Types.DeleteCampaignSurveysMutation>;
export type DeleteCampaignSurveysMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCampaignSurveysMutation, Types.DeleteCampaignSurveysMutationVariables>;
export const GetCampaignsDocument = gql`
    query getCampaigns {
  campaign {
    campaign_id
    name
    audience_roles
    created_at
    end_ts
    frequency
    org_id
    should_send_email
    start_ts
    updated_at
    users {
      user_id
      user {
        name
        email
        role
      }
    }
    surveys {
      survey {
        name
        survey_id
      }
      survey_id
    }
  }
}
    `;

/**
 * __useGetCampaignsQuery__
 *
 * To run a query within a React component, call `useGetCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetCampaignsQuery, Types.GetCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetCampaignsQuery, Types.GetCampaignsQueryVariables>(GetCampaignsDocument, options);
      }
export function useGetCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetCampaignsQuery, Types.GetCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetCampaignsQuery, Types.GetCampaignsQueryVariables>(GetCampaignsDocument, options);
        }
// @ts-ignore
export function useGetCampaignsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetCampaignsQuery, Types.GetCampaignsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetCampaignsQuery, Types.GetCampaignsQueryVariables>;
export function useGetCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetCampaignsQuery, Types.GetCampaignsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetCampaignsQuery | undefined, Types.GetCampaignsQueryVariables>;
export function useGetCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetCampaignsQuery, Types.GetCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetCampaignsQuery, Types.GetCampaignsQueryVariables>(GetCampaignsDocument, options);
        }
export type GetCampaignsQueryHookResult = ReturnType<typeof useGetCampaignsQuery>;
export type GetCampaignsLazyQueryHookResult = ReturnType<typeof useGetCampaignsLazyQuery>;
export type GetCampaignsSuspenseQueryHookResult = ReturnType<typeof useGetCampaignsSuspenseQuery>;
export type GetCampaignsQueryResult = Apollo.QueryResult<Types.GetCampaignsQuery, Types.GetCampaignsQueryVariables>;
export const GetCampaignByIdDocument = gql`
    query getCampaignById($campaignId: uuid!) {
  campaign_by_pk(campaign_id: $campaignId) {
    campaign_id
    name
    audience_roles
    created_at
    end_ts
    frequency
    org_id
    should_send_email
    start_ts
    updated_at
    users {
      user_id
      user {
        name
        email
        role
      }
    }
    surveys {
      survey {
        name
        survey_id
      }
      survey_id
    }
  }
}
    `;

/**
 * __useGetCampaignByIdQuery__
 *
 * To run a query within a React component, call `useGetCampaignByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignByIdQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetCampaignByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetCampaignByIdQuery, Types.GetCampaignByIdQueryVariables> & ({ variables: Types.GetCampaignByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetCampaignByIdQuery, Types.GetCampaignByIdQueryVariables>(GetCampaignByIdDocument, options);
      }
export function useGetCampaignByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetCampaignByIdQuery, Types.GetCampaignByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetCampaignByIdQuery, Types.GetCampaignByIdQueryVariables>(GetCampaignByIdDocument, options);
        }
// @ts-ignore
export function useGetCampaignByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetCampaignByIdQuery, Types.GetCampaignByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetCampaignByIdQuery, Types.GetCampaignByIdQueryVariables>;
export function useGetCampaignByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetCampaignByIdQuery, Types.GetCampaignByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetCampaignByIdQuery | undefined, Types.GetCampaignByIdQueryVariables>;
export function useGetCampaignByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetCampaignByIdQuery, Types.GetCampaignByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetCampaignByIdQuery, Types.GetCampaignByIdQueryVariables>(GetCampaignByIdDocument, options);
        }
export type GetCampaignByIdQueryHookResult = ReturnType<typeof useGetCampaignByIdQuery>;
export type GetCampaignByIdLazyQueryHookResult = ReturnType<typeof useGetCampaignByIdLazyQuery>;
export type GetCampaignByIdSuspenseQueryHookResult = ReturnType<typeof useGetCampaignByIdSuspenseQuery>;
export type GetCampaignByIdQueryResult = Apollo.QueryResult<Types.GetCampaignByIdQuery, Types.GetCampaignByIdQueryVariables>;
export const GetCampaignsByOrgIdDocument = gql`
    query getCampaignsByOrgId($orgId: uuid!) {
  campaign(where: {org_id: {_eq: $orgId}}) {
    campaign_id
    name
    audience_roles
    created_at
    end_ts
    frequency
    org_id
    should_send_email
    start_ts
    updated_at
    users {
      user_id
      user {
        name
        email
        role
      }
    }
    surveys {
      survey {
        name
        survey_id
      }
      survey_id
    }
  }
}
    `;

/**
 * __useGetCampaignsByOrgIdQuery__
 *
 * To run a query within a React component, call `useGetCampaignsByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignsByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignsByOrgIdQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetCampaignsByOrgIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetCampaignsByOrgIdQuery, Types.GetCampaignsByOrgIdQueryVariables> & ({ variables: Types.GetCampaignsByOrgIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetCampaignsByOrgIdQuery, Types.GetCampaignsByOrgIdQueryVariables>(GetCampaignsByOrgIdDocument, options);
      }
export function useGetCampaignsByOrgIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetCampaignsByOrgIdQuery, Types.GetCampaignsByOrgIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetCampaignsByOrgIdQuery, Types.GetCampaignsByOrgIdQueryVariables>(GetCampaignsByOrgIdDocument, options);
        }
// @ts-ignore
export function useGetCampaignsByOrgIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetCampaignsByOrgIdQuery, Types.GetCampaignsByOrgIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetCampaignsByOrgIdQuery, Types.GetCampaignsByOrgIdQueryVariables>;
export function useGetCampaignsByOrgIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetCampaignsByOrgIdQuery, Types.GetCampaignsByOrgIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetCampaignsByOrgIdQuery | undefined, Types.GetCampaignsByOrgIdQueryVariables>;
export function useGetCampaignsByOrgIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetCampaignsByOrgIdQuery, Types.GetCampaignsByOrgIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetCampaignsByOrgIdQuery, Types.GetCampaignsByOrgIdQueryVariables>(GetCampaignsByOrgIdDocument, options);
        }
export type GetCampaignsByOrgIdQueryHookResult = ReturnType<typeof useGetCampaignsByOrgIdQuery>;
export type GetCampaignsByOrgIdLazyQueryHookResult = ReturnType<typeof useGetCampaignsByOrgIdLazyQuery>;
export type GetCampaignsByOrgIdSuspenseQueryHookResult = ReturnType<typeof useGetCampaignsByOrgIdSuspenseQuery>;
export type GetCampaignsByOrgIdQueryResult = Apollo.QueryResult<Types.GetCampaignsByOrgIdQuery, Types.GetCampaignsByOrgIdQueryVariables>;
export const GetUserCampaignsDocument = gql`
    query getUserCampaigns($userId: uuid!) {
  campaign_user(where: {user_id: {_eq: $userId}}) {
    campaign_user_id
    campaign_id
    user_id
    campaign {
      campaign_id
      name
      audience_roles
      created_at
      end_ts
      frequency
      org_id
      should_send_email
      start_ts
      updated_at
      surveys {
        survey {
          name
          survey_id
        }
        survey_id
      }
    }
  }
}
    `;

/**
 * __useGetUserCampaignsQuery__
 *
 * To run a query within a React component, call `useGetUserCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCampaignsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserCampaignsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetUserCampaignsQuery, Types.GetUserCampaignsQueryVariables> & ({ variables: Types.GetUserCampaignsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetUserCampaignsQuery, Types.GetUserCampaignsQueryVariables>(GetUserCampaignsDocument, options);
      }
export function useGetUserCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUserCampaignsQuery, Types.GetUserCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetUserCampaignsQuery, Types.GetUserCampaignsQueryVariables>(GetUserCampaignsDocument, options);
        }
// @ts-ignore
export function useGetUserCampaignsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetUserCampaignsQuery, Types.GetUserCampaignsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUserCampaignsQuery, Types.GetUserCampaignsQueryVariables>;
export function useGetUserCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUserCampaignsQuery, Types.GetUserCampaignsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUserCampaignsQuery | undefined, Types.GetUserCampaignsQueryVariables>;
export function useGetUserCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUserCampaignsQuery, Types.GetUserCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetUserCampaignsQuery, Types.GetUserCampaignsQueryVariables>(GetUserCampaignsDocument, options);
        }
export type GetUserCampaignsQueryHookResult = ReturnType<typeof useGetUserCampaignsQuery>;
export type GetUserCampaignsLazyQueryHookResult = ReturnType<typeof useGetUserCampaignsLazyQuery>;
export type GetUserCampaignsSuspenseQueryHookResult = ReturnType<typeof useGetUserCampaignsSuspenseQuery>;
export type GetUserCampaignsQueryResult = Apollo.QueryResult<Types.GetUserCampaignsQuery, Types.GetUserCampaignsQueryVariables>;
export const CreateChatWithParticipantsDocument = gql`
    mutation createChatWithParticipants($title: String!, $userId1: uuid!, $userId2: uuid!) {
  insert_chat_one(
    object: {title: $title, chat_users: {data: [{user_id: $userId1}, {user_id: $userId2}]}}
  ) {
    chat_id
    title
    created_at
    updated_at
  }
}
    `;
export type CreateChatWithParticipantsMutationFn = Apollo.MutationFunction<Types.CreateChatWithParticipantsMutation, Types.CreateChatWithParticipantsMutationVariables>;

/**
 * __useCreateChatWithParticipantsMutation__
 *
 * To run a mutation, you first call `useCreateChatWithParticipantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatWithParticipantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatWithParticipantsMutation, { data, loading, error }] = useCreateChatWithParticipantsMutation({
 *   variables: {
 *      title: // value for 'title'
 *      userId1: // value for 'userId1'
 *      userId2: // value for 'userId2'
 *   },
 * });
 */
export function useCreateChatWithParticipantsMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateChatWithParticipantsMutation, Types.CreateChatWithParticipantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateChatWithParticipantsMutation, Types.CreateChatWithParticipantsMutationVariables>(CreateChatWithParticipantsDocument, options);
      }
export type CreateChatWithParticipantsMutationHookResult = ReturnType<typeof useCreateChatWithParticipantsMutation>;
export type CreateChatWithParticipantsMutationResult = Apollo.MutationResult<Types.CreateChatWithParticipantsMutation>;
export type CreateChatWithParticipantsMutationOptions = Apollo.BaseMutationOptions<Types.CreateChatWithParticipantsMutation, Types.CreateChatWithParticipantsMutationVariables>;
export const InsertChatDocument = gql`
    mutation insertChat($object: chat_insert_input!) {
  insert_chat_one(object: $object) {
    chat_id
    title
    created_at
    updated_at
  }
}
    `;
export type InsertChatMutationFn = Apollo.MutationFunction<Types.InsertChatMutation, Types.InsertChatMutationVariables>;

/**
 * __useInsertChatMutation__
 *
 * To run a mutation, you first call `useInsertChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertChatMutation, { data, loading, error }] = useInsertChatMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertChatMutation(baseOptions?: Apollo.MutationHookOptions<Types.InsertChatMutation, Types.InsertChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.InsertChatMutation, Types.InsertChatMutationVariables>(InsertChatDocument, options);
      }
export type InsertChatMutationHookResult = ReturnType<typeof useInsertChatMutation>;
export type InsertChatMutationResult = Apollo.MutationResult<Types.InsertChatMutation>;
export type InsertChatMutationOptions = Apollo.BaseMutationOptions<Types.InsertChatMutation, Types.InsertChatMutationVariables>;
export const InsertChatMessageDocument = gql`
    mutation insertChatMessage($object: chat_message_insert_input!) {
  insert_chat_message_one(object: $object) {
    chat_message_id
    chat_id
    message
    created_at
    user_id
  }
}
    `;
export type InsertChatMessageMutationFn = Apollo.MutationFunction<Types.InsertChatMessageMutation, Types.InsertChatMessageMutationVariables>;

/**
 * __useInsertChatMessageMutation__
 *
 * To run a mutation, you first call `useInsertChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertChatMessageMutation, { data, loading, error }] = useInsertChatMessageMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<Types.InsertChatMessageMutation, Types.InsertChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.InsertChatMessageMutation, Types.InsertChatMessageMutationVariables>(InsertChatMessageDocument, options);
      }
export type InsertChatMessageMutationHookResult = ReturnType<typeof useInsertChatMessageMutation>;
export type InsertChatMessageMutationResult = Apollo.MutationResult<Types.InsertChatMessageMutation>;
export type InsertChatMessageMutationOptions = Apollo.BaseMutationOptions<Types.InsertChatMessageMutation, Types.InsertChatMessageMutationVariables>;
export const InsertChatUsersDocument = gql`
    mutation insertChatUsers($objects: [chat_user_insert_input!]!) {
  insert_chat_user(objects: $objects) {
    affected_rows
    returning {
      chat_user_id
      chat_id
      user_id
    }
  }
}
    `;
export type InsertChatUsersMutationFn = Apollo.MutationFunction<Types.InsertChatUsersMutation, Types.InsertChatUsersMutationVariables>;

/**
 * __useInsertChatUsersMutation__
 *
 * To run a mutation, you first call `useInsertChatUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertChatUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertChatUsersMutation, { data, loading, error }] = useInsertChatUsersMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertChatUsersMutation(baseOptions?: Apollo.MutationHookOptions<Types.InsertChatUsersMutation, Types.InsertChatUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.InsertChatUsersMutation, Types.InsertChatUsersMutationVariables>(InsertChatUsersDocument, options);
      }
export type InsertChatUsersMutationHookResult = ReturnType<typeof useInsertChatUsersMutation>;
export type InsertChatUsersMutationResult = Apollo.MutationResult<Types.InsertChatUsersMutation>;
export type InsertChatUsersMutationOptions = Apollo.BaseMutationOptions<Types.InsertChatUsersMutation, Types.InsertChatUsersMutationVariables>;
export const UpdateChatByPkDocument = gql`
    mutation updateChatByPk($chatId: uuid!, $set: chat_set_input!) {
  update_chat_by_pk(pk_columns: {chat_id: $chatId}, _set: $set) {
    chat_id
    updated_at
    viewed_at
  }
}
    `;
export type UpdateChatByPkMutationFn = Apollo.MutationFunction<Types.UpdateChatByPkMutation, Types.UpdateChatByPkMutationVariables>;

/**
 * __useUpdateChatByPkMutation__
 *
 * To run a mutation, you first call `useUpdateChatByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatByPkMutation, { data, loading, error }] = useUpdateChatByPkMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdateChatByPkMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateChatByPkMutation, Types.UpdateChatByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateChatByPkMutation, Types.UpdateChatByPkMutationVariables>(UpdateChatByPkDocument, options);
      }
export type UpdateChatByPkMutationHookResult = ReturnType<typeof useUpdateChatByPkMutation>;
export type UpdateChatByPkMutationResult = Apollo.MutationResult<Types.UpdateChatByPkMutation>;
export type UpdateChatByPkMutationOptions = Apollo.BaseMutationOptions<Types.UpdateChatByPkMutation, Types.UpdateChatByPkMutationVariables>;
export const UpdateChatMessageByPkDocument = gql`
    mutation updateChatMessageByPk($chatMessageId: uuid!, $set: chat_message_set_input!) {
  update_chat_message_by_pk(
    pk_columns: {chat_message_id: $chatMessageId}
    _set: $set
  ) {
    chat_message_id
    message
    viewed_at
    updated_at
  }
}
    `;
export type UpdateChatMessageByPkMutationFn = Apollo.MutationFunction<Types.UpdateChatMessageByPkMutation, Types.UpdateChatMessageByPkMutationVariables>;

/**
 * __useUpdateChatMessageByPkMutation__
 *
 * To run a mutation, you first call `useUpdateChatMessageByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatMessageByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatMessageByPkMutation, { data, loading, error }] = useUpdateChatMessageByPkMutation({
 *   variables: {
 *      chatMessageId: // value for 'chatMessageId'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdateChatMessageByPkMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateChatMessageByPkMutation, Types.UpdateChatMessageByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateChatMessageByPkMutation, Types.UpdateChatMessageByPkMutationVariables>(UpdateChatMessageByPkDocument, options);
      }
export type UpdateChatMessageByPkMutationHookResult = ReturnType<typeof useUpdateChatMessageByPkMutation>;
export type UpdateChatMessageByPkMutationResult = Apollo.MutationResult<Types.UpdateChatMessageByPkMutation>;
export type UpdateChatMessageByPkMutationOptions = Apollo.BaseMutationOptions<Types.UpdateChatMessageByPkMutation, Types.UpdateChatMessageByPkMutationVariables>;
export const DeleteChatByPkDocument = gql`
    mutation deleteChatByPk($chatId: uuid!) {
  delete_chat_by_pk(chat_id: $chatId) {
    chat_id
  }
}
    `;
export type DeleteChatByPkMutationFn = Apollo.MutationFunction<Types.DeleteChatByPkMutation, Types.DeleteChatByPkMutationVariables>;

/**
 * __useDeleteChatByPkMutation__
 *
 * To run a mutation, you first call `useDeleteChatByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChatByPkMutation, { data, loading, error }] = useDeleteChatByPkMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useDeleteChatByPkMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteChatByPkMutation, Types.DeleteChatByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteChatByPkMutation, Types.DeleteChatByPkMutationVariables>(DeleteChatByPkDocument, options);
      }
export type DeleteChatByPkMutationHookResult = ReturnType<typeof useDeleteChatByPkMutation>;
export type DeleteChatByPkMutationResult = Apollo.MutationResult<Types.DeleteChatByPkMutation>;
export type DeleteChatByPkMutationOptions = Apollo.BaseMutationOptions<Types.DeleteChatByPkMutation, Types.DeleteChatByPkMutationVariables>;
export const DeleteChatMessageByPkDocument = gql`
    mutation deleteChatMessageByPk($chatMessageId: uuid!) {
  delete_chat_message_by_pk(chat_message_id: $chatMessageId) {
    chat_message_id
  }
}
    `;
export type DeleteChatMessageByPkMutationFn = Apollo.MutationFunction<Types.DeleteChatMessageByPkMutation, Types.DeleteChatMessageByPkMutationVariables>;

/**
 * __useDeleteChatMessageByPkMutation__
 *
 * To run a mutation, you first call `useDeleteChatMessageByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatMessageByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChatMessageByPkMutation, { data, loading, error }] = useDeleteChatMessageByPkMutation({
 *   variables: {
 *      chatMessageId: // value for 'chatMessageId'
 *   },
 * });
 */
export function useDeleteChatMessageByPkMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteChatMessageByPkMutation, Types.DeleteChatMessageByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteChatMessageByPkMutation, Types.DeleteChatMessageByPkMutationVariables>(DeleteChatMessageByPkDocument, options);
      }
export type DeleteChatMessageByPkMutationHookResult = ReturnType<typeof useDeleteChatMessageByPkMutation>;
export type DeleteChatMessageByPkMutationResult = Apollo.MutationResult<Types.DeleteChatMessageByPkMutation>;
export type DeleteChatMessageByPkMutationOptions = Apollo.BaseMutationOptions<Types.DeleteChatMessageByPkMutation, Types.DeleteChatMessageByPkMutationVariables>;
export const DeleteChatUserByPkDocument = gql`
    mutation deleteChatUserByPk($chatUserId: uuid!) {
  delete_chat_user_by_pk(chat_user_id: $chatUserId) {
    chat_user_id
  }
}
    `;
export type DeleteChatUserByPkMutationFn = Apollo.MutationFunction<Types.DeleteChatUserByPkMutation, Types.DeleteChatUserByPkMutationVariables>;

/**
 * __useDeleteChatUserByPkMutation__
 *
 * To run a mutation, you first call `useDeleteChatUserByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatUserByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChatUserByPkMutation, { data, loading, error }] = useDeleteChatUserByPkMutation({
 *   variables: {
 *      chatUserId: // value for 'chatUserId'
 *   },
 * });
 */
export function useDeleteChatUserByPkMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteChatUserByPkMutation, Types.DeleteChatUserByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteChatUserByPkMutation, Types.DeleteChatUserByPkMutationVariables>(DeleteChatUserByPkDocument, options);
      }
export type DeleteChatUserByPkMutationHookResult = ReturnType<typeof useDeleteChatUserByPkMutation>;
export type DeleteChatUserByPkMutationResult = Apollo.MutationResult<Types.DeleteChatUserByPkMutation>;
export type DeleteChatUserByPkMutationOptions = Apollo.BaseMutationOptions<Types.DeleteChatUserByPkMutation, Types.DeleteChatUserByPkMutationVariables>;
export const GetChatsForUserDocument = gql`
    query getChatsForUser($userId: uuid!) {
  chat(
    where: {chat_users: {user_id: {_eq: $userId}}}
    order_by: {chat_messages_aggregate: {max: {created_at: desc_nulls_last}}}
  ) {
    chat_id
    title
    created_at
    updated_at
    viewed_at
    chat_users {
      chat_user_id
      user_id
    }
  }
}
    `;

/**
 * __useGetChatsForUserQuery__
 *
 * To run a query within a React component, call `useGetChatsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatsForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetChatsForUserQuery(baseOptions: Apollo.QueryHookOptions<Types.GetChatsForUserQuery, Types.GetChatsForUserQueryVariables> & ({ variables: Types.GetChatsForUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetChatsForUserQuery, Types.GetChatsForUserQueryVariables>(GetChatsForUserDocument, options);
      }
export function useGetChatsForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetChatsForUserQuery, Types.GetChatsForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetChatsForUserQuery, Types.GetChatsForUserQueryVariables>(GetChatsForUserDocument, options);
        }
// @ts-ignore
export function useGetChatsForUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetChatsForUserQuery, Types.GetChatsForUserQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetChatsForUserQuery, Types.GetChatsForUserQueryVariables>;
export function useGetChatsForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetChatsForUserQuery, Types.GetChatsForUserQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetChatsForUserQuery | undefined, Types.GetChatsForUserQueryVariables>;
export function useGetChatsForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetChatsForUserQuery, Types.GetChatsForUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetChatsForUserQuery, Types.GetChatsForUserQueryVariables>(GetChatsForUserDocument, options);
        }
export type GetChatsForUserQueryHookResult = ReturnType<typeof useGetChatsForUserQuery>;
export type GetChatsForUserLazyQueryHookResult = ReturnType<typeof useGetChatsForUserLazyQuery>;
export type GetChatsForUserSuspenseQueryHookResult = ReturnType<typeof useGetChatsForUserSuspenseQuery>;
export type GetChatsForUserQueryResult = Apollo.QueryResult<Types.GetChatsForUserQuery, Types.GetChatsForUserQueryVariables>;
export const GetChatByIdDocument = gql`
    query getChatById($chatId: uuid!) {
  chat_by_pk(chat_id: $chatId) {
    chat_id
    title
    created_at
    updated_at
    viewed_at
    chat_users {
      chat_user_id
      user_id
    }
  }
}
    `;

/**
 * __useGetChatByIdQuery__
 *
 * To run a query within a React component, call `useGetChatByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatByIdQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useGetChatByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetChatByIdQuery, Types.GetChatByIdQueryVariables> & ({ variables: Types.GetChatByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetChatByIdQuery, Types.GetChatByIdQueryVariables>(GetChatByIdDocument, options);
      }
export function useGetChatByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetChatByIdQuery, Types.GetChatByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetChatByIdQuery, Types.GetChatByIdQueryVariables>(GetChatByIdDocument, options);
        }
// @ts-ignore
export function useGetChatByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetChatByIdQuery, Types.GetChatByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetChatByIdQuery, Types.GetChatByIdQueryVariables>;
export function useGetChatByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetChatByIdQuery, Types.GetChatByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetChatByIdQuery | undefined, Types.GetChatByIdQueryVariables>;
export function useGetChatByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetChatByIdQuery, Types.GetChatByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetChatByIdQuery, Types.GetChatByIdQueryVariables>(GetChatByIdDocument, options);
        }
export type GetChatByIdQueryHookResult = ReturnType<typeof useGetChatByIdQuery>;
export type GetChatByIdLazyQueryHookResult = ReturnType<typeof useGetChatByIdLazyQuery>;
export type GetChatByIdSuspenseQueryHookResult = ReturnType<typeof useGetChatByIdSuspenseQuery>;
export type GetChatByIdQueryResult = Apollo.QueryResult<Types.GetChatByIdQuery, Types.GetChatByIdQueryVariables>;
export const GetChatMessagesDocument = gql`
    query getChatMessages($chatId: uuid!) {
  chat_message(where: {chat_id: {_eq: $chatId}}, order_by: {created_at: asc}) {
    chat_message_id
    chat_id
    message
    created_at
    updated_at
    viewed_at
    user_id
    user {
      user_id
      name
      email
      picture_url
    }
  }
}
    `;

/**
 * __useGetChatMessagesQuery__
 *
 * To run a query within a React component, call `useGetChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatMessagesQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useGetChatMessagesQuery(baseOptions: Apollo.QueryHookOptions<Types.GetChatMessagesQuery, Types.GetChatMessagesQueryVariables> & ({ variables: Types.GetChatMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetChatMessagesQuery, Types.GetChatMessagesQueryVariables>(GetChatMessagesDocument, options);
      }
export function useGetChatMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetChatMessagesQuery, Types.GetChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetChatMessagesQuery, Types.GetChatMessagesQueryVariables>(GetChatMessagesDocument, options);
        }
// @ts-ignore
export function useGetChatMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetChatMessagesQuery, Types.GetChatMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetChatMessagesQuery, Types.GetChatMessagesQueryVariables>;
export function useGetChatMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetChatMessagesQuery, Types.GetChatMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetChatMessagesQuery | undefined, Types.GetChatMessagesQueryVariables>;
export function useGetChatMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetChatMessagesQuery, Types.GetChatMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetChatMessagesQuery, Types.GetChatMessagesQueryVariables>(GetChatMessagesDocument, options);
        }
export type GetChatMessagesQueryHookResult = ReturnType<typeof useGetChatMessagesQuery>;
export type GetChatMessagesLazyQueryHookResult = ReturnType<typeof useGetChatMessagesLazyQuery>;
export type GetChatMessagesSuspenseQueryHookResult = ReturnType<typeof useGetChatMessagesSuspenseQuery>;
export type GetChatMessagesQueryResult = Apollo.QueryResult<Types.GetChatMessagesQuery, Types.GetChatMessagesQueryVariables>;
export const GetChatUnreadMessageCountDocument = gql`
    query getChatUnreadMessageCount($chatId: uuid!, $userId: uuid!, $after: timestamptz!) {
  chat_message(
    where: {chat_id: {_eq: $chatId}, user_id: {_neq: $userId}, created_at: {_gt: $after}}
    limit: 1000
  ) {
    chat_message_id
  }
}
    `;

/**
 * __useGetChatUnreadMessageCountQuery__
 *
 * To run a query within a React component, call `useGetChatUnreadMessageCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatUnreadMessageCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatUnreadMessageCountQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      userId: // value for 'userId'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetChatUnreadMessageCountQuery(baseOptions: Apollo.QueryHookOptions<Types.GetChatUnreadMessageCountQuery, Types.GetChatUnreadMessageCountQueryVariables> & ({ variables: Types.GetChatUnreadMessageCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetChatUnreadMessageCountQuery, Types.GetChatUnreadMessageCountQueryVariables>(GetChatUnreadMessageCountDocument, options);
      }
export function useGetChatUnreadMessageCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetChatUnreadMessageCountQuery, Types.GetChatUnreadMessageCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetChatUnreadMessageCountQuery, Types.GetChatUnreadMessageCountQueryVariables>(GetChatUnreadMessageCountDocument, options);
        }
// @ts-ignore
export function useGetChatUnreadMessageCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetChatUnreadMessageCountQuery, Types.GetChatUnreadMessageCountQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetChatUnreadMessageCountQuery, Types.GetChatUnreadMessageCountQueryVariables>;
export function useGetChatUnreadMessageCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetChatUnreadMessageCountQuery, Types.GetChatUnreadMessageCountQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetChatUnreadMessageCountQuery | undefined, Types.GetChatUnreadMessageCountQueryVariables>;
export function useGetChatUnreadMessageCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetChatUnreadMessageCountQuery, Types.GetChatUnreadMessageCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetChatUnreadMessageCountQuery, Types.GetChatUnreadMessageCountQueryVariables>(GetChatUnreadMessageCountDocument, options);
        }
export type GetChatUnreadMessageCountQueryHookResult = ReturnType<typeof useGetChatUnreadMessageCountQuery>;
export type GetChatUnreadMessageCountLazyQueryHookResult = ReturnType<typeof useGetChatUnreadMessageCountLazyQuery>;
export type GetChatUnreadMessageCountSuspenseQueryHookResult = ReturnType<typeof useGetChatUnreadMessageCountSuspenseQuery>;
export type GetChatUnreadMessageCountQueryResult = Apollo.QueryResult<Types.GetChatUnreadMessageCountQuery, Types.GetChatUnreadMessageCountQueryVariables>;
export const GetUserOrgScopeForChatDocument = gql`
    query getUserOrgScopeForChat($userId: uuid!) {
  membership_orgs: organization_user(where: {user_id: {_eq: $userId}}) {
    org_id
  }
  grad_class_orgs: graduation_class(
    where: {students: {student_id: {_eq: $userId}}}
  ) {
    program {
      org_id
    }
  }
}
    `;

/**
 * __useGetUserOrgScopeForChatQuery__
 *
 * To run a query within a React component, call `useGetUserOrgScopeForChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOrgScopeForChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOrgScopeForChatQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserOrgScopeForChatQuery(baseOptions: Apollo.QueryHookOptions<Types.GetUserOrgScopeForChatQuery, Types.GetUserOrgScopeForChatQueryVariables> & ({ variables: Types.GetUserOrgScopeForChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetUserOrgScopeForChatQuery, Types.GetUserOrgScopeForChatQueryVariables>(GetUserOrgScopeForChatDocument, options);
      }
export function useGetUserOrgScopeForChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUserOrgScopeForChatQuery, Types.GetUserOrgScopeForChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetUserOrgScopeForChatQuery, Types.GetUserOrgScopeForChatQueryVariables>(GetUserOrgScopeForChatDocument, options);
        }
// @ts-ignore
export function useGetUserOrgScopeForChatSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetUserOrgScopeForChatQuery, Types.GetUserOrgScopeForChatQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUserOrgScopeForChatQuery, Types.GetUserOrgScopeForChatQueryVariables>;
export function useGetUserOrgScopeForChatSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUserOrgScopeForChatQuery, Types.GetUserOrgScopeForChatQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUserOrgScopeForChatQuery | undefined, Types.GetUserOrgScopeForChatQueryVariables>;
export function useGetUserOrgScopeForChatSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUserOrgScopeForChatQuery, Types.GetUserOrgScopeForChatQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetUserOrgScopeForChatQuery, Types.GetUserOrgScopeForChatQueryVariables>(GetUserOrgScopeForChatDocument, options);
        }
export type GetUserOrgScopeForChatQueryHookResult = ReturnType<typeof useGetUserOrgScopeForChatQuery>;
export type GetUserOrgScopeForChatLazyQueryHookResult = ReturnType<typeof useGetUserOrgScopeForChatLazyQuery>;
export type GetUserOrgScopeForChatSuspenseQueryHookResult = ReturnType<typeof useGetUserOrgScopeForChatSuspenseQuery>;
export type GetUserOrgScopeForChatQueryResult = Apollo.QueryResult<Types.GetUserOrgScopeForChatQuery, Types.GetUserOrgScopeForChatQueryVariables>;
export const GetLearnersByOrgIdsDocument = gql`
    query getLearnersByOrgIds($orgIds: [uuid!]!) {
  graduation_class(where: {program: {org_id: {_in: $orgIds}}}) {
    graduation_class_id
    name
    students {
      student {
        user_id
        email
        role
        name
        picture_url
      }
    }
  }
}
    `;

/**
 * __useGetLearnersByOrgIdsQuery__
 *
 * To run a query within a React component, call `useGetLearnersByOrgIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearnersByOrgIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearnersByOrgIdsQuery({
 *   variables: {
 *      orgIds: // value for 'orgIds'
 *   },
 * });
 */
export function useGetLearnersByOrgIdsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetLearnersByOrgIdsQuery, Types.GetLearnersByOrgIdsQueryVariables> & ({ variables: Types.GetLearnersByOrgIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetLearnersByOrgIdsQuery, Types.GetLearnersByOrgIdsQueryVariables>(GetLearnersByOrgIdsDocument, options);
      }
export function useGetLearnersByOrgIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetLearnersByOrgIdsQuery, Types.GetLearnersByOrgIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetLearnersByOrgIdsQuery, Types.GetLearnersByOrgIdsQueryVariables>(GetLearnersByOrgIdsDocument, options);
        }
// @ts-ignore
export function useGetLearnersByOrgIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetLearnersByOrgIdsQuery, Types.GetLearnersByOrgIdsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetLearnersByOrgIdsQuery, Types.GetLearnersByOrgIdsQueryVariables>;
export function useGetLearnersByOrgIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetLearnersByOrgIdsQuery, Types.GetLearnersByOrgIdsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetLearnersByOrgIdsQuery | undefined, Types.GetLearnersByOrgIdsQueryVariables>;
export function useGetLearnersByOrgIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetLearnersByOrgIdsQuery, Types.GetLearnersByOrgIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetLearnersByOrgIdsQuery, Types.GetLearnersByOrgIdsQueryVariables>(GetLearnersByOrgIdsDocument, options);
        }
export type GetLearnersByOrgIdsQueryHookResult = ReturnType<typeof useGetLearnersByOrgIdsQuery>;
export type GetLearnersByOrgIdsLazyQueryHookResult = ReturnType<typeof useGetLearnersByOrgIdsLazyQuery>;
export type GetLearnersByOrgIdsSuspenseQueryHookResult = ReturnType<typeof useGetLearnersByOrgIdsSuspenseQuery>;
export type GetLearnersByOrgIdsQueryResult = Apollo.QueryResult<Types.GetLearnersByOrgIdsQuery, Types.GetLearnersByOrgIdsQueryVariables>;
export const GetCoachesByOrgIdsDocument = gql`
    query getCoachesByOrgIds($orgIds: [uuid!]!) {
  organization_user(where: {org_id: {_in: $orgIds}, user: {role: {_eq: "coach"}}}) {
    org_id
    user {
      user_id
      email
      role
      name
      picture_url
    }
  }
}
    `;

/**
 * __useGetCoachesByOrgIdsQuery__
 *
 * To run a query within a React component, call `useGetCoachesByOrgIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachesByOrgIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachesByOrgIdsQuery({
 *   variables: {
 *      orgIds: // value for 'orgIds'
 *   },
 * });
 */
export function useGetCoachesByOrgIdsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetCoachesByOrgIdsQuery, Types.GetCoachesByOrgIdsQueryVariables> & ({ variables: Types.GetCoachesByOrgIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetCoachesByOrgIdsQuery, Types.GetCoachesByOrgIdsQueryVariables>(GetCoachesByOrgIdsDocument, options);
      }
export function useGetCoachesByOrgIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetCoachesByOrgIdsQuery, Types.GetCoachesByOrgIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetCoachesByOrgIdsQuery, Types.GetCoachesByOrgIdsQueryVariables>(GetCoachesByOrgIdsDocument, options);
        }
// @ts-ignore
export function useGetCoachesByOrgIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetCoachesByOrgIdsQuery, Types.GetCoachesByOrgIdsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetCoachesByOrgIdsQuery, Types.GetCoachesByOrgIdsQueryVariables>;
export function useGetCoachesByOrgIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetCoachesByOrgIdsQuery, Types.GetCoachesByOrgIdsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetCoachesByOrgIdsQuery | undefined, Types.GetCoachesByOrgIdsQueryVariables>;
export function useGetCoachesByOrgIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetCoachesByOrgIdsQuery, Types.GetCoachesByOrgIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetCoachesByOrgIdsQuery, Types.GetCoachesByOrgIdsQueryVariables>(GetCoachesByOrgIdsDocument, options);
        }
export type GetCoachesByOrgIdsQueryHookResult = ReturnType<typeof useGetCoachesByOrgIdsQuery>;
export type GetCoachesByOrgIdsLazyQueryHookResult = ReturnType<typeof useGetCoachesByOrgIdsLazyQuery>;
export type GetCoachesByOrgIdsSuspenseQueryHookResult = ReturnType<typeof useGetCoachesByOrgIdsSuspenseQuery>;
export type GetCoachesByOrgIdsQueryResult = Apollo.QueryResult<Types.GetCoachesByOrgIdsQuery, Types.GetCoachesByOrgIdsQueryVariables>;
export const AddCustomLabelsDocument = gql`
    mutation addCustomLabels($objects: [custom_label_insert_input!]!) {
  insert_custom_label(objects: $objects) {
    affected_rows
    returning {
      custom_label_id
    }
  }
}
    `;
export type AddCustomLabelsMutationFn = Apollo.MutationFunction<Types.AddCustomLabelsMutation, Types.AddCustomLabelsMutationVariables>;

/**
 * __useAddCustomLabelsMutation__
 *
 * To run a mutation, you first call `useAddCustomLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCustomLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCustomLabelsMutation, { data, loading, error }] = useAddCustomLabelsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddCustomLabelsMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddCustomLabelsMutation, Types.AddCustomLabelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddCustomLabelsMutation, Types.AddCustomLabelsMutationVariables>(AddCustomLabelsDocument, options);
      }
export type AddCustomLabelsMutationHookResult = ReturnType<typeof useAddCustomLabelsMutation>;
export type AddCustomLabelsMutationResult = Apollo.MutationResult<Types.AddCustomLabelsMutation>;
export type AddCustomLabelsMutationOptions = Apollo.BaseMutationOptions<Types.AddCustomLabelsMutation, Types.AddCustomLabelsMutationVariables>;
export const UpdateCustomLabelDocument = gql`
    mutation updateCustomLabel($id: uuid!, $custom_label: custom_label_set_input!) {
  update_custom_label(where: {custom_label_id: {_eq: $id}}, _set: $custom_label) {
    affected_rows
    returning {
      custom_label_id
    }
  }
}
    `;
export type UpdateCustomLabelMutationFn = Apollo.MutationFunction<Types.UpdateCustomLabelMutation, Types.UpdateCustomLabelMutationVariables>;

/**
 * __useUpdateCustomLabelMutation__
 *
 * To run a mutation, you first call `useUpdateCustomLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomLabelMutation, { data, loading, error }] = useUpdateCustomLabelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      custom_label: // value for 'custom_label'
 *   },
 * });
 */
export function useUpdateCustomLabelMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateCustomLabelMutation, Types.UpdateCustomLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateCustomLabelMutation, Types.UpdateCustomLabelMutationVariables>(UpdateCustomLabelDocument, options);
      }
export type UpdateCustomLabelMutationHookResult = ReturnType<typeof useUpdateCustomLabelMutation>;
export type UpdateCustomLabelMutationResult = Apollo.MutationResult<Types.UpdateCustomLabelMutation>;
export type UpdateCustomLabelMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCustomLabelMutation, Types.UpdateCustomLabelMutationVariables>;
export const DeleteCustomLabelDocument = gql`
    mutation deleteCustomLabel($id: uuid!) {
  delete_custom_label(where: {custom_label_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteCustomLabelMutationFn = Apollo.MutationFunction<Types.DeleteCustomLabelMutation, Types.DeleteCustomLabelMutationVariables>;

/**
 * __useDeleteCustomLabelMutation__
 *
 * To run a mutation, you first call `useDeleteCustomLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomLabelMutation, { data, loading, error }] = useDeleteCustomLabelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomLabelMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteCustomLabelMutation, Types.DeleteCustomLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteCustomLabelMutation, Types.DeleteCustomLabelMutationVariables>(DeleteCustomLabelDocument, options);
      }
export type DeleteCustomLabelMutationHookResult = ReturnType<typeof useDeleteCustomLabelMutation>;
export type DeleteCustomLabelMutationResult = Apollo.MutationResult<Types.DeleteCustomLabelMutation>;
export type DeleteCustomLabelMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCustomLabelMutation, Types.DeleteCustomLabelMutationVariables>;
export const GetCustomLabelsDocument = gql`
    query getCustomLabels {
  custom_label {
    custom_label_id
    type
    index
    label
  }
}
    `;

/**
 * __useGetCustomLabelsQuery__
 *
 * To run a query within a React component, call `useGetCustomLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomLabelsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetCustomLabelsQuery, Types.GetCustomLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetCustomLabelsQuery, Types.GetCustomLabelsQueryVariables>(GetCustomLabelsDocument, options);
      }
export function useGetCustomLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetCustomLabelsQuery, Types.GetCustomLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetCustomLabelsQuery, Types.GetCustomLabelsQueryVariables>(GetCustomLabelsDocument, options);
        }
// @ts-ignore
export function useGetCustomLabelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetCustomLabelsQuery, Types.GetCustomLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetCustomLabelsQuery, Types.GetCustomLabelsQueryVariables>;
export function useGetCustomLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetCustomLabelsQuery, Types.GetCustomLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetCustomLabelsQuery | undefined, Types.GetCustomLabelsQueryVariables>;
export function useGetCustomLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetCustomLabelsQuery, Types.GetCustomLabelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetCustomLabelsQuery, Types.GetCustomLabelsQueryVariables>(GetCustomLabelsDocument, options);
        }
export type GetCustomLabelsQueryHookResult = ReturnType<typeof useGetCustomLabelsQuery>;
export type GetCustomLabelsLazyQueryHookResult = ReturnType<typeof useGetCustomLabelsLazyQuery>;
export type GetCustomLabelsSuspenseQueryHookResult = ReturnType<typeof useGetCustomLabelsSuspenseQuery>;
export type GetCustomLabelsQueryResult = Apollo.QueryResult<Types.GetCustomLabelsQuery, Types.GetCustomLabelsQueryVariables>;
export const GetCustomLabelByIdDocument = gql`
    query getCustomLabelById($customLabelId: uuid!) {
  custom_label_by_pk(custom_label_id: $customLabelId) {
    custom_label_id
    type
    index
    label
  }
}
    `;

/**
 * __useGetCustomLabelByIdQuery__
 *
 * To run a query within a React component, call `useGetCustomLabelByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomLabelByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomLabelByIdQuery({
 *   variables: {
 *      customLabelId: // value for 'customLabelId'
 *   },
 * });
 */
export function useGetCustomLabelByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetCustomLabelByIdQuery, Types.GetCustomLabelByIdQueryVariables> & ({ variables: Types.GetCustomLabelByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetCustomLabelByIdQuery, Types.GetCustomLabelByIdQueryVariables>(GetCustomLabelByIdDocument, options);
      }
export function useGetCustomLabelByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetCustomLabelByIdQuery, Types.GetCustomLabelByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetCustomLabelByIdQuery, Types.GetCustomLabelByIdQueryVariables>(GetCustomLabelByIdDocument, options);
        }
// @ts-ignore
export function useGetCustomLabelByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetCustomLabelByIdQuery, Types.GetCustomLabelByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetCustomLabelByIdQuery, Types.GetCustomLabelByIdQueryVariables>;
export function useGetCustomLabelByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetCustomLabelByIdQuery, Types.GetCustomLabelByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetCustomLabelByIdQuery | undefined, Types.GetCustomLabelByIdQueryVariables>;
export function useGetCustomLabelByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetCustomLabelByIdQuery, Types.GetCustomLabelByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetCustomLabelByIdQuery, Types.GetCustomLabelByIdQueryVariables>(GetCustomLabelByIdDocument, options);
        }
export type GetCustomLabelByIdQueryHookResult = ReturnType<typeof useGetCustomLabelByIdQuery>;
export type GetCustomLabelByIdLazyQueryHookResult = ReturnType<typeof useGetCustomLabelByIdLazyQuery>;
export type GetCustomLabelByIdSuspenseQueryHookResult = ReturnType<typeof useGetCustomLabelByIdSuspenseQuery>;
export type GetCustomLabelByIdQueryResult = Apollo.QueryResult<Types.GetCustomLabelByIdQuery, Types.GetCustomLabelByIdQueryVariables>;
export const GetEngagementAnalyticsDocument = gql`
    query getEngagementAnalytics($orgIds: [uuid!]!, $sinceDate: timestamptz!, $activitySince: date!) {
  organization(where: {org_id: {_in: $orgIds}}, order_by: {name: asc}) {
    org_id
    name
  }
  users: user(where: {org_id: {_in: $orgIds}}) {
    user_id
    org_id
    role
    accepted_terms_of_use
    engagement {
      first_session_at
      last_session_at
      session_count
      active_days_count
      terms_accepted_at
    }
  }
  activity_days: user_activity_day(
    where: {activity_date: {_gte: $activitySince}, user: {org_id: {_in: $orgIds}}}
  ) {
    user_id
    activity_date
    session_count
    user {
      org_id
      role
    }
  }
  recent_sessions: user_engagement(
    where: {last_session_at: {_gte: $sinceDate}, user: {org_id: {_in: $orgIds}}}
    order_by: {last_session_at: desc}
    limit: 25
  ) {
    user_id
    first_session_at
    last_session_at
    session_count
    active_days_count
    user {
      name
      email
      role
      org_id
    }
  }
}
    `;

/**
 * __useGetEngagementAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetEngagementAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementAnalyticsQuery({
 *   variables: {
 *      orgIds: // value for 'orgIds'
 *      sinceDate: // value for 'sinceDate'
 *      activitySince: // value for 'activitySince'
 *   },
 * });
 */
export function useGetEngagementAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetEngagementAnalyticsQuery, Types.GetEngagementAnalyticsQueryVariables> & ({ variables: Types.GetEngagementAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetEngagementAnalyticsQuery, Types.GetEngagementAnalyticsQueryVariables>(GetEngagementAnalyticsDocument, options);
      }
export function useGetEngagementAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetEngagementAnalyticsQuery, Types.GetEngagementAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetEngagementAnalyticsQuery, Types.GetEngagementAnalyticsQueryVariables>(GetEngagementAnalyticsDocument, options);
        }
// @ts-ignore
export function useGetEngagementAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetEngagementAnalyticsQuery, Types.GetEngagementAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetEngagementAnalyticsQuery, Types.GetEngagementAnalyticsQueryVariables>;
export function useGetEngagementAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetEngagementAnalyticsQuery, Types.GetEngagementAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetEngagementAnalyticsQuery | undefined, Types.GetEngagementAnalyticsQueryVariables>;
export function useGetEngagementAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetEngagementAnalyticsQuery, Types.GetEngagementAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetEngagementAnalyticsQuery, Types.GetEngagementAnalyticsQueryVariables>(GetEngagementAnalyticsDocument, options);
        }
export type GetEngagementAnalyticsQueryHookResult = ReturnType<typeof useGetEngagementAnalyticsQuery>;
export type GetEngagementAnalyticsLazyQueryHookResult = ReturnType<typeof useGetEngagementAnalyticsLazyQuery>;
export type GetEngagementAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetEngagementAnalyticsSuspenseQuery>;
export type GetEngagementAnalyticsQueryResult = Apollo.QueryResult<Types.GetEngagementAnalyticsQuery, Types.GetEngagementAnalyticsQueryVariables>;
export const AddEvaluationMetricDocument = gql`
    mutation addEvaluationMetric($objects: [evaluation_metric_insert_input!]!) {
  insert_evaluation_metric(
    objects: $objects
    on_conflict: {constraint: evaluation_metric_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddEvaluationMetricMutationFn = Apollo.MutationFunction<Types.AddEvaluationMetricMutation, Types.AddEvaluationMetricMutationVariables>;

/**
 * __useAddEvaluationMetricMutation__
 *
 * To run a mutation, you first call `useAddEvaluationMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEvaluationMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEvaluationMetricMutation, { data, loading, error }] = useAddEvaluationMetricMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddEvaluationMetricMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddEvaluationMetricMutation, Types.AddEvaluationMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddEvaluationMetricMutation, Types.AddEvaluationMetricMutationVariables>(AddEvaluationMetricDocument, options);
      }
export type AddEvaluationMetricMutationHookResult = ReturnType<typeof useAddEvaluationMetricMutation>;
export type AddEvaluationMetricMutationResult = Apollo.MutationResult<Types.AddEvaluationMetricMutation>;
export type AddEvaluationMetricMutationOptions = Apollo.BaseMutationOptions<Types.AddEvaluationMetricMutation, Types.AddEvaluationMetricMutationVariables>;
export const DeleteEvaluationMetricDocument = gql`
    mutation deleteEvaluationMetric($id: uuid!) {
  delete_evaluation_metric(where: {evaluation_metric_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteEvaluationMetricMutationFn = Apollo.MutationFunction<Types.DeleteEvaluationMetricMutation, Types.DeleteEvaluationMetricMutationVariables>;

/**
 * __useDeleteEvaluationMetricMutation__
 *
 * To run a mutation, you first call `useDeleteEvaluationMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEvaluationMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEvaluationMetricMutation, { data, loading, error }] = useDeleteEvaluationMetricMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEvaluationMetricMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteEvaluationMetricMutation, Types.DeleteEvaluationMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteEvaluationMetricMutation, Types.DeleteEvaluationMetricMutationVariables>(DeleteEvaluationMetricDocument, options);
      }
export type DeleteEvaluationMetricMutationHookResult = ReturnType<typeof useDeleteEvaluationMetricMutation>;
export type DeleteEvaluationMetricMutationResult = Apollo.MutationResult<Types.DeleteEvaluationMetricMutation>;
export type DeleteEvaluationMetricMutationOptions = Apollo.BaseMutationOptions<Types.DeleteEvaluationMetricMutation, Types.DeleteEvaluationMetricMutationVariables>;
export const UpdateEvaluationMetricManyDocument = gql`
    mutation updateEvaluationMetricMany($updates: [evaluation_metric_updates!]!) {
  update_evaluation_metric_many(updates: $updates) {
    affected_rows
  }
}
    `;
export type UpdateEvaluationMetricManyMutationFn = Apollo.MutationFunction<Types.UpdateEvaluationMetricManyMutation, Types.UpdateEvaluationMetricManyMutationVariables>;

/**
 * __useUpdateEvaluationMetricManyMutation__
 *
 * To run a mutation, you first call `useUpdateEvaluationMetricManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEvaluationMetricManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEvaluationMetricManyMutation, { data, loading, error }] = useUpdateEvaluationMetricManyMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateEvaluationMetricManyMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateEvaluationMetricManyMutation, Types.UpdateEvaluationMetricManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateEvaluationMetricManyMutation, Types.UpdateEvaluationMetricManyMutationVariables>(UpdateEvaluationMetricManyDocument, options);
      }
export type UpdateEvaluationMetricManyMutationHookResult = ReturnType<typeof useUpdateEvaluationMetricManyMutation>;
export type UpdateEvaluationMetricManyMutationResult = Apollo.MutationResult<Types.UpdateEvaluationMetricManyMutation>;
export type UpdateEvaluationMetricManyMutationOptions = Apollo.BaseMutationOptions<Types.UpdateEvaluationMetricManyMutation, Types.UpdateEvaluationMetricManyMutationVariables>;
export const GetEvaluationMetricDocument = gql`
    query getEvaluationMetric {
  evaluation_metric {
    description
    evaluation_metric_id
    requirement_id
    skill_level
    target_achievement_time
    skill_level_label
    target_achievement_time_label
  }
}
    `;

/**
 * __useGetEvaluationMetricQuery__
 *
 * To run a query within a React component, call `useGetEvaluationMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEvaluationMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEvaluationMetricQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEvaluationMetricQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetEvaluationMetricQuery, Types.GetEvaluationMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetEvaluationMetricQuery, Types.GetEvaluationMetricQueryVariables>(GetEvaluationMetricDocument, options);
      }
export function useGetEvaluationMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetEvaluationMetricQuery, Types.GetEvaluationMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetEvaluationMetricQuery, Types.GetEvaluationMetricQueryVariables>(GetEvaluationMetricDocument, options);
        }
// @ts-ignore
export function useGetEvaluationMetricSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetEvaluationMetricQuery, Types.GetEvaluationMetricQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetEvaluationMetricQuery, Types.GetEvaluationMetricQueryVariables>;
export function useGetEvaluationMetricSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetEvaluationMetricQuery, Types.GetEvaluationMetricQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetEvaluationMetricQuery | undefined, Types.GetEvaluationMetricQueryVariables>;
export function useGetEvaluationMetricSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetEvaluationMetricQuery, Types.GetEvaluationMetricQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetEvaluationMetricQuery, Types.GetEvaluationMetricQueryVariables>(GetEvaluationMetricDocument, options);
        }
export type GetEvaluationMetricQueryHookResult = ReturnType<typeof useGetEvaluationMetricQuery>;
export type GetEvaluationMetricLazyQueryHookResult = ReturnType<typeof useGetEvaluationMetricLazyQuery>;
export type GetEvaluationMetricSuspenseQueryHookResult = ReturnType<typeof useGetEvaluationMetricSuspenseQuery>;
export type GetEvaluationMetricQueryResult = Apollo.QueryResult<Types.GetEvaluationMetricQuery, Types.GetEvaluationMetricQueryVariables>;
export const AddFeedbackDocument = gql`
    mutation addFeedback($org_id: uuid!, $student_id: uuid!, $coach_id: uuid, $species_id: uuid, $animal_size: String, $mrn: String, $animal_name: String, $site_id: uuid, $status: String, $note_to_coach: String, $reviewed_at: String, $observation_date: String, $animal_sex: String) {
  insert_feedback(
    objects: [{org_id: $org_id, student_id: $student_id, coach_id: $coach_id, species_id: $species_id, animal_size: $animal_size, mrn: $mrn, status: $status, note_to_coach: $note_to_coach, reviewed_at: $reviewed_at, observation_date: $observation_date, animal_sex: $animal_sex, animal_name: $animal_name, site_id: $site_id}]
    on_conflict: {constraint: feedback_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      feedback_id
      created_at
    }
  }
}
    `;
export type AddFeedbackMutationFn = Apollo.MutationFunction<Types.AddFeedbackMutation, Types.AddFeedbackMutationVariables>;

/**
 * __useAddFeedbackMutation__
 *
 * To run a mutation, you first call `useAddFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFeedbackMutation, { data, loading, error }] = useAddFeedbackMutation({
 *   variables: {
 *      org_id: // value for 'org_id'
 *      student_id: // value for 'student_id'
 *      coach_id: // value for 'coach_id'
 *      species_id: // value for 'species_id'
 *      animal_size: // value for 'animal_size'
 *      mrn: // value for 'mrn'
 *      animal_name: // value for 'animal_name'
 *      site_id: // value for 'site_id'
 *      status: // value for 'status'
 *      note_to_coach: // value for 'note_to_coach'
 *      reviewed_at: // value for 'reviewed_at'
 *      observation_date: // value for 'observation_date'
 *      animal_sex: // value for 'animal_sex'
 *   },
 * });
 */
export function useAddFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddFeedbackMutation, Types.AddFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddFeedbackMutation, Types.AddFeedbackMutationVariables>(AddFeedbackDocument, options);
      }
export type AddFeedbackMutationHookResult = ReturnType<typeof useAddFeedbackMutation>;
export type AddFeedbackMutationResult = Apollo.MutationResult<Types.AddFeedbackMutation>;
export type AddFeedbackMutationOptions = Apollo.BaseMutationOptions<Types.AddFeedbackMutation, Types.AddFeedbackMutationVariables>;
export const UpdateFeedbackDocument = gql`
    mutation updateFeedback($id: uuid!, $feedback: feedback_set_input!) {
  update_feedback(where: {feedback_id: {_eq: $id}}, _set: $feedback) {
    affected_rows
  }
}
    `;
export type UpdateFeedbackMutationFn = Apollo.MutationFunction<Types.UpdateFeedbackMutation, Types.UpdateFeedbackMutationVariables>;

/**
 * __useUpdateFeedbackMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackMutation, { data, loading, error }] = useUpdateFeedbackMutation({
 *   variables: {
 *      id: // value for 'id'
 *      feedback: // value for 'feedback'
 *   },
 * });
 */
export function useUpdateFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFeedbackMutation, Types.UpdateFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFeedbackMutation, Types.UpdateFeedbackMutationVariables>(UpdateFeedbackDocument, options);
      }
export type UpdateFeedbackMutationHookResult = ReturnType<typeof useUpdateFeedbackMutation>;
export type UpdateFeedbackMutationResult = Apollo.MutationResult<Types.UpdateFeedbackMutation>;
export type UpdateFeedbackMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFeedbackMutation, Types.UpdateFeedbackMutationVariables>;
export const DeleteFeedbackDocument = gql`
    mutation deleteFeedback($id: uuid!) {
  delete_feedback(where: {feedback_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteFeedbackMutationFn = Apollo.MutationFunction<Types.DeleteFeedbackMutation, Types.DeleteFeedbackMutationVariables>;

/**
 * __useDeleteFeedbackMutation__
 *
 * To run a mutation, you first call `useDeleteFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeedbackMutation, { data, loading, error }] = useDeleteFeedbackMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteFeedbackMutation, Types.DeleteFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteFeedbackMutation, Types.DeleteFeedbackMutationVariables>(DeleteFeedbackDocument, options);
      }
export type DeleteFeedbackMutationHookResult = ReturnType<typeof useDeleteFeedbackMutation>;
export type DeleteFeedbackMutationResult = Apollo.MutationResult<Types.DeleteFeedbackMutation>;
export type DeleteFeedbackMutationOptions = Apollo.BaseMutationOptions<Types.DeleteFeedbackMutation, Types.DeleteFeedbackMutationVariables>;
export const GetDataRequestFeedbackDocument = gql`
    query getDataRequestFeedback($user_id: uuid!, $org_id: uuid!) {
  mentors: mentoring(where: {mentee_id: {_eq: $user_id}}) {
    mentor {
      user_id
      email
      role
      name
      updated_at
      created_at
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
  }
  species {
    species_id
    name
  }
  competencySkills: requirement(where: {type: {_eq: "COMPETENCY"}}) {
    requirement_id
    name
    type
    description
    overview
    domains {
      relation
      domain {
        requirement_domain_id
        name
        code
        color_hex
        sort_order
      }
    }
    evaluation_metrics {
      evaluation_metric_id
      skill_level
      description
      target_achievement_time
      skill_level_label
      target_achievement_time_label
    }
  }
  graduation_class_student(where: {student: {user_id: {_eq: $user_id}}}) {
    graduation_class {
      current_academic_year {
        requirements {
          requirement {
            requirement_id
            name
            type
            description
            overview
            domains {
              relation
              domain {
                requirement_domain_id
                name
                code
                color_hex
                sort_order
              }
            }
            evaluation_metrics {
              evaluation_metric_id
              skill_level
              description
              target_achievement_time
              skill_level_label
              target_achievement_time_label
            }
            competencies {
              competency {
                requirement_id
                name
                type
                description
                overview
                domains {
                  relation
                  domain {
                    requirement_domain_id
                    name
                    code
                    color_hex
                    sort_order
                  }
                }
                evaluation_metrics {
                  evaluation_metric_id
                  skill_level
                  description
                  target_achievement_time
                  skill_level_label
                  target_achievement_time_label
                }
              }
            }
          }
        }
      }
    }
  }
  user(where: {user_id: {_eq: $user_id}}) {
    user_id
    org_id
    name
    email
  }
  organization_site(where: {org_id: {_eq: $org_id}}) {
    org_site_id
    site {
      name
      site_id
      address {
        address_id
        address_line_1
        address_line_2
        city
        state
        country
        zip_code
      }
    }
  }
  tag(where: {type: {_eq: "feedbackFocus"}}) {
    name
    tag_id
    type
  }
}
    `;

/**
 * __useGetDataRequestFeedbackQuery__
 *
 * To run a query within a React component, call `useGetDataRequestFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataRequestFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataRequestFeedbackQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      org_id: // value for 'org_id'
 *   },
 * });
 */
export function useGetDataRequestFeedbackQuery(baseOptions: Apollo.QueryHookOptions<Types.GetDataRequestFeedbackQuery, Types.GetDataRequestFeedbackQueryVariables> & ({ variables: Types.GetDataRequestFeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetDataRequestFeedbackQuery, Types.GetDataRequestFeedbackQueryVariables>(GetDataRequestFeedbackDocument, options);
      }
export function useGetDataRequestFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetDataRequestFeedbackQuery, Types.GetDataRequestFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetDataRequestFeedbackQuery, Types.GetDataRequestFeedbackQueryVariables>(GetDataRequestFeedbackDocument, options);
        }
// @ts-ignore
export function useGetDataRequestFeedbackSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetDataRequestFeedbackQuery, Types.GetDataRequestFeedbackQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetDataRequestFeedbackQuery, Types.GetDataRequestFeedbackQueryVariables>;
export function useGetDataRequestFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetDataRequestFeedbackQuery, Types.GetDataRequestFeedbackQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetDataRequestFeedbackQuery | undefined, Types.GetDataRequestFeedbackQueryVariables>;
export function useGetDataRequestFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetDataRequestFeedbackQuery, Types.GetDataRequestFeedbackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetDataRequestFeedbackQuery, Types.GetDataRequestFeedbackQueryVariables>(GetDataRequestFeedbackDocument, options);
        }
export type GetDataRequestFeedbackQueryHookResult = ReturnType<typeof useGetDataRequestFeedbackQuery>;
export type GetDataRequestFeedbackLazyQueryHookResult = ReturnType<typeof useGetDataRequestFeedbackLazyQuery>;
export type GetDataRequestFeedbackSuspenseQueryHookResult = ReturnType<typeof useGetDataRequestFeedbackSuspenseQuery>;
export type GetDataRequestFeedbackQueryResult = Apollo.QueryResult<Types.GetDataRequestFeedbackQuery, Types.GetDataRequestFeedbackQueryVariables>;
export const GetFeedbacksDocument = gql`
    query getFeedbacks {
  feedback {
    feedback_id
    org_id
    student_id
    coach_id
    species_id
    animal_size
    course
    mrn
    status
    note_to_coach
    created_at
    reviewed_at
    observation_date
    animal_sex
    organization {
      org_id
      name
    }
    student {
      user_id
      email
      name
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    coach {
      user_id
      email
      name
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    species {
      name
      species_id
    }
    feedback_skills {
      actions
      areas
      coach_comments
      feedback_skill_id
      note
      requirement {
        name
        requirement_id
        type
        domains {
          relation
          domain {
            requirement_domain_id
            name
            code
            color_hex
            sort_order
          }
        }
        competencies {
          competency {
            requirement_id
            domains {
              relation
              domain {
                requirement_domain_id
                name
                code
                color_hex
                sort_order
              }
            }
          }
        }
        evaluation_metrics {
          evaluation_metric_id
          skill_level
          description
          target_achievement_time
          skill_level_label
          target_achievement_time_label
        }
      }
      self_rating
      coach_rating
      student_comments
    }
  }
}
    `;

/**
 * __useGetFeedbacksQuery__
 *
 * To run a query within a React component, call `useGetFeedbacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbacksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeedbacksQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetFeedbacksQuery, Types.GetFeedbacksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFeedbacksQuery, Types.GetFeedbacksQueryVariables>(GetFeedbacksDocument, options);
      }
export function useGetFeedbacksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFeedbacksQuery, Types.GetFeedbacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFeedbacksQuery, Types.GetFeedbacksQueryVariables>(GetFeedbacksDocument, options);
        }
// @ts-ignore
export function useGetFeedbacksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetFeedbacksQuery, Types.GetFeedbacksQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbacksQuery, Types.GetFeedbacksQueryVariables>;
export function useGetFeedbacksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbacksQuery, Types.GetFeedbacksQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbacksQuery | undefined, Types.GetFeedbacksQueryVariables>;
export function useGetFeedbacksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbacksQuery, Types.GetFeedbacksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetFeedbacksQuery, Types.GetFeedbacksQueryVariables>(GetFeedbacksDocument, options);
        }
export type GetFeedbacksQueryHookResult = ReturnType<typeof useGetFeedbacksQuery>;
export type GetFeedbacksLazyQueryHookResult = ReturnType<typeof useGetFeedbacksLazyQuery>;
export type GetFeedbacksSuspenseQueryHookResult = ReturnType<typeof useGetFeedbacksSuspenseQuery>;
export type GetFeedbacksQueryResult = Apollo.QueryResult<Types.GetFeedbacksQuery, Types.GetFeedbacksQueryVariables>;
export const GetFeedbacksByOrganizationIdDocument = gql`
    query getFeedbacksByOrganizationId($organizationId: uuid!) {
  feedback(where: {org_id: {_eq: $organizationId}}) {
    feedback_id
    org_id
    student_id
    coach_id
    species_id
    animal_size
    mrn
    status
    course
    note_to_coach
    created_at
    reviewed_at
    observation_date
    animal_sex
    organization {
      org_id
      name
    }
    student {
      user_id
      email
      name
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    coach {
      user_id
      email
      name
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    species {
      name
      species_id
    }
    feedback_skills {
      actions
      areas
      coach_comments
      feedback_skill_id
      note
      requirement {
        name
        requirement_id
        type
        description
        overview
        domains {
          relation
          domain {
            requirement_domain_id
            name
            code
            color_hex
            sort_order
          }
        }
        competencies {
          competency {
            requirement_id
            domains {
              relation
              domain {
                requirement_domain_id
                name
                code
                color_hex
                sort_order
              }
            }
          }
        }
        evaluation_metrics {
          evaluation_metric_id
          skill_level
          description
          target_achievement_time
          skill_level_label
          target_achievement_time_label
        }
      }
      self_rating
      coach_rating
      student_comments
    }
  }
}
    `;

/**
 * __useGetFeedbacksByOrganizationIdQuery__
 *
 * To run a query within a React component, call `useGetFeedbacksByOrganizationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbacksByOrganizationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbacksByOrganizationIdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetFeedbacksByOrganizationIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetFeedbacksByOrganizationIdQuery, Types.GetFeedbacksByOrganizationIdQueryVariables> & ({ variables: Types.GetFeedbacksByOrganizationIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFeedbacksByOrganizationIdQuery, Types.GetFeedbacksByOrganizationIdQueryVariables>(GetFeedbacksByOrganizationIdDocument, options);
      }
export function useGetFeedbacksByOrganizationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFeedbacksByOrganizationIdQuery, Types.GetFeedbacksByOrganizationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFeedbacksByOrganizationIdQuery, Types.GetFeedbacksByOrganizationIdQueryVariables>(GetFeedbacksByOrganizationIdDocument, options);
        }
// @ts-ignore
export function useGetFeedbacksByOrganizationIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetFeedbacksByOrganizationIdQuery, Types.GetFeedbacksByOrganizationIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbacksByOrganizationIdQuery, Types.GetFeedbacksByOrganizationIdQueryVariables>;
export function useGetFeedbacksByOrganizationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbacksByOrganizationIdQuery, Types.GetFeedbacksByOrganizationIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbacksByOrganizationIdQuery | undefined, Types.GetFeedbacksByOrganizationIdQueryVariables>;
export function useGetFeedbacksByOrganizationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbacksByOrganizationIdQuery, Types.GetFeedbacksByOrganizationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetFeedbacksByOrganizationIdQuery, Types.GetFeedbacksByOrganizationIdQueryVariables>(GetFeedbacksByOrganizationIdDocument, options);
        }
export type GetFeedbacksByOrganizationIdQueryHookResult = ReturnType<typeof useGetFeedbacksByOrganizationIdQuery>;
export type GetFeedbacksByOrganizationIdLazyQueryHookResult = ReturnType<typeof useGetFeedbacksByOrganizationIdLazyQuery>;
export type GetFeedbacksByOrganizationIdSuspenseQueryHookResult = ReturnType<typeof useGetFeedbacksByOrganizationIdSuspenseQuery>;
export type GetFeedbacksByOrganizationIdQueryResult = Apollo.QueryResult<Types.GetFeedbacksByOrganizationIdQuery, Types.GetFeedbacksByOrganizationIdQueryVariables>;
export const GetFeedbacksByOrganizationIdsDocument = gql`
    query getFeedbacksByOrganizationIds($organizationIds: [uuid!]!, $sinceDate: timestamptz!, $excludeTestOrgNamePattern: String!) {
  feedback(
    where: {org_id: {_in: $organizationIds}, created_at: {_gte: $sinceDate}, organization: {name: {_nilike: $excludeTestOrgNamePattern}}}
  ) {
    feedback_id
    org_id
    student_id
    coach_id
    species_id
    animal_size
    mrn
    status
    course
    note_to_coach
    created_at
    reviewed_at
    observation_date
    animal_sex
    organization {
      org_id
      name
    }
    student {
      user_id
      email
      name
      picture_url
    }
    coach {
      user_id
      email
      name
      picture_url
    }
    species {
      name
      species_id
    }
    feedback_skills {
      actions
      areas
      coach_comments
      feedback_skill_id
      note
      requirement {
        name
        requirement_id
        type
        description
        overview
        domains {
          relation
          domain {
            requirement_domain_id
            name
            code
            color_hex
            sort_order
          }
        }
        competencies {
          competency {
            requirement_id
            domains {
              relation
              domain {
                requirement_domain_id
                name
                code
                color_hex
                sort_order
              }
            }
          }
        }
        evaluation_metrics {
          evaluation_metric_id
          skill_level
          description
          target_achievement_time
          skill_level_label
          target_achievement_time_label
        }
      }
      self_rating
      coach_rating
      student_comments
    }
  }
}
    `;

/**
 * __useGetFeedbacksByOrganizationIdsQuery__
 *
 * To run a query within a React component, call `useGetFeedbacksByOrganizationIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbacksByOrganizationIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbacksByOrganizationIdsQuery({
 *   variables: {
 *      organizationIds: // value for 'organizationIds'
 *      sinceDate: // value for 'sinceDate'
 *      excludeTestOrgNamePattern: // value for 'excludeTestOrgNamePattern'
 *   },
 * });
 */
export function useGetFeedbacksByOrganizationIdsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetFeedbacksByOrganizationIdsQuery, Types.GetFeedbacksByOrganizationIdsQueryVariables> & ({ variables: Types.GetFeedbacksByOrganizationIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFeedbacksByOrganizationIdsQuery, Types.GetFeedbacksByOrganizationIdsQueryVariables>(GetFeedbacksByOrganizationIdsDocument, options);
      }
export function useGetFeedbacksByOrganizationIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFeedbacksByOrganizationIdsQuery, Types.GetFeedbacksByOrganizationIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFeedbacksByOrganizationIdsQuery, Types.GetFeedbacksByOrganizationIdsQueryVariables>(GetFeedbacksByOrganizationIdsDocument, options);
        }
// @ts-ignore
export function useGetFeedbacksByOrganizationIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetFeedbacksByOrganizationIdsQuery, Types.GetFeedbacksByOrganizationIdsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbacksByOrganizationIdsQuery, Types.GetFeedbacksByOrganizationIdsQueryVariables>;
export function useGetFeedbacksByOrganizationIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbacksByOrganizationIdsQuery, Types.GetFeedbacksByOrganizationIdsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbacksByOrganizationIdsQuery | undefined, Types.GetFeedbacksByOrganizationIdsQueryVariables>;
export function useGetFeedbacksByOrganizationIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbacksByOrganizationIdsQuery, Types.GetFeedbacksByOrganizationIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetFeedbacksByOrganizationIdsQuery, Types.GetFeedbacksByOrganizationIdsQueryVariables>(GetFeedbacksByOrganizationIdsDocument, options);
        }
export type GetFeedbacksByOrganizationIdsQueryHookResult = ReturnType<typeof useGetFeedbacksByOrganizationIdsQuery>;
export type GetFeedbacksByOrganizationIdsLazyQueryHookResult = ReturnType<typeof useGetFeedbacksByOrganizationIdsLazyQuery>;
export type GetFeedbacksByOrganizationIdsSuspenseQueryHookResult = ReturnType<typeof useGetFeedbacksByOrganizationIdsSuspenseQuery>;
export type GetFeedbacksByOrganizationIdsQueryResult = Apollo.QueryResult<Types.GetFeedbacksByOrganizationIdsQuery, Types.GetFeedbacksByOrganizationIdsQueryVariables>;
export const GetFeedbacksByStudentIdDocument = gql`
    query getFeedbacksByStudentId($studentId: uuid!) {
  feedback(where: {student_id: {_eq: $studentId}}) {
    feedback_id
    org_id
    student_id
    coach_id
    species_id
    animal_size
    mrn
    status
    course
    note_to_coach
    created_at
    reviewed_at
    observation_date
    animal_sex
    organization {
      org_id
      name
    }
    student {
      user_id
      email
      name
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    coach {
      user_id
      email
      name
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    species {
      name
      species_id
    }
    feedback_skills {
      coach_rating
      actions
      areas
      coach_comments
      feedback_skill_id
      note
      requirement {
        name
        requirement_id
        type
        description
        overview
        domains {
          relation
          domain {
            requirement_domain_id
            name
            code
            color_hex
            sort_order
          }
        }
        competencies {
          competency {
            requirement_id
            domains {
              relation
              domain {
                requirement_domain_id
                name
                code
                color_hex
                sort_order
              }
            }
          }
        }
        evaluation_metrics {
          evaluation_metric_id
          skill_level
          description
          target_achievement_time
          skill_level_label
          target_achievement_time_label
        }
      }
      student_comments
    }
  }
}
    `;

/**
 * __useGetFeedbacksByStudentIdQuery__
 *
 * To run a query within a React component, call `useGetFeedbacksByStudentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbacksByStudentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbacksByStudentIdQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetFeedbacksByStudentIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetFeedbacksByStudentIdQuery, Types.GetFeedbacksByStudentIdQueryVariables> & ({ variables: Types.GetFeedbacksByStudentIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFeedbacksByStudentIdQuery, Types.GetFeedbacksByStudentIdQueryVariables>(GetFeedbacksByStudentIdDocument, options);
      }
export function useGetFeedbacksByStudentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFeedbacksByStudentIdQuery, Types.GetFeedbacksByStudentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFeedbacksByStudentIdQuery, Types.GetFeedbacksByStudentIdQueryVariables>(GetFeedbacksByStudentIdDocument, options);
        }
// @ts-ignore
export function useGetFeedbacksByStudentIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetFeedbacksByStudentIdQuery, Types.GetFeedbacksByStudentIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbacksByStudentIdQuery, Types.GetFeedbacksByStudentIdQueryVariables>;
export function useGetFeedbacksByStudentIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbacksByStudentIdQuery, Types.GetFeedbacksByStudentIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbacksByStudentIdQuery | undefined, Types.GetFeedbacksByStudentIdQueryVariables>;
export function useGetFeedbacksByStudentIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbacksByStudentIdQuery, Types.GetFeedbacksByStudentIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetFeedbacksByStudentIdQuery, Types.GetFeedbacksByStudentIdQueryVariables>(GetFeedbacksByStudentIdDocument, options);
        }
export type GetFeedbacksByStudentIdQueryHookResult = ReturnType<typeof useGetFeedbacksByStudentIdQuery>;
export type GetFeedbacksByStudentIdLazyQueryHookResult = ReturnType<typeof useGetFeedbacksByStudentIdLazyQuery>;
export type GetFeedbacksByStudentIdSuspenseQueryHookResult = ReturnType<typeof useGetFeedbacksByStudentIdSuspenseQuery>;
export type GetFeedbacksByStudentIdQueryResult = Apollo.QueryResult<Types.GetFeedbacksByStudentIdQuery, Types.GetFeedbacksByStudentIdQueryVariables>;
export const GetValidFeedbacksByStudentIdDocument = gql`
    query getValidFeedbacksByStudentId($studentId: uuid!) {
  feedback(
    where: {student_id: {_eq: $studentId}, status: {_nin: ["DRAFT", "ARCHIVED", "HIDDEN"]}}
  ) {
    feedback_id
    org_id
    student_id
    coach_id
    species_id
    animal_size
    mrn
    status
    course
    note_to_coach
    created_at
    reviewed_at
    observation_date
    animal_sex
    organization {
      org_id
      name
    }
    student {
      user_id
      email
      name
    }
    coach {
      user_id
      email
      name
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    species {
      name
      species_id
    }
    feedback_skills {
      actions
      areas
      coach_comments
      feedback_skill_id
      note
      requirement {
        name
        requirement_id
        type
        description
        overview
        domains {
          relation
          domain {
            requirement_domain_id
            name
            code
            color_hex
            sort_order
          }
        }
        competencies {
          competency {
            requirement_id
            domains {
              relation
              domain {
                requirement_domain_id
                name
                code
                color_hex
                sort_order
              }
            }
          }
        }
        evaluation_metrics {
          evaluation_metric_id
          skill_level
          description
          target_achievement_time
          skill_level_label
          target_achievement_time_label
        }
      }
      self_rating
      coach_rating
      student_comments
    }
  }
}
    `;

/**
 * __useGetValidFeedbacksByStudentIdQuery__
 *
 * To run a query within a React component, call `useGetValidFeedbacksByStudentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValidFeedbacksByStudentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValidFeedbacksByStudentIdQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetValidFeedbacksByStudentIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetValidFeedbacksByStudentIdQuery, Types.GetValidFeedbacksByStudentIdQueryVariables> & ({ variables: Types.GetValidFeedbacksByStudentIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetValidFeedbacksByStudentIdQuery, Types.GetValidFeedbacksByStudentIdQueryVariables>(GetValidFeedbacksByStudentIdDocument, options);
      }
export function useGetValidFeedbacksByStudentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetValidFeedbacksByStudentIdQuery, Types.GetValidFeedbacksByStudentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetValidFeedbacksByStudentIdQuery, Types.GetValidFeedbacksByStudentIdQueryVariables>(GetValidFeedbacksByStudentIdDocument, options);
        }
// @ts-ignore
export function useGetValidFeedbacksByStudentIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetValidFeedbacksByStudentIdQuery, Types.GetValidFeedbacksByStudentIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetValidFeedbacksByStudentIdQuery, Types.GetValidFeedbacksByStudentIdQueryVariables>;
export function useGetValidFeedbacksByStudentIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetValidFeedbacksByStudentIdQuery, Types.GetValidFeedbacksByStudentIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetValidFeedbacksByStudentIdQuery | undefined, Types.GetValidFeedbacksByStudentIdQueryVariables>;
export function useGetValidFeedbacksByStudentIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetValidFeedbacksByStudentIdQuery, Types.GetValidFeedbacksByStudentIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetValidFeedbacksByStudentIdQuery, Types.GetValidFeedbacksByStudentIdQueryVariables>(GetValidFeedbacksByStudentIdDocument, options);
        }
export type GetValidFeedbacksByStudentIdQueryHookResult = ReturnType<typeof useGetValidFeedbacksByStudentIdQuery>;
export type GetValidFeedbacksByStudentIdLazyQueryHookResult = ReturnType<typeof useGetValidFeedbacksByStudentIdLazyQuery>;
export type GetValidFeedbacksByStudentIdSuspenseQueryHookResult = ReturnType<typeof useGetValidFeedbacksByStudentIdSuspenseQuery>;
export type GetValidFeedbacksByStudentIdQueryResult = Apollo.QueryResult<Types.GetValidFeedbacksByStudentIdQuery, Types.GetValidFeedbacksByStudentIdQueryVariables>;
export const GetValidFeedbacksByStudentAndCoachDocument = gql`
    query getValidFeedbacksByStudentAndCoach($studentId: uuid!, $coachId: uuid!) {
  feedback(
    where: {student_id: {_eq: $studentId}, coach_id: {_eq: $coachId}, status: {_nin: ["DRAFT", "ARCHIVED", "HIDDEN"]}}
  ) {
    feedback_id
    org_id
    student_id
    coach_id
    species_id
    animal_size
    mrn
    status
    course
    note_to_coach
    created_at
    reviewed_at
    observation_date
    animal_sex
    organization {
      org_id
      name
    }
    student {
      user_id
      email
      name
    }
    coach {
      user_id
      email
      name
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    species {
      name
      species_id
    }
    feedback_skills {
      actions
      areas
      coach_comments
      feedback_skill_id
      note
      requirement {
        name
        requirement_id
        type
        description
        overview
        domains {
          relation
          domain {
            requirement_domain_id
            name
            code
            color_hex
            sort_order
          }
        }
        competencies {
          competency {
            requirement_id
            domains {
              relation
              domain {
                requirement_domain_id
                name
                code
                color_hex
                sort_order
              }
            }
          }
        }
        evaluation_metrics {
          evaluation_metric_id
          skill_level
          description
          target_achievement_time
          skill_level_label
          target_achievement_time_label
        }
      }
      self_rating
      coach_rating
      student_comments
    }
  }
}
    `;

/**
 * __useGetValidFeedbacksByStudentAndCoachQuery__
 *
 * To run a query within a React component, call `useGetValidFeedbacksByStudentAndCoachQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValidFeedbacksByStudentAndCoachQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValidFeedbacksByStudentAndCoachQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      coachId: // value for 'coachId'
 *   },
 * });
 */
export function useGetValidFeedbacksByStudentAndCoachQuery(baseOptions: Apollo.QueryHookOptions<Types.GetValidFeedbacksByStudentAndCoachQuery, Types.GetValidFeedbacksByStudentAndCoachQueryVariables> & ({ variables: Types.GetValidFeedbacksByStudentAndCoachQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetValidFeedbacksByStudentAndCoachQuery, Types.GetValidFeedbacksByStudentAndCoachQueryVariables>(GetValidFeedbacksByStudentAndCoachDocument, options);
      }
export function useGetValidFeedbacksByStudentAndCoachLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetValidFeedbacksByStudentAndCoachQuery, Types.GetValidFeedbacksByStudentAndCoachQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetValidFeedbacksByStudentAndCoachQuery, Types.GetValidFeedbacksByStudentAndCoachQueryVariables>(GetValidFeedbacksByStudentAndCoachDocument, options);
        }
// @ts-ignore
export function useGetValidFeedbacksByStudentAndCoachSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetValidFeedbacksByStudentAndCoachQuery, Types.GetValidFeedbacksByStudentAndCoachQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetValidFeedbacksByStudentAndCoachQuery, Types.GetValidFeedbacksByStudentAndCoachQueryVariables>;
export function useGetValidFeedbacksByStudentAndCoachSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetValidFeedbacksByStudentAndCoachQuery, Types.GetValidFeedbacksByStudentAndCoachQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetValidFeedbacksByStudentAndCoachQuery | undefined, Types.GetValidFeedbacksByStudentAndCoachQueryVariables>;
export function useGetValidFeedbacksByStudentAndCoachSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetValidFeedbacksByStudentAndCoachQuery, Types.GetValidFeedbacksByStudentAndCoachQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetValidFeedbacksByStudentAndCoachQuery, Types.GetValidFeedbacksByStudentAndCoachQueryVariables>(GetValidFeedbacksByStudentAndCoachDocument, options);
        }
export type GetValidFeedbacksByStudentAndCoachQueryHookResult = ReturnType<typeof useGetValidFeedbacksByStudentAndCoachQuery>;
export type GetValidFeedbacksByStudentAndCoachLazyQueryHookResult = ReturnType<typeof useGetValidFeedbacksByStudentAndCoachLazyQuery>;
export type GetValidFeedbacksByStudentAndCoachSuspenseQueryHookResult = ReturnType<typeof useGetValidFeedbacksByStudentAndCoachSuspenseQuery>;
export type GetValidFeedbacksByStudentAndCoachQueryResult = Apollo.QueryResult<Types.GetValidFeedbacksByStudentAndCoachQuery, Types.GetValidFeedbacksByStudentAndCoachQueryVariables>;
export const GetFeedbacksByCoachIdDocument = gql`
    query getFeedbacksByCoachId($coachId: uuid!) {
  feedback(where: {coach_id: {_eq: $coachId}}) {
    feedback_id
    org_id
    student_id
    coach_id
    course
    species_id
    animal_size
    mrn
    status
    note_to_coach
    created_at
    reviewed_at
    observation_date
    animal_sex
    organization {
      org_id
      name
    }
    student {
      user_id
      email
      name
    }
    coach {
      user_id
      email
      name
    }
    species {
      name
      species_id
    }
    feedback_skills {
      actions
      areas
      coach_comments
      feedback_skill_id
      note
      requirement {
        name
        requirement_id
        type
        description
        overview
        domains {
          relation
          domain {
            requirement_domain_id
            name
            code
            color_hex
            sort_order
          }
        }
        competencies {
          competency {
            requirement_id
            domains {
              relation
              domain {
                requirement_domain_id
                name
                code
                color_hex
                sort_order
              }
            }
          }
        }
        evaluation_metrics {
          evaluation_metric_id
          skill_level
          description
          target_achievement_time
          skill_level_label
          target_achievement_time_label
        }
      }
      self_rating
      coach_rating
      student_comments
    }
  }
}
    `;

/**
 * __useGetFeedbacksByCoachIdQuery__
 *
 * To run a query within a React component, call `useGetFeedbacksByCoachIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbacksByCoachIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbacksByCoachIdQuery({
 *   variables: {
 *      coachId: // value for 'coachId'
 *   },
 * });
 */
export function useGetFeedbacksByCoachIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetFeedbacksByCoachIdQuery, Types.GetFeedbacksByCoachIdQueryVariables> & ({ variables: Types.GetFeedbacksByCoachIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFeedbacksByCoachIdQuery, Types.GetFeedbacksByCoachIdQueryVariables>(GetFeedbacksByCoachIdDocument, options);
      }
export function useGetFeedbacksByCoachIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFeedbacksByCoachIdQuery, Types.GetFeedbacksByCoachIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFeedbacksByCoachIdQuery, Types.GetFeedbacksByCoachIdQueryVariables>(GetFeedbacksByCoachIdDocument, options);
        }
// @ts-ignore
export function useGetFeedbacksByCoachIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetFeedbacksByCoachIdQuery, Types.GetFeedbacksByCoachIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbacksByCoachIdQuery, Types.GetFeedbacksByCoachIdQueryVariables>;
export function useGetFeedbacksByCoachIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbacksByCoachIdQuery, Types.GetFeedbacksByCoachIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbacksByCoachIdQuery | undefined, Types.GetFeedbacksByCoachIdQueryVariables>;
export function useGetFeedbacksByCoachIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbacksByCoachIdQuery, Types.GetFeedbacksByCoachIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetFeedbacksByCoachIdQuery, Types.GetFeedbacksByCoachIdQueryVariables>(GetFeedbacksByCoachIdDocument, options);
        }
export type GetFeedbacksByCoachIdQueryHookResult = ReturnType<typeof useGetFeedbacksByCoachIdQuery>;
export type GetFeedbacksByCoachIdLazyQueryHookResult = ReturnType<typeof useGetFeedbacksByCoachIdLazyQuery>;
export type GetFeedbacksByCoachIdSuspenseQueryHookResult = ReturnType<typeof useGetFeedbacksByCoachIdSuspenseQuery>;
export type GetFeedbacksByCoachIdQueryResult = Apollo.QueryResult<Types.GetFeedbacksByCoachIdQuery, Types.GetFeedbacksByCoachIdQueryVariables>;
export const GetFeedbackByIdDocument = gql`
    query getFeedbackById($feedbackId: uuid!) {
  feedback_by_pk(feedback_id: $feedbackId) {
    animal_size
    animal_name
    animal_sex
    feedback_type
    feedback_id
    org_id
    student_id
    student {
      user_id
      email
      name
      role
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    coach_id
    coach {
      user_id
      email
      name
      role
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    species_id
    species {
      name
      species_id
    }
    course
    mrn
    status
    note_to_coach
    record_correction
    record_corrected_at
    coach_rate
    created_at
    reviewed_at
    observation_date
    animal_sex
    species {
      name
      species_id
    }
    feedback_skills {
      actions
      areas
      coach_comments
      feedback_skill_id
      note
      requirement {
        requirement_id
        name
        type
        description
        overview
        domains {
          relation
          domain {
            requirement_domain_id
            name
            code
            color_hex
            sort_order
          }
        }
        competencies {
          competency {
            requirement_id
            domains {
              relation
              domain {
                requirement_domain_id
                name
                code
                color_hex
                sort_order
              }
            }
          }
        }
        evaluation_metrics {
          evaluation_metric_id
          skill_level
          description
          target_achievement_time
          skill_level_label
          target_achievement_time_label
        }
      }
      self_rating
      coach_rating
      student_comments
    }
    site {
      site_id
      name
    }
    tags {
      tag {
        name
        tag_id
        type
      }
      feedback_tag_id
    }
    organization {
      custom_labels {
        custom_label {
          custom_label_id
          index
          label
          type
        }
      }
    }
  }
}
    `;

/**
 * __useGetFeedbackByIdQuery__
 *
 * To run a query within a React component, call `useGetFeedbackByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackByIdQuery({
 *   variables: {
 *      feedbackId: // value for 'feedbackId'
 *   },
 * });
 */
export function useGetFeedbackByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetFeedbackByIdQuery, Types.GetFeedbackByIdQueryVariables> & ({ variables: Types.GetFeedbackByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFeedbackByIdQuery, Types.GetFeedbackByIdQueryVariables>(GetFeedbackByIdDocument, options);
      }
export function useGetFeedbackByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFeedbackByIdQuery, Types.GetFeedbackByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFeedbackByIdQuery, Types.GetFeedbackByIdQueryVariables>(GetFeedbackByIdDocument, options);
        }
// @ts-ignore
export function useGetFeedbackByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetFeedbackByIdQuery, Types.GetFeedbackByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackByIdQuery, Types.GetFeedbackByIdQueryVariables>;
export function useGetFeedbackByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackByIdQuery, Types.GetFeedbackByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackByIdQuery | undefined, Types.GetFeedbackByIdQueryVariables>;
export function useGetFeedbackByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackByIdQuery, Types.GetFeedbackByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetFeedbackByIdQuery, Types.GetFeedbackByIdQueryVariables>(GetFeedbackByIdDocument, options);
        }
export type GetFeedbackByIdQueryHookResult = ReturnType<typeof useGetFeedbackByIdQuery>;
export type GetFeedbackByIdLazyQueryHookResult = ReturnType<typeof useGetFeedbackByIdLazyQuery>;
export type GetFeedbackByIdSuspenseQueryHookResult = ReturnType<typeof useGetFeedbackByIdSuspenseQuery>;
export type GetFeedbackByIdQueryResult = Apollo.QueryResult<Types.GetFeedbackByIdQuery, Types.GetFeedbackByIdQueryVariables>;
export const GetRequirementFeedbackStatsByStudentIdDocument = gql`
    query getRequirementFeedbackStatsByStudentId($requirementId: uuid!, $studentId: uuid!) {
  feedback(
    where: {feedback_skills: {requirement_id: {_eq: $requirementId}}, student_id: {_eq: $studentId}, status: {_nin: ["DRAFT", "ARCHIVED", "HIDDEN"]}}
    order_by: {observation_date: asc}
  ) {
    feedback_id
    course
    observation_date
    student_id
    status
    created_at
    reviewed_at
    coach_id
    coach {
      user_id
      email
      name
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    feedback_skills(where: {requirement_id: {_eq: $requirementId}}) {
      coach_rating
      self_rating
    }
  }
}
    `;

/**
 * __useGetRequirementFeedbackStatsByStudentIdQuery__
 *
 * To run a query within a React component, call `useGetRequirementFeedbackStatsByStudentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequirementFeedbackStatsByStudentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequirementFeedbackStatsByStudentIdQuery({
 *   variables: {
 *      requirementId: // value for 'requirementId'
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetRequirementFeedbackStatsByStudentIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetRequirementFeedbackStatsByStudentIdQuery, Types.GetRequirementFeedbackStatsByStudentIdQueryVariables> & ({ variables: Types.GetRequirementFeedbackStatsByStudentIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetRequirementFeedbackStatsByStudentIdQuery, Types.GetRequirementFeedbackStatsByStudentIdQueryVariables>(GetRequirementFeedbackStatsByStudentIdDocument, options);
      }
export function useGetRequirementFeedbackStatsByStudentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRequirementFeedbackStatsByStudentIdQuery, Types.GetRequirementFeedbackStatsByStudentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetRequirementFeedbackStatsByStudentIdQuery, Types.GetRequirementFeedbackStatsByStudentIdQueryVariables>(GetRequirementFeedbackStatsByStudentIdDocument, options);
        }
// @ts-ignore
export function useGetRequirementFeedbackStatsByStudentIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetRequirementFeedbackStatsByStudentIdQuery, Types.GetRequirementFeedbackStatsByStudentIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementFeedbackStatsByStudentIdQuery, Types.GetRequirementFeedbackStatsByStudentIdQueryVariables>;
export function useGetRequirementFeedbackStatsByStudentIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementFeedbackStatsByStudentIdQuery, Types.GetRequirementFeedbackStatsByStudentIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementFeedbackStatsByStudentIdQuery | undefined, Types.GetRequirementFeedbackStatsByStudentIdQueryVariables>;
export function useGetRequirementFeedbackStatsByStudentIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementFeedbackStatsByStudentIdQuery, Types.GetRequirementFeedbackStatsByStudentIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetRequirementFeedbackStatsByStudentIdQuery, Types.GetRequirementFeedbackStatsByStudentIdQueryVariables>(GetRequirementFeedbackStatsByStudentIdDocument, options);
        }
export type GetRequirementFeedbackStatsByStudentIdQueryHookResult = ReturnType<typeof useGetRequirementFeedbackStatsByStudentIdQuery>;
export type GetRequirementFeedbackStatsByStudentIdLazyQueryHookResult = ReturnType<typeof useGetRequirementFeedbackStatsByStudentIdLazyQuery>;
export type GetRequirementFeedbackStatsByStudentIdSuspenseQueryHookResult = ReturnType<typeof useGetRequirementFeedbackStatsByStudentIdSuspenseQuery>;
export type GetRequirementFeedbackStatsByStudentIdQueryResult = Apollo.QueryResult<Types.GetRequirementFeedbackStatsByStudentIdQuery, Types.GetRequirementFeedbackStatsByStudentIdQueryVariables>;
export const GetRequirementFeedbackStatsByStudentAndCoachDocument = gql`
    query getRequirementFeedbackStatsByStudentAndCoach($requirementId: uuid!, $studentId: uuid!, $coachId: uuid!) {
  feedback(
    where: {feedback_skills: {requirement_id: {_eq: $requirementId}}, student_id: {_eq: $studentId}, coach_id: {_eq: $coachId}, status: {_nin: ["DRAFT", "ARCHIVED", "HIDDEN"]}}
    order_by: {observation_date: asc}
  ) {
    feedback_id
    course
    observation_date
    student_id
    status
    created_at
    reviewed_at
    coach_id
    coach {
      user_id
      email
      name
      picture_url
    }
    feedback_skills(where: {requirement_id: {_eq: $requirementId}}) {
      coach_rating
      self_rating
    }
  }
}
    `;

/**
 * __useGetRequirementFeedbackStatsByStudentAndCoachQuery__
 *
 * To run a query within a React component, call `useGetRequirementFeedbackStatsByStudentAndCoachQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequirementFeedbackStatsByStudentAndCoachQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequirementFeedbackStatsByStudentAndCoachQuery({
 *   variables: {
 *      requirementId: // value for 'requirementId'
 *      studentId: // value for 'studentId'
 *      coachId: // value for 'coachId'
 *   },
 * });
 */
export function useGetRequirementFeedbackStatsByStudentAndCoachQuery(baseOptions: Apollo.QueryHookOptions<Types.GetRequirementFeedbackStatsByStudentAndCoachQuery, Types.GetRequirementFeedbackStatsByStudentAndCoachQueryVariables> & ({ variables: Types.GetRequirementFeedbackStatsByStudentAndCoachQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetRequirementFeedbackStatsByStudentAndCoachQuery, Types.GetRequirementFeedbackStatsByStudentAndCoachQueryVariables>(GetRequirementFeedbackStatsByStudentAndCoachDocument, options);
      }
export function useGetRequirementFeedbackStatsByStudentAndCoachLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRequirementFeedbackStatsByStudentAndCoachQuery, Types.GetRequirementFeedbackStatsByStudentAndCoachQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetRequirementFeedbackStatsByStudentAndCoachQuery, Types.GetRequirementFeedbackStatsByStudentAndCoachQueryVariables>(GetRequirementFeedbackStatsByStudentAndCoachDocument, options);
        }
// @ts-ignore
export function useGetRequirementFeedbackStatsByStudentAndCoachSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetRequirementFeedbackStatsByStudentAndCoachQuery, Types.GetRequirementFeedbackStatsByStudentAndCoachQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementFeedbackStatsByStudentAndCoachQuery, Types.GetRequirementFeedbackStatsByStudentAndCoachQueryVariables>;
export function useGetRequirementFeedbackStatsByStudentAndCoachSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementFeedbackStatsByStudentAndCoachQuery, Types.GetRequirementFeedbackStatsByStudentAndCoachQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementFeedbackStatsByStudentAndCoachQuery | undefined, Types.GetRequirementFeedbackStatsByStudentAndCoachQueryVariables>;
export function useGetRequirementFeedbackStatsByStudentAndCoachSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementFeedbackStatsByStudentAndCoachQuery, Types.GetRequirementFeedbackStatsByStudentAndCoachQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetRequirementFeedbackStatsByStudentAndCoachQuery, Types.GetRequirementFeedbackStatsByStudentAndCoachQueryVariables>(GetRequirementFeedbackStatsByStudentAndCoachDocument, options);
        }
export type GetRequirementFeedbackStatsByStudentAndCoachQueryHookResult = ReturnType<typeof useGetRequirementFeedbackStatsByStudentAndCoachQuery>;
export type GetRequirementFeedbackStatsByStudentAndCoachLazyQueryHookResult = ReturnType<typeof useGetRequirementFeedbackStatsByStudentAndCoachLazyQuery>;
export type GetRequirementFeedbackStatsByStudentAndCoachSuspenseQueryHookResult = ReturnType<typeof useGetRequirementFeedbackStatsByStudentAndCoachSuspenseQuery>;
export type GetRequirementFeedbackStatsByStudentAndCoachQueryResult = Apollo.QueryResult<Types.GetRequirementFeedbackStatsByStudentAndCoachQuery, Types.GetRequirementFeedbackStatsByStudentAndCoachQueryVariables>;
export const GetCoachFeedbackCountDocument = gql`
    query getCoachFeedbackCount($coachId: uuid!) {
  feedback(where: {coach_id: {_eq: $coachId}, status: {_eq: "DONE"}}) {
    feedback_id
  }
}
    `;

/**
 * __useGetCoachFeedbackCountQuery__
 *
 * To run a query within a React component, call `useGetCoachFeedbackCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachFeedbackCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachFeedbackCountQuery({
 *   variables: {
 *      coachId: // value for 'coachId'
 *   },
 * });
 */
export function useGetCoachFeedbackCountQuery(baseOptions: Apollo.QueryHookOptions<Types.GetCoachFeedbackCountQuery, Types.GetCoachFeedbackCountQueryVariables> & ({ variables: Types.GetCoachFeedbackCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetCoachFeedbackCountQuery, Types.GetCoachFeedbackCountQueryVariables>(GetCoachFeedbackCountDocument, options);
      }
export function useGetCoachFeedbackCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetCoachFeedbackCountQuery, Types.GetCoachFeedbackCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetCoachFeedbackCountQuery, Types.GetCoachFeedbackCountQueryVariables>(GetCoachFeedbackCountDocument, options);
        }
// @ts-ignore
export function useGetCoachFeedbackCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetCoachFeedbackCountQuery, Types.GetCoachFeedbackCountQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetCoachFeedbackCountQuery, Types.GetCoachFeedbackCountQueryVariables>;
export function useGetCoachFeedbackCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetCoachFeedbackCountQuery, Types.GetCoachFeedbackCountQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetCoachFeedbackCountQuery | undefined, Types.GetCoachFeedbackCountQueryVariables>;
export function useGetCoachFeedbackCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetCoachFeedbackCountQuery, Types.GetCoachFeedbackCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetCoachFeedbackCountQuery, Types.GetCoachFeedbackCountQueryVariables>(GetCoachFeedbackCountDocument, options);
        }
export type GetCoachFeedbackCountQueryHookResult = ReturnType<typeof useGetCoachFeedbackCountQuery>;
export type GetCoachFeedbackCountLazyQueryHookResult = ReturnType<typeof useGetCoachFeedbackCountLazyQuery>;
export type GetCoachFeedbackCountSuspenseQueryHookResult = ReturnType<typeof useGetCoachFeedbackCountSuspenseQuery>;
export type GetCoachFeedbackCountQueryResult = Apollo.QueryResult<Types.GetCoachFeedbackCountQuery, Types.GetCoachFeedbackCountQueryVariables>;
export const GetLearnerFeedbackRequestCountDocument = gql`
    query getLearnerFeedbackRequestCount($studentId: uuid!) {
  feedback(where: {student_id: {_eq: $studentId}}) {
    feedback_id
  }
}
    `;

/**
 * __useGetLearnerFeedbackRequestCountQuery__
 *
 * To run a query within a React component, call `useGetLearnerFeedbackRequestCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearnerFeedbackRequestCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearnerFeedbackRequestCountQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetLearnerFeedbackRequestCountQuery(baseOptions: Apollo.QueryHookOptions<Types.GetLearnerFeedbackRequestCountQuery, Types.GetLearnerFeedbackRequestCountQueryVariables> & ({ variables: Types.GetLearnerFeedbackRequestCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetLearnerFeedbackRequestCountQuery, Types.GetLearnerFeedbackRequestCountQueryVariables>(GetLearnerFeedbackRequestCountDocument, options);
      }
export function useGetLearnerFeedbackRequestCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetLearnerFeedbackRequestCountQuery, Types.GetLearnerFeedbackRequestCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetLearnerFeedbackRequestCountQuery, Types.GetLearnerFeedbackRequestCountQueryVariables>(GetLearnerFeedbackRequestCountDocument, options);
        }
// @ts-ignore
export function useGetLearnerFeedbackRequestCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetLearnerFeedbackRequestCountQuery, Types.GetLearnerFeedbackRequestCountQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetLearnerFeedbackRequestCountQuery, Types.GetLearnerFeedbackRequestCountQueryVariables>;
export function useGetLearnerFeedbackRequestCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetLearnerFeedbackRequestCountQuery, Types.GetLearnerFeedbackRequestCountQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetLearnerFeedbackRequestCountQuery | undefined, Types.GetLearnerFeedbackRequestCountQueryVariables>;
export function useGetLearnerFeedbackRequestCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetLearnerFeedbackRequestCountQuery, Types.GetLearnerFeedbackRequestCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetLearnerFeedbackRequestCountQuery, Types.GetLearnerFeedbackRequestCountQueryVariables>(GetLearnerFeedbackRequestCountDocument, options);
        }
export type GetLearnerFeedbackRequestCountQueryHookResult = ReturnType<typeof useGetLearnerFeedbackRequestCountQuery>;
export type GetLearnerFeedbackRequestCountLazyQueryHookResult = ReturnType<typeof useGetLearnerFeedbackRequestCountLazyQuery>;
export type GetLearnerFeedbackRequestCountSuspenseQueryHookResult = ReturnType<typeof useGetLearnerFeedbackRequestCountSuspenseQuery>;
export type GetLearnerFeedbackRequestCountQueryResult = Apollo.QueryResult<Types.GetLearnerFeedbackRequestCountQuery, Types.GetLearnerFeedbackRequestCountQueryVariables>;
export const AddFeedbackAmendmentRequestDocument = gql`
    mutation addFeedbackAmendmentRequest($feedbackId: uuid!, $reason: String!) {
  insert_feedback_amendment_request_one(
    object: {feedback_id: $feedbackId, reason: $reason}
  ) {
    amendment_request_id
  }
}
    `;
export type AddFeedbackAmendmentRequestMutationFn = Apollo.MutationFunction<Types.AddFeedbackAmendmentRequestMutation, Types.AddFeedbackAmendmentRequestMutationVariables>;

/**
 * __useAddFeedbackAmendmentRequestMutation__
 *
 * To run a mutation, you first call `useAddFeedbackAmendmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFeedbackAmendmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFeedbackAmendmentRequestMutation, { data, loading, error }] = useAddFeedbackAmendmentRequestMutation({
 *   variables: {
 *      feedbackId: // value for 'feedbackId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useAddFeedbackAmendmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddFeedbackAmendmentRequestMutation, Types.AddFeedbackAmendmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddFeedbackAmendmentRequestMutation, Types.AddFeedbackAmendmentRequestMutationVariables>(AddFeedbackAmendmentRequestDocument, options);
      }
export type AddFeedbackAmendmentRequestMutationHookResult = ReturnType<typeof useAddFeedbackAmendmentRequestMutation>;
export type AddFeedbackAmendmentRequestMutationResult = Apollo.MutationResult<Types.AddFeedbackAmendmentRequestMutation>;
export type AddFeedbackAmendmentRequestMutationOptions = Apollo.BaseMutationOptions<Types.AddFeedbackAmendmentRequestMutation, Types.AddFeedbackAmendmentRequestMutationVariables>;
export const AddStudentStatementDocument = gql`
    mutation addStudentStatement($id: uuid!, $statement: String!) {
  update_feedback_amendment_request(
    where: {amendment_request_id: {_eq: $id}}
    _set: {student_statement: $statement}
  ) {
    affected_rows
  }
}
    `;
export type AddStudentStatementMutationFn = Apollo.MutationFunction<Types.AddStudentStatementMutation, Types.AddStudentStatementMutationVariables>;

/**
 * __useAddStudentStatementMutation__
 *
 * To run a mutation, you first call `useAddStudentStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStudentStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStudentStatementMutation, { data, loading, error }] = useAddStudentStatementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      statement: // value for 'statement'
 *   },
 * });
 */
export function useAddStudentStatementMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddStudentStatementMutation, Types.AddStudentStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddStudentStatementMutation, Types.AddStudentStatementMutationVariables>(AddStudentStatementDocument, options);
      }
export type AddStudentStatementMutationHookResult = ReturnType<typeof useAddStudentStatementMutation>;
export type AddStudentStatementMutationResult = Apollo.MutationResult<Types.AddStudentStatementMutation>;
export type AddStudentStatementMutationOptions = Apollo.BaseMutationOptions<Types.AddStudentStatementMutation, Types.AddStudentStatementMutationVariables>;
export const DecideFeedbackAmendmentRequestDocument = gql`
    mutation decideFeedbackAmendmentRequest($id: uuid!, $request: feedback_amendment_request_set_input!) {
  update_feedback_amendment_request(
    where: {amendment_request_id: {_eq: $id}}
    _set: $request
  ) {
    affected_rows
  }
}
    `;
export type DecideFeedbackAmendmentRequestMutationFn = Apollo.MutationFunction<Types.DecideFeedbackAmendmentRequestMutation, Types.DecideFeedbackAmendmentRequestMutationVariables>;

/**
 * __useDecideFeedbackAmendmentRequestMutation__
 *
 * To run a mutation, you first call `useDecideFeedbackAmendmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDecideFeedbackAmendmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [decideFeedbackAmendmentRequestMutation, { data, loading, error }] = useDecideFeedbackAmendmentRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      request: // value for 'request'
 *   },
 * });
 */
export function useDecideFeedbackAmendmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<Types.DecideFeedbackAmendmentRequestMutation, Types.DecideFeedbackAmendmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DecideFeedbackAmendmentRequestMutation, Types.DecideFeedbackAmendmentRequestMutationVariables>(DecideFeedbackAmendmentRequestDocument, options);
      }
export type DecideFeedbackAmendmentRequestMutationHookResult = ReturnType<typeof useDecideFeedbackAmendmentRequestMutation>;
export type DecideFeedbackAmendmentRequestMutationResult = Apollo.MutationResult<Types.DecideFeedbackAmendmentRequestMutation>;
export type DecideFeedbackAmendmentRequestMutationOptions = Apollo.BaseMutationOptions<Types.DecideFeedbackAmendmentRequestMutation, Types.DecideFeedbackAmendmentRequestMutationVariables>;
export const GetFeedbackAmendmentRequestsDocument = gql`
    query getFeedbackAmendmentRequests($feedbackId: uuid!) {
  feedback_amendment_request(
    where: {feedback_id: {_eq: $feedbackId}}
    order_by: {created_at: desc}
  ) {
    amendment_request_id
    feedback_id
    reason
    student_statement
    status
    decision_note
    decided_at
    created_at
    requester {
      user_id
      name
    }
    decider {
      user_id
      name
    }
  }
}
    `;

/**
 * __useGetFeedbackAmendmentRequestsQuery__
 *
 * To run a query within a React component, call `useGetFeedbackAmendmentRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackAmendmentRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackAmendmentRequestsQuery({
 *   variables: {
 *      feedbackId: // value for 'feedbackId'
 *   },
 * });
 */
export function useGetFeedbackAmendmentRequestsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetFeedbackAmendmentRequestsQuery, Types.GetFeedbackAmendmentRequestsQueryVariables> & ({ variables: Types.GetFeedbackAmendmentRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFeedbackAmendmentRequestsQuery, Types.GetFeedbackAmendmentRequestsQueryVariables>(GetFeedbackAmendmentRequestsDocument, options);
      }
export function useGetFeedbackAmendmentRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFeedbackAmendmentRequestsQuery, Types.GetFeedbackAmendmentRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFeedbackAmendmentRequestsQuery, Types.GetFeedbackAmendmentRequestsQueryVariables>(GetFeedbackAmendmentRequestsDocument, options);
        }
// @ts-ignore
export function useGetFeedbackAmendmentRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetFeedbackAmendmentRequestsQuery, Types.GetFeedbackAmendmentRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackAmendmentRequestsQuery, Types.GetFeedbackAmendmentRequestsQueryVariables>;
export function useGetFeedbackAmendmentRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackAmendmentRequestsQuery, Types.GetFeedbackAmendmentRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackAmendmentRequestsQuery | undefined, Types.GetFeedbackAmendmentRequestsQueryVariables>;
export function useGetFeedbackAmendmentRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackAmendmentRequestsQuery, Types.GetFeedbackAmendmentRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetFeedbackAmendmentRequestsQuery, Types.GetFeedbackAmendmentRequestsQueryVariables>(GetFeedbackAmendmentRequestsDocument, options);
        }
export type GetFeedbackAmendmentRequestsQueryHookResult = ReturnType<typeof useGetFeedbackAmendmentRequestsQuery>;
export type GetFeedbackAmendmentRequestsLazyQueryHookResult = ReturnType<typeof useGetFeedbackAmendmentRequestsLazyQuery>;
export type GetFeedbackAmendmentRequestsSuspenseQueryHookResult = ReturnType<typeof useGetFeedbackAmendmentRequestsSuspenseQuery>;
export type GetFeedbackAmendmentRequestsQueryResult = Apollo.QueryResult<Types.GetFeedbackAmendmentRequestsQuery, Types.GetFeedbackAmendmentRequestsQueryVariables>;
export const AddFeedbackCommentDocument = gql`
    mutation addFeedbackComment($feedback_id: uuid!, $user_id: uuid!, $text: String) {
  insert_feedback_comment(
    objects: [{feedback_id: $feedback_id, user_id: $user_id, text: $text}]
    on_conflict: {constraint: feedback_comment_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddFeedbackCommentMutationFn = Apollo.MutationFunction<Types.AddFeedbackCommentMutation, Types.AddFeedbackCommentMutationVariables>;

/**
 * __useAddFeedbackCommentMutation__
 *
 * To run a mutation, you first call `useAddFeedbackCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFeedbackCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFeedbackCommentMutation, { data, loading, error }] = useAddFeedbackCommentMutation({
 *   variables: {
 *      feedback_id: // value for 'feedback_id'
 *      user_id: // value for 'user_id'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useAddFeedbackCommentMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddFeedbackCommentMutation, Types.AddFeedbackCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddFeedbackCommentMutation, Types.AddFeedbackCommentMutationVariables>(AddFeedbackCommentDocument, options);
      }
export type AddFeedbackCommentMutationHookResult = ReturnType<typeof useAddFeedbackCommentMutation>;
export type AddFeedbackCommentMutationResult = Apollo.MutationResult<Types.AddFeedbackCommentMutation>;
export type AddFeedbackCommentMutationOptions = Apollo.BaseMutationOptions<Types.AddFeedbackCommentMutation, Types.AddFeedbackCommentMutationVariables>;
export const UpdateFeedbackCommentDocument = gql`
    mutation updateFeedbackComment($id: uuid!, $feedback_comment: feedback_comment_set_input!) {
  update_feedback_comment(
    where: {feedback_comment_id: {_eq: $id}}
    _set: $feedback_comment
  ) {
    affected_rows
  }
}
    `;
export type UpdateFeedbackCommentMutationFn = Apollo.MutationFunction<Types.UpdateFeedbackCommentMutation, Types.UpdateFeedbackCommentMutationVariables>;

/**
 * __useUpdateFeedbackCommentMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackCommentMutation, { data, loading, error }] = useUpdateFeedbackCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      feedback_comment: // value for 'feedback_comment'
 *   },
 * });
 */
export function useUpdateFeedbackCommentMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFeedbackCommentMutation, Types.UpdateFeedbackCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFeedbackCommentMutation, Types.UpdateFeedbackCommentMutationVariables>(UpdateFeedbackCommentDocument, options);
      }
export type UpdateFeedbackCommentMutationHookResult = ReturnType<typeof useUpdateFeedbackCommentMutation>;
export type UpdateFeedbackCommentMutationResult = Apollo.MutationResult<Types.UpdateFeedbackCommentMutation>;
export type UpdateFeedbackCommentMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFeedbackCommentMutation, Types.UpdateFeedbackCommentMutationVariables>;
export const DeleteFeedbackCommentDocument = gql`
    mutation deleteFeedbackComment($id: uuid!) {
  delete_feedback_comment(where: {feedback_comment_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteFeedbackCommentMutationFn = Apollo.MutationFunction<Types.DeleteFeedbackCommentMutation, Types.DeleteFeedbackCommentMutationVariables>;

/**
 * __useDeleteFeedbackCommentMutation__
 *
 * To run a mutation, you first call `useDeleteFeedbackCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeedbackCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeedbackCommentMutation, { data, loading, error }] = useDeleteFeedbackCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeedbackCommentMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteFeedbackCommentMutation, Types.DeleteFeedbackCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteFeedbackCommentMutation, Types.DeleteFeedbackCommentMutationVariables>(DeleteFeedbackCommentDocument, options);
      }
export type DeleteFeedbackCommentMutationHookResult = ReturnType<typeof useDeleteFeedbackCommentMutation>;
export type DeleteFeedbackCommentMutationResult = Apollo.MutationResult<Types.DeleteFeedbackCommentMutation>;
export type DeleteFeedbackCommentMutationOptions = Apollo.BaseMutationOptions<Types.DeleteFeedbackCommentMutation, Types.DeleteFeedbackCommentMutationVariables>;
export const GetFeedbackCommentDocument = gql`
    query getFeedbackComment {
  feedback_comment {
    feedback_comment_id
    feedback_id
    user_id
    text
    user {
      user_id
      name
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
  }
}
    `;

/**
 * __useGetFeedbackCommentQuery__
 *
 * To run a query within a React component, call `useGetFeedbackCommentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackCommentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackCommentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeedbackCommentQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetFeedbackCommentQuery, Types.GetFeedbackCommentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFeedbackCommentQuery, Types.GetFeedbackCommentQueryVariables>(GetFeedbackCommentDocument, options);
      }
export function useGetFeedbackCommentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFeedbackCommentQuery, Types.GetFeedbackCommentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFeedbackCommentQuery, Types.GetFeedbackCommentQueryVariables>(GetFeedbackCommentDocument, options);
        }
// @ts-ignore
export function useGetFeedbackCommentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetFeedbackCommentQuery, Types.GetFeedbackCommentQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackCommentQuery, Types.GetFeedbackCommentQueryVariables>;
export function useGetFeedbackCommentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackCommentQuery, Types.GetFeedbackCommentQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackCommentQuery | undefined, Types.GetFeedbackCommentQueryVariables>;
export function useGetFeedbackCommentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackCommentQuery, Types.GetFeedbackCommentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetFeedbackCommentQuery, Types.GetFeedbackCommentQueryVariables>(GetFeedbackCommentDocument, options);
        }
export type GetFeedbackCommentQueryHookResult = ReturnType<typeof useGetFeedbackCommentQuery>;
export type GetFeedbackCommentLazyQueryHookResult = ReturnType<typeof useGetFeedbackCommentLazyQuery>;
export type GetFeedbackCommentSuspenseQueryHookResult = ReturnType<typeof useGetFeedbackCommentSuspenseQuery>;
export type GetFeedbackCommentQueryResult = Apollo.QueryResult<Types.GetFeedbackCommentQuery, Types.GetFeedbackCommentQueryVariables>;
export const GetFeedbackCommentByIdDocument = gql`
    query getFeedbackCommentById($feedbackCommentId: uuid!) {
  feedback_comment_by_pk(feedback_comment_id: $feedbackCommentId) {
    feedback_comment_id
    feedback_id
    text
    user {
      user_id
      name
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
  }
}
    `;

/**
 * __useGetFeedbackCommentByIdQuery__
 *
 * To run a query within a React component, call `useGetFeedbackCommentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackCommentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackCommentByIdQuery({
 *   variables: {
 *      feedbackCommentId: // value for 'feedbackCommentId'
 *   },
 * });
 */
export function useGetFeedbackCommentByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetFeedbackCommentByIdQuery, Types.GetFeedbackCommentByIdQueryVariables> & ({ variables: Types.GetFeedbackCommentByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFeedbackCommentByIdQuery, Types.GetFeedbackCommentByIdQueryVariables>(GetFeedbackCommentByIdDocument, options);
      }
export function useGetFeedbackCommentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFeedbackCommentByIdQuery, Types.GetFeedbackCommentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFeedbackCommentByIdQuery, Types.GetFeedbackCommentByIdQueryVariables>(GetFeedbackCommentByIdDocument, options);
        }
// @ts-ignore
export function useGetFeedbackCommentByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetFeedbackCommentByIdQuery, Types.GetFeedbackCommentByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackCommentByIdQuery, Types.GetFeedbackCommentByIdQueryVariables>;
export function useGetFeedbackCommentByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackCommentByIdQuery, Types.GetFeedbackCommentByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackCommentByIdQuery | undefined, Types.GetFeedbackCommentByIdQueryVariables>;
export function useGetFeedbackCommentByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackCommentByIdQuery, Types.GetFeedbackCommentByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetFeedbackCommentByIdQuery, Types.GetFeedbackCommentByIdQueryVariables>(GetFeedbackCommentByIdDocument, options);
        }
export type GetFeedbackCommentByIdQueryHookResult = ReturnType<typeof useGetFeedbackCommentByIdQuery>;
export type GetFeedbackCommentByIdLazyQueryHookResult = ReturnType<typeof useGetFeedbackCommentByIdLazyQuery>;
export type GetFeedbackCommentByIdSuspenseQueryHookResult = ReturnType<typeof useGetFeedbackCommentByIdSuspenseQuery>;
export type GetFeedbackCommentByIdQueryResult = Apollo.QueryResult<Types.GetFeedbackCommentByIdQuery, Types.GetFeedbackCommentByIdQueryVariables>;
export const GetFeedbackCommentByFeedbackIdDocument = gql`
    query getFeedbackCommentByFeedbackId($feedbackId: uuid!) {
  feedback_comment(where: {feedback_id: {_eq: $feedbackId}}) {
    feedback_comment_id
    feedback_id
    user_id
    text
    created_at
    user {
      user_id
      name
      picture_url
      role
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
  }
}
    `;

/**
 * __useGetFeedbackCommentByFeedbackIdQuery__
 *
 * To run a query within a React component, call `useGetFeedbackCommentByFeedbackIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackCommentByFeedbackIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackCommentByFeedbackIdQuery({
 *   variables: {
 *      feedbackId: // value for 'feedbackId'
 *   },
 * });
 */
export function useGetFeedbackCommentByFeedbackIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetFeedbackCommentByFeedbackIdQuery, Types.GetFeedbackCommentByFeedbackIdQueryVariables> & ({ variables: Types.GetFeedbackCommentByFeedbackIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFeedbackCommentByFeedbackIdQuery, Types.GetFeedbackCommentByFeedbackIdQueryVariables>(GetFeedbackCommentByFeedbackIdDocument, options);
      }
export function useGetFeedbackCommentByFeedbackIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFeedbackCommentByFeedbackIdQuery, Types.GetFeedbackCommentByFeedbackIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFeedbackCommentByFeedbackIdQuery, Types.GetFeedbackCommentByFeedbackIdQueryVariables>(GetFeedbackCommentByFeedbackIdDocument, options);
        }
// @ts-ignore
export function useGetFeedbackCommentByFeedbackIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetFeedbackCommentByFeedbackIdQuery, Types.GetFeedbackCommentByFeedbackIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackCommentByFeedbackIdQuery, Types.GetFeedbackCommentByFeedbackIdQueryVariables>;
export function useGetFeedbackCommentByFeedbackIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackCommentByFeedbackIdQuery, Types.GetFeedbackCommentByFeedbackIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackCommentByFeedbackIdQuery | undefined, Types.GetFeedbackCommentByFeedbackIdQueryVariables>;
export function useGetFeedbackCommentByFeedbackIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackCommentByFeedbackIdQuery, Types.GetFeedbackCommentByFeedbackIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetFeedbackCommentByFeedbackIdQuery, Types.GetFeedbackCommentByFeedbackIdQueryVariables>(GetFeedbackCommentByFeedbackIdDocument, options);
        }
export type GetFeedbackCommentByFeedbackIdQueryHookResult = ReturnType<typeof useGetFeedbackCommentByFeedbackIdQuery>;
export type GetFeedbackCommentByFeedbackIdLazyQueryHookResult = ReturnType<typeof useGetFeedbackCommentByFeedbackIdLazyQuery>;
export type GetFeedbackCommentByFeedbackIdSuspenseQueryHookResult = ReturnType<typeof useGetFeedbackCommentByFeedbackIdSuspenseQuery>;
export type GetFeedbackCommentByFeedbackIdQueryResult = Apollo.QueryResult<Types.GetFeedbackCommentByFeedbackIdQuery, Types.GetFeedbackCommentByFeedbackIdQueryVariables>;
export const AddFeedbackSkillDocument = gql`
    mutation addFeedbackSkill($feedback_id: uuid!, $requirement_id: uuid!, $student_comments: String, $coach_comments: String, $areas: String, $actions: String, $self_rating: Int, $coach_rating: Int, $note: String) {
  insert_feedback_skill(
    objects: [{feedback_id: $feedback_id, requirement_id: $requirement_id, student_comments: $student_comments, coach_comments: $coach_comments, areas: $areas, actions: $actions, self_rating: $self_rating, coach_rating: $coach_rating, note: $note}]
    on_conflict: {constraint: feedback_skill_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      feedback_skill_id
    }
  }
}
    `;
export type AddFeedbackSkillMutationFn = Apollo.MutationFunction<Types.AddFeedbackSkillMutation, Types.AddFeedbackSkillMutationVariables>;

/**
 * __useAddFeedbackSkillMutation__
 *
 * To run a mutation, you first call `useAddFeedbackSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFeedbackSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFeedbackSkillMutation, { data, loading, error }] = useAddFeedbackSkillMutation({
 *   variables: {
 *      feedback_id: // value for 'feedback_id'
 *      requirement_id: // value for 'requirement_id'
 *      student_comments: // value for 'student_comments'
 *      coach_comments: // value for 'coach_comments'
 *      areas: // value for 'areas'
 *      actions: // value for 'actions'
 *      self_rating: // value for 'self_rating'
 *      coach_rating: // value for 'coach_rating'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useAddFeedbackSkillMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddFeedbackSkillMutation, Types.AddFeedbackSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddFeedbackSkillMutation, Types.AddFeedbackSkillMutationVariables>(AddFeedbackSkillDocument, options);
      }
export type AddFeedbackSkillMutationHookResult = ReturnType<typeof useAddFeedbackSkillMutation>;
export type AddFeedbackSkillMutationResult = Apollo.MutationResult<Types.AddFeedbackSkillMutation>;
export type AddFeedbackSkillMutationOptions = Apollo.BaseMutationOptions<Types.AddFeedbackSkillMutation, Types.AddFeedbackSkillMutationVariables>;
export const UpdateFeedbackSkillDocument = gql`
    mutation updateFeedbackSkill($id: uuid!, $feedback_skill: feedback_skill_set_input!) {
  update_feedback_skill(
    where: {feedback_skill_id: {_eq: $id}}
    _set: $feedback_skill
  ) {
    affected_rows
  }
}
    `;
export type UpdateFeedbackSkillMutationFn = Apollo.MutationFunction<Types.UpdateFeedbackSkillMutation, Types.UpdateFeedbackSkillMutationVariables>;

/**
 * __useUpdateFeedbackSkillMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackSkillMutation, { data, loading, error }] = useUpdateFeedbackSkillMutation({
 *   variables: {
 *      id: // value for 'id'
 *      feedback_skill: // value for 'feedback_skill'
 *   },
 * });
 */
export function useUpdateFeedbackSkillMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFeedbackSkillMutation, Types.UpdateFeedbackSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFeedbackSkillMutation, Types.UpdateFeedbackSkillMutationVariables>(UpdateFeedbackSkillDocument, options);
      }
export type UpdateFeedbackSkillMutationHookResult = ReturnType<typeof useUpdateFeedbackSkillMutation>;
export type UpdateFeedbackSkillMutationResult = Apollo.MutationResult<Types.UpdateFeedbackSkillMutation>;
export type UpdateFeedbackSkillMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFeedbackSkillMutation, Types.UpdateFeedbackSkillMutationVariables>;
export const DeleteFeedbackSkillDocument = gql`
    mutation deleteFeedbackSkill($id: uuid!) {
  delete_feedback_skill(where: {feedback_skill_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteFeedbackSkillMutationFn = Apollo.MutationFunction<Types.DeleteFeedbackSkillMutation, Types.DeleteFeedbackSkillMutationVariables>;

/**
 * __useDeleteFeedbackSkillMutation__
 *
 * To run a mutation, you first call `useDeleteFeedbackSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeedbackSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeedbackSkillMutation, { data, loading, error }] = useDeleteFeedbackSkillMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeedbackSkillMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteFeedbackSkillMutation, Types.DeleteFeedbackSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteFeedbackSkillMutation, Types.DeleteFeedbackSkillMutationVariables>(DeleteFeedbackSkillDocument, options);
      }
export type DeleteFeedbackSkillMutationHookResult = ReturnType<typeof useDeleteFeedbackSkillMutation>;
export type DeleteFeedbackSkillMutationResult = Apollo.MutationResult<Types.DeleteFeedbackSkillMutation>;
export type DeleteFeedbackSkillMutationOptions = Apollo.BaseMutationOptions<Types.DeleteFeedbackSkillMutation, Types.DeleteFeedbackSkillMutationVariables>;
export const GetFeedbackSkillDocument = gql`
    query getFeedbackSkill {
  feedback_skill {
    feedback_skill_id
    requirement_id
    feedback_id
    student_comments
    coach_comments
    areas
    actions
    skill_level
    note
  }
}
    `;

/**
 * __useGetFeedbackSkillQuery__
 *
 * To run a query within a React component, call `useGetFeedbackSkillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackSkillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackSkillQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeedbackSkillQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetFeedbackSkillQuery, Types.GetFeedbackSkillQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFeedbackSkillQuery, Types.GetFeedbackSkillQueryVariables>(GetFeedbackSkillDocument, options);
      }
export function useGetFeedbackSkillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFeedbackSkillQuery, Types.GetFeedbackSkillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFeedbackSkillQuery, Types.GetFeedbackSkillQueryVariables>(GetFeedbackSkillDocument, options);
        }
// @ts-ignore
export function useGetFeedbackSkillSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetFeedbackSkillQuery, Types.GetFeedbackSkillQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackSkillQuery, Types.GetFeedbackSkillQueryVariables>;
export function useGetFeedbackSkillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackSkillQuery, Types.GetFeedbackSkillQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackSkillQuery | undefined, Types.GetFeedbackSkillQueryVariables>;
export function useGetFeedbackSkillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackSkillQuery, Types.GetFeedbackSkillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetFeedbackSkillQuery, Types.GetFeedbackSkillQueryVariables>(GetFeedbackSkillDocument, options);
        }
export type GetFeedbackSkillQueryHookResult = ReturnType<typeof useGetFeedbackSkillQuery>;
export type GetFeedbackSkillLazyQueryHookResult = ReturnType<typeof useGetFeedbackSkillLazyQuery>;
export type GetFeedbackSkillSuspenseQueryHookResult = ReturnType<typeof useGetFeedbackSkillSuspenseQuery>;
export type GetFeedbackSkillQueryResult = Apollo.QueryResult<Types.GetFeedbackSkillQuery, Types.GetFeedbackSkillQueryVariables>;
export const GetFeedbackSkillByIdDocument = gql`
    query getFeedbackSkillById($feedback_skillId: uuid!) {
  feedback_skill_by_pk(feedback_skill_id: $feedback_skillId) {
    feedback_skill_id
    requirement_id
    feedback_id
    student_comments
    coach_comments
    areas
    actions
    skill_level
    note
  }
}
    `;

/**
 * __useGetFeedbackSkillByIdQuery__
 *
 * To run a query within a React component, call `useGetFeedbackSkillByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackSkillByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackSkillByIdQuery({
 *   variables: {
 *      feedback_skillId: // value for 'feedback_skillId'
 *   },
 * });
 */
export function useGetFeedbackSkillByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetFeedbackSkillByIdQuery, Types.GetFeedbackSkillByIdQueryVariables> & ({ variables: Types.GetFeedbackSkillByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFeedbackSkillByIdQuery, Types.GetFeedbackSkillByIdQueryVariables>(GetFeedbackSkillByIdDocument, options);
      }
export function useGetFeedbackSkillByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFeedbackSkillByIdQuery, Types.GetFeedbackSkillByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFeedbackSkillByIdQuery, Types.GetFeedbackSkillByIdQueryVariables>(GetFeedbackSkillByIdDocument, options);
        }
// @ts-ignore
export function useGetFeedbackSkillByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetFeedbackSkillByIdQuery, Types.GetFeedbackSkillByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackSkillByIdQuery, Types.GetFeedbackSkillByIdQueryVariables>;
export function useGetFeedbackSkillByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackSkillByIdQuery, Types.GetFeedbackSkillByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackSkillByIdQuery | undefined, Types.GetFeedbackSkillByIdQueryVariables>;
export function useGetFeedbackSkillByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackSkillByIdQuery, Types.GetFeedbackSkillByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetFeedbackSkillByIdQuery, Types.GetFeedbackSkillByIdQueryVariables>(GetFeedbackSkillByIdDocument, options);
        }
export type GetFeedbackSkillByIdQueryHookResult = ReturnType<typeof useGetFeedbackSkillByIdQuery>;
export type GetFeedbackSkillByIdLazyQueryHookResult = ReturnType<typeof useGetFeedbackSkillByIdLazyQuery>;
export type GetFeedbackSkillByIdSuspenseQueryHookResult = ReturnType<typeof useGetFeedbackSkillByIdSuspenseQuery>;
export type GetFeedbackSkillByIdQueryResult = Apollo.QueryResult<Types.GetFeedbackSkillByIdQuery, Types.GetFeedbackSkillByIdQueryVariables>;
export const AddFeedbackTagDocument = gql`
    mutation addFeedbackTag($feedbackId: uuid!, $tagId: uuid) {
  insert_feedback_tag(
    objects: [{feedback_id: $feedbackId, tag_id: $tagId}]
    on_conflict: {constraint: feedback_tag_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddFeedbackTagMutationFn = Apollo.MutationFunction<Types.AddFeedbackTagMutation, Types.AddFeedbackTagMutationVariables>;

/**
 * __useAddFeedbackTagMutation__
 *
 * To run a mutation, you first call `useAddFeedbackTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFeedbackTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFeedbackTagMutation, { data, loading, error }] = useAddFeedbackTagMutation({
 *   variables: {
 *      feedbackId: // value for 'feedbackId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useAddFeedbackTagMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddFeedbackTagMutation, Types.AddFeedbackTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddFeedbackTagMutation, Types.AddFeedbackTagMutationVariables>(AddFeedbackTagDocument, options);
      }
export type AddFeedbackTagMutationHookResult = ReturnType<typeof useAddFeedbackTagMutation>;
export type AddFeedbackTagMutationResult = Apollo.MutationResult<Types.AddFeedbackTagMutation>;
export type AddFeedbackTagMutationOptions = Apollo.BaseMutationOptions<Types.AddFeedbackTagMutation, Types.AddFeedbackTagMutationVariables>;
export const AddFeedbackTagsDocument = gql`
    mutation addFeedbackTags($objects: [feedback_tag_insert_input!]!) {
  insert_feedback_tag(
    objects: $objects
    on_conflict: {constraint: feedback_tag_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddFeedbackTagsMutationFn = Apollo.MutationFunction<Types.AddFeedbackTagsMutation, Types.AddFeedbackTagsMutationVariables>;

/**
 * __useAddFeedbackTagsMutation__
 *
 * To run a mutation, you first call `useAddFeedbackTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFeedbackTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFeedbackTagsMutation, { data, loading, error }] = useAddFeedbackTagsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddFeedbackTagsMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddFeedbackTagsMutation, Types.AddFeedbackTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddFeedbackTagsMutation, Types.AddFeedbackTagsMutationVariables>(AddFeedbackTagsDocument, options);
      }
export type AddFeedbackTagsMutationHookResult = ReturnType<typeof useAddFeedbackTagsMutation>;
export type AddFeedbackTagsMutationResult = Apollo.MutationResult<Types.AddFeedbackTagsMutation>;
export type AddFeedbackTagsMutationOptions = Apollo.BaseMutationOptions<Types.AddFeedbackTagsMutation, Types.AddFeedbackTagsMutationVariables>;
export const DeleteFeedbackTagDocument = gql`
    mutation deleteFeedbackTag($id: uuid!) {
  delete_feedback_tag(where: {feedback_tag_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteFeedbackTagMutationFn = Apollo.MutationFunction<Types.DeleteFeedbackTagMutation, Types.DeleteFeedbackTagMutationVariables>;

/**
 * __useDeleteFeedbackTagMutation__
 *
 * To run a mutation, you first call `useDeleteFeedbackTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeedbackTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeedbackTagMutation, { data, loading, error }] = useDeleteFeedbackTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeedbackTagMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteFeedbackTagMutation, Types.DeleteFeedbackTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteFeedbackTagMutation, Types.DeleteFeedbackTagMutationVariables>(DeleteFeedbackTagDocument, options);
      }
export type DeleteFeedbackTagMutationHookResult = ReturnType<typeof useDeleteFeedbackTagMutation>;
export type DeleteFeedbackTagMutationResult = Apollo.MutationResult<Types.DeleteFeedbackTagMutation>;
export type DeleteFeedbackTagMutationOptions = Apollo.BaseMutationOptions<Types.DeleteFeedbackTagMutation, Types.DeleteFeedbackTagMutationVariables>;
export const DeleteFeedbackTagByTagAndFeedbackDocument = gql`
    mutation deleteFeedbackTagByTagAndFeedback($feedbackId: uuid!, $tagId: uuid!) {
  delete_feedback_tag(
    where: {feedback_id: {_eq: $feedbackId}, tag_id: {_eq: $tagId}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteFeedbackTagByTagAndFeedbackMutationFn = Apollo.MutationFunction<Types.DeleteFeedbackTagByTagAndFeedbackMutation, Types.DeleteFeedbackTagByTagAndFeedbackMutationVariables>;

/**
 * __useDeleteFeedbackTagByTagAndFeedbackMutation__
 *
 * To run a mutation, you first call `useDeleteFeedbackTagByTagAndFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeedbackTagByTagAndFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeedbackTagByTagAndFeedbackMutation, { data, loading, error }] = useDeleteFeedbackTagByTagAndFeedbackMutation({
 *   variables: {
 *      feedbackId: // value for 'feedbackId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useDeleteFeedbackTagByTagAndFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteFeedbackTagByTagAndFeedbackMutation, Types.DeleteFeedbackTagByTagAndFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteFeedbackTagByTagAndFeedbackMutation, Types.DeleteFeedbackTagByTagAndFeedbackMutationVariables>(DeleteFeedbackTagByTagAndFeedbackDocument, options);
      }
export type DeleteFeedbackTagByTagAndFeedbackMutationHookResult = ReturnType<typeof useDeleteFeedbackTagByTagAndFeedbackMutation>;
export type DeleteFeedbackTagByTagAndFeedbackMutationResult = Apollo.MutationResult<Types.DeleteFeedbackTagByTagAndFeedbackMutation>;
export type DeleteFeedbackTagByTagAndFeedbackMutationOptions = Apollo.BaseMutationOptions<Types.DeleteFeedbackTagByTagAndFeedbackMutation, Types.DeleteFeedbackTagByTagAndFeedbackMutationVariables>;
export const GetFeedbackTagsDocument = gql`
    query getFeedbackTags {
  feedback_tag {
    feedback_tag_id
    tag_id
    feedback_id
  }
}
    `;

/**
 * __useGetFeedbackTagsQuery__
 *
 * To run a query within a React component, call `useGetFeedbackTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeedbackTagsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetFeedbackTagsQuery, Types.GetFeedbackTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFeedbackTagsQuery, Types.GetFeedbackTagsQueryVariables>(GetFeedbackTagsDocument, options);
      }
export function useGetFeedbackTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFeedbackTagsQuery, Types.GetFeedbackTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFeedbackTagsQuery, Types.GetFeedbackTagsQueryVariables>(GetFeedbackTagsDocument, options);
        }
// @ts-ignore
export function useGetFeedbackTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetFeedbackTagsQuery, Types.GetFeedbackTagsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackTagsQuery, Types.GetFeedbackTagsQueryVariables>;
export function useGetFeedbackTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackTagsQuery, Types.GetFeedbackTagsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackTagsQuery | undefined, Types.GetFeedbackTagsQueryVariables>;
export function useGetFeedbackTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackTagsQuery, Types.GetFeedbackTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetFeedbackTagsQuery, Types.GetFeedbackTagsQueryVariables>(GetFeedbackTagsDocument, options);
        }
export type GetFeedbackTagsQueryHookResult = ReturnType<typeof useGetFeedbackTagsQuery>;
export type GetFeedbackTagsLazyQueryHookResult = ReturnType<typeof useGetFeedbackTagsLazyQuery>;
export type GetFeedbackTagsSuspenseQueryHookResult = ReturnType<typeof useGetFeedbackTagsSuspenseQuery>;
export type GetFeedbackTagsQueryResult = Apollo.QueryResult<Types.GetFeedbackTagsQuery, Types.GetFeedbackTagsQueryVariables>;
export const GetFeedbackTagsByFeedbackIdDocument = gql`
    query getFeedbackTagsByFeedbackId($feedbackId: uuid!) {
  feedback_tag(where: {feedback_id: {_eq: $feedbackId}}) {
    feedback_tag_id
    tag {
      name
      tag_id
      type
    }
  }
}
    `;

/**
 * __useGetFeedbackTagsByFeedbackIdQuery__
 *
 * To run a query within a React component, call `useGetFeedbackTagsByFeedbackIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackTagsByFeedbackIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackTagsByFeedbackIdQuery({
 *   variables: {
 *      feedbackId: // value for 'feedbackId'
 *   },
 * });
 */
export function useGetFeedbackTagsByFeedbackIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetFeedbackTagsByFeedbackIdQuery, Types.GetFeedbackTagsByFeedbackIdQueryVariables> & ({ variables: Types.GetFeedbackTagsByFeedbackIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFeedbackTagsByFeedbackIdQuery, Types.GetFeedbackTagsByFeedbackIdQueryVariables>(GetFeedbackTagsByFeedbackIdDocument, options);
      }
export function useGetFeedbackTagsByFeedbackIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFeedbackTagsByFeedbackIdQuery, Types.GetFeedbackTagsByFeedbackIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFeedbackTagsByFeedbackIdQuery, Types.GetFeedbackTagsByFeedbackIdQueryVariables>(GetFeedbackTagsByFeedbackIdDocument, options);
        }
// @ts-ignore
export function useGetFeedbackTagsByFeedbackIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetFeedbackTagsByFeedbackIdQuery, Types.GetFeedbackTagsByFeedbackIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackTagsByFeedbackIdQuery, Types.GetFeedbackTagsByFeedbackIdQueryVariables>;
export function useGetFeedbackTagsByFeedbackIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackTagsByFeedbackIdQuery, Types.GetFeedbackTagsByFeedbackIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackTagsByFeedbackIdQuery | undefined, Types.GetFeedbackTagsByFeedbackIdQueryVariables>;
export function useGetFeedbackTagsByFeedbackIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackTagsByFeedbackIdQuery, Types.GetFeedbackTagsByFeedbackIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetFeedbackTagsByFeedbackIdQuery, Types.GetFeedbackTagsByFeedbackIdQueryVariables>(GetFeedbackTagsByFeedbackIdDocument, options);
        }
export type GetFeedbackTagsByFeedbackIdQueryHookResult = ReturnType<typeof useGetFeedbackTagsByFeedbackIdQuery>;
export type GetFeedbackTagsByFeedbackIdLazyQueryHookResult = ReturnType<typeof useGetFeedbackTagsByFeedbackIdLazyQuery>;
export type GetFeedbackTagsByFeedbackIdSuspenseQueryHookResult = ReturnType<typeof useGetFeedbackTagsByFeedbackIdSuspenseQuery>;
export type GetFeedbackTagsByFeedbackIdQueryResult = Apollo.QueryResult<Types.GetFeedbackTagsByFeedbackIdQuery, Types.GetFeedbackTagsByFeedbackIdQueryVariables>;
export const UpsertFeedbackViewDocument = gql`
    mutation upsertFeedbackView($object: feedback_view_insert_input!) {
  insert_feedback_view_one(
    object: $object
    on_conflict: {constraint: feedback_view_pkey, update_columns: [count, updated_at]}
  ) {
    feedback_view_id
    feedback_id
    user_id
    count
    updated_at
  }
}
    `;
export type UpsertFeedbackViewMutationFn = Apollo.MutationFunction<Types.UpsertFeedbackViewMutation, Types.UpsertFeedbackViewMutationVariables>;

/**
 * __useUpsertFeedbackViewMutation__
 *
 * To run a mutation, you first call `useUpsertFeedbackViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFeedbackViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertFeedbackViewMutation, { data, loading, error }] = useUpsertFeedbackViewMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpsertFeedbackViewMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpsertFeedbackViewMutation, Types.UpsertFeedbackViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpsertFeedbackViewMutation, Types.UpsertFeedbackViewMutationVariables>(UpsertFeedbackViewDocument, options);
      }
export type UpsertFeedbackViewMutationHookResult = ReturnType<typeof useUpsertFeedbackViewMutation>;
export type UpsertFeedbackViewMutationResult = Apollo.MutationResult<Types.UpsertFeedbackViewMutation>;
export type UpsertFeedbackViewMutationOptions = Apollo.BaseMutationOptions<Types.UpsertFeedbackViewMutation, Types.UpsertFeedbackViewMutationVariables>;
export const IncrementFeedbackViewCountDocument = gql`
    mutation incrementFeedbackViewCount($feedbackViewId: uuid!, $incrementBy: Int = 1) {
  update_feedback_view(
    where: {feedback_view_id: {_eq: $feedbackViewId}}
    _inc: {count: $incrementBy}
  ) {
    affected_rows
    returning {
      feedback_view_id
      count
      updated_at
    }
  }
}
    `;
export type IncrementFeedbackViewCountMutationFn = Apollo.MutationFunction<Types.IncrementFeedbackViewCountMutation, Types.IncrementFeedbackViewCountMutationVariables>;

/**
 * __useIncrementFeedbackViewCountMutation__
 *
 * To run a mutation, you first call `useIncrementFeedbackViewCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIncrementFeedbackViewCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [incrementFeedbackViewCountMutation, { data, loading, error }] = useIncrementFeedbackViewCountMutation({
 *   variables: {
 *      feedbackViewId: // value for 'feedbackViewId'
 *      incrementBy: // value for 'incrementBy'
 *   },
 * });
 */
export function useIncrementFeedbackViewCountMutation(baseOptions?: Apollo.MutationHookOptions<Types.IncrementFeedbackViewCountMutation, Types.IncrementFeedbackViewCountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.IncrementFeedbackViewCountMutation, Types.IncrementFeedbackViewCountMutationVariables>(IncrementFeedbackViewCountDocument, options);
      }
export type IncrementFeedbackViewCountMutationHookResult = ReturnType<typeof useIncrementFeedbackViewCountMutation>;
export type IncrementFeedbackViewCountMutationResult = Apollo.MutationResult<Types.IncrementFeedbackViewCountMutation>;
export type IncrementFeedbackViewCountMutationOptions = Apollo.BaseMutationOptions<Types.IncrementFeedbackViewCountMutation, Types.IncrementFeedbackViewCountMutationVariables>;
export const DeleteFeedbackViewDocument = gql`
    mutation deleteFeedbackView($id: uuid!) {
  delete_feedback_view(where: {feedback_view_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteFeedbackViewMutationFn = Apollo.MutationFunction<Types.DeleteFeedbackViewMutation, Types.DeleteFeedbackViewMutationVariables>;

/**
 * __useDeleteFeedbackViewMutation__
 *
 * To run a mutation, you first call `useDeleteFeedbackViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeedbackViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeedbackViewMutation, { data, loading, error }] = useDeleteFeedbackViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeedbackViewMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteFeedbackViewMutation, Types.DeleteFeedbackViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteFeedbackViewMutation, Types.DeleteFeedbackViewMutationVariables>(DeleteFeedbackViewDocument, options);
      }
export type DeleteFeedbackViewMutationHookResult = ReturnType<typeof useDeleteFeedbackViewMutation>;
export type DeleteFeedbackViewMutationResult = Apollo.MutationResult<Types.DeleteFeedbackViewMutation>;
export type DeleteFeedbackViewMutationOptions = Apollo.BaseMutationOptions<Types.DeleteFeedbackViewMutation, Types.DeleteFeedbackViewMutationVariables>;
export const GetFeedbackViewsDocument = gql`
    query getFeedbackViews {
  feedback_view(order_by: {updated_at: desc}) {
    feedback_view_id
    feedback_id
    user_id
    count
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetFeedbackViewsQuery__
 *
 * To run a query within a React component, call `useGetFeedbackViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackViewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeedbackViewsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetFeedbackViewsQuery, Types.GetFeedbackViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFeedbackViewsQuery, Types.GetFeedbackViewsQueryVariables>(GetFeedbackViewsDocument, options);
      }
export function useGetFeedbackViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFeedbackViewsQuery, Types.GetFeedbackViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFeedbackViewsQuery, Types.GetFeedbackViewsQueryVariables>(GetFeedbackViewsDocument, options);
        }
// @ts-ignore
export function useGetFeedbackViewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetFeedbackViewsQuery, Types.GetFeedbackViewsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackViewsQuery, Types.GetFeedbackViewsQueryVariables>;
export function useGetFeedbackViewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackViewsQuery, Types.GetFeedbackViewsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackViewsQuery | undefined, Types.GetFeedbackViewsQueryVariables>;
export function useGetFeedbackViewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackViewsQuery, Types.GetFeedbackViewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetFeedbackViewsQuery, Types.GetFeedbackViewsQueryVariables>(GetFeedbackViewsDocument, options);
        }
export type GetFeedbackViewsQueryHookResult = ReturnType<typeof useGetFeedbackViewsQuery>;
export type GetFeedbackViewsLazyQueryHookResult = ReturnType<typeof useGetFeedbackViewsLazyQuery>;
export type GetFeedbackViewsSuspenseQueryHookResult = ReturnType<typeof useGetFeedbackViewsSuspenseQuery>;
export type GetFeedbackViewsQueryResult = Apollo.QueryResult<Types.GetFeedbackViewsQuery, Types.GetFeedbackViewsQueryVariables>;
export const GetFeedbackViewsByOrgIdDocument = gql`
    query getFeedbackViewsByOrgId($organizationId: uuid!, $sinceDate: timestamptz!) {
  feedback_view(
    where: {updated_at: {_gte: $sinceDate}, feedback: {org_id: {_eq: $organizationId}}}
    order_by: {updated_at: desc}
  ) {
    feedback_view_id
    feedback_id
    user_id
    count
    created_at
    updated_at
    feedback {
      feedback_id
      status
      created_at
      reviewed_at
      student_id
      coach_id
    }
    user {
      user_id
      name
      role
    }
  }
}
    `;

/**
 * __useGetFeedbackViewsByOrgIdQuery__
 *
 * To run a query within a React component, call `useGetFeedbackViewsByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackViewsByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackViewsByOrgIdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      sinceDate: // value for 'sinceDate'
 *   },
 * });
 */
export function useGetFeedbackViewsByOrgIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetFeedbackViewsByOrgIdQuery, Types.GetFeedbackViewsByOrgIdQueryVariables> & ({ variables: Types.GetFeedbackViewsByOrgIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFeedbackViewsByOrgIdQuery, Types.GetFeedbackViewsByOrgIdQueryVariables>(GetFeedbackViewsByOrgIdDocument, options);
      }
export function useGetFeedbackViewsByOrgIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFeedbackViewsByOrgIdQuery, Types.GetFeedbackViewsByOrgIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFeedbackViewsByOrgIdQuery, Types.GetFeedbackViewsByOrgIdQueryVariables>(GetFeedbackViewsByOrgIdDocument, options);
        }
// @ts-ignore
export function useGetFeedbackViewsByOrgIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetFeedbackViewsByOrgIdQuery, Types.GetFeedbackViewsByOrgIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackViewsByOrgIdQuery, Types.GetFeedbackViewsByOrgIdQueryVariables>;
export function useGetFeedbackViewsByOrgIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackViewsByOrgIdQuery, Types.GetFeedbackViewsByOrgIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackViewsByOrgIdQuery | undefined, Types.GetFeedbackViewsByOrgIdQueryVariables>;
export function useGetFeedbackViewsByOrgIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackViewsByOrgIdQuery, Types.GetFeedbackViewsByOrgIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetFeedbackViewsByOrgIdQuery, Types.GetFeedbackViewsByOrgIdQueryVariables>(GetFeedbackViewsByOrgIdDocument, options);
        }
export type GetFeedbackViewsByOrgIdQueryHookResult = ReturnType<typeof useGetFeedbackViewsByOrgIdQuery>;
export type GetFeedbackViewsByOrgIdLazyQueryHookResult = ReturnType<typeof useGetFeedbackViewsByOrgIdLazyQuery>;
export type GetFeedbackViewsByOrgIdSuspenseQueryHookResult = ReturnType<typeof useGetFeedbackViewsByOrgIdSuspenseQuery>;
export type GetFeedbackViewsByOrgIdQueryResult = Apollo.QueryResult<Types.GetFeedbackViewsByOrgIdQuery, Types.GetFeedbackViewsByOrgIdQueryVariables>;
export const GetFeedbackViewsByOrgIdsDocument = gql`
    query getFeedbackViewsByOrgIds($organizationIds: [uuid!]!, $sinceDate: timestamptz!, $excludeTestOrgNamePattern: String!) {
  feedback_view(
    where: {updated_at: {_gte: $sinceDate}, feedback: {org_id: {_in: $organizationIds}, organization: {name: {_nilike: $excludeTestOrgNamePattern}}}}
    order_by: {updated_at: desc}
  ) {
    feedback_view_id
    feedback_id
    user_id
    count
    created_at
    updated_at
    feedback {
      feedback_id
      status
      created_at
      reviewed_at
      student_id
      coach_id
    }
    user {
      user_id
      name
      role
    }
  }
}
    `;

/**
 * __useGetFeedbackViewsByOrgIdsQuery__
 *
 * To run a query within a React component, call `useGetFeedbackViewsByOrgIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackViewsByOrgIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackViewsByOrgIdsQuery({
 *   variables: {
 *      organizationIds: // value for 'organizationIds'
 *      sinceDate: // value for 'sinceDate'
 *      excludeTestOrgNamePattern: // value for 'excludeTestOrgNamePattern'
 *   },
 * });
 */
export function useGetFeedbackViewsByOrgIdsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetFeedbackViewsByOrgIdsQuery, Types.GetFeedbackViewsByOrgIdsQueryVariables> & ({ variables: Types.GetFeedbackViewsByOrgIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFeedbackViewsByOrgIdsQuery, Types.GetFeedbackViewsByOrgIdsQueryVariables>(GetFeedbackViewsByOrgIdsDocument, options);
      }
export function useGetFeedbackViewsByOrgIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFeedbackViewsByOrgIdsQuery, Types.GetFeedbackViewsByOrgIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFeedbackViewsByOrgIdsQuery, Types.GetFeedbackViewsByOrgIdsQueryVariables>(GetFeedbackViewsByOrgIdsDocument, options);
        }
// @ts-ignore
export function useGetFeedbackViewsByOrgIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetFeedbackViewsByOrgIdsQuery, Types.GetFeedbackViewsByOrgIdsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackViewsByOrgIdsQuery, Types.GetFeedbackViewsByOrgIdsQueryVariables>;
export function useGetFeedbackViewsByOrgIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackViewsByOrgIdsQuery, Types.GetFeedbackViewsByOrgIdsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackViewsByOrgIdsQuery | undefined, Types.GetFeedbackViewsByOrgIdsQueryVariables>;
export function useGetFeedbackViewsByOrgIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackViewsByOrgIdsQuery, Types.GetFeedbackViewsByOrgIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetFeedbackViewsByOrgIdsQuery, Types.GetFeedbackViewsByOrgIdsQueryVariables>(GetFeedbackViewsByOrgIdsDocument, options);
        }
export type GetFeedbackViewsByOrgIdsQueryHookResult = ReturnType<typeof useGetFeedbackViewsByOrgIdsQuery>;
export type GetFeedbackViewsByOrgIdsLazyQueryHookResult = ReturnType<typeof useGetFeedbackViewsByOrgIdsLazyQuery>;
export type GetFeedbackViewsByOrgIdsSuspenseQueryHookResult = ReturnType<typeof useGetFeedbackViewsByOrgIdsSuspenseQuery>;
export type GetFeedbackViewsByOrgIdsQueryResult = Apollo.QueryResult<Types.GetFeedbackViewsByOrgIdsQuery, Types.GetFeedbackViewsByOrgIdsQueryVariables>;
export const GetFeedbackViewSummaryByOrgIdDocument = gql`
    query getFeedbackViewSummaryByOrgId($organizationId: uuid!, $sinceDate: timestamptz!) {
  feedback_view_aggregate(
    where: {updated_at: {_gte: $sinceDate}, feedback: {org_id: {_eq: $organizationId}}}
  ) {
    aggregate {
      count
      sum {
        count
      }
    }
  }
}
    `;

/**
 * __useGetFeedbackViewSummaryByOrgIdQuery__
 *
 * To run a query within a React component, call `useGetFeedbackViewSummaryByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackViewSummaryByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackViewSummaryByOrgIdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      sinceDate: // value for 'sinceDate'
 *   },
 * });
 */
export function useGetFeedbackViewSummaryByOrgIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetFeedbackViewSummaryByOrgIdQuery, Types.GetFeedbackViewSummaryByOrgIdQueryVariables> & ({ variables: Types.GetFeedbackViewSummaryByOrgIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFeedbackViewSummaryByOrgIdQuery, Types.GetFeedbackViewSummaryByOrgIdQueryVariables>(GetFeedbackViewSummaryByOrgIdDocument, options);
      }
export function useGetFeedbackViewSummaryByOrgIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFeedbackViewSummaryByOrgIdQuery, Types.GetFeedbackViewSummaryByOrgIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFeedbackViewSummaryByOrgIdQuery, Types.GetFeedbackViewSummaryByOrgIdQueryVariables>(GetFeedbackViewSummaryByOrgIdDocument, options);
        }
// @ts-ignore
export function useGetFeedbackViewSummaryByOrgIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetFeedbackViewSummaryByOrgIdQuery, Types.GetFeedbackViewSummaryByOrgIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackViewSummaryByOrgIdQuery, Types.GetFeedbackViewSummaryByOrgIdQueryVariables>;
export function useGetFeedbackViewSummaryByOrgIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackViewSummaryByOrgIdQuery, Types.GetFeedbackViewSummaryByOrgIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetFeedbackViewSummaryByOrgIdQuery | undefined, Types.GetFeedbackViewSummaryByOrgIdQueryVariables>;
export function useGetFeedbackViewSummaryByOrgIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetFeedbackViewSummaryByOrgIdQuery, Types.GetFeedbackViewSummaryByOrgIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetFeedbackViewSummaryByOrgIdQuery, Types.GetFeedbackViewSummaryByOrgIdQueryVariables>(GetFeedbackViewSummaryByOrgIdDocument, options);
        }
export type GetFeedbackViewSummaryByOrgIdQueryHookResult = ReturnType<typeof useGetFeedbackViewSummaryByOrgIdQuery>;
export type GetFeedbackViewSummaryByOrgIdLazyQueryHookResult = ReturnType<typeof useGetFeedbackViewSummaryByOrgIdLazyQuery>;
export type GetFeedbackViewSummaryByOrgIdSuspenseQueryHookResult = ReturnType<typeof useGetFeedbackViewSummaryByOrgIdSuspenseQuery>;
export type GetFeedbackViewSummaryByOrgIdQueryResult = Apollo.QueryResult<Types.GetFeedbackViewSummaryByOrgIdQuery, Types.GetFeedbackViewSummaryByOrgIdQueryVariables>;
export const AddGraduationClassDocument = gql`
    mutation addGraduationClass($name: String!, $start_date: String, $program_id: uuid, $current_academic_year_id: uuid) {
  insert_graduation_class(
    objects: [{name: $name, start_date: $start_date, program_id: $program_id, current_academic_year_id: $current_academic_year_id}]
    on_conflict: {constraint: graduation_class_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      graduation_class_id
    }
  }
}
    `;
export type AddGraduationClassMutationFn = Apollo.MutationFunction<Types.AddGraduationClassMutation, Types.AddGraduationClassMutationVariables>;

/**
 * __useAddGraduationClassMutation__
 *
 * To run a mutation, you first call `useAddGraduationClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGraduationClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGraduationClassMutation, { data, loading, error }] = useAddGraduationClassMutation({
 *   variables: {
 *      name: // value for 'name'
 *      start_date: // value for 'start_date'
 *      program_id: // value for 'program_id'
 *      current_academic_year_id: // value for 'current_academic_year_id'
 *   },
 * });
 */
export function useAddGraduationClassMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddGraduationClassMutation, Types.AddGraduationClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddGraduationClassMutation, Types.AddGraduationClassMutationVariables>(AddGraduationClassDocument, options);
      }
export type AddGraduationClassMutationHookResult = ReturnType<typeof useAddGraduationClassMutation>;
export type AddGraduationClassMutationResult = Apollo.MutationResult<Types.AddGraduationClassMutation>;
export type AddGraduationClassMutationOptions = Apollo.BaseMutationOptions<Types.AddGraduationClassMutation, Types.AddGraduationClassMutationVariables>;
export const UpdateGraduationClassDocument = gql`
    mutation updateGraduationClass($id: uuid!, $graduationClass: graduation_class_set_input!) {
  update_graduation_class(
    where: {graduation_class_id: {_eq: $id}}
    _set: $graduationClass
  ) {
    affected_rows
  }
}
    `;
export type UpdateGraduationClassMutationFn = Apollo.MutationFunction<Types.UpdateGraduationClassMutation, Types.UpdateGraduationClassMutationVariables>;

/**
 * __useUpdateGraduationClassMutation__
 *
 * To run a mutation, you first call `useUpdateGraduationClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGraduationClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGraduationClassMutation, { data, loading, error }] = useUpdateGraduationClassMutation({
 *   variables: {
 *      id: // value for 'id'
 *      graduationClass: // value for 'graduationClass'
 *   },
 * });
 */
export function useUpdateGraduationClassMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateGraduationClassMutation, Types.UpdateGraduationClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateGraduationClassMutation, Types.UpdateGraduationClassMutationVariables>(UpdateGraduationClassDocument, options);
      }
export type UpdateGraduationClassMutationHookResult = ReturnType<typeof useUpdateGraduationClassMutation>;
export type UpdateGraduationClassMutationResult = Apollo.MutationResult<Types.UpdateGraduationClassMutation>;
export type UpdateGraduationClassMutationOptions = Apollo.BaseMutationOptions<Types.UpdateGraduationClassMutation, Types.UpdateGraduationClassMutationVariables>;
export const DeleteGraduationClassDocument = gql`
    mutation deleteGraduationClass($id: uuid!) {
  delete_graduation_class(where: {graduation_class_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteGraduationClassMutationFn = Apollo.MutationFunction<Types.DeleteGraduationClassMutation, Types.DeleteGraduationClassMutationVariables>;

/**
 * __useDeleteGraduationClassMutation__
 *
 * To run a mutation, you first call `useDeleteGraduationClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGraduationClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGraduationClassMutation, { data, loading, error }] = useDeleteGraduationClassMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGraduationClassMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteGraduationClassMutation, Types.DeleteGraduationClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteGraduationClassMutation, Types.DeleteGraduationClassMutationVariables>(DeleteGraduationClassDocument, options);
      }
export type DeleteGraduationClassMutationHookResult = ReturnType<typeof useDeleteGraduationClassMutation>;
export type DeleteGraduationClassMutationResult = Apollo.MutationResult<Types.DeleteGraduationClassMutation>;
export type DeleteGraduationClassMutationOptions = Apollo.BaseMutationOptions<Types.DeleteGraduationClassMutation, Types.DeleteGraduationClassMutationVariables>;
export const GetGraduationClassesDocument = gql`
    query getGraduationClasses {
  graduation_class {
    graduation_class_id
    name
    program_id
    start_date
    current_academic_year_id
  }
}
    `;

/**
 * __useGetGraduationClassesQuery__
 *
 * To run a query within a React component, call `useGetGraduationClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraduationClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraduationClassesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGraduationClassesQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetGraduationClassesQuery, Types.GetGraduationClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetGraduationClassesQuery, Types.GetGraduationClassesQueryVariables>(GetGraduationClassesDocument, options);
      }
export function useGetGraduationClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetGraduationClassesQuery, Types.GetGraduationClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetGraduationClassesQuery, Types.GetGraduationClassesQueryVariables>(GetGraduationClassesDocument, options);
        }
// @ts-ignore
export function useGetGraduationClassesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassesQuery, Types.GetGraduationClassesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetGraduationClassesQuery, Types.GetGraduationClassesQueryVariables>;
export function useGetGraduationClassesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassesQuery, Types.GetGraduationClassesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetGraduationClassesQuery | undefined, Types.GetGraduationClassesQueryVariables>;
export function useGetGraduationClassesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassesQuery, Types.GetGraduationClassesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetGraduationClassesQuery, Types.GetGraduationClassesQueryVariables>(GetGraduationClassesDocument, options);
        }
export type GetGraduationClassesQueryHookResult = ReturnType<typeof useGetGraduationClassesQuery>;
export type GetGraduationClassesLazyQueryHookResult = ReturnType<typeof useGetGraduationClassesLazyQuery>;
export type GetGraduationClassesSuspenseQueryHookResult = ReturnType<typeof useGetGraduationClassesSuspenseQuery>;
export type GetGraduationClassesQueryResult = Apollo.QueryResult<Types.GetGraduationClassesQuery, Types.GetGraduationClassesQueryVariables>;
export const GetGraduationClassesByProgramDocument = gql`
    query getGraduationClassesByProgram($programId: uuid!) {
  graduation_class(where: {program_id: {_eq: $programId}}) {
    graduation_class_id
    name
    program_id
    start_date
    current_academic_year_id
  }
}
    `;

/**
 * __useGetGraduationClassesByProgramQuery__
 *
 * To run a query within a React component, call `useGetGraduationClassesByProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraduationClassesByProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraduationClassesByProgramQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useGetGraduationClassesByProgramQuery(baseOptions: Apollo.QueryHookOptions<Types.GetGraduationClassesByProgramQuery, Types.GetGraduationClassesByProgramQueryVariables> & ({ variables: Types.GetGraduationClassesByProgramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetGraduationClassesByProgramQuery, Types.GetGraduationClassesByProgramQueryVariables>(GetGraduationClassesByProgramDocument, options);
      }
export function useGetGraduationClassesByProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetGraduationClassesByProgramQuery, Types.GetGraduationClassesByProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetGraduationClassesByProgramQuery, Types.GetGraduationClassesByProgramQueryVariables>(GetGraduationClassesByProgramDocument, options);
        }
// @ts-ignore
export function useGetGraduationClassesByProgramSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassesByProgramQuery, Types.GetGraduationClassesByProgramQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetGraduationClassesByProgramQuery, Types.GetGraduationClassesByProgramQueryVariables>;
export function useGetGraduationClassesByProgramSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassesByProgramQuery, Types.GetGraduationClassesByProgramQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetGraduationClassesByProgramQuery | undefined, Types.GetGraduationClassesByProgramQueryVariables>;
export function useGetGraduationClassesByProgramSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassesByProgramQuery, Types.GetGraduationClassesByProgramQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetGraduationClassesByProgramQuery, Types.GetGraduationClassesByProgramQueryVariables>(GetGraduationClassesByProgramDocument, options);
        }
export type GetGraduationClassesByProgramQueryHookResult = ReturnType<typeof useGetGraduationClassesByProgramQuery>;
export type GetGraduationClassesByProgramLazyQueryHookResult = ReturnType<typeof useGetGraduationClassesByProgramLazyQuery>;
export type GetGraduationClassesByProgramSuspenseQueryHookResult = ReturnType<typeof useGetGraduationClassesByProgramSuspenseQuery>;
export type GetGraduationClassesByProgramQueryResult = Apollo.QueryResult<Types.GetGraduationClassesByProgramQuery, Types.GetGraduationClassesByProgramQueryVariables>;
export const GetGraduationClassByOrgDocument = gql`
    query getGraduationClassByOrg($orgId: uuid!) {
  graduation_class(where: {program: {org_id: {_eq: $orgId}}}) {
    graduation_class_id
    name
    program_id
    start_date
    current_academic_year_id
  }
}
    `;

/**
 * __useGetGraduationClassByOrgQuery__
 *
 * To run a query within a React component, call `useGetGraduationClassByOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraduationClassByOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraduationClassByOrgQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetGraduationClassByOrgQuery(baseOptions: Apollo.QueryHookOptions<Types.GetGraduationClassByOrgQuery, Types.GetGraduationClassByOrgQueryVariables> & ({ variables: Types.GetGraduationClassByOrgQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetGraduationClassByOrgQuery, Types.GetGraduationClassByOrgQueryVariables>(GetGraduationClassByOrgDocument, options);
      }
export function useGetGraduationClassByOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetGraduationClassByOrgQuery, Types.GetGraduationClassByOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetGraduationClassByOrgQuery, Types.GetGraduationClassByOrgQueryVariables>(GetGraduationClassByOrgDocument, options);
        }
// @ts-ignore
export function useGetGraduationClassByOrgSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassByOrgQuery, Types.GetGraduationClassByOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetGraduationClassByOrgQuery, Types.GetGraduationClassByOrgQueryVariables>;
export function useGetGraduationClassByOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassByOrgQuery, Types.GetGraduationClassByOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetGraduationClassByOrgQuery | undefined, Types.GetGraduationClassByOrgQueryVariables>;
export function useGetGraduationClassByOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassByOrgQuery, Types.GetGraduationClassByOrgQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetGraduationClassByOrgQuery, Types.GetGraduationClassByOrgQueryVariables>(GetGraduationClassByOrgDocument, options);
        }
export type GetGraduationClassByOrgQueryHookResult = ReturnType<typeof useGetGraduationClassByOrgQuery>;
export type GetGraduationClassByOrgLazyQueryHookResult = ReturnType<typeof useGetGraduationClassByOrgLazyQuery>;
export type GetGraduationClassByOrgSuspenseQueryHookResult = ReturnType<typeof useGetGraduationClassByOrgSuspenseQuery>;
export type GetGraduationClassByOrgQueryResult = Apollo.QueryResult<Types.GetGraduationClassByOrgQuery, Types.GetGraduationClassByOrgQueryVariables>;
export const GetGraduationClassesByStudentDocument = gql`
    query getGraduationClassesByStudent($userId: uuid!) {
  graduation_class(where: {students: {student: {user_id: {_eq: $userId}}}}) {
    graduation_class_id
    name
    program_id
    start_date
    current_academic_year_id
    program {
      program_id
      org_id
      organization {
        name
        org_id
      }
    }
  }
}
    `;

/**
 * __useGetGraduationClassesByStudentQuery__
 *
 * To run a query within a React component, call `useGetGraduationClassesByStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraduationClassesByStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraduationClassesByStudentQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetGraduationClassesByStudentQuery(baseOptions: Apollo.QueryHookOptions<Types.GetGraduationClassesByStudentQuery, Types.GetGraduationClassesByStudentQueryVariables> & ({ variables: Types.GetGraduationClassesByStudentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetGraduationClassesByStudentQuery, Types.GetGraduationClassesByStudentQueryVariables>(GetGraduationClassesByStudentDocument, options);
      }
export function useGetGraduationClassesByStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetGraduationClassesByStudentQuery, Types.GetGraduationClassesByStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetGraduationClassesByStudentQuery, Types.GetGraduationClassesByStudentQueryVariables>(GetGraduationClassesByStudentDocument, options);
        }
// @ts-ignore
export function useGetGraduationClassesByStudentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassesByStudentQuery, Types.GetGraduationClassesByStudentQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetGraduationClassesByStudentQuery, Types.GetGraduationClassesByStudentQueryVariables>;
export function useGetGraduationClassesByStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassesByStudentQuery, Types.GetGraduationClassesByStudentQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetGraduationClassesByStudentQuery | undefined, Types.GetGraduationClassesByStudentQueryVariables>;
export function useGetGraduationClassesByStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassesByStudentQuery, Types.GetGraduationClassesByStudentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetGraduationClassesByStudentQuery, Types.GetGraduationClassesByStudentQueryVariables>(GetGraduationClassesByStudentDocument, options);
        }
export type GetGraduationClassesByStudentQueryHookResult = ReturnType<typeof useGetGraduationClassesByStudentQuery>;
export type GetGraduationClassesByStudentLazyQueryHookResult = ReturnType<typeof useGetGraduationClassesByStudentLazyQuery>;
export type GetGraduationClassesByStudentSuspenseQueryHookResult = ReturnType<typeof useGetGraduationClassesByStudentSuspenseQuery>;
export type GetGraduationClassesByStudentQueryResult = Apollo.QueryResult<Types.GetGraduationClassesByStudentQuery, Types.GetGraduationClassesByStudentQueryVariables>;
export const GetGraduationClassesByIdDocument = gql`
    query getGraduationClassesById($graduation_class_id: uuid!) {
  graduation_class_by_pk(graduation_class_id: $graduation_class_id) {
    graduation_class_id
    name
    program_id
    start_date
    current_academic_year_id
    students {
      graduation_class_student_id
      student {
        user_id
        name
        email
        picture_url
        equipped_store_items(where: {item_type: {_eq: "PET"}}) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
    }
    tags {
      graduation_class_tag_id
      tag {
        tag_id
        name
        type
      }
    }
  }
}
    `;

/**
 * __useGetGraduationClassesByIdQuery__
 *
 * To run a query within a React component, call `useGetGraduationClassesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraduationClassesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraduationClassesByIdQuery({
 *   variables: {
 *      graduation_class_id: // value for 'graduation_class_id'
 *   },
 * });
 */
export function useGetGraduationClassesByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetGraduationClassesByIdQuery, Types.GetGraduationClassesByIdQueryVariables> & ({ variables: Types.GetGraduationClassesByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetGraduationClassesByIdQuery, Types.GetGraduationClassesByIdQueryVariables>(GetGraduationClassesByIdDocument, options);
      }
export function useGetGraduationClassesByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetGraduationClassesByIdQuery, Types.GetGraduationClassesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetGraduationClassesByIdQuery, Types.GetGraduationClassesByIdQueryVariables>(GetGraduationClassesByIdDocument, options);
        }
// @ts-ignore
export function useGetGraduationClassesByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassesByIdQuery, Types.GetGraduationClassesByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetGraduationClassesByIdQuery, Types.GetGraduationClassesByIdQueryVariables>;
export function useGetGraduationClassesByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassesByIdQuery, Types.GetGraduationClassesByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetGraduationClassesByIdQuery | undefined, Types.GetGraduationClassesByIdQueryVariables>;
export function useGetGraduationClassesByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassesByIdQuery, Types.GetGraduationClassesByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetGraduationClassesByIdQuery, Types.GetGraduationClassesByIdQueryVariables>(GetGraduationClassesByIdDocument, options);
        }
export type GetGraduationClassesByIdQueryHookResult = ReturnType<typeof useGetGraduationClassesByIdQuery>;
export type GetGraduationClassesByIdLazyQueryHookResult = ReturnType<typeof useGetGraduationClassesByIdLazyQuery>;
export type GetGraduationClassesByIdSuspenseQueryHookResult = ReturnType<typeof useGetGraduationClassesByIdSuspenseQuery>;
export type GetGraduationClassesByIdQueryResult = Apollo.QueryResult<Types.GetGraduationClassesByIdQuery, Types.GetGraduationClassesByIdQueryVariables>;
export const AddGraduationClassStudentDocument = gql`
    mutation addGraduationClassStudent($graduation_class_id: uuid!, $student_id: uuid) {
  insert_graduation_class_student(
    objects: [{graduation_class_id: $graduation_class_id, student_id: $student_id}]
    on_conflict: {constraint: graduation_class_student_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddGraduationClassStudentMutationFn = Apollo.MutationFunction<Types.AddGraduationClassStudentMutation, Types.AddGraduationClassStudentMutationVariables>;

/**
 * __useAddGraduationClassStudentMutation__
 *
 * To run a mutation, you first call `useAddGraduationClassStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGraduationClassStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGraduationClassStudentMutation, { data, loading, error }] = useAddGraduationClassStudentMutation({
 *   variables: {
 *      graduation_class_id: // value for 'graduation_class_id'
 *      student_id: // value for 'student_id'
 *   },
 * });
 */
export function useAddGraduationClassStudentMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddGraduationClassStudentMutation, Types.AddGraduationClassStudentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddGraduationClassStudentMutation, Types.AddGraduationClassStudentMutationVariables>(AddGraduationClassStudentDocument, options);
      }
export type AddGraduationClassStudentMutationHookResult = ReturnType<typeof useAddGraduationClassStudentMutation>;
export type AddGraduationClassStudentMutationResult = Apollo.MutationResult<Types.AddGraduationClassStudentMutation>;
export type AddGraduationClassStudentMutationOptions = Apollo.BaseMutationOptions<Types.AddGraduationClassStudentMutation, Types.AddGraduationClassStudentMutationVariables>;
export const AddGraduationClassStudentsDocument = gql`
    mutation addGraduationClassStudents($objects: [graduation_class_student_insert_input!]!) {
  insert_graduation_class_student(
    objects: $objects
    on_conflict: {constraint: graduation_class_student_graduation_class_id_student_id_key, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddGraduationClassStudentsMutationFn = Apollo.MutationFunction<Types.AddGraduationClassStudentsMutation, Types.AddGraduationClassStudentsMutationVariables>;

/**
 * __useAddGraduationClassStudentsMutation__
 *
 * To run a mutation, you first call `useAddGraduationClassStudentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGraduationClassStudentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGraduationClassStudentsMutation, { data, loading, error }] = useAddGraduationClassStudentsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddGraduationClassStudentsMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddGraduationClassStudentsMutation, Types.AddGraduationClassStudentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddGraduationClassStudentsMutation, Types.AddGraduationClassStudentsMutationVariables>(AddGraduationClassStudentsDocument, options);
      }
export type AddGraduationClassStudentsMutationHookResult = ReturnType<typeof useAddGraduationClassStudentsMutation>;
export type AddGraduationClassStudentsMutationResult = Apollo.MutationResult<Types.AddGraduationClassStudentsMutation>;
export type AddGraduationClassStudentsMutationOptions = Apollo.BaseMutationOptions<Types.AddGraduationClassStudentsMutation, Types.AddGraduationClassStudentsMutationVariables>;
export const DeleteGraduationClassStudentDocument = gql`
    mutation deleteGraduationClassStudent($id: uuid!) {
  delete_graduation_class_student(
    where: {graduation_class_student_id: {_eq: $id}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteGraduationClassStudentMutationFn = Apollo.MutationFunction<Types.DeleteGraduationClassStudentMutation, Types.DeleteGraduationClassStudentMutationVariables>;

/**
 * __useDeleteGraduationClassStudentMutation__
 *
 * To run a mutation, you first call `useDeleteGraduationClassStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGraduationClassStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGraduationClassStudentMutation, { data, loading, error }] = useDeleteGraduationClassStudentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGraduationClassStudentMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteGraduationClassStudentMutation, Types.DeleteGraduationClassStudentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteGraduationClassStudentMutation, Types.DeleteGraduationClassStudentMutationVariables>(DeleteGraduationClassStudentDocument, options);
      }
export type DeleteGraduationClassStudentMutationHookResult = ReturnType<typeof useDeleteGraduationClassStudentMutation>;
export type DeleteGraduationClassStudentMutationResult = Apollo.MutationResult<Types.DeleteGraduationClassStudentMutation>;
export type DeleteGraduationClassStudentMutationOptions = Apollo.BaseMutationOptions<Types.DeleteGraduationClassStudentMutation, Types.DeleteGraduationClassStudentMutationVariables>;
export const DeleteGraduationClassStudentByStudentAndGraduationCLassDocument = gql`
    mutation deleteGraduationClassStudentByStudentAndGraduationCLass($graduation_class_id: uuid!, $student_id: uuid!) {
  delete_graduation_class_student(
    where: {graduation_class_id: {_eq: $graduation_class_id}, student_id: {_eq: $student_id}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteGraduationClassStudentByStudentAndGraduationCLassMutationFn = Apollo.MutationFunction<Types.DeleteGraduationClassStudentByStudentAndGraduationCLassMutation, Types.DeleteGraduationClassStudentByStudentAndGraduationCLassMutationVariables>;

/**
 * __useDeleteGraduationClassStudentByStudentAndGraduationCLassMutation__
 *
 * To run a mutation, you first call `useDeleteGraduationClassStudentByStudentAndGraduationCLassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGraduationClassStudentByStudentAndGraduationCLassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGraduationClassStudentByStudentAndGraduationCLassMutation, { data, loading, error }] = useDeleteGraduationClassStudentByStudentAndGraduationCLassMutation({
 *   variables: {
 *      graduation_class_id: // value for 'graduation_class_id'
 *      student_id: // value for 'student_id'
 *   },
 * });
 */
export function useDeleteGraduationClassStudentByStudentAndGraduationCLassMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteGraduationClassStudentByStudentAndGraduationCLassMutation, Types.DeleteGraduationClassStudentByStudentAndGraduationCLassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteGraduationClassStudentByStudentAndGraduationCLassMutation, Types.DeleteGraduationClassStudentByStudentAndGraduationCLassMutationVariables>(DeleteGraduationClassStudentByStudentAndGraduationCLassDocument, options);
      }
export type DeleteGraduationClassStudentByStudentAndGraduationCLassMutationHookResult = ReturnType<typeof useDeleteGraduationClassStudentByStudentAndGraduationCLassMutation>;
export type DeleteGraduationClassStudentByStudentAndGraduationCLassMutationResult = Apollo.MutationResult<Types.DeleteGraduationClassStudentByStudentAndGraduationCLassMutation>;
export type DeleteGraduationClassStudentByStudentAndGraduationCLassMutationOptions = Apollo.BaseMutationOptions<Types.DeleteGraduationClassStudentByStudentAndGraduationCLassMutation, Types.DeleteGraduationClassStudentByStudentAndGraduationCLassMutationVariables>;
export const GetGraduationClassStudentsDocument = gql`
    query getGraduationClassStudents {
  graduation_class_student {
    graduation_class_student_id
    graduation_class_id
    student_id
  }
}
    `;

/**
 * __useGetGraduationClassStudentsQuery__
 *
 * To run a query within a React component, call `useGetGraduationClassStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraduationClassStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraduationClassStudentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGraduationClassStudentsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetGraduationClassStudentsQuery, Types.GetGraduationClassStudentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetGraduationClassStudentsQuery, Types.GetGraduationClassStudentsQueryVariables>(GetGraduationClassStudentsDocument, options);
      }
export function useGetGraduationClassStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetGraduationClassStudentsQuery, Types.GetGraduationClassStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetGraduationClassStudentsQuery, Types.GetGraduationClassStudentsQueryVariables>(GetGraduationClassStudentsDocument, options);
        }
// @ts-ignore
export function useGetGraduationClassStudentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassStudentsQuery, Types.GetGraduationClassStudentsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetGraduationClassStudentsQuery, Types.GetGraduationClassStudentsQueryVariables>;
export function useGetGraduationClassStudentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassStudentsQuery, Types.GetGraduationClassStudentsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetGraduationClassStudentsQuery | undefined, Types.GetGraduationClassStudentsQueryVariables>;
export function useGetGraduationClassStudentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassStudentsQuery, Types.GetGraduationClassStudentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetGraduationClassStudentsQuery, Types.GetGraduationClassStudentsQueryVariables>(GetGraduationClassStudentsDocument, options);
        }
export type GetGraduationClassStudentsQueryHookResult = ReturnType<typeof useGetGraduationClassStudentsQuery>;
export type GetGraduationClassStudentsLazyQueryHookResult = ReturnType<typeof useGetGraduationClassStudentsLazyQuery>;
export type GetGraduationClassStudentsSuspenseQueryHookResult = ReturnType<typeof useGetGraduationClassStudentsSuspenseQuery>;
export type GetGraduationClassStudentsQueryResult = Apollo.QueryResult<Types.GetGraduationClassStudentsQuery, Types.GetGraduationClassStudentsQueryVariables>;
export const AddGraduationClassTagDocument = gql`
    mutation addGraduationClassTag($graduationClassId: uuid!, $tagId: uuid) {
  insert_graduation_class_tag(
    objects: [{graduation_class_id: $graduationClassId, tag_id: $tagId}]
    on_conflict: {constraint: graduation_class_tag_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddGraduationClassTagMutationFn = Apollo.MutationFunction<Types.AddGraduationClassTagMutation, Types.AddGraduationClassTagMutationVariables>;

/**
 * __useAddGraduationClassTagMutation__
 *
 * To run a mutation, you first call `useAddGraduationClassTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGraduationClassTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGraduationClassTagMutation, { data, loading, error }] = useAddGraduationClassTagMutation({
 *   variables: {
 *      graduationClassId: // value for 'graduationClassId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useAddGraduationClassTagMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddGraduationClassTagMutation, Types.AddGraduationClassTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddGraduationClassTagMutation, Types.AddGraduationClassTagMutationVariables>(AddGraduationClassTagDocument, options);
      }
export type AddGraduationClassTagMutationHookResult = ReturnType<typeof useAddGraduationClassTagMutation>;
export type AddGraduationClassTagMutationResult = Apollo.MutationResult<Types.AddGraduationClassTagMutation>;
export type AddGraduationClassTagMutationOptions = Apollo.BaseMutationOptions<Types.AddGraduationClassTagMutation, Types.AddGraduationClassTagMutationVariables>;
export const DeleteGraduationClassTagDocument = gql`
    mutation deleteGraduationClassTag($id: uuid!) {
  delete_graduation_class_tag(where: {graduation_class_tag_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteGraduationClassTagMutationFn = Apollo.MutationFunction<Types.DeleteGraduationClassTagMutation, Types.DeleteGraduationClassTagMutationVariables>;

/**
 * __useDeleteGraduationClassTagMutation__
 *
 * To run a mutation, you first call `useDeleteGraduationClassTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGraduationClassTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGraduationClassTagMutation, { data, loading, error }] = useDeleteGraduationClassTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGraduationClassTagMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteGraduationClassTagMutation, Types.DeleteGraduationClassTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteGraduationClassTagMutation, Types.DeleteGraduationClassTagMutationVariables>(DeleteGraduationClassTagDocument, options);
      }
export type DeleteGraduationClassTagMutationHookResult = ReturnType<typeof useDeleteGraduationClassTagMutation>;
export type DeleteGraduationClassTagMutationResult = Apollo.MutationResult<Types.DeleteGraduationClassTagMutation>;
export type DeleteGraduationClassTagMutationOptions = Apollo.BaseMutationOptions<Types.DeleteGraduationClassTagMutation, Types.DeleteGraduationClassTagMutationVariables>;
export const DeleteGraduationClassTagByTagAndGraduationClassDocument = gql`
    mutation deleteGraduationClassTagByTagAndGraduationClass($graduationClassId: uuid!, $tagId: uuid!) {
  delete_graduation_class_tag(
    where: {graduation_class_id: {_eq: $graduationClassId}, tag_id: {_eq: $tagId}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteGraduationClassTagByTagAndGraduationClassMutationFn = Apollo.MutationFunction<Types.DeleteGraduationClassTagByTagAndGraduationClassMutation, Types.DeleteGraduationClassTagByTagAndGraduationClassMutationVariables>;

/**
 * __useDeleteGraduationClassTagByTagAndGraduationClassMutation__
 *
 * To run a mutation, you first call `useDeleteGraduationClassTagByTagAndGraduationClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGraduationClassTagByTagAndGraduationClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGraduationClassTagByTagAndGraduationClassMutation, { data, loading, error }] = useDeleteGraduationClassTagByTagAndGraduationClassMutation({
 *   variables: {
 *      graduationClassId: // value for 'graduationClassId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useDeleteGraduationClassTagByTagAndGraduationClassMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteGraduationClassTagByTagAndGraduationClassMutation, Types.DeleteGraduationClassTagByTagAndGraduationClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteGraduationClassTagByTagAndGraduationClassMutation, Types.DeleteGraduationClassTagByTagAndGraduationClassMutationVariables>(DeleteGraduationClassTagByTagAndGraduationClassDocument, options);
      }
export type DeleteGraduationClassTagByTagAndGraduationClassMutationHookResult = ReturnType<typeof useDeleteGraduationClassTagByTagAndGraduationClassMutation>;
export type DeleteGraduationClassTagByTagAndGraduationClassMutationResult = Apollo.MutationResult<Types.DeleteGraduationClassTagByTagAndGraduationClassMutation>;
export type DeleteGraduationClassTagByTagAndGraduationClassMutationOptions = Apollo.BaseMutationOptions<Types.DeleteGraduationClassTagByTagAndGraduationClassMutation, Types.DeleteGraduationClassTagByTagAndGraduationClassMutationVariables>;
export const GetGraduationClassTagsDocument = gql`
    query getGraduationClassTags {
  graduation_class_tag {
    graduation_class_tag_id
    tag_id
    graduation_class_id
  }
}
    `;

/**
 * __useGetGraduationClassTagsQuery__
 *
 * To run a query within a React component, call `useGetGraduationClassTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraduationClassTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraduationClassTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGraduationClassTagsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetGraduationClassTagsQuery, Types.GetGraduationClassTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetGraduationClassTagsQuery, Types.GetGraduationClassTagsQueryVariables>(GetGraduationClassTagsDocument, options);
      }
export function useGetGraduationClassTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetGraduationClassTagsQuery, Types.GetGraduationClassTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetGraduationClassTagsQuery, Types.GetGraduationClassTagsQueryVariables>(GetGraduationClassTagsDocument, options);
        }
// @ts-ignore
export function useGetGraduationClassTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassTagsQuery, Types.GetGraduationClassTagsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetGraduationClassTagsQuery, Types.GetGraduationClassTagsQueryVariables>;
export function useGetGraduationClassTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassTagsQuery, Types.GetGraduationClassTagsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetGraduationClassTagsQuery | undefined, Types.GetGraduationClassTagsQueryVariables>;
export function useGetGraduationClassTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassTagsQuery, Types.GetGraduationClassTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetGraduationClassTagsQuery, Types.GetGraduationClassTagsQueryVariables>(GetGraduationClassTagsDocument, options);
        }
export type GetGraduationClassTagsQueryHookResult = ReturnType<typeof useGetGraduationClassTagsQuery>;
export type GetGraduationClassTagsLazyQueryHookResult = ReturnType<typeof useGetGraduationClassTagsLazyQuery>;
export type GetGraduationClassTagsSuspenseQueryHookResult = ReturnType<typeof useGetGraduationClassTagsSuspenseQuery>;
export type GetGraduationClassTagsQueryResult = Apollo.QueryResult<Types.GetGraduationClassTagsQuery, Types.GetGraduationClassTagsQueryVariables>;
export const GetGraduationClassTagsByGraduationClassIdDocument = gql`
    query getGraduationClassTagsByGraduationClassId($graduation_class_id: uuid!) {
  graduation_class_tag(where: {graduation_class_id: {_eq: $graduation_class_id}}) {
    graduation_class_tag_id
    tag {
      name
      tag_id
      type
    }
  }
}
    `;

/**
 * __useGetGraduationClassTagsByGraduationClassIdQuery__
 *
 * To run a query within a React component, call `useGetGraduationClassTagsByGraduationClassIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraduationClassTagsByGraduationClassIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraduationClassTagsByGraduationClassIdQuery({
 *   variables: {
 *      graduation_class_id: // value for 'graduation_class_id'
 *   },
 * });
 */
export function useGetGraduationClassTagsByGraduationClassIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetGraduationClassTagsByGraduationClassIdQuery, Types.GetGraduationClassTagsByGraduationClassIdQueryVariables> & ({ variables: Types.GetGraduationClassTagsByGraduationClassIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetGraduationClassTagsByGraduationClassIdQuery, Types.GetGraduationClassTagsByGraduationClassIdQueryVariables>(GetGraduationClassTagsByGraduationClassIdDocument, options);
      }
export function useGetGraduationClassTagsByGraduationClassIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetGraduationClassTagsByGraduationClassIdQuery, Types.GetGraduationClassTagsByGraduationClassIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetGraduationClassTagsByGraduationClassIdQuery, Types.GetGraduationClassTagsByGraduationClassIdQueryVariables>(GetGraduationClassTagsByGraduationClassIdDocument, options);
        }
// @ts-ignore
export function useGetGraduationClassTagsByGraduationClassIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassTagsByGraduationClassIdQuery, Types.GetGraduationClassTagsByGraduationClassIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetGraduationClassTagsByGraduationClassIdQuery, Types.GetGraduationClassTagsByGraduationClassIdQueryVariables>;
export function useGetGraduationClassTagsByGraduationClassIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassTagsByGraduationClassIdQuery, Types.GetGraduationClassTagsByGraduationClassIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetGraduationClassTagsByGraduationClassIdQuery | undefined, Types.GetGraduationClassTagsByGraduationClassIdQueryVariables>;
export function useGetGraduationClassTagsByGraduationClassIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetGraduationClassTagsByGraduationClassIdQuery, Types.GetGraduationClassTagsByGraduationClassIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetGraduationClassTagsByGraduationClassIdQuery, Types.GetGraduationClassTagsByGraduationClassIdQueryVariables>(GetGraduationClassTagsByGraduationClassIdDocument, options);
        }
export type GetGraduationClassTagsByGraduationClassIdQueryHookResult = ReturnType<typeof useGetGraduationClassTagsByGraduationClassIdQuery>;
export type GetGraduationClassTagsByGraduationClassIdLazyQueryHookResult = ReturnType<typeof useGetGraduationClassTagsByGraduationClassIdLazyQuery>;
export type GetGraduationClassTagsByGraduationClassIdSuspenseQueryHookResult = ReturnType<typeof useGetGraduationClassTagsByGraduationClassIdSuspenseQuery>;
export type GetGraduationClassTagsByGraduationClassIdQueryResult = Apollo.QueryResult<Types.GetGraduationClassTagsByGraduationClassIdQuery, Types.GetGraduationClassTagsByGraduationClassIdQueryVariables>;
export const GetHomeDataAdminDocument = gql`
    query getHomeDataAdmin($sinceDate: timestamptz!, $excludeTestOrgNamePattern: String!) {
  epaRequirements: requirement(limit: 3, where: {type: {_eq: "EPA"}}) {
    requirement_id
    name
    type
    description
  }
  competencyRequirements: requirement(
    limit: 3
    where: {type: {_eq: "COMPETENCY"}}
  ) {
    requirement_id
    name
    type
    description
  }
  feedbacks: feedback(
    limit: 5
    order_by: {observation_date: desc}
    where: {status: {_nin: ["DRAFT", "ARCHIVED", "HIDDEN"]}, created_at: {_gte: $sinceDate}, organization: {name: {_nilike: $excludeTestOrgNamePattern}}}
  ) {
    course
    animal_sex
    site {
      site_id
      name
    }
    species {
      species_id
      name
    }
    observation_date
    feedback_id
    student_id
    student {
      user_id
      email
      name
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    coach_id
    coach {
      user_id
      email
      name
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    feedback_skills {
      feedback_skill_id
      requirement {
        name
        requirement_id
        type
      }
      self_rating
      coach_rating
    }
    status
  }
  feedbackStatsData: feedback(
    where: {status: {_nin: ["DRAFT", "ARCHIVED", "HIDDEN"]}, created_at: {_gte: $sinceDate}, organization: {name: {_nilike: $excludeTestOrgNamePattern}}}
  ) {
    status
    observation_date
    created_at
    reviewed_at
    feedback_id
    coach_id
    coach {
      user_id
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
      email
      name
    }
    student_id
    student {
      user_id
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
      email
      name
    }
  }
}
    `;

/**
 * __useGetHomeDataAdminQuery__
 *
 * To run a query within a React component, call `useGetHomeDataAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeDataAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeDataAdminQuery({
 *   variables: {
 *      sinceDate: // value for 'sinceDate'
 *      excludeTestOrgNamePattern: // value for 'excludeTestOrgNamePattern'
 *   },
 * });
 */
export function useGetHomeDataAdminQuery(baseOptions: Apollo.QueryHookOptions<Types.GetHomeDataAdminQuery, Types.GetHomeDataAdminQueryVariables> & ({ variables: Types.GetHomeDataAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetHomeDataAdminQuery, Types.GetHomeDataAdminQueryVariables>(GetHomeDataAdminDocument, options);
      }
export function useGetHomeDataAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetHomeDataAdminQuery, Types.GetHomeDataAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetHomeDataAdminQuery, Types.GetHomeDataAdminQueryVariables>(GetHomeDataAdminDocument, options);
        }
// @ts-ignore
export function useGetHomeDataAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetHomeDataAdminQuery, Types.GetHomeDataAdminQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetHomeDataAdminQuery, Types.GetHomeDataAdminQueryVariables>;
export function useGetHomeDataAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetHomeDataAdminQuery, Types.GetHomeDataAdminQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetHomeDataAdminQuery | undefined, Types.GetHomeDataAdminQueryVariables>;
export function useGetHomeDataAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetHomeDataAdminQuery, Types.GetHomeDataAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetHomeDataAdminQuery, Types.GetHomeDataAdminQueryVariables>(GetHomeDataAdminDocument, options);
        }
export type GetHomeDataAdminQueryHookResult = ReturnType<typeof useGetHomeDataAdminQuery>;
export type GetHomeDataAdminLazyQueryHookResult = ReturnType<typeof useGetHomeDataAdminLazyQuery>;
export type GetHomeDataAdminSuspenseQueryHookResult = ReturnType<typeof useGetHomeDataAdminSuspenseQuery>;
export type GetHomeDataAdminQueryResult = Apollo.QueryResult<Types.GetHomeDataAdminQuery, Types.GetHomeDataAdminQueryVariables>;
export const GetHomeDataCoachDocument = gql`
    query getHomeDataCoach($userId: uuid!, $sinceDate: timestamptz!, $excludeTestOrgNamePattern: String!) {
  epaRequirements: requirement(limit: 3, where: {type: {_eq: "EPA"}}) {
    requirement_id
    name
    type
    description
  }
  competencyRequirements: requirement(
    limit: 3
    where: {type: {_eq: "COMPETENCY"}}
  ) {
    requirement_id
    name
    type
    description
  }
  pendingFeedbacks: feedback(
    limit: 20
    order_by: {created_at: desc}
    where: {coach_id: {_eq: $userId}, status: {_eq: "PENDING"}}
  ) {
    feedback_id
    status
    created_at
    observation_date
    student {
      user_id
      name
    }
    coach {
      user_id
      name
    }
  }
  feedbacks: feedback(
    limit: 20
    order_by: {created_at: desc}
    where: {coach_id: {_eq: $userId}, status: {_nin: ["DRAFT", "ARCHIVED", "HIDDEN"]}}
  ) {
    feedback_id
    student_id
    course
    animal_sex
    site {
      site_id
      name
    }
    species {
      species_id
      name
    }
    observation_date
    created_at
    student {
      user_id
      email
      name
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    feedback_skills {
      feedback_skill_id
      requirement {
        name
        requirement_id
        type
      }
      self_rating
      coach_rating
    }
    status
  }
  feedbackStatsData: feedback(
    where: {coach_id: {_eq: $userId}, status: {_nin: ["DRAFT", "ARCHIVED", "HIDDEN"]}, created_at: {_gte: $sinceDate}, organization: {name: {_nilike: $excludeTestOrgNamePattern}}}
  ) {
    feedback_id
    status
    observation_date
    created_at
    reviewed_at
    coach_id
    student {
      user_id
      name
    }
    coach {
      user_id
      name
    }
  }
}
    `;

/**
 * __useGetHomeDataCoachQuery__
 *
 * To run a query within a React component, call `useGetHomeDataCoachQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeDataCoachQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeDataCoachQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      sinceDate: // value for 'sinceDate'
 *      excludeTestOrgNamePattern: // value for 'excludeTestOrgNamePattern'
 *   },
 * });
 */
export function useGetHomeDataCoachQuery(baseOptions: Apollo.QueryHookOptions<Types.GetHomeDataCoachQuery, Types.GetHomeDataCoachQueryVariables> & ({ variables: Types.GetHomeDataCoachQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetHomeDataCoachQuery, Types.GetHomeDataCoachQueryVariables>(GetHomeDataCoachDocument, options);
      }
export function useGetHomeDataCoachLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetHomeDataCoachQuery, Types.GetHomeDataCoachQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetHomeDataCoachQuery, Types.GetHomeDataCoachQueryVariables>(GetHomeDataCoachDocument, options);
        }
// @ts-ignore
export function useGetHomeDataCoachSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetHomeDataCoachQuery, Types.GetHomeDataCoachQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetHomeDataCoachQuery, Types.GetHomeDataCoachQueryVariables>;
export function useGetHomeDataCoachSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetHomeDataCoachQuery, Types.GetHomeDataCoachQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetHomeDataCoachQuery | undefined, Types.GetHomeDataCoachQueryVariables>;
export function useGetHomeDataCoachSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetHomeDataCoachQuery, Types.GetHomeDataCoachQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetHomeDataCoachQuery, Types.GetHomeDataCoachQueryVariables>(GetHomeDataCoachDocument, options);
        }
export type GetHomeDataCoachQueryHookResult = ReturnType<typeof useGetHomeDataCoachQuery>;
export type GetHomeDataCoachLazyQueryHookResult = ReturnType<typeof useGetHomeDataCoachLazyQuery>;
export type GetHomeDataCoachSuspenseQueryHookResult = ReturnType<typeof useGetHomeDataCoachSuspenseQuery>;
export type GetHomeDataCoachQueryResult = Apollo.QueryResult<Types.GetHomeDataCoachQuery, Types.GetHomeDataCoachQueryVariables>;
export const GetHomeDataStudentDocument = gql`
    query getHomeDataStudent($userId: uuid!, $sinceDate: timestamptz!, $excludeTestOrgNamePattern: String!) {
  feedbacksApproved: feedback(
    limit: 5000
    order_by: {observation_date: desc}
    where: {student_id: {_eq: $userId}, status: {_eq: "DONE"}, created_at: {_gte: $sinceDate}, organization: {name: {_nilike: $excludeTestOrgNamePattern}}}
  ) {
    feedback_id
    coach_rate
    feedback_skills {
      requirement_id
      feedback_skill_id
      skill_level
      self_rating
      coach_rating
    }
  }
  pendingFeedbacks: feedback(
    limit: 20
    order_by: {created_at: desc}
    where: {student_id: {_eq: $userId}, status: {_eq: "PENDING"}}
  ) {
    feedback_id
    status
    created_at
    observation_date
    coach {
      user_id
      name
    }
    student {
      user_id
      name
    }
  }
  feedbacks: feedback(
    limit: 20
    order_by: {created_at: desc}
    where: {student_id: {_eq: $userId}, status: {_nin: ["DRAFT", "ARCHIVED", "HIDDEN"]}}
  ) {
    feedback_id
    org_id
    student_id
    coach_id
    species_id
    animal_size
    mrn
    status
    note_to_coach
    created_at
    reviewed_at
    observation_date
    animal_sex
    organization {
      org_id
      name
    }
    student {
      user_id
      email
      name
    }
    coach {
      user_id
      email
      name
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    species {
      name
      species_id
    }
    feedback_skills {
      actions
      areas
      coach_comments
      feedback_skill_id
      note
      requirement {
        name
        requirement_id
        type
        description
        overview
      }
      self_rating
      coach_rating
      student_comments
    }
  }
  resources: graduation_class(
    where: {students: {student: {user_id: {_eq: $userId}}}}
  ) {
    current_academic_year {
      requirements {
        requirement {
          resources {
            resource {
              description
              name
              resource_id
              url
            }
          }
        }
      }
    }
  }
  graduation_class(where: {students: {student: {user_id: {_eq: $userId}}}}) {
    current_academic_year {
      requirements {
        requirement_id
        requirement {
          requirement_id
          name
          description
          task_time
          animal_size
          type
          overview
          requirement_type
          min_performance
          min_score
          min_small_animals_count
          min_large_animals_count
          competencies {
            competency {
              requirement_id
              name
              description
              task_time
              animal_size
              type
              overview
              requirement_type
              min_performance
              min_score
              min_small_animals_count
              min_large_animals_count
            }
          }
          resources {
            resource {
              description
              name
              resource_id
              url
            }
          }
        }
      }
    }
  }
  feedbackStatsData: feedback(
    limit: 5000
    where: {student_id: {_eq: $userId}, status: {_nin: ["DRAFT", "ARCHIVED", "HIDDEN"]}, created_at: {_gte: $sinceDate}, organization: {name: {_nilike: $excludeTestOrgNamePattern}}}
    order_by: {observation_date: asc}
  ) {
    status
    observation_date
    created_at
    reviewed_at
    coach_id
    feedback_skills {
      requirement_id
      self_rating
      coach_rating
    }
    feedback_id
    coach {
      user_id
      picture_url
      email
      name
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    student_id
    student {
      user_id
      picture_url
      email
      name
    }
  }
  mentors: mentoring(where: {mentee_id: {_eq: $userId}}) {
    mentor {
      user_id
      picture_url
      email
      name
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
  }
}
    `;

/**
 * __useGetHomeDataStudentQuery__
 *
 * To run a query within a React component, call `useGetHomeDataStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeDataStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeDataStudentQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      sinceDate: // value for 'sinceDate'
 *      excludeTestOrgNamePattern: // value for 'excludeTestOrgNamePattern'
 *   },
 * });
 */
export function useGetHomeDataStudentQuery(baseOptions: Apollo.QueryHookOptions<Types.GetHomeDataStudentQuery, Types.GetHomeDataStudentQueryVariables> & ({ variables: Types.GetHomeDataStudentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetHomeDataStudentQuery, Types.GetHomeDataStudentQueryVariables>(GetHomeDataStudentDocument, options);
      }
export function useGetHomeDataStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetHomeDataStudentQuery, Types.GetHomeDataStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetHomeDataStudentQuery, Types.GetHomeDataStudentQueryVariables>(GetHomeDataStudentDocument, options);
        }
// @ts-ignore
export function useGetHomeDataStudentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetHomeDataStudentQuery, Types.GetHomeDataStudentQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetHomeDataStudentQuery, Types.GetHomeDataStudentQueryVariables>;
export function useGetHomeDataStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetHomeDataStudentQuery, Types.GetHomeDataStudentQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetHomeDataStudentQuery | undefined, Types.GetHomeDataStudentQueryVariables>;
export function useGetHomeDataStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetHomeDataStudentQuery, Types.GetHomeDataStudentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetHomeDataStudentQuery, Types.GetHomeDataStudentQueryVariables>(GetHomeDataStudentDocument, options);
        }
export type GetHomeDataStudentQueryHookResult = ReturnType<typeof useGetHomeDataStudentQuery>;
export type GetHomeDataStudentLazyQueryHookResult = ReturnType<typeof useGetHomeDataStudentLazyQuery>;
export type GetHomeDataStudentSuspenseQueryHookResult = ReturnType<typeof useGetHomeDataStudentSuspenseQuery>;
export type GetHomeDataStudentQueryResult = Apollo.QueryResult<Types.GetHomeDataStudentQuery, Types.GetHomeDataStudentQueryVariables>;
export const GetHomeDataManagerDocument = gql`
    query getHomeDataManager($orgId: uuid!, $sinceDate: timestamptz!, $excludeTestOrgNamePattern: String!) {
  feedbacks: feedback(
    limit: 5
    order_by: {observation_date: desc}
    where: {org_id: {_eq: $orgId}, status: {_nin: ["DRAFT", "ARCHIVED", "HIDDEN"]}, created_at: {_gte: $sinceDate}, organization: {name: {_nilike: $excludeTestOrgNamePattern}}}
  ) {
    feedback_id
    student_id
    student {
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
      user_id
      email
      name
    }
    coach_id
    coach {
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
      user_id
      email
      name
    }
    feedback_skills {
      feedback_skill_id
      requirement {
        name
        requirement_id
        type
      }
      coach_rating
      self_rating
    }
    status
  }
  feedbackStatsData: feedback(
    where: {org_id: {_eq: $orgId}, status: {_nin: ["DRAFT", "ARCHIVED", "HIDDEN"]}, created_at: {_gte: $sinceDate}, organization: {name: {_nilike: $excludeTestOrgNamePattern}}}
  ) {
    status
    observation_date
    created_at
    reviewed_at
    feedback_id
    coach_id
    coach {
      user_id
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
      email
      name
    }
    student_id
    student {
      user_id
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
      email
      name
    }
  }
}
    `;

/**
 * __useGetHomeDataManagerQuery__
 *
 * To run a query within a React component, call `useGetHomeDataManagerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeDataManagerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeDataManagerQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      sinceDate: // value for 'sinceDate'
 *      excludeTestOrgNamePattern: // value for 'excludeTestOrgNamePattern'
 *   },
 * });
 */
export function useGetHomeDataManagerQuery(baseOptions: Apollo.QueryHookOptions<Types.GetHomeDataManagerQuery, Types.GetHomeDataManagerQueryVariables> & ({ variables: Types.GetHomeDataManagerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetHomeDataManagerQuery, Types.GetHomeDataManagerQueryVariables>(GetHomeDataManagerDocument, options);
      }
export function useGetHomeDataManagerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetHomeDataManagerQuery, Types.GetHomeDataManagerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetHomeDataManagerQuery, Types.GetHomeDataManagerQueryVariables>(GetHomeDataManagerDocument, options);
        }
// @ts-ignore
export function useGetHomeDataManagerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetHomeDataManagerQuery, Types.GetHomeDataManagerQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetHomeDataManagerQuery, Types.GetHomeDataManagerQueryVariables>;
export function useGetHomeDataManagerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetHomeDataManagerQuery, Types.GetHomeDataManagerQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetHomeDataManagerQuery | undefined, Types.GetHomeDataManagerQueryVariables>;
export function useGetHomeDataManagerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetHomeDataManagerQuery, Types.GetHomeDataManagerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetHomeDataManagerQuery, Types.GetHomeDataManagerQueryVariables>(GetHomeDataManagerDocument, options);
        }
export type GetHomeDataManagerQueryHookResult = ReturnType<typeof useGetHomeDataManagerQuery>;
export type GetHomeDataManagerLazyQueryHookResult = ReturnType<typeof useGetHomeDataManagerLazyQuery>;
export type GetHomeDataManagerSuspenseQueryHookResult = ReturnType<typeof useGetHomeDataManagerSuspenseQuery>;
export type GetHomeDataManagerQueryResult = Apollo.QueryResult<Types.GetHomeDataManagerQuery, Types.GetHomeDataManagerQueryVariables>;
export const GetHomeLearnerActivityDocument = gql`
    query getHomeLearnerActivity($userId: uuid!) {
  pendingFeedbacks: feedback(
    limit: 20
    order_by: {created_at: desc}
    where: {student_id: {_eq: $userId}, status: {_eq: "PENDING"}}
  ) {
    feedback_id
    status
    created_at
    observation_date
    feedback_type
    course
    animal_sex
    site {
      site_id
      name
    }
    species {
      species_id
      name
    }
    coach {
      user_id
      name
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    student {
      user_id
      name
    }
    feedback_skills {
      feedback_skill_id
      requirement {
        name
        requirement_id
        type
      }
      self_rating
      coach_rating
    }
  }
  feedbacks: feedback(
    limit: 20
    order_by: {created_at: desc}
    where: {student_id: {_eq: $userId}, status: {_nin: ["DRAFT", "ARCHIVED", "HIDDEN"]}}
  ) {
    feedback_id
    status
    created_at
    observation_date
    feedback_type
    course
    animal_sex
    site {
      site_id
      name
    }
    species {
      species_id
      name
    }
    coach {
      user_id
      name
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    student {
      user_id
      name
      picture_url
    }
    feedback_skills {
      feedback_skill_id
      requirement {
        name
        requirement_id
        type
      }
      self_rating
      coach_rating
    }
  }
}
    `;

/**
 * __useGetHomeLearnerActivityQuery__
 *
 * To run a query within a React component, call `useGetHomeLearnerActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeLearnerActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeLearnerActivityQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetHomeLearnerActivityQuery(baseOptions: Apollo.QueryHookOptions<Types.GetHomeLearnerActivityQuery, Types.GetHomeLearnerActivityQueryVariables> & ({ variables: Types.GetHomeLearnerActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetHomeLearnerActivityQuery, Types.GetHomeLearnerActivityQueryVariables>(GetHomeLearnerActivityDocument, options);
      }
export function useGetHomeLearnerActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetHomeLearnerActivityQuery, Types.GetHomeLearnerActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetHomeLearnerActivityQuery, Types.GetHomeLearnerActivityQueryVariables>(GetHomeLearnerActivityDocument, options);
        }
// @ts-ignore
export function useGetHomeLearnerActivitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetHomeLearnerActivityQuery, Types.GetHomeLearnerActivityQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetHomeLearnerActivityQuery, Types.GetHomeLearnerActivityQueryVariables>;
export function useGetHomeLearnerActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetHomeLearnerActivityQuery, Types.GetHomeLearnerActivityQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetHomeLearnerActivityQuery | undefined, Types.GetHomeLearnerActivityQueryVariables>;
export function useGetHomeLearnerActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetHomeLearnerActivityQuery, Types.GetHomeLearnerActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetHomeLearnerActivityQuery, Types.GetHomeLearnerActivityQueryVariables>(GetHomeLearnerActivityDocument, options);
        }
export type GetHomeLearnerActivityQueryHookResult = ReturnType<typeof useGetHomeLearnerActivityQuery>;
export type GetHomeLearnerActivityLazyQueryHookResult = ReturnType<typeof useGetHomeLearnerActivityLazyQuery>;
export type GetHomeLearnerActivitySuspenseQueryHookResult = ReturnType<typeof useGetHomeLearnerActivitySuspenseQuery>;
export type GetHomeLearnerActivityQueryResult = Apollo.QueryResult<Types.GetHomeLearnerActivityQuery, Types.GetHomeLearnerActivityQueryVariables>;
export const GetHomeCoachActivityDocument = gql`
    query getHomeCoachActivity($userId: uuid!) {
  pendingFeedbacks: feedback(
    limit: 20
    order_by: {created_at: desc}
    where: {coach_id: {_eq: $userId}, status: {_eq: "PENDING"}}
  ) {
    feedback_id
    status
    created_at
    observation_date
    student {
      user_id
      name
    }
    coach {
      user_id
      name
    }
  }
  feedbacks: feedback(
    limit: 20
    order_by: {created_at: desc}
    where: {coach_id: {_eq: $userId}, status: {_nin: ["DRAFT", "ARCHIVED", "HIDDEN"]}}
  ) {
    feedback_id
    status
    created_at
    observation_date
    feedback_type
    course
    animal_sex
    site {
      site_id
      name
    }
    species {
      species_id
      name
    }
    student {
      user_id
      name
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    coach {
      user_id
      name
    }
    feedback_skills {
      feedback_skill_id
      requirement {
        name
        requirement_id
        type
      }
      self_rating
      coach_rating
    }
  }
}
    `;

/**
 * __useGetHomeCoachActivityQuery__
 *
 * To run a query within a React component, call `useGetHomeCoachActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeCoachActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeCoachActivityQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetHomeCoachActivityQuery(baseOptions: Apollo.QueryHookOptions<Types.GetHomeCoachActivityQuery, Types.GetHomeCoachActivityQueryVariables> & ({ variables: Types.GetHomeCoachActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetHomeCoachActivityQuery, Types.GetHomeCoachActivityQueryVariables>(GetHomeCoachActivityDocument, options);
      }
export function useGetHomeCoachActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetHomeCoachActivityQuery, Types.GetHomeCoachActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetHomeCoachActivityQuery, Types.GetHomeCoachActivityQueryVariables>(GetHomeCoachActivityDocument, options);
        }
// @ts-ignore
export function useGetHomeCoachActivitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetHomeCoachActivityQuery, Types.GetHomeCoachActivityQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetHomeCoachActivityQuery, Types.GetHomeCoachActivityQueryVariables>;
export function useGetHomeCoachActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetHomeCoachActivityQuery, Types.GetHomeCoachActivityQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetHomeCoachActivityQuery | undefined, Types.GetHomeCoachActivityQueryVariables>;
export function useGetHomeCoachActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetHomeCoachActivityQuery, Types.GetHomeCoachActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetHomeCoachActivityQuery, Types.GetHomeCoachActivityQueryVariables>(GetHomeCoachActivityDocument, options);
        }
export type GetHomeCoachActivityQueryHookResult = ReturnType<typeof useGetHomeCoachActivityQuery>;
export type GetHomeCoachActivityLazyQueryHookResult = ReturnType<typeof useGetHomeCoachActivityLazyQuery>;
export type GetHomeCoachActivitySuspenseQueryHookResult = ReturnType<typeof useGetHomeCoachActivitySuspenseQuery>;
export type GetHomeCoachActivityQueryResult = Apollo.QueryResult<Types.GetHomeCoachActivityQuery, Types.GetHomeCoachActivityQueryVariables>;
export const AddMentoringDocument = gql`
    mutation addMentoring($mentee: uuid!, $mentor: uuid!) {
  insert_mentoring(
    objects: [{mentee_id: $mentee, mentor_id: $mentor}]
    on_conflict: {constraint: mentoring_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddMentoringMutationFn = Apollo.MutationFunction<Types.AddMentoringMutation, Types.AddMentoringMutationVariables>;

/**
 * __useAddMentoringMutation__
 *
 * To run a mutation, you first call `useAddMentoringMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMentoringMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMentoringMutation, { data, loading, error }] = useAddMentoringMutation({
 *   variables: {
 *      mentee: // value for 'mentee'
 *      mentor: // value for 'mentor'
 *   },
 * });
 */
export function useAddMentoringMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddMentoringMutation, Types.AddMentoringMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddMentoringMutation, Types.AddMentoringMutationVariables>(AddMentoringDocument, options);
      }
export type AddMentoringMutationHookResult = ReturnType<typeof useAddMentoringMutation>;
export type AddMentoringMutationResult = Apollo.MutationResult<Types.AddMentoringMutation>;
export type AddMentoringMutationOptions = Apollo.BaseMutationOptions<Types.AddMentoringMutation, Types.AddMentoringMutationVariables>;
export const UpdateMentoringDocument = gql`
    mutation updateMentoring($id: uuid!, $mentoring: mentoring_set_input!) {
  update_mentoring(where: {mentoring_id: {_eq: $id}}, _set: $mentoring) {
    affected_rows
  }
}
    `;
export type UpdateMentoringMutationFn = Apollo.MutationFunction<Types.UpdateMentoringMutation, Types.UpdateMentoringMutationVariables>;

/**
 * __useUpdateMentoringMutation__
 *
 * To run a mutation, you first call `useUpdateMentoringMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMentoringMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMentoringMutation, { data, loading, error }] = useUpdateMentoringMutation({
 *   variables: {
 *      id: // value for 'id'
 *      mentoring: // value for 'mentoring'
 *   },
 * });
 */
export function useUpdateMentoringMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMentoringMutation, Types.UpdateMentoringMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMentoringMutation, Types.UpdateMentoringMutationVariables>(UpdateMentoringDocument, options);
      }
export type UpdateMentoringMutationHookResult = ReturnType<typeof useUpdateMentoringMutation>;
export type UpdateMentoringMutationResult = Apollo.MutationResult<Types.UpdateMentoringMutation>;
export type UpdateMentoringMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMentoringMutation, Types.UpdateMentoringMutationVariables>;
export const DeleteMentoringDocument = gql`
    mutation deleteMentoring($id: uuid!) {
  delete_mentoring(where: {mentoring_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteMentoringMutationFn = Apollo.MutationFunction<Types.DeleteMentoringMutation, Types.DeleteMentoringMutationVariables>;

/**
 * __useDeleteMentoringMutation__
 *
 * To run a mutation, you first call `useDeleteMentoringMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMentoringMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMentoringMutation, { data, loading, error }] = useDeleteMentoringMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMentoringMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteMentoringMutation, Types.DeleteMentoringMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteMentoringMutation, Types.DeleteMentoringMutationVariables>(DeleteMentoringDocument, options);
      }
export type DeleteMentoringMutationHookResult = ReturnType<typeof useDeleteMentoringMutation>;
export type DeleteMentoringMutationResult = Apollo.MutationResult<Types.DeleteMentoringMutation>;
export type DeleteMentoringMutationOptions = Apollo.BaseMutationOptions<Types.DeleteMentoringMutation, Types.DeleteMentoringMutationVariables>;
export const GetMentoringsDocument = gql`
    query getMentorings {
  mentoring {
    mentoring_id
    mentee_id
    mentor_id
  }
}
    `;

/**
 * __useGetMentoringsQuery__
 *
 * To run a query within a React component, call `useGetMentoringsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentoringsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentoringsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMentoringsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetMentoringsQuery, Types.GetMentoringsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMentoringsQuery, Types.GetMentoringsQueryVariables>(GetMentoringsDocument, options);
      }
export function useGetMentoringsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMentoringsQuery, Types.GetMentoringsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMentoringsQuery, Types.GetMentoringsQueryVariables>(GetMentoringsDocument, options);
        }
// @ts-ignore
export function useGetMentoringsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetMentoringsQuery, Types.GetMentoringsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetMentoringsQuery, Types.GetMentoringsQueryVariables>;
export function useGetMentoringsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetMentoringsQuery, Types.GetMentoringsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetMentoringsQuery | undefined, Types.GetMentoringsQueryVariables>;
export function useGetMentoringsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetMentoringsQuery, Types.GetMentoringsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMentoringsQuery, Types.GetMentoringsQueryVariables>(GetMentoringsDocument, options);
        }
export type GetMentoringsQueryHookResult = ReturnType<typeof useGetMentoringsQuery>;
export type GetMentoringsLazyQueryHookResult = ReturnType<typeof useGetMentoringsLazyQuery>;
export type GetMentoringsSuspenseQueryHookResult = ReturnType<typeof useGetMentoringsSuspenseQuery>;
export type GetMentoringsQueryResult = Apollo.QueryResult<Types.GetMentoringsQuery, Types.GetMentoringsQueryVariables>;
export const GetMentoringByIdDocument = gql`
    query getMentoringById($mentoringId: uuid!) {
  mentoring_by_pk(mentoring_id: $mentoringId) {
    mentoring_id
    mentee_id
    mentor_id
  }
}
    `;

/**
 * __useGetMentoringByIdQuery__
 *
 * To run a query within a React component, call `useGetMentoringByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentoringByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentoringByIdQuery({
 *   variables: {
 *      mentoringId: // value for 'mentoringId'
 *   },
 * });
 */
export function useGetMentoringByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMentoringByIdQuery, Types.GetMentoringByIdQueryVariables> & ({ variables: Types.GetMentoringByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMentoringByIdQuery, Types.GetMentoringByIdQueryVariables>(GetMentoringByIdDocument, options);
      }
export function useGetMentoringByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMentoringByIdQuery, Types.GetMentoringByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMentoringByIdQuery, Types.GetMentoringByIdQueryVariables>(GetMentoringByIdDocument, options);
        }
// @ts-ignore
export function useGetMentoringByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetMentoringByIdQuery, Types.GetMentoringByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetMentoringByIdQuery, Types.GetMentoringByIdQueryVariables>;
export function useGetMentoringByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetMentoringByIdQuery, Types.GetMentoringByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetMentoringByIdQuery | undefined, Types.GetMentoringByIdQueryVariables>;
export function useGetMentoringByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetMentoringByIdQuery, Types.GetMentoringByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMentoringByIdQuery, Types.GetMentoringByIdQueryVariables>(GetMentoringByIdDocument, options);
        }
export type GetMentoringByIdQueryHookResult = ReturnType<typeof useGetMentoringByIdQuery>;
export type GetMentoringByIdLazyQueryHookResult = ReturnType<typeof useGetMentoringByIdLazyQuery>;
export type GetMentoringByIdSuspenseQueryHookResult = ReturnType<typeof useGetMentoringByIdSuspenseQuery>;
export type GetMentoringByIdQueryResult = Apollo.QueryResult<Types.GetMentoringByIdQuery, Types.GetMentoringByIdQueryVariables>;
export const GetMentoringsByMenteeDocument = gql`
    query getMentoringsByMentee($mentee: uuid!) {
  mentoring(where: {mentee_id: {_eq: $mentee}}) {
    mentoring_id
    mentee_id
    mentor_id
    mentor {
      user_id
      name
      email
      picture_url
      role
      org_id
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
  }
}
    `;

/**
 * __useGetMentoringsByMenteeQuery__
 *
 * To run a query within a React component, call `useGetMentoringsByMenteeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentoringsByMenteeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentoringsByMenteeQuery({
 *   variables: {
 *      mentee: // value for 'mentee'
 *   },
 * });
 */
export function useGetMentoringsByMenteeQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMentoringsByMenteeQuery, Types.GetMentoringsByMenteeQueryVariables> & ({ variables: Types.GetMentoringsByMenteeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMentoringsByMenteeQuery, Types.GetMentoringsByMenteeQueryVariables>(GetMentoringsByMenteeDocument, options);
      }
export function useGetMentoringsByMenteeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMentoringsByMenteeQuery, Types.GetMentoringsByMenteeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMentoringsByMenteeQuery, Types.GetMentoringsByMenteeQueryVariables>(GetMentoringsByMenteeDocument, options);
        }
// @ts-ignore
export function useGetMentoringsByMenteeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetMentoringsByMenteeQuery, Types.GetMentoringsByMenteeQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetMentoringsByMenteeQuery, Types.GetMentoringsByMenteeQueryVariables>;
export function useGetMentoringsByMenteeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetMentoringsByMenteeQuery, Types.GetMentoringsByMenteeQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetMentoringsByMenteeQuery | undefined, Types.GetMentoringsByMenteeQueryVariables>;
export function useGetMentoringsByMenteeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetMentoringsByMenteeQuery, Types.GetMentoringsByMenteeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMentoringsByMenteeQuery, Types.GetMentoringsByMenteeQueryVariables>(GetMentoringsByMenteeDocument, options);
        }
export type GetMentoringsByMenteeQueryHookResult = ReturnType<typeof useGetMentoringsByMenteeQuery>;
export type GetMentoringsByMenteeLazyQueryHookResult = ReturnType<typeof useGetMentoringsByMenteeLazyQuery>;
export type GetMentoringsByMenteeSuspenseQueryHookResult = ReturnType<typeof useGetMentoringsByMenteeSuspenseQuery>;
export type GetMentoringsByMenteeQueryResult = Apollo.QueryResult<Types.GetMentoringsByMenteeQuery, Types.GetMentoringsByMenteeQueryVariables>;
export const GetMentoringsByMentorDocument = gql`
    query getMentoringsByMentor($mentor: uuid!) {
  mentoring(where: {mentor_id: {_eq: $mentor}}) {
    mentoring_id
    mentee_id
    mentor_id
  }
}
    `;

/**
 * __useGetMentoringsByMentorQuery__
 *
 * To run a query within a React component, call `useGetMentoringsByMentorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentoringsByMentorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentoringsByMentorQuery({
 *   variables: {
 *      mentor: // value for 'mentor'
 *   },
 * });
 */
export function useGetMentoringsByMentorQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMentoringsByMentorQuery, Types.GetMentoringsByMentorQueryVariables> & ({ variables: Types.GetMentoringsByMentorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMentoringsByMentorQuery, Types.GetMentoringsByMentorQueryVariables>(GetMentoringsByMentorDocument, options);
      }
export function useGetMentoringsByMentorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMentoringsByMentorQuery, Types.GetMentoringsByMentorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMentoringsByMentorQuery, Types.GetMentoringsByMentorQueryVariables>(GetMentoringsByMentorDocument, options);
        }
// @ts-ignore
export function useGetMentoringsByMentorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetMentoringsByMentorQuery, Types.GetMentoringsByMentorQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetMentoringsByMentorQuery, Types.GetMentoringsByMentorQueryVariables>;
export function useGetMentoringsByMentorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetMentoringsByMentorQuery, Types.GetMentoringsByMentorQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetMentoringsByMentorQuery | undefined, Types.GetMentoringsByMentorQueryVariables>;
export function useGetMentoringsByMentorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetMentoringsByMentorQuery, Types.GetMentoringsByMentorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMentoringsByMentorQuery, Types.GetMentoringsByMentorQueryVariables>(GetMentoringsByMentorDocument, options);
        }
export type GetMentoringsByMentorQueryHookResult = ReturnType<typeof useGetMentoringsByMentorQuery>;
export type GetMentoringsByMentorLazyQueryHookResult = ReturnType<typeof useGetMentoringsByMentorLazyQuery>;
export type GetMentoringsByMentorSuspenseQueryHookResult = ReturnType<typeof useGetMentoringsByMentorSuspenseQuery>;
export type GetMentoringsByMentorQueryResult = Apollo.QueryResult<Types.GetMentoringsByMentorQuery, Types.GetMentoringsByMentorQueryVariables>;
export const GetMenteesByMentorDocument = gql`
    query getMenteesByMentor($mentor: uuid!) {
  mentoring(where: {mentor_id: {_eq: $mentor}}) {
    mentee {
      user_id
      name
      email
      picture_url
      role
      org_id
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
  }
}
    `;

/**
 * __useGetMenteesByMentorQuery__
 *
 * To run a query within a React component, call `useGetMenteesByMentorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenteesByMentorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenteesByMentorQuery({
 *   variables: {
 *      mentor: // value for 'mentor'
 *   },
 * });
 */
export function useGetMenteesByMentorQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMenteesByMentorQuery, Types.GetMenteesByMentorQueryVariables> & ({ variables: Types.GetMenteesByMentorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMenteesByMentorQuery, Types.GetMenteesByMentorQueryVariables>(GetMenteesByMentorDocument, options);
      }
export function useGetMenteesByMentorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMenteesByMentorQuery, Types.GetMenteesByMentorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMenteesByMentorQuery, Types.GetMenteesByMentorQueryVariables>(GetMenteesByMentorDocument, options);
        }
// @ts-ignore
export function useGetMenteesByMentorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetMenteesByMentorQuery, Types.GetMenteesByMentorQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetMenteesByMentorQuery, Types.GetMenteesByMentorQueryVariables>;
export function useGetMenteesByMentorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetMenteesByMentorQuery, Types.GetMenteesByMentorQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetMenteesByMentorQuery | undefined, Types.GetMenteesByMentorQueryVariables>;
export function useGetMenteesByMentorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetMenteesByMentorQuery, Types.GetMenteesByMentorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMenteesByMentorQuery, Types.GetMenteesByMentorQueryVariables>(GetMenteesByMentorDocument, options);
        }
export type GetMenteesByMentorQueryHookResult = ReturnType<typeof useGetMenteesByMentorQuery>;
export type GetMenteesByMentorLazyQueryHookResult = ReturnType<typeof useGetMenteesByMentorLazyQuery>;
export type GetMenteesByMentorSuspenseQueryHookResult = ReturnType<typeof useGetMenteesByMentorSuspenseQuery>;
export type GetMenteesByMentorQueryResult = Apollo.QueryResult<Types.GetMenteesByMentorQuery, Types.GetMenteesByMentorQueryVariables>;
export const GetOrgDomainTagsDocument = gql`
    query getOrgDomainTags($orgId: uuid!) {
  organization_tag(where: {org_id: {_eq: $orgId}, tag: {type: {_eq: "domain"}}}) {
    tag_id
    tag {
      tag_id
      name
      type
    }
  }
}
    `;

/**
 * __useGetOrgDomainTagsQuery__
 *
 * To run a query within a React component, call `useGetOrgDomainTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgDomainTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgDomainTagsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrgDomainTagsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOrgDomainTagsQuery, Types.GetOrgDomainTagsQueryVariables> & ({ variables: Types.GetOrgDomainTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrgDomainTagsQuery, Types.GetOrgDomainTagsQueryVariables>(GetOrgDomainTagsDocument, options);
      }
export function useGetOrgDomainTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrgDomainTagsQuery, Types.GetOrgDomainTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrgDomainTagsQuery, Types.GetOrgDomainTagsQueryVariables>(GetOrgDomainTagsDocument, options);
        }
// @ts-ignore
export function useGetOrgDomainTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrgDomainTagsQuery, Types.GetOrgDomainTagsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgDomainTagsQuery, Types.GetOrgDomainTagsQueryVariables>;
export function useGetOrgDomainTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgDomainTagsQuery, Types.GetOrgDomainTagsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgDomainTagsQuery | undefined, Types.GetOrgDomainTagsQueryVariables>;
export function useGetOrgDomainTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgDomainTagsQuery, Types.GetOrgDomainTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrgDomainTagsQuery, Types.GetOrgDomainTagsQueryVariables>(GetOrgDomainTagsDocument, options);
        }
export type GetOrgDomainTagsQueryHookResult = ReturnType<typeof useGetOrgDomainTagsQuery>;
export type GetOrgDomainTagsLazyQueryHookResult = ReturnType<typeof useGetOrgDomainTagsLazyQuery>;
export type GetOrgDomainTagsSuspenseQueryHookResult = ReturnType<typeof useGetOrgDomainTagsSuspenseQuery>;
export type GetOrgDomainTagsQueryResult = Apollo.QueryResult<Types.GetOrgDomainTagsQuery, Types.GetOrgDomainTagsQueryVariables>;
export const GetAllDomainMembershipsDocument = gql`
    query getAllDomainMemberships {
  organization_tag(where: {tag: {type: {_eq: "domain"}}}) {
    tag_id
    tag {
      tag_id
      name
    }
    org_id
    organization {
      org_id
      name
    }
  }
}
    `;

/**
 * __useGetAllDomainMembershipsQuery__
 *
 * To run a query within a React component, call `useGetAllDomainMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDomainMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDomainMembershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllDomainMembershipsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllDomainMembershipsQuery, Types.GetAllDomainMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllDomainMembershipsQuery, Types.GetAllDomainMembershipsQueryVariables>(GetAllDomainMembershipsDocument, options);
      }
export function useGetAllDomainMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllDomainMembershipsQuery, Types.GetAllDomainMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllDomainMembershipsQuery, Types.GetAllDomainMembershipsQueryVariables>(GetAllDomainMembershipsDocument, options);
        }
// @ts-ignore
export function useGetAllDomainMembershipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAllDomainMembershipsQuery, Types.GetAllDomainMembershipsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAllDomainMembershipsQuery, Types.GetAllDomainMembershipsQueryVariables>;
export function useGetAllDomainMembershipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAllDomainMembershipsQuery, Types.GetAllDomainMembershipsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAllDomainMembershipsQuery | undefined, Types.GetAllDomainMembershipsQueryVariables>;
export function useGetAllDomainMembershipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAllDomainMembershipsQuery, Types.GetAllDomainMembershipsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllDomainMembershipsQuery, Types.GetAllDomainMembershipsQueryVariables>(GetAllDomainMembershipsDocument, options);
        }
export type GetAllDomainMembershipsQueryHookResult = ReturnType<typeof useGetAllDomainMembershipsQuery>;
export type GetAllDomainMembershipsLazyQueryHookResult = ReturnType<typeof useGetAllDomainMembershipsLazyQuery>;
export type GetAllDomainMembershipsSuspenseQueryHookResult = ReturnType<typeof useGetAllDomainMembershipsSuspenseQuery>;
export type GetAllDomainMembershipsQueryResult = Apollo.QueryResult<Types.GetAllDomainMembershipsQuery, Types.GetAllDomainMembershipsQueryVariables>;
export const GetOrganizationsByDomainTagDocument = gql`
    query getOrganizationsByDomainTag($tagId: uuid!) {
  organization_tag(where: {tag_id: {_eq: $tagId}}) {
    org_id
    organization {
      org_id
      name
    }
  }
}
    `;

/**
 * __useGetOrganizationsByDomainTagQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsByDomainTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsByDomainTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsByDomainTagQuery({
 *   variables: {
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useGetOrganizationsByDomainTagQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOrganizationsByDomainTagQuery, Types.GetOrganizationsByDomainTagQueryVariables> & ({ variables: Types.GetOrganizationsByDomainTagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrganizationsByDomainTagQuery, Types.GetOrganizationsByDomainTagQueryVariables>(GetOrganizationsByDomainTagDocument, options);
      }
export function useGetOrganizationsByDomainTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrganizationsByDomainTagQuery, Types.GetOrganizationsByDomainTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrganizationsByDomainTagQuery, Types.GetOrganizationsByDomainTagQueryVariables>(GetOrganizationsByDomainTagDocument, options);
        }
// @ts-ignore
export function useGetOrganizationsByDomainTagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrganizationsByDomainTagQuery, Types.GetOrganizationsByDomainTagQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrganizationsByDomainTagQuery, Types.GetOrganizationsByDomainTagQueryVariables>;
export function useGetOrganizationsByDomainTagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrganizationsByDomainTagQuery, Types.GetOrganizationsByDomainTagQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrganizationsByDomainTagQuery | undefined, Types.GetOrganizationsByDomainTagQueryVariables>;
export function useGetOrganizationsByDomainTagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrganizationsByDomainTagQuery, Types.GetOrganizationsByDomainTagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrganizationsByDomainTagQuery, Types.GetOrganizationsByDomainTagQueryVariables>(GetOrganizationsByDomainTagDocument, options);
        }
export type GetOrganizationsByDomainTagQueryHookResult = ReturnType<typeof useGetOrganizationsByDomainTagQuery>;
export type GetOrganizationsByDomainTagLazyQueryHookResult = ReturnType<typeof useGetOrganizationsByDomainTagLazyQuery>;
export type GetOrganizationsByDomainTagSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationsByDomainTagSuspenseQuery>;
export type GetOrganizationsByDomainTagQueryResult = Apollo.QueryResult<Types.GetOrganizationsByDomainTagQuery, Types.GetOrganizationsByDomainTagQueryVariables>;
export const GetHospitalFeedbackCompetitionDocument = gql`
    query getHospitalFeedbackCompetition($orgIds: [uuid!]!, $sinceDate: timestamptz!, $excludeTestOrgNamePattern: String!) {
  organization(
    where: {org_id: {_in: $orgIds}, name: {_nilike: $excludeTestOrgNamePattern}}
    order_by: {name: asc}
  ) {
    org_id
    name
  }
  learners: user(where: {org_id: {_in: $orgIds}, role: {_eq: "student"}}) {
    user_id
    org_id
  }
  feedback(
    where: {org_id: {_in: $orgIds}, created_at: {_gte: $sinceDate}, student_id: {_is_null: false}, organization: {name: {_nilike: $excludeTestOrgNamePattern}}}
  ) {
    org_id
    student_id
  }
}
    `;

/**
 * __useGetHospitalFeedbackCompetitionQuery__
 *
 * To run a query within a React component, call `useGetHospitalFeedbackCompetitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHospitalFeedbackCompetitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHospitalFeedbackCompetitionQuery({
 *   variables: {
 *      orgIds: // value for 'orgIds'
 *      sinceDate: // value for 'sinceDate'
 *      excludeTestOrgNamePattern: // value for 'excludeTestOrgNamePattern'
 *   },
 * });
 */
export function useGetHospitalFeedbackCompetitionQuery(baseOptions: Apollo.QueryHookOptions<Types.GetHospitalFeedbackCompetitionQuery, Types.GetHospitalFeedbackCompetitionQueryVariables> & ({ variables: Types.GetHospitalFeedbackCompetitionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetHospitalFeedbackCompetitionQuery, Types.GetHospitalFeedbackCompetitionQueryVariables>(GetHospitalFeedbackCompetitionDocument, options);
      }
export function useGetHospitalFeedbackCompetitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetHospitalFeedbackCompetitionQuery, Types.GetHospitalFeedbackCompetitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetHospitalFeedbackCompetitionQuery, Types.GetHospitalFeedbackCompetitionQueryVariables>(GetHospitalFeedbackCompetitionDocument, options);
        }
// @ts-ignore
export function useGetHospitalFeedbackCompetitionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetHospitalFeedbackCompetitionQuery, Types.GetHospitalFeedbackCompetitionQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetHospitalFeedbackCompetitionQuery, Types.GetHospitalFeedbackCompetitionQueryVariables>;
export function useGetHospitalFeedbackCompetitionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetHospitalFeedbackCompetitionQuery, Types.GetHospitalFeedbackCompetitionQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetHospitalFeedbackCompetitionQuery | undefined, Types.GetHospitalFeedbackCompetitionQueryVariables>;
export function useGetHospitalFeedbackCompetitionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetHospitalFeedbackCompetitionQuery, Types.GetHospitalFeedbackCompetitionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetHospitalFeedbackCompetitionQuery, Types.GetHospitalFeedbackCompetitionQueryVariables>(GetHospitalFeedbackCompetitionDocument, options);
        }
export type GetHospitalFeedbackCompetitionQueryHookResult = ReturnType<typeof useGetHospitalFeedbackCompetitionQuery>;
export type GetHospitalFeedbackCompetitionLazyQueryHookResult = ReturnType<typeof useGetHospitalFeedbackCompetitionLazyQuery>;
export type GetHospitalFeedbackCompetitionSuspenseQueryHookResult = ReturnType<typeof useGetHospitalFeedbackCompetitionSuspenseQuery>;
export type GetHospitalFeedbackCompetitionQueryResult = Apollo.QueryResult<Types.GetHospitalFeedbackCompetitionQuery, Types.GetHospitalFeedbackCompetitionQueryVariables>;
export const GetDirectorOrgMetricsDocument = gql`
    query getDirectorOrgMetrics($orgIds: [uuid!]!, $sinceDate: timestamptz!, $excludeTestOrgNamePattern: String!) {
  organization(where: {org_id: {_in: $orgIds}}, order_by: {name: asc}) {
    org_id
    name
  }
  learners: user(where: {org_id: {_in: $orgIds}, role: {_eq: "student"}}) {
    org_id
    accepted_terms_of_use
  }
  coaches: organization_user(
    where: {org_id: {_in: $orgIds}, user: {role: {_eq: "coach"}}}
  ) {
    org_id
    user {
      accepted_terms_of_use
    }
  }
  feedback(
    where: {org_id: {_in: $orgIds}, created_at: {_gte: $sinceDate}, organization: {name: {_nilike: $excludeTestOrgNamePattern}}}
  ) {
    org_id
  }
}
    `;

/**
 * __useGetDirectorOrgMetricsQuery__
 *
 * To run a query within a React component, call `useGetDirectorOrgMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectorOrgMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectorOrgMetricsQuery({
 *   variables: {
 *      orgIds: // value for 'orgIds'
 *      sinceDate: // value for 'sinceDate'
 *      excludeTestOrgNamePattern: // value for 'excludeTestOrgNamePattern'
 *   },
 * });
 */
export function useGetDirectorOrgMetricsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetDirectorOrgMetricsQuery, Types.GetDirectorOrgMetricsQueryVariables> & ({ variables: Types.GetDirectorOrgMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetDirectorOrgMetricsQuery, Types.GetDirectorOrgMetricsQueryVariables>(GetDirectorOrgMetricsDocument, options);
      }
export function useGetDirectorOrgMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetDirectorOrgMetricsQuery, Types.GetDirectorOrgMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetDirectorOrgMetricsQuery, Types.GetDirectorOrgMetricsQueryVariables>(GetDirectorOrgMetricsDocument, options);
        }
// @ts-ignore
export function useGetDirectorOrgMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetDirectorOrgMetricsQuery, Types.GetDirectorOrgMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetDirectorOrgMetricsQuery, Types.GetDirectorOrgMetricsQueryVariables>;
export function useGetDirectorOrgMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetDirectorOrgMetricsQuery, Types.GetDirectorOrgMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetDirectorOrgMetricsQuery | undefined, Types.GetDirectorOrgMetricsQueryVariables>;
export function useGetDirectorOrgMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetDirectorOrgMetricsQuery, Types.GetDirectorOrgMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetDirectorOrgMetricsQuery, Types.GetDirectorOrgMetricsQueryVariables>(GetDirectorOrgMetricsDocument, options);
        }
export type GetDirectorOrgMetricsQueryHookResult = ReturnType<typeof useGetDirectorOrgMetricsQuery>;
export type GetDirectorOrgMetricsLazyQueryHookResult = ReturnType<typeof useGetDirectorOrgMetricsLazyQuery>;
export type GetDirectorOrgMetricsSuspenseQueryHookResult = ReturnType<typeof useGetDirectorOrgMetricsSuspenseQuery>;
export type GetDirectorOrgMetricsQueryResult = Apollo.QueryResult<Types.GetDirectorOrgMetricsQuery, Types.GetDirectorOrgMetricsQueryVariables>;
export const InsertNotificationDocument = gql`
    mutation insertNotification($object: notification_insert_input!) {
  insert_notification_one(object: $object) {
    notification_id
    text
    link
  }
}
    `;
export type InsertNotificationMutationFn = Apollo.MutationFunction<Types.InsertNotificationMutation, Types.InsertNotificationMutationVariables>;

/**
 * __useInsertNotificationMutation__
 *
 * To run a mutation, you first call `useInsertNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertNotificationMutation, { data, loading, error }] = useInsertNotificationMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertNotificationMutation(baseOptions?: Apollo.MutationHookOptions<Types.InsertNotificationMutation, Types.InsertNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.InsertNotificationMutation, Types.InsertNotificationMutationVariables>(InsertNotificationDocument, options);
      }
export type InsertNotificationMutationHookResult = ReturnType<typeof useInsertNotificationMutation>;
export type InsertNotificationMutationResult = Apollo.MutationResult<Types.InsertNotificationMutation>;
export type InsertNotificationMutationOptions = Apollo.BaseMutationOptions<Types.InsertNotificationMutation, Types.InsertNotificationMutationVariables>;
export const UpdateNotificationViewedDocument = gql`
    mutation updateNotificationViewed($notificationId: uuid!, $alreadyViewed: Boolean!) {
  update_notification_by_pk(
    pk_columns: {notification_id: $notificationId}
    _set: {already_viewed: $alreadyViewed}
  ) {
    notification_id
    already_viewed
  }
}
    `;
export type UpdateNotificationViewedMutationFn = Apollo.MutationFunction<Types.UpdateNotificationViewedMutation, Types.UpdateNotificationViewedMutationVariables>;

/**
 * __useUpdateNotificationViewedMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationViewedMutation, { data, loading, error }] = useUpdateNotificationViewedMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *      alreadyViewed: // value for 'alreadyViewed'
 *   },
 * });
 */
export function useUpdateNotificationViewedMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateNotificationViewedMutation, Types.UpdateNotificationViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateNotificationViewedMutation, Types.UpdateNotificationViewedMutationVariables>(UpdateNotificationViewedDocument, options);
      }
export type UpdateNotificationViewedMutationHookResult = ReturnType<typeof useUpdateNotificationViewedMutation>;
export type UpdateNotificationViewedMutationResult = Apollo.MutationResult<Types.UpdateNotificationViewedMutation>;
export type UpdateNotificationViewedMutationOptions = Apollo.BaseMutationOptions<Types.UpdateNotificationViewedMutation, Types.UpdateNotificationViewedMutationVariables>;
export const MarkAllNotificationsReadDocument = gql`
    mutation markAllNotificationsRead($userId: uuid!) {
  update_notification(
    where: {user_id: {_eq: $userId}, already_viewed: {_eq: false}}
    _set: {already_viewed: true}
  ) {
    affected_rows
  }
}
    `;
export type MarkAllNotificationsReadMutationFn = Apollo.MutationFunction<Types.MarkAllNotificationsReadMutation, Types.MarkAllNotificationsReadMutationVariables>;

/**
 * __useMarkAllNotificationsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsReadMutation, { data, loading, error }] = useMarkAllNotificationsReadMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useMarkAllNotificationsReadMutation(baseOptions?: Apollo.MutationHookOptions<Types.MarkAllNotificationsReadMutation, Types.MarkAllNotificationsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MarkAllNotificationsReadMutation, Types.MarkAllNotificationsReadMutationVariables>(MarkAllNotificationsReadDocument, options);
      }
export type MarkAllNotificationsReadMutationHookResult = ReturnType<typeof useMarkAllNotificationsReadMutation>;
export type MarkAllNotificationsReadMutationResult = Apollo.MutationResult<Types.MarkAllNotificationsReadMutation>;
export type MarkAllNotificationsReadMutationOptions = Apollo.BaseMutationOptions<Types.MarkAllNotificationsReadMutation, Types.MarkAllNotificationsReadMutationVariables>;
export const GetNotificationsForUserDocument = gql`
    query getNotificationsForUser($userId: uuid!) {
  notification(
    where: {user_id: {_eq: $userId}}
    order_by: {notification_id: desc}
  ) {
    notification_id
    user_id
    text
    link
    already_viewed
  }
}
    `;

/**
 * __useGetNotificationsForUserQuery__
 *
 * To run a query within a React component, call `useGetNotificationsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetNotificationsForUserQuery(baseOptions: Apollo.QueryHookOptions<Types.GetNotificationsForUserQuery, Types.GetNotificationsForUserQueryVariables> & ({ variables: Types.GetNotificationsForUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetNotificationsForUserQuery, Types.GetNotificationsForUserQueryVariables>(GetNotificationsForUserDocument, options);
      }
export function useGetNotificationsForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetNotificationsForUserQuery, Types.GetNotificationsForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetNotificationsForUserQuery, Types.GetNotificationsForUserQueryVariables>(GetNotificationsForUserDocument, options);
        }
// @ts-ignore
export function useGetNotificationsForUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetNotificationsForUserQuery, Types.GetNotificationsForUserQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetNotificationsForUserQuery, Types.GetNotificationsForUserQueryVariables>;
export function useGetNotificationsForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetNotificationsForUserQuery, Types.GetNotificationsForUserQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetNotificationsForUserQuery | undefined, Types.GetNotificationsForUserQueryVariables>;
export function useGetNotificationsForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetNotificationsForUserQuery, Types.GetNotificationsForUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetNotificationsForUserQuery, Types.GetNotificationsForUserQueryVariables>(GetNotificationsForUserDocument, options);
        }
export type GetNotificationsForUserQueryHookResult = ReturnType<typeof useGetNotificationsForUserQuery>;
export type GetNotificationsForUserLazyQueryHookResult = ReturnType<typeof useGetNotificationsForUserLazyQuery>;
export type GetNotificationsForUserSuspenseQueryHookResult = ReturnType<typeof useGetNotificationsForUserSuspenseQuery>;
export type GetNotificationsForUserQueryResult = Apollo.QueryResult<Types.GetNotificationsForUserQuery, Types.GetNotificationsForUserQueryVariables>;
export const GetUnreadNotificationCountDocument = gql`
    query getUnreadNotificationCount($userId: uuid!) {
  notification_aggregate(
    where: {user_id: {_eq: $userId}, already_viewed: {_eq: false}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetUnreadNotificationCountQuery__
 *
 * To run a query within a React component, call `useGetUnreadNotificationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadNotificationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadNotificationCountQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUnreadNotificationCountQuery(baseOptions: Apollo.QueryHookOptions<Types.GetUnreadNotificationCountQuery, Types.GetUnreadNotificationCountQueryVariables> & ({ variables: Types.GetUnreadNotificationCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetUnreadNotificationCountQuery, Types.GetUnreadNotificationCountQueryVariables>(GetUnreadNotificationCountDocument, options);
      }
export function useGetUnreadNotificationCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUnreadNotificationCountQuery, Types.GetUnreadNotificationCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetUnreadNotificationCountQuery, Types.GetUnreadNotificationCountQueryVariables>(GetUnreadNotificationCountDocument, options);
        }
// @ts-ignore
export function useGetUnreadNotificationCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetUnreadNotificationCountQuery, Types.GetUnreadNotificationCountQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUnreadNotificationCountQuery, Types.GetUnreadNotificationCountQueryVariables>;
export function useGetUnreadNotificationCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUnreadNotificationCountQuery, Types.GetUnreadNotificationCountQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUnreadNotificationCountQuery | undefined, Types.GetUnreadNotificationCountQueryVariables>;
export function useGetUnreadNotificationCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUnreadNotificationCountQuery, Types.GetUnreadNotificationCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetUnreadNotificationCountQuery, Types.GetUnreadNotificationCountQueryVariables>(GetUnreadNotificationCountDocument, options);
        }
export type GetUnreadNotificationCountQueryHookResult = ReturnType<typeof useGetUnreadNotificationCountQuery>;
export type GetUnreadNotificationCountLazyQueryHookResult = ReturnType<typeof useGetUnreadNotificationCountLazyQuery>;
export type GetUnreadNotificationCountSuspenseQueryHookResult = ReturnType<typeof useGetUnreadNotificationCountSuspenseQuery>;
export type GetUnreadNotificationCountQueryResult = Apollo.QueryResult<Types.GetUnreadNotificationCountQuery, Types.GetUnreadNotificationCountQueryVariables>;
export const AddOptionDocument = gql`
    mutation addOption($order: Int, $questionId: uuid!, $text: String!) {
  insert_option(
    objects: [{order: $order, question_id: $questionId, text: $text}]
    on_conflict: {constraint: option_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      option_id
    }
  }
}
    `;
export type AddOptionMutationFn = Apollo.MutationFunction<Types.AddOptionMutation, Types.AddOptionMutationVariables>;

/**
 * __useAddOptionMutation__
 *
 * To run a mutation, you first call `useAddOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOptionMutation, { data, loading, error }] = useAddOptionMutation({
 *   variables: {
 *      order: // value for 'order'
 *      questionId: // value for 'questionId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useAddOptionMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddOptionMutation, Types.AddOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddOptionMutation, Types.AddOptionMutationVariables>(AddOptionDocument, options);
      }
export type AddOptionMutationHookResult = ReturnType<typeof useAddOptionMutation>;
export type AddOptionMutationResult = Apollo.MutationResult<Types.AddOptionMutation>;
export type AddOptionMutationOptions = Apollo.BaseMutationOptions<Types.AddOptionMutation, Types.AddOptionMutationVariables>;
export const UpdateOptionDocument = gql`
    mutation updateOption($id: uuid!, $option: option_set_input!) {
  update_option(where: {option_id: {_eq: $id}}, _set: $option) {
    affected_rows
  }
}
    `;
export type UpdateOptionMutationFn = Apollo.MutationFunction<Types.UpdateOptionMutation, Types.UpdateOptionMutationVariables>;

/**
 * __useUpdateOptionMutation__
 *
 * To run a mutation, you first call `useUpdateOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOptionMutation, { data, loading, error }] = useUpdateOptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      option: // value for 'option'
 *   },
 * });
 */
export function useUpdateOptionMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOptionMutation, Types.UpdateOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOptionMutation, Types.UpdateOptionMutationVariables>(UpdateOptionDocument, options);
      }
export type UpdateOptionMutationHookResult = ReturnType<typeof useUpdateOptionMutation>;
export type UpdateOptionMutationResult = Apollo.MutationResult<Types.UpdateOptionMutation>;
export type UpdateOptionMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOptionMutation, Types.UpdateOptionMutationVariables>;
export const DeleteOptionDocument = gql`
    mutation deleteOption($id: uuid!) {
  delete_option(where: {option_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteOptionMutationFn = Apollo.MutationFunction<Types.DeleteOptionMutation, Types.DeleteOptionMutationVariables>;

/**
 * __useDeleteOptionMutation__
 *
 * To run a mutation, you first call `useDeleteOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOptionMutation, { data, loading, error }] = useDeleteOptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOptionMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOptionMutation, Types.DeleteOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOptionMutation, Types.DeleteOptionMutationVariables>(DeleteOptionDocument, options);
      }
export type DeleteOptionMutationHookResult = ReturnType<typeof useDeleteOptionMutation>;
export type DeleteOptionMutationResult = Apollo.MutationResult<Types.DeleteOptionMutation>;
export type DeleteOptionMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOptionMutation, Types.DeleteOptionMutationVariables>;
export const GetOptionsDocument = gql`
    query getOptions {
  option {
    option_id
    order
    question_id
    text
  }
}
    `;

/**
 * __useGetOptionsQuery__
 *
 * To run a query within a React component, call `useGetOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetOptionsQuery, Types.GetOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOptionsQuery, Types.GetOptionsQueryVariables>(GetOptionsDocument, options);
      }
export function useGetOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOptionsQuery, Types.GetOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOptionsQuery, Types.GetOptionsQueryVariables>(GetOptionsDocument, options);
        }
// @ts-ignore
export function useGetOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOptionsQuery, Types.GetOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOptionsQuery, Types.GetOptionsQueryVariables>;
export function useGetOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOptionsQuery, Types.GetOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOptionsQuery | undefined, Types.GetOptionsQueryVariables>;
export function useGetOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOptionsQuery, Types.GetOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOptionsQuery, Types.GetOptionsQueryVariables>(GetOptionsDocument, options);
        }
export type GetOptionsQueryHookResult = ReturnType<typeof useGetOptionsQuery>;
export type GetOptionsLazyQueryHookResult = ReturnType<typeof useGetOptionsLazyQuery>;
export type GetOptionsSuspenseQueryHookResult = ReturnType<typeof useGetOptionsSuspenseQuery>;
export type GetOptionsQueryResult = Apollo.QueryResult<Types.GetOptionsQuery, Types.GetOptionsQueryVariables>;
export const GetOptionByIdDocument = gql`
    query getOptionById($optionId: uuid!) {
  option_by_pk(option_id: $optionId) {
    option_id
    order
    question_id
    text
  }
}
    `;

/**
 * __useGetOptionByIdQuery__
 *
 * To run a query within a React component, call `useGetOptionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOptionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOptionByIdQuery({
 *   variables: {
 *      optionId: // value for 'optionId'
 *   },
 * });
 */
export function useGetOptionByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOptionByIdQuery, Types.GetOptionByIdQueryVariables> & ({ variables: Types.GetOptionByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOptionByIdQuery, Types.GetOptionByIdQueryVariables>(GetOptionByIdDocument, options);
      }
export function useGetOptionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOptionByIdQuery, Types.GetOptionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOptionByIdQuery, Types.GetOptionByIdQueryVariables>(GetOptionByIdDocument, options);
        }
// @ts-ignore
export function useGetOptionByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOptionByIdQuery, Types.GetOptionByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOptionByIdQuery, Types.GetOptionByIdQueryVariables>;
export function useGetOptionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOptionByIdQuery, Types.GetOptionByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOptionByIdQuery | undefined, Types.GetOptionByIdQueryVariables>;
export function useGetOptionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOptionByIdQuery, Types.GetOptionByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOptionByIdQuery, Types.GetOptionByIdQueryVariables>(GetOptionByIdDocument, options);
        }
export type GetOptionByIdQueryHookResult = ReturnType<typeof useGetOptionByIdQuery>;
export type GetOptionByIdLazyQueryHookResult = ReturnType<typeof useGetOptionByIdLazyQuery>;
export type GetOptionByIdSuspenseQueryHookResult = ReturnType<typeof useGetOptionByIdSuspenseQuery>;
export type GetOptionByIdQueryResult = Apollo.QueryResult<Types.GetOptionByIdQuery, Types.GetOptionByIdQueryVariables>;
export const GetOptionsByQuestionIdDocument = gql`
    query getOptionsByQuestionId($questionId: uuid!) {
  option(where: {question_id: {_eq: $questionId}}) {
    option_id
    order
    question_id
    text
  }
}
    `;

/**
 * __useGetOptionsByQuestionIdQuery__
 *
 * To run a query within a React component, call `useGetOptionsByQuestionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOptionsByQuestionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOptionsByQuestionIdQuery({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useGetOptionsByQuestionIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOptionsByQuestionIdQuery, Types.GetOptionsByQuestionIdQueryVariables> & ({ variables: Types.GetOptionsByQuestionIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOptionsByQuestionIdQuery, Types.GetOptionsByQuestionIdQueryVariables>(GetOptionsByQuestionIdDocument, options);
      }
export function useGetOptionsByQuestionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOptionsByQuestionIdQuery, Types.GetOptionsByQuestionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOptionsByQuestionIdQuery, Types.GetOptionsByQuestionIdQueryVariables>(GetOptionsByQuestionIdDocument, options);
        }
// @ts-ignore
export function useGetOptionsByQuestionIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOptionsByQuestionIdQuery, Types.GetOptionsByQuestionIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOptionsByQuestionIdQuery, Types.GetOptionsByQuestionIdQueryVariables>;
export function useGetOptionsByQuestionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOptionsByQuestionIdQuery, Types.GetOptionsByQuestionIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOptionsByQuestionIdQuery | undefined, Types.GetOptionsByQuestionIdQueryVariables>;
export function useGetOptionsByQuestionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOptionsByQuestionIdQuery, Types.GetOptionsByQuestionIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOptionsByQuestionIdQuery, Types.GetOptionsByQuestionIdQueryVariables>(GetOptionsByQuestionIdDocument, options);
        }
export type GetOptionsByQuestionIdQueryHookResult = ReturnType<typeof useGetOptionsByQuestionIdQuery>;
export type GetOptionsByQuestionIdLazyQueryHookResult = ReturnType<typeof useGetOptionsByQuestionIdLazyQuery>;
export type GetOptionsByQuestionIdSuspenseQueryHookResult = ReturnType<typeof useGetOptionsByQuestionIdSuspenseQuery>;
export type GetOptionsByQuestionIdQueryResult = Apollo.QueryResult<Types.GetOptionsByQuestionIdQuery, Types.GetOptionsByQuestionIdQueryVariables>;
export const AddOrganizationDocument = gql`
    mutation addOrganization($name: String!, $primary_contact_name: String, $primary_contact_email: String, $secondary_contact_name: String, $secondary_contact_email: String, $type: String, $logo_url: String) {
  insert_organization(
    objects: [{name: $name, primary_contact_name: $primary_contact_name, primary_contact_email: $primary_contact_email, secondary_contact_name: $secondary_contact_name, secondary_contact_email: $secondary_contact_email, type: $type, logo_url: $logo_url}]
    on_conflict: {constraint: organization_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      org_id
    }
  }
}
    `;
export type AddOrganizationMutationFn = Apollo.MutationFunction<Types.AddOrganizationMutation, Types.AddOrganizationMutationVariables>;

/**
 * __useAddOrganizationMutation__
 *
 * To run a mutation, you first call `useAddOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationMutation, { data, loading, error }] = useAddOrganizationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      primary_contact_name: // value for 'primary_contact_name'
 *      primary_contact_email: // value for 'primary_contact_email'
 *      secondary_contact_name: // value for 'secondary_contact_name'
 *      secondary_contact_email: // value for 'secondary_contact_email'
 *      type: // value for 'type'
 *      logo_url: // value for 'logo_url'
 *   },
 * });
 */
export function useAddOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddOrganizationMutation, Types.AddOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddOrganizationMutation, Types.AddOrganizationMutationVariables>(AddOrganizationDocument, options);
      }
export type AddOrganizationMutationHookResult = ReturnType<typeof useAddOrganizationMutation>;
export type AddOrganizationMutationResult = Apollo.MutationResult<Types.AddOrganizationMutation>;
export type AddOrganizationMutationOptions = Apollo.BaseMutationOptions<Types.AddOrganizationMutation, Types.AddOrganizationMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation updateOrganization($id: uuid!, $organization: organization_set_input!) {
  update_organization(where: {org_id: {_eq: $id}}, _set: $organization) {
    affected_rows
  }
}
    `;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<Types.UpdateOrganizationMutation, Types.UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrganizationMutation, Types.UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrganizationMutation, Types.UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<Types.UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrganizationMutation, Types.UpdateOrganizationMutationVariables>;
export const DeleteOrganizationDocument = gql`
    mutation deleteOrganization($id: uuid!) {
  delete_organization(where: {org_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteOrganizationMutationFn = Apollo.MutationFunction<Types.DeleteOrganizationMutation, Types.DeleteOrganizationMutationVariables>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrganizationMutation, Types.DeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrganizationMutation, Types.DeleteOrganizationMutationVariables>(DeleteOrganizationDocument, options);
      }
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = Apollo.MutationResult<Types.DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrganizationMutation, Types.DeleteOrganizationMutationVariables>;
export const GetOrganizationsDocument = gql`
    query getOrganizations {
  organization {
    org_id
    name
    ferpa_school
    school_officials_accepted_at
    primary_contact_name
    primary_contact_email
    secondary_contact_name
    secondary_contact_email
    type
    logo_url
    users {
      user {
        user_id
        email
        name
        role
        picture_url
        accepted_terms_of_use
      }
    }
    sites {
      site {
        site_id
        name
        address {
          address_id
          address_line_1
          address_line_2
          city
          state
          country
          zip_code
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetOrganizationsQuery, Types.GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrganizationsQuery, Types.GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrganizationsQuery, Types.GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrganizationsQuery, Types.GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
// @ts-ignore
export function useGetOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrganizationsQuery, Types.GetOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrganizationsQuery, Types.GetOrganizationsQueryVariables>;
export function useGetOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrganizationsQuery, Types.GetOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrganizationsQuery | undefined, Types.GetOrganizationsQueryVariables>;
export function useGetOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrganizationsQuery, Types.GetOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrganizationsQuery, Types.GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationsSuspenseQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<Types.GetOrganizationsQuery, Types.GetOrganizationsQueryVariables>;
export const GetOrganizationDetailByIdDocument = gql`
    query getOrganizationDetailById($organizationId: uuid!) {
  organization_by_pk(org_id: $organizationId) {
    org_id
    name
    ferpa_school
    school_officials_accepted_at
    primary_contact_name
    primary_contact_email
    secondary_contact_name
    secondary_contact_email
    type
    logo_url
    users {
      user {
        user_id
        email
        name
        role
        picture_url
        accepted_terms_of_use
      }
    }
    sites {
      site {
        site_id
        name
        address {
          address_id
          address_line_1
          address_line_2
          city
          state
          country
          zip_code
        }
      }
    }
    custom_labels {
      custom_label {
        index
        label
        type
        custom_label_id
      }
    }
    tags {
      organization_tag_id
      tag_id
      tag {
        tag_id
        name
        type
      }
    }
  }
  academic_year(where: {program: {org_id: {_eq: $organizationId}}}) {
    academic_year_id
    end_date
    name
    program_id
    start_date
  }
  graduation_class(
    where: {program: {organization: {org_id: {_eq: $organizationId}}}}
  ) {
    name
    graduation_class_id
    current_academic_year_id
    start_date
    students {
      student {
        created_at
        email
        name
        org_id
        picture_url
        role
        updated_at
        user_id
        accepted_terms_of_use
      }
    }
  }
  organization_requirement(where: {org_id: {_eq: $organizationId}}) {
    org_requirement_id
    org_id
    requirement_id
    requirement {
      requirement_id
      name
      description
      overview
      requirement_type
      type
      domains {
        relation
        domain {
          requirement_domain_id
          name
          code
          color_hex
          sort_order
        }
      }
      competencies {
        competency {
          requirement_id
          name
          type
          domains {
            relation
            domain {
              requirement_domain_id
              name
              code
              color_hex
              sort_order
            }
          }
        }
      }
    }
  }
  program(where: {org_id: {_eq: $organizationId}}) {
    program_id
  }
  learners: user(
    where: {org_id: {_eq: $organizationId}, role: {_eq: "student"}}
    order_by: {name: asc}
  ) {
    user_id
    email
    name
    role
    picture_url
    accepted_terms_of_use
  }
}
    `;

/**
 * __useGetOrganizationDetailByIdQuery__
 *
 * To run a query within a React component, call `useGetOrganizationDetailByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationDetailByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationDetailByIdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationDetailByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOrganizationDetailByIdQuery, Types.GetOrganizationDetailByIdQueryVariables> & ({ variables: Types.GetOrganizationDetailByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrganizationDetailByIdQuery, Types.GetOrganizationDetailByIdQueryVariables>(GetOrganizationDetailByIdDocument, options);
      }
export function useGetOrganizationDetailByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrganizationDetailByIdQuery, Types.GetOrganizationDetailByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrganizationDetailByIdQuery, Types.GetOrganizationDetailByIdQueryVariables>(GetOrganizationDetailByIdDocument, options);
        }
// @ts-ignore
export function useGetOrganizationDetailByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrganizationDetailByIdQuery, Types.GetOrganizationDetailByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrganizationDetailByIdQuery, Types.GetOrganizationDetailByIdQueryVariables>;
export function useGetOrganizationDetailByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrganizationDetailByIdQuery, Types.GetOrganizationDetailByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrganizationDetailByIdQuery | undefined, Types.GetOrganizationDetailByIdQueryVariables>;
export function useGetOrganizationDetailByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrganizationDetailByIdQuery, Types.GetOrganizationDetailByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrganizationDetailByIdQuery, Types.GetOrganizationDetailByIdQueryVariables>(GetOrganizationDetailByIdDocument, options);
        }
export type GetOrganizationDetailByIdQueryHookResult = ReturnType<typeof useGetOrganizationDetailByIdQuery>;
export type GetOrganizationDetailByIdLazyQueryHookResult = ReturnType<typeof useGetOrganizationDetailByIdLazyQuery>;
export type GetOrganizationDetailByIdSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationDetailByIdSuspenseQuery>;
export type GetOrganizationDetailByIdQueryResult = Apollo.QueryResult<Types.GetOrganizationDetailByIdQuery, Types.GetOrganizationDetailByIdQueryVariables>;
export const GetOrganizationByIdDocument = gql`
    query getOrganizationById($organizationId: uuid!) {
  organization_by_pk(org_id: $organizationId) {
    org_id
    name
    ferpa_school
    school_officials_accepted_at
    primary_contact_name
    primary_contact_email
    secondary_contact_name
    secondary_contact_email
    type
    logo_url
    users {
      user {
        user_id
        email
        name
        role
        picture_url
        accepted_terms_of_use
        equipped_store_items(where: {item_type: {_eq: "PET"}}) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
    }
    sites {
      site {
        site_id
        name
        address {
          address_id
          address_line_1
          address_line_2
          city
          state
          country
          zip_code
        }
      }
    }
    custom_labels {
      custom_label {
        custom_label_id
        index
        label
        type
      }
    }
    tags {
      organization_tag_id
      tag_id
      tag {
        tag_id
        name
        type
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationByIdQuery__
 *
 * To run a query within a React component, call `useGetOrganizationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationByIdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOrganizationByIdQuery, Types.GetOrganizationByIdQueryVariables> & ({ variables: Types.GetOrganizationByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrganizationByIdQuery, Types.GetOrganizationByIdQueryVariables>(GetOrganizationByIdDocument, options);
      }
export function useGetOrganizationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrganizationByIdQuery, Types.GetOrganizationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrganizationByIdQuery, Types.GetOrganizationByIdQueryVariables>(GetOrganizationByIdDocument, options);
        }
// @ts-ignore
export function useGetOrganizationByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrganizationByIdQuery, Types.GetOrganizationByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrganizationByIdQuery, Types.GetOrganizationByIdQueryVariables>;
export function useGetOrganizationByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrganizationByIdQuery, Types.GetOrganizationByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrganizationByIdQuery | undefined, Types.GetOrganizationByIdQueryVariables>;
export function useGetOrganizationByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrganizationByIdQuery, Types.GetOrganizationByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrganizationByIdQuery, Types.GetOrganizationByIdQueryVariables>(GetOrganizationByIdDocument, options);
        }
export type GetOrganizationByIdQueryHookResult = ReturnType<typeof useGetOrganizationByIdQuery>;
export type GetOrganizationByIdLazyQueryHookResult = ReturnType<typeof useGetOrganizationByIdLazyQuery>;
export type GetOrganizationByIdSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationByIdSuspenseQuery>;
export type GetOrganizationByIdQueryResult = Apollo.QueryResult<Types.GetOrganizationByIdQuery, Types.GetOrganizationByIdQueryVariables>;
export const GetOrganizationByUserIdDocument = gql`
    query getOrganizationByUserId($userId: uuid!) {
  organization(where: {users: {user: {user_id: {_eq: $userId}}}}) {
    org_id
    name
    logo_url
    requirements {
      requirement {
        requirement_id
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationByUserIdQuery__
 *
 * To run a query within a React component, call `useGetOrganizationByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetOrganizationByUserIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOrganizationByUserIdQuery, Types.GetOrganizationByUserIdQueryVariables> & ({ variables: Types.GetOrganizationByUserIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrganizationByUserIdQuery, Types.GetOrganizationByUserIdQueryVariables>(GetOrganizationByUserIdDocument, options);
      }
export function useGetOrganizationByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrganizationByUserIdQuery, Types.GetOrganizationByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrganizationByUserIdQuery, Types.GetOrganizationByUserIdQueryVariables>(GetOrganizationByUserIdDocument, options);
        }
// @ts-ignore
export function useGetOrganizationByUserIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrganizationByUserIdQuery, Types.GetOrganizationByUserIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrganizationByUserIdQuery, Types.GetOrganizationByUserIdQueryVariables>;
export function useGetOrganizationByUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrganizationByUserIdQuery, Types.GetOrganizationByUserIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrganizationByUserIdQuery | undefined, Types.GetOrganizationByUserIdQueryVariables>;
export function useGetOrganizationByUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrganizationByUserIdQuery, Types.GetOrganizationByUserIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrganizationByUserIdQuery, Types.GetOrganizationByUserIdQueryVariables>(GetOrganizationByUserIdDocument, options);
        }
export type GetOrganizationByUserIdQueryHookResult = ReturnType<typeof useGetOrganizationByUserIdQuery>;
export type GetOrganizationByUserIdLazyQueryHookResult = ReturnType<typeof useGetOrganizationByUserIdLazyQuery>;
export type GetOrganizationByUserIdSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationByUserIdSuspenseQuery>;
export type GetOrganizationByUserIdQueryResult = Apollo.QueryResult<Types.GetOrganizationByUserIdQuery, Types.GetOrganizationByUserIdQueryVariables>;
export const AddOrganizationCustomLabelDocument = gql`
    mutation addOrganizationCustomLabel($org_id: uuid!, $custom_label_id: uuid) {
  insert_organization_custom_label(
    objects: [{org_id: $org_id, custom_label_id: $custom_label_id}]
    on_conflict: {constraint: organization_custom_label_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddOrganizationCustomLabelMutationFn = Apollo.MutationFunction<Types.AddOrganizationCustomLabelMutation, Types.AddOrganizationCustomLabelMutationVariables>;

/**
 * __useAddOrganizationCustomLabelMutation__
 *
 * To run a mutation, you first call `useAddOrganizationCustomLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationCustomLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationCustomLabelMutation, { data, loading, error }] = useAddOrganizationCustomLabelMutation({
 *   variables: {
 *      org_id: // value for 'org_id'
 *      custom_label_id: // value for 'custom_label_id'
 *   },
 * });
 */
export function useAddOrganizationCustomLabelMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddOrganizationCustomLabelMutation, Types.AddOrganizationCustomLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddOrganizationCustomLabelMutation, Types.AddOrganizationCustomLabelMutationVariables>(AddOrganizationCustomLabelDocument, options);
      }
export type AddOrganizationCustomLabelMutationHookResult = ReturnType<typeof useAddOrganizationCustomLabelMutation>;
export type AddOrganizationCustomLabelMutationResult = Apollo.MutationResult<Types.AddOrganizationCustomLabelMutation>;
export type AddOrganizationCustomLabelMutationOptions = Apollo.BaseMutationOptions<Types.AddOrganizationCustomLabelMutation, Types.AddOrganizationCustomLabelMutationVariables>;
export const AddOrganizationCustomLabelsDocument = gql`
    mutation addOrganizationCustomLabels($objects: [organization_custom_label_insert_input!]!) {
  insert_organization_custom_label(
    objects: $objects
    on_conflict: {constraint: organization_custom_label_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddOrganizationCustomLabelsMutationFn = Apollo.MutationFunction<Types.AddOrganizationCustomLabelsMutation, Types.AddOrganizationCustomLabelsMutationVariables>;

/**
 * __useAddOrganizationCustomLabelsMutation__
 *
 * To run a mutation, you first call `useAddOrganizationCustomLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationCustomLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationCustomLabelsMutation, { data, loading, error }] = useAddOrganizationCustomLabelsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddOrganizationCustomLabelsMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddOrganizationCustomLabelsMutation, Types.AddOrganizationCustomLabelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddOrganizationCustomLabelsMutation, Types.AddOrganizationCustomLabelsMutationVariables>(AddOrganizationCustomLabelsDocument, options);
      }
export type AddOrganizationCustomLabelsMutationHookResult = ReturnType<typeof useAddOrganizationCustomLabelsMutation>;
export type AddOrganizationCustomLabelsMutationResult = Apollo.MutationResult<Types.AddOrganizationCustomLabelsMutation>;
export type AddOrganizationCustomLabelsMutationOptions = Apollo.BaseMutationOptions<Types.AddOrganizationCustomLabelsMutation, Types.AddOrganizationCustomLabelsMutationVariables>;
export const DeleteOrganizationCustomLabelDocument = gql`
    mutation deleteOrganizationCustomLabel($id: uuid!) {
  delete_organization_custom_label(
    where: {organization_custom_label_id: {_eq: $id}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteOrganizationCustomLabelMutationFn = Apollo.MutationFunction<Types.DeleteOrganizationCustomLabelMutation, Types.DeleteOrganizationCustomLabelMutationVariables>;

/**
 * __useDeleteOrganizationCustomLabelMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationCustomLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationCustomLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationCustomLabelMutation, { data, loading, error }] = useDeleteOrganizationCustomLabelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationCustomLabelMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrganizationCustomLabelMutation, Types.DeleteOrganizationCustomLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrganizationCustomLabelMutation, Types.DeleteOrganizationCustomLabelMutationVariables>(DeleteOrganizationCustomLabelDocument, options);
      }
export type DeleteOrganizationCustomLabelMutationHookResult = ReturnType<typeof useDeleteOrganizationCustomLabelMutation>;
export type DeleteOrganizationCustomLabelMutationResult = Apollo.MutationResult<Types.DeleteOrganizationCustomLabelMutation>;
export type DeleteOrganizationCustomLabelMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrganizationCustomLabelMutation, Types.DeleteOrganizationCustomLabelMutationVariables>;
export const DeleteOrganizationCustomLabelByOrgIdAndCustomLabelIdDocument = gql`
    mutation deleteOrganizationCustomLabelByOrgIdAndCustomLabelId($org_id: uuid!, $custom_label_id: uuid!) {
  delete_organization_custom_label(
    where: {org_id: {_eq: $org_id}, custom_label_id: {_eq: $custom_label_id}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteOrganizationCustomLabelByOrgIdAndCustomLabelIdMutationFn = Apollo.MutationFunction<Types.DeleteOrganizationCustomLabelByOrgIdAndCustomLabelIdMutation, Types.DeleteOrganizationCustomLabelByOrgIdAndCustomLabelIdMutationVariables>;

/**
 * __useDeleteOrganizationCustomLabelByOrgIdAndCustomLabelIdMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationCustomLabelByOrgIdAndCustomLabelIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationCustomLabelByOrgIdAndCustomLabelIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationCustomLabelByOrgIdAndCustomLabelIdMutation, { data, loading, error }] = useDeleteOrganizationCustomLabelByOrgIdAndCustomLabelIdMutation({
 *   variables: {
 *      org_id: // value for 'org_id'
 *      custom_label_id: // value for 'custom_label_id'
 *   },
 * });
 */
export function useDeleteOrganizationCustomLabelByOrgIdAndCustomLabelIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrganizationCustomLabelByOrgIdAndCustomLabelIdMutation, Types.DeleteOrganizationCustomLabelByOrgIdAndCustomLabelIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrganizationCustomLabelByOrgIdAndCustomLabelIdMutation, Types.DeleteOrganizationCustomLabelByOrgIdAndCustomLabelIdMutationVariables>(DeleteOrganizationCustomLabelByOrgIdAndCustomLabelIdDocument, options);
      }
export type DeleteOrganizationCustomLabelByOrgIdAndCustomLabelIdMutationHookResult = ReturnType<typeof useDeleteOrganizationCustomLabelByOrgIdAndCustomLabelIdMutation>;
export type DeleteOrganizationCustomLabelByOrgIdAndCustomLabelIdMutationResult = Apollo.MutationResult<Types.DeleteOrganizationCustomLabelByOrgIdAndCustomLabelIdMutation>;
export type DeleteOrganizationCustomLabelByOrgIdAndCustomLabelIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrganizationCustomLabelByOrgIdAndCustomLabelIdMutation, Types.DeleteOrganizationCustomLabelByOrgIdAndCustomLabelIdMutationVariables>;
export const GetOrgCustomLabelsDocument = gql`
    query getOrgCustomLabels {
  organization_custom_label {
    organization_custom_label_id
    org_id
    custom_label_id
  }
}
    `;

/**
 * __useGetOrgCustomLabelsQuery__
 *
 * To run a query within a React component, call `useGetOrgCustomLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgCustomLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgCustomLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrgCustomLabelsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetOrgCustomLabelsQuery, Types.GetOrgCustomLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrgCustomLabelsQuery, Types.GetOrgCustomLabelsQueryVariables>(GetOrgCustomLabelsDocument, options);
      }
export function useGetOrgCustomLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrgCustomLabelsQuery, Types.GetOrgCustomLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrgCustomLabelsQuery, Types.GetOrgCustomLabelsQueryVariables>(GetOrgCustomLabelsDocument, options);
        }
// @ts-ignore
export function useGetOrgCustomLabelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrgCustomLabelsQuery, Types.GetOrgCustomLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgCustomLabelsQuery, Types.GetOrgCustomLabelsQueryVariables>;
export function useGetOrgCustomLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgCustomLabelsQuery, Types.GetOrgCustomLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgCustomLabelsQuery | undefined, Types.GetOrgCustomLabelsQueryVariables>;
export function useGetOrgCustomLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgCustomLabelsQuery, Types.GetOrgCustomLabelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrgCustomLabelsQuery, Types.GetOrgCustomLabelsQueryVariables>(GetOrgCustomLabelsDocument, options);
        }
export type GetOrgCustomLabelsQueryHookResult = ReturnType<typeof useGetOrgCustomLabelsQuery>;
export type GetOrgCustomLabelsLazyQueryHookResult = ReturnType<typeof useGetOrgCustomLabelsLazyQuery>;
export type GetOrgCustomLabelsSuspenseQueryHookResult = ReturnType<typeof useGetOrgCustomLabelsSuspenseQuery>;
export type GetOrgCustomLabelsQueryResult = Apollo.QueryResult<Types.GetOrgCustomLabelsQuery, Types.GetOrgCustomLabelsQueryVariables>;
export const GetOrgCustomLabelsByOrgDocument = gql`
    query getOrgCustomLabelsByOrg($orgId: uuid!) {
  organization_custom_label(where: {org_id: {_eq: $orgId}}) {
    organization_custom_label_id
    org_id
    custom_label_id
    custom_label {
      custom_label_id
      type
      index
      label
    }
  }
}
    `;

/**
 * __useGetOrgCustomLabelsByOrgQuery__
 *
 * To run a query within a React component, call `useGetOrgCustomLabelsByOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgCustomLabelsByOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgCustomLabelsByOrgQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrgCustomLabelsByOrgQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOrgCustomLabelsByOrgQuery, Types.GetOrgCustomLabelsByOrgQueryVariables> & ({ variables: Types.GetOrgCustomLabelsByOrgQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrgCustomLabelsByOrgQuery, Types.GetOrgCustomLabelsByOrgQueryVariables>(GetOrgCustomLabelsByOrgDocument, options);
      }
export function useGetOrgCustomLabelsByOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrgCustomLabelsByOrgQuery, Types.GetOrgCustomLabelsByOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrgCustomLabelsByOrgQuery, Types.GetOrgCustomLabelsByOrgQueryVariables>(GetOrgCustomLabelsByOrgDocument, options);
        }
// @ts-ignore
export function useGetOrgCustomLabelsByOrgSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrgCustomLabelsByOrgQuery, Types.GetOrgCustomLabelsByOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgCustomLabelsByOrgQuery, Types.GetOrgCustomLabelsByOrgQueryVariables>;
export function useGetOrgCustomLabelsByOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgCustomLabelsByOrgQuery, Types.GetOrgCustomLabelsByOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgCustomLabelsByOrgQuery | undefined, Types.GetOrgCustomLabelsByOrgQueryVariables>;
export function useGetOrgCustomLabelsByOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgCustomLabelsByOrgQuery, Types.GetOrgCustomLabelsByOrgQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrgCustomLabelsByOrgQuery, Types.GetOrgCustomLabelsByOrgQueryVariables>(GetOrgCustomLabelsByOrgDocument, options);
        }
export type GetOrgCustomLabelsByOrgQueryHookResult = ReturnType<typeof useGetOrgCustomLabelsByOrgQuery>;
export type GetOrgCustomLabelsByOrgLazyQueryHookResult = ReturnType<typeof useGetOrgCustomLabelsByOrgLazyQuery>;
export type GetOrgCustomLabelsByOrgSuspenseQueryHookResult = ReturnType<typeof useGetOrgCustomLabelsByOrgSuspenseQuery>;
export type GetOrgCustomLabelsByOrgQueryResult = Apollo.QueryResult<Types.GetOrgCustomLabelsByOrgQuery, Types.GetOrgCustomLabelsByOrgQueryVariables>;
export const GetOrgCustomLabelsByOrgAndTypeDocument = gql`
    query getOrgCustomLabelsByOrgAndType($orgId: uuid!, $type: String!) {
  organization_custom_label(
    where: {org_id: {_eq: $orgId}, custom_label: {type: {_eq: $type}}}
  ) {
    organization_custom_label_id
    org_id
    custom_label_id
    custom_label {
      custom_label_id
      type
      index
      label
    }
  }
}
    `;

/**
 * __useGetOrgCustomLabelsByOrgAndTypeQuery__
 *
 * To run a query within a React component, call `useGetOrgCustomLabelsByOrgAndTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgCustomLabelsByOrgAndTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgCustomLabelsByOrgAndTypeQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetOrgCustomLabelsByOrgAndTypeQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOrgCustomLabelsByOrgAndTypeQuery, Types.GetOrgCustomLabelsByOrgAndTypeQueryVariables> & ({ variables: Types.GetOrgCustomLabelsByOrgAndTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrgCustomLabelsByOrgAndTypeQuery, Types.GetOrgCustomLabelsByOrgAndTypeQueryVariables>(GetOrgCustomLabelsByOrgAndTypeDocument, options);
      }
export function useGetOrgCustomLabelsByOrgAndTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrgCustomLabelsByOrgAndTypeQuery, Types.GetOrgCustomLabelsByOrgAndTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrgCustomLabelsByOrgAndTypeQuery, Types.GetOrgCustomLabelsByOrgAndTypeQueryVariables>(GetOrgCustomLabelsByOrgAndTypeDocument, options);
        }
// @ts-ignore
export function useGetOrgCustomLabelsByOrgAndTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrgCustomLabelsByOrgAndTypeQuery, Types.GetOrgCustomLabelsByOrgAndTypeQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgCustomLabelsByOrgAndTypeQuery, Types.GetOrgCustomLabelsByOrgAndTypeQueryVariables>;
export function useGetOrgCustomLabelsByOrgAndTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgCustomLabelsByOrgAndTypeQuery, Types.GetOrgCustomLabelsByOrgAndTypeQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgCustomLabelsByOrgAndTypeQuery | undefined, Types.GetOrgCustomLabelsByOrgAndTypeQueryVariables>;
export function useGetOrgCustomLabelsByOrgAndTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgCustomLabelsByOrgAndTypeQuery, Types.GetOrgCustomLabelsByOrgAndTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrgCustomLabelsByOrgAndTypeQuery, Types.GetOrgCustomLabelsByOrgAndTypeQueryVariables>(GetOrgCustomLabelsByOrgAndTypeDocument, options);
        }
export type GetOrgCustomLabelsByOrgAndTypeQueryHookResult = ReturnType<typeof useGetOrgCustomLabelsByOrgAndTypeQuery>;
export type GetOrgCustomLabelsByOrgAndTypeLazyQueryHookResult = ReturnType<typeof useGetOrgCustomLabelsByOrgAndTypeLazyQuery>;
export type GetOrgCustomLabelsByOrgAndTypeSuspenseQueryHookResult = ReturnType<typeof useGetOrgCustomLabelsByOrgAndTypeSuspenseQuery>;
export type GetOrgCustomLabelsByOrgAndTypeQueryResult = Apollo.QueryResult<Types.GetOrgCustomLabelsByOrgAndTypeQuery, Types.GetOrgCustomLabelsByOrgAndTypeQueryVariables>;
export const AddOrganizationRequirementDocument = gql`
    mutation addOrganizationRequirement($org_id: uuid!, $requirement_id: uuid) {
  insert_organization_requirement(
    objects: [{org_id: $org_id, requirement_id: $requirement_id}]
    on_conflict: {constraint: organization_requirement_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddOrganizationRequirementMutationFn = Apollo.MutationFunction<Types.AddOrganizationRequirementMutation, Types.AddOrganizationRequirementMutationVariables>;

/**
 * __useAddOrganizationRequirementMutation__
 *
 * To run a mutation, you first call `useAddOrganizationRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationRequirementMutation, { data, loading, error }] = useAddOrganizationRequirementMutation({
 *   variables: {
 *      org_id: // value for 'org_id'
 *      requirement_id: // value for 'requirement_id'
 *   },
 * });
 */
export function useAddOrganizationRequirementMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddOrganizationRequirementMutation, Types.AddOrganizationRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddOrganizationRequirementMutation, Types.AddOrganizationRequirementMutationVariables>(AddOrganizationRequirementDocument, options);
      }
export type AddOrganizationRequirementMutationHookResult = ReturnType<typeof useAddOrganizationRequirementMutation>;
export type AddOrganizationRequirementMutationResult = Apollo.MutationResult<Types.AddOrganizationRequirementMutation>;
export type AddOrganizationRequirementMutationOptions = Apollo.BaseMutationOptions<Types.AddOrganizationRequirementMutation, Types.AddOrganizationRequirementMutationVariables>;
export const AddOrganizationRequirementsDocument = gql`
    mutation addOrganizationRequirements($objects: [organization_requirement_insert_input!]!) {
  insert_organization_requirement(
    objects: $objects
    on_conflict: {constraint: organization_requirement_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddOrganizationRequirementsMutationFn = Apollo.MutationFunction<Types.AddOrganizationRequirementsMutation, Types.AddOrganizationRequirementsMutationVariables>;

/**
 * __useAddOrganizationRequirementsMutation__
 *
 * To run a mutation, you first call `useAddOrganizationRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationRequirementsMutation, { data, loading, error }] = useAddOrganizationRequirementsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddOrganizationRequirementsMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddOrganizationRequirementsMutation, Types.AddOrganizationRequirementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddOrganizationRequirementsMutation, Types.AddOrganizationRequirementsMutationVariables>(AddOrganizationRequirementsDocument, options);
      }
export type AddOrganizationRequirementsMutationHookResult = ReturnType<typeof useAddOrganizationRequirementsMutation>;
export type AddOrganizationRequirementsMutationResult = Apollo.MutationResult<Types.AddOrganizationRequirementsMutation>;
export type AddOrganizationRequirementsMutationOptions = Apollo.BaseMutationOptions<Types.AddOrganizationRequirementsMutation, Types.AddOrganizationRequirementsMutationVariables>;
export const DeleteOrganizationRequirementDocument = gql`
    mutation deleteOrganizationRequirement($id: uuid!) {
  delete_organization_requirement(where: {org_requirement_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteOrganizationRequirementMutationFn = Apollo.MutationFunction<Types.DeleteOrganizationRequirementMutation, Types.DeleteOrganizationRequirementMutationVariables>;

/**
 * __useDeleteOrganizationRequirementMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationRequirementMutation, { data, loading, error }] = useDeleteOrganizationRequirementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationRequirementMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrganizationRequirementMutation, Types.DeleteOrganizationRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrganizationRequirementMutation, Types.DeleteOrganizationRequirementMutationVariables>(DeleteOrganizationRequirementDocument, options);
      }
export type DeleteOrganizationRequirementMutationHookResult = ReturnType<typeof useDeleteOrganizationRequirementMutation>;
export type DeleteOrganizationRequirementMutationResult = Apollo.MutationResult<Types.DeleteOrganizationRequirementMutation>;
export type DeleteOrganizationRequirementMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrganizationRequirementMutation, Types.DeleteOrganizationRequirementMutationVariables>;
export const DeleteOrganizationRequirementByOrgIdAndRequirementIdDocument = gql`
    mutation deleteOrganizationRequirementByOrgIdAndRequirementId($org_id: uuid!, $requirement_id: uuid!) {
  delete_organization_requirement(
    where: {org_id: {_eq: $org_id}, requirement_id: {_eq: $requirement_id}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteOrganizationRequirementByOrgIdAndRequirementIdMutationFn = Apollo.MutationFunction<Types.DeleteOrganizationRequirementByOrgIdAndRequirementIdMutation, Types.DeleteOrganizationRequirementByOrgIdAndRequirementIdMutationVariables>;

/**
 * __useDeleteOrganizationRequirementByOrgIdAndRequirementIdMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationRequirementByOrgIdAndRequirementIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationRequirementByOrgIdAndRequirementIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationRequirementByOrgIdAndRequirementIdMutation, { data, loading, error }] = useDeleteOrganizationRequirementByOrgIdAndRequirementIdMutation({
 *   variables: {
 *      org_id: // value for 'org_id'
 *      requirement_id: // value for 'requirement_id'
 *   },
 * });
 */
export function useDeleteOrganizationRequirementByOrgIdAndRequirementIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrganizationRequirementByOrgIdAndRequirementIdMutation, Types.DeleteOrganizationRequirementByOrgIdAndRequirementIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrganizationRequirementByOrgIdAndRequirementIdMutation, Types.DeleteOrganizationRequirementByOrgIdAndRequirementIdMutationVariables>(DeleteOrganizationRequirementByOrgIdAndRequirementIdDocument, options);
      }
export type DeleteOrganizationRequirementByOrgIdAndRequirementIdMutationHookResult = ReturnType<typeof useDeleteOrganizationRequirementByOrgIdAndRequirementIdMutation>;
export type DeleteOrganizationRequirementByOrgIdAndRequirementIdMutationResult = Apollo.MutationResult<Types.DeleteOrganizationRequirementByOrgIdAndRequirementIdMutation>;
export type DeleteOrganizationRequirementByOrgIdAndRequirementIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrganizationRequirementByOrgIdAndRequirementIdMutation, Types.DeleteOrganizationRequirementByOrgIdAndRequirementIdMutationVariables>;
export const GetOrgRequirementsDocument = gql`
    query getOrgRequirements {
  organization_requirement {
    org_requirement_id
    org_id
    requirement_id
  }
}
    `;

/**
 * __useGetOrgRequirementsQuery__
 *
 * To run a query within a React component, call `useGetOrgRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgRequirementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrgRequirementsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetOrgRequirementsQuery, Types.GetOrgRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrgRequirementsQuery, Types.GetOrgRequirementsQueryVariables>(GetOrgRequirementsDocument, options);
      }
export function useGetOrgRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrgRequirementsQuery, Types.GetOrgRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrgRequirementsQuery, Types.GetOrgRequirementsQueryVariables>(GetOrgRequirementsDocument, options);
        }
// @ts-ignore
export function useGetOrgRequirementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrgRequirementsQuery, Types.GetOrgRequirementsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgRequirementsQuery, Types.GetOrgRequirementsQueryVariables>;
export function useGetOrgRequirementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgRequirementsQuery, Types.GetOrgRequirementsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgRequirementsQuery | undefined, Types.GetOrgRequirementsQueryVariables>;
export function useGetOrgRequirementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgRequirementsQuery, Types.GetOrgRequirementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrgRequirementsQuery, Types.GetOrgRequirementsQueryVariables>(GetOrgRequirementsDocument, options);
        }
export type GetOrgRequirementsQueryHookResult = ReturnType<typeof useGetOrgRequirementsQuery>;
export type GetOrgRequirementsLazyQueryHookResult = ReturnType<typeof useGetOrgRequirementsLazyQuery>;
export type GetOrgRequirementsSuspenseQueryHookResult = ReturnType<typeof useGetOrgRequirementsSuspenseQuery>;
export type GetOrgRequirementsQueryResult = Apollo.QueryResult<Types.GetOrgRequirementsQuery, Types.GetOrgRequirementsQueryVariables>;
export const GetOrgRequirementsByOrgDocument = gql`
    query getOrgRequirementsByOrg($orgId: uuid!) {
  organization_requirement(where: {org_id: {_eq: $orgId}}) {
    org_requirement_id
    org_id
    requirement_id
    requirement {
      requirement_id
      name
      description
      task_time
      animal_size
      type
      overview
      requirement_type
      min_performance
      min_score
      min_small_animals_count
      min_large_animals_count
      domains {
        relation
        domain {
          requirement_domain_id
          name
          code
          color_hex
          sort_order
        }
      }
      competencies {
        competency {
          requirement_id
          name
          type
          domains {
            relation
            domain {
              requirement_domain_id
              name
              code
              color_hex
              sort_order
            }
          }
        }
      }
      resources {
        requirement_resource_id
        resource {
          resource_id
          name
          description
        }
      }
      species {
        name
        species_id
      }
    }
  }
}
    `;

/**
 * __useGetOrgRequirementsByOrgQuery__
 *
 * To run a query within a React component, call `useGetOrgRequirementsByOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgRequirementsByOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgRequirementsByOrgQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrgRequirementsByOrgQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOrgRequirementsByOrgQuery, Types.GetOrgRequirementsByOrgQueryVariables> & ({ variables: Types.GetOrgRequirementsByOrgQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrgRequirementsByOrgQuery, Types.GetOrgRequirementsByOrgQueryVariables>(GetOrgRequirementsByOrgDocument, options);
      }
export function useGetOrgRequirementsByOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrgRequirementsByOrgQuery, Types.GetOrgRequirementsByOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrgRequirementsByOrgQuery, Types.GetOrgRequirementsByOrgQueryVariables>(GetOrgRequirementsByOrgDocument, options);
        }
// @ts-ignore
export function useGetOrgRequirementsByOrgSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrgRequirementsByOrgQuery, Types.GetOrgRequirementsByOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgRequirementsByOrgQuery, Types.GetOrgRequirementsByOrgQueryVariables>;
export function useGetOrgRequirementsByOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgRequirementsByOrgQuery, Types.GetOrgRequirementsByOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgRequirementsByOrgQuery | undefined, Types.GetOrgRequirementsByOrgQueryVariables>;
export function useGetOrgRequirementsByOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgRequirementsByOrgQuery, Types.GetOrgRequirementsByOrgQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrgRequirementsByOrgQuery, Types.GetOrgRequirementsByOrgQueryVariables>(GetOrgRequirementsByOrgDocument, options);
        }
export type GetOrgRequirementsByOrgQueryHookResult = ReturnType<typeof useGetOrgRequirementsByOrgQuery>;
export type GetOrgRequirementsByOrgLazyQueryHookResult = ReturnType<typeof useGetOrgRequirementsByOrgLazyQuery>;
export type GetOrgRequirementsByOrgSuspenseQueryHookResult = ReturnType<typeof useGetOrgRequirementsByOrgSuspenseQuery>;
export type GetOrgRequirementsByOrgQueryResult = Apollo.QueryResult<Types.GetOrgRequirementsByOrgQuery, Types.GetOrgRequirementsByOrgQueryVariables>;
export const GetOrgRequirementsByOrgAndTypeDocument = gql`
    query getOrgRequirementsByOrgAndType($orgId: uuid!, $type: String!) {
  organization_requirement(
    where: {org_id: {_eq: $orgId}, requirement: {type: {_eq: $type}}}
  ) {
    org_requirement_id
    org_id
    requirement_id
    requirement {
      requirement_id
      name
      description
      task_time
      animal_size
      type
      overview
      requirement_type
      min_performance
      min_score
      min_small_animals_count
      min_large_animals_count
      domains {
        relation
        domain {
          requirement_domain_id
          name
          code
          color_hex
          sort_order
        }
      }
      competencies {
        competency {
          requirement_id
          name
          type
          domains {
            relation
            domain {
              requirement_domain_id
              name
              code
              color_hex
              sort_order
            }
          }
        }
      }
      resources {
        requirement_resource_id
        resource {
          resource_id
          name
          description
        }
      }
      species {
        name
        species_id
      }
    }
  }
}
    `;

/**
 * __useGetOrgRequirementsByOrgAndTypeQuery__
 *
 * To run a query within a React component, call `useGetOrgRequirementsByOrgAndTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgRequirementsByOrgAndTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgRequirementsByOrgAndTypeQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetOrgRequirementsByOrgAndTypeQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOrgRequirementsByOrgAndTypeQuery, Types.GetOrgRequirementsByOrgAndTypeQueryVariables> & ({ variables: Types.GetOrgRequirementsByOrgAndTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrgRequirementsByOrgAndTypeQuery, Types.GetOrgRequirementsByOrgAndTypeQueryVariables>(GetOrgRequirementsByOrgAndTypeDocument, options);
      }
export function useGetOrgRequirementsByOrgAndTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrgRequirementsByOrgAndTypeQuery, Types.GetOrgRequirementsByOrgAndTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrgRequirementsByOrgAndTypeQuery, Types.GetOrgRequirementsByOrgAndTypeQueryVariables>(GetOrgRequirementsByOrgAndTypeDocument, options);
        }
// @ts-ignore
export function useGetOrgRequirementsByOrgAndTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrgRequirementsByOrgAndTypeQuery, Types.GetOrgRequirementsByOrgAndTypeQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgRequirementsByOrgAndTypeQuery, Types.GetOrgRequirementsByOrgAndTypeQueryVariables>;
export function useGetOrgRequirementsByOrgAndTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgRequirementsByOrgAndTypeQuery, Types.GetOrgRequirementsByOrgAndTypeQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgRequirementsByOrgAndTypeQuery | undefined, Types.GetOrgRequirementsByOrgAndTypeQueryVariables>;
export function useGetOrgRequirementsByOrgAndTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgRequirementsByOrgAndTypeQuery, Types.GetOrgRequirementsByOrgAndTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrgRequirementsByOrgAndTypeQuery, Types.GetOrgRequirementsByOrgAndTypeQueryVariables>(GetOrgRequirementsByOrgAndTypeDocument, options);
        }
export type GetOrgRequirementsByOrgAndTypeQueryHookResult = ReturnType<typeof useGetOrgRequirementsByOrgAndTypeQuery>;
export type GetOrgRequirementsByOrgAndTypeLazyQueryHookResult = ReturnType<typeof useGetOrgRequirementsByOrgAndTypeLazyQuery>;
export type GetOrgRequirementsByOrgAndTypeSuspenseQueryHookResult = ReturnType<typeof useGetOrgRequirementsByOrgAndTypeSuspenseQuery>;
export type GetOrgRequirementsByOrgAndTypeQueryResult = Apollo.QueryResult<Types.GetOrgRequirementsByOrgAndTypeQuery, Types.GetOrgRequirementsByOrgAndTypeQueryVariables>;
export const AddOrganizationSiteDocument = gql`
    mutation addOrganizationSite($org_id: uuid!, $site_id: uuid) {
  insert_organization_site(
    objects: [{org_id: $org_id, site_id: $site_id}]
    on_conflict: {constraint: organization_site_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddOrganizationSiteMutationFn = Apollo.MutationFunction<Types.AddOrganizationSiteMutation, Types.AddOrganizationSiteMutationVariables>;

/**
 * __useAddOrganizationSiteMutation__
 *
 * To run a mutation, you first call `useAddOrganizationSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationSiteMutation, { data, loading, error }] = useAddOrganizationSiteMutation({
 *   variables: {
 *      org_id: // value for 'org_id'
 *      site_id: // value for 'site_id'
 *   },
 * });
 */
export function useAddOrganizationSiteMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddOrganizationSiteMutation, Types.AddOrganizationSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddOrganizationSiteMutation, Types.AddOrganizationSiteMutationVariables>(AddOrganizationSiteDocument, options);
      }
export type AddOrganizationSiteMutationHookResult = ReturnType<typeof useAddOrganizationSiteMutation>;
export type AddOrganizationSiteMutationResult = Apollo.MutationResult<Types.AddOrganizationSiteMutation>;
export type AddOrganizationSiteMutationOptions = Apollo.BaseMutationOptions<Types.AddOrganizationSiteMutation, Types.AddOrganizationSiteMutationVariables>;
export const AddOrganizationSitesDocument = gql`
    mutation addOrganizationSites($objects: [organization_site_insert_input!]!) {
  insert_organization_site(
    objects: $objects
    on_conflict: {constraint: organization_site_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddOrganizationSitesMutationFn = Apollo.MutationFunction<Types.AddOrganizationSitesMutation, Types.AddOrganizationSitesMutationVariables>;

/**
 * __useAddOrganizationSitesMutation__
 *
 * To run a mutation, you first call `useAddOrganizationSitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationSitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationSitesMutation, { data, loading, error }] = useAddOrganizationSitesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddOrganizationSitesMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddOrganizationSitesMutation, Types.AddOrganizationSitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddOrganizationSitesMutation, Types.AddOrganizationSitesMutationVariables>(AddOrganizationSitesDocument, options);
      }
export type AddOrganizationSitesMutationHookResult = ReturnType<typeof useAddOrganizationSitesMutation>;
export type AddOrganizationSitesMutationResult = Apollo.MutationResult<Types.AddOrganizationSitesMutation>;
export type AddOrganizationSitesMutationOptions = Apollo.BaseMutationOptions<Types.AddOrganizationSitesMutation, Types.AddOrganizationSitesMutationVariables>;
export const DeleteOrganizationSiteDocument = gql`
    mutation deleteOrganizationSite($id: uuid!) {
  delete_organization_site(where: {org_site_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteOrganizationSiteMutationFn = Apollo.MutationFunction<Types.DeleteOrganizationSiteMutation, Types.DeleteOrganizationSiteMutationVariables>;

/**
 * __useDeleteOrganizationSiteMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationSiteMutation, { data, loading, error }] = useDeleteOrganizationSiteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationSiteMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrganizationSiteMutation, Types.DeleteOrganizationSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrganizationSiteMutation, Types.DeleteOrganizationSiteMutationVariables>(DeleteOrganizationSiteDocument, options);
      }
export type DeleteOrganizationSiteMutationHookResult = ReturnType<typeof useDeleteOrganizationSiteMutation>;
export type DeleteOrganizationSiteMutationResult = Apollo.MutationResult<Types.DeleteOrganizationSiteMutation>;
export type DeleteOrganizationSiteMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrganizationSiteMutation, Types.DeleteOrganizationSiteMutationVariables>;
export const DeleteOrganizationSiteByOrgIdAndSiteIdDocument = gql`
    mutation deleteOrganizationSiteByOrgIdAndSiteId($org_id: uuid!, $site_id: uuid!) {
  delete_organization_site(
    where: {org_id: {_eq: $org_id}, site_id: {_eq: $site_id}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteOrganizationSiteByOrgIdAndSiteIdMutationFn = Apollo.MutationFunction<Types.DeleteOrganizationSiteByOrgIdAndSiteIdMutation, Types.DeleteOrganizationSiteByOrgIdAndSiteIdMutationVariables>;

/**
 * __useDeleteOrganizationSiteByOrgIdAndSiteIdMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationSiteByOrgIdAndSiteIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationSiteByOrgIdAndSiteIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationSiteByOrgIdAndSiteIdMutation, { data, loading, error }] = useDeleteOrganizationSiteByOrgIdAndSiteIdMutation({
 *   variables: {
 *      org_id: // value for 'org_id'
 *      site_id: // value for 'site_id'
 *   },
 * });
 */
export function useDeleteOrganizationSiteByOrgIdAndSiteIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrganizationSiteByOrgIdAndSiteIdMutation, Types.DeleteOrganizationSiteByOrgIdAndSiteIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrganizationSiteByOrgIdAndSiteIdMutation, Types.DeleteOrganizationSiteByOrgIdAndSiteIdMutationVariables>(DeleteOrganizationSiteByOrgIdAndSiteIdDocument, options);
      }
export type DeleteOrganizationSiteByOrgIdAndSiteIdMutationHookResult = ReturnType<typeof useDeleteOrganizationSiteByOrgIdAndSiteIdMutation>;
export type DeleteOrganizationSiteByOrgIdAndSiteIdMutationResult = Apollo.MutationResult<Types.DeleteOrganizationSiteByOrgIdAndSiteIdMutation>;
export type DeleteOrganizationSiteByOrgIdAndSiteIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrganizationSiteByOrgIdAndSiteIdMutation, Types.DeleteOrganizationSiteByOrgIdAndSiteIdMutationVariables>;
export const GetOrgSitesDocument = gql`
    query getOrgSites {
  organization_site {
    org_site_id
    org_id
    site_id
  }
}
    `;

/**
 * __useGetOrgSitesQuery__
 *
 * To run a query within a React component, call `useGetOrgSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgSitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrgSitesQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetOrgSitesQuery, Types.GetOrgSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrgSitesQuery, Types.GetOrgSitesQueryVariables>(GetOrgSitesDocument, options);
      }
export function useGetOrgSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrgSitesQuery, Types.GetOrgSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrgSitesQuery, Types.GetOrgSitesQueryVariables>(GetOrgSitesDocument, options);
        }
// @ts-ignore
export function useGetOrgSitesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrgSitesQuery, Types.GetOrgSitesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgSitesQuery, Types.GetOrgSitesQueryVariables>;
export function useGetOrgSitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgSitesQuery, Types.GetOrgSitesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgSitesQuery | undefined, Types.GetOrgSitesQueryVariables>;
export function useGetOrgSitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgSitesQuery, Types.GetOrgSitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrgSitesQuery, Types.GetOrgSitesQueryVariables>(GetOrgSitesDocument, options);
        }
export type GetOrgSitesQueryHookResult = ReturnType<typeof useGetOrgSitesQuery>;
export type GetOrgSitesLazyQueryHookResult = ReturnType<typeof useGetOrgSitesLazyQuery>;
export type GetOrgSitesSuspenseQueryHookResult = ReturnType<typeof useGetOrgSitesSuspenseQuery>;
export type GetOrgSitesQueryResult = Apollo.QueryResult<Types.GetOrgSitesQuery, Types.GetOrgSitesQueryVariables>;
export const GetOrgSitesByOrgDocument = gql`
    query getOrgSitesByOrg($orgId: uuid!) {
  organization_site(where: {org_id: {_eq: $orgId}}) {
    org_site_id
    org_id
    site_id
    site {
      name
      address {
        address_id
        address_line_1
        address_line_2
        city
        state
        country
        zip_code
      }
    }
  }
}
    `;

/**
 * __useGetOrgSitesByOrgQuery__
 *
 * To run a query within a React component, call `useGetOrgSitesByOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgSitesByOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgSitesByOrgQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrgSitesByOrgQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOrgSitesByOrgQuery, Types.GetOrgSitesByOrgQueryVariables> & ({ variables: Types.GetOrgSitesByOrgQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrgSitesByOrgQuery, Types.GetOrgSitesByOrgQueryVariables>(GetOrgSitesByOrgDocument, options);
      }
export function useGetOrgSitesByOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrgSitesByOrgQuery, Types.GetOrgSitesByOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrgSitesByOrgQuery, Types.GetOrgSitesByOrgQueryVariables>(GetOrgSitesByOrgDocument, options);
        }
// @ts-ignore
export function useGetOrgSitesByOrgSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrgSitesByOrgQuery, Types.GetOrgSitesByOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgSitesByOrgQuery, Types.GetOrgSitesByOrgQueryVariables>;
export function useGetOrgSitesByOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgSitesByOrgQuery, Types.GetOrgSitesByOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgSitesByOrgQuery | undefined, Types.GetOrgSitesByOrgQueryVariables>;
export function useGetOrgSitesByOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgSitesByOrgQuery, Types.GetOrgSitesByOrgQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrgSitesByOrgQuery, Types.GetOrgSitesByOrgQueryVariables>(GetOrgSitesByOrgDocument, options);
        }
export type GetOrgSitesByOrgQueryHookResult = ReturnType<typeof useGetOrgSitesByOrgQuery>;
export type GetOrgSitesByOrgLazyQueryHookResult = ReturnType<typeof useGetOrgSitesByOrgLazyQuery>;
export type GetOrgSitesByOrgSuspenseQueryHookResult = ReturnType<typeof useGetOrgSitesByOrgSuspenseQuery>;
export type GetOrgSitesByOrgQueryResult = Apollo.QueryResult<Types.GetOrgSitesByOrgQuery, Types.GetOrgSitesByOrgQueryVariables>;
export const AddOrganizationTagDocument = gql`
    mutation addOrganizationTag($org_id: uuid!, $tag_id: uuid!) {
  insert_organization_tag(
    objects: [{org_id: $org_id, tag_id: $tag_id}]
    on_conflict: {constraint: organization_tag_org_id_tag_id_key, update_columns: []}
  ) {
    affected_rows
    returning {
      organization_tag_id
      org_id
      tag_id
    }
  }
}
    `;
export type AddOrganizationTagMutationFn = Apollo.MutationFunction<Types.AddOrganizationTagMutation, Types.AddOrganizationTagMutationVariables>;

/**
 * __useAddOrganizationTagMutation__
 *
 * To run a mutation, you first call `useAddOrganizationTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationTagMutation, { data, loading, error }] = useAddOrganizationTagMutation({
 *   variables: {
 *      org_id: // value for 'org_id'
 *      tag_id: // value for 'tag_id'
 *   },
 * });
 */
export function useAddOrganizationTagMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddOrganizationTagMutation, Types.AddOrganizationTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddOrganizationTagMutation, Types.AddOrganizationTagMutationVariables>(AddOrganizationTagDocument, options);
      }
export type AddOrganizationTagMutationHookResult = ReturnType<typeof useAddOrganizationTagMutation>;
export type AddOrganizationTagMutationResult = Apollo.MutationResult<Types.AddOrganizationTagMutation>;
export type AddOrganizationTagMutationOptions = Apollo.BaseMutationOptions<Types.AddOrganizationTagMutation, Types.AddOrganizationTagMutationVariables>;
export const DeleteOrganizationTagByOrgIdAndTagIdDocument = gql`
    mutation deleteOrganizationTagByOrgIdAndTagId($org_id: uuid!, $tag_id: uuid!) {
  delete_organization_tag(where: {org_id: {_eq: $org_id}, tag_id: {_eq: $tag_id}}) {
    affected_rows
  }
}
    `;
export type DeleteOrganizationTagByOrgIdAndTagIdMutationFn = Apollo.MutationFunction<Types.DeleteOrganizationTagByOrgIdAndTagIdMutation, Types.DeleteOrganizationTagByOrgIdAndTagIdMutationVariables>;

/**
 * __useDeleteOrganizationTagByOrgIdAndTagIdMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationTagByOrgIdAndTagIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationTagByOrgIdAndTagIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationTagByOrgIdAndTagIdMutation, { data, loading, error }] = useDeleteOrganizationTagByOrgIdAndTagIdMutation({
 *   variables: {
 *      org_id: // value for 'org_id'
 *      tag_id: // value for 'tag_id'
 *   },
 * });
 */
export function useDeleteOrganizationTagByOrgIdAndTagIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrganizationTagByOrgIdAndTagIdMutation, Types.DeleteOrganizationTagByOrgIdAndTagIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrganizationTagByOrgIdAndTagIdMutation, Types.DeleteOrganizationTagByOrgIdAndTagIdMutationVariables>(DeleteOrganizationTagByOrgIdAndTagIdDocument, options);
      }
export type DeleteOrganizationTagByOrgIdAndTagIdMutationHookResult = ReturnType<typeof useDeleteOrganizationTagByOrgIdAndTagIdMutation>;
export type DeleteOrganizationTagByOrgIdAndTagIdMutationResult = Apollo.MutationResult<Types.DeleteOrganizationTagByOrgIdAndTagIdMutation>;
export type DeleteOrganizationTagByOrgIdAndTagIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrganizationTagByOrgIdAndTagIdMutation, Types.DeleteOrganizationTagByOrgIdAndTagIdMutationVariables>;
export const GetOrganizationDomainTagsDocument = gql`
    query getOrganizationDomainTags($orgId: uuid!) {
  organization_tag(where: {org_id: {_eq: $orgId}, tag: {type: {_eq: "domain"}}}) {
    organization_tag_id
    org_id
    tag_id
    tag {
      tag_id
      name
      type
    }
  }
}
    `;

/**
 * __useGetOrganizationDomainTagsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationDomainTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationDomainTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationDomainTagsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrganizationDomainTagsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOrganizationDomainTagsQuery, Types.GetOrganizationDomainTagsQueryVariables> & ({ variables: Types.GetOrganizationDomainTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrganizationDomainTagsQuery, Types.GetOrganizationDomainTagsQueryVariables>(GetOrganizationDomainTagsDocument, options);
      }
export function useGetOrganizationDomainTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrganizationDomainTagsQuery, Types.GetOrganizationDomainTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrganizationDomainTagsQuery, Types.GetOrganizationDomainTagsQueryVariables>(GetOrganizationDomainTagsDocument, options);
        }
// @ts-ignore
export function useGetOrganizationDomainTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrganizationDomainTagsQuery, Types.GetOrganizationDomainTagsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrganizationDomainTagsQuery, Types.GetOrganizationDomainTagsQueryVariables>;
export function useGetOrganizationDomainTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrganizationDomainTagsQuery, Types.GetOrganizationDomainTagsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrganizationDomainTagsQuery | undefined, Types.GetOrganizationDomainTagsQueryVariables>;
export function useGetOrganizationDomainTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrganizationDomainTagsQuery, Types.GetOrganizationDomainTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrganizationDomainTagsQuery, Types.GetOrganizationDomainTagsQueryVariables>(GetOrganizationDomainTagsDocument, options);
        }
export type GetOrganizationDomainTagsQueryHookResult = ReturnType<typeof useGetOrganizationDomainTagsQuery>;
export type GetOrganizationDomainTagsLazyQueryHookResult = ReturnType<typeof useGetOrganizationDomainTagsLazyQuery>;
export type GetOrganizationDomainTagsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationDomainTagsSuspenseQuery>;
export type GetOrganizationDomainTagsQueryResult = Apollo.QueryResult<Types.GetOrganizationDomainTagsQuery, Types.GetOrganizationDomainTagsQueryVariables>;
export const GetOrganizationDomainTagsByOrgIdsDocument = gql`
    query getOrganizationDomainTagsByOrgIds($orgIds: [uuid!]!) {
  organization_tag(where: {org_id: {_in: $orgIds}, tag: {type: {_eq: "domain"}}}) {
    organization_tag_id
    org_id
    tag_id
    tag {
      tag_id
      name
      type
    }
  }
}
    `;

/**
 * __useGetOrganizationDomainTagsByOrgIdsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationDomainTagsByOrgIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationDomainTagsByOrgIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationDomainTagsByOrgIdsQuery({
 *   variables: {
 *      orgIds: // value for 'orgIds'
 *   },
 * });
 */
export function useGetOrganizationDomainTagsByOrgIdsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOrganizationDomainTagsByOrgIdsQuery, Types.GetOrganizationDomainTagsByOrgIdsQueryVariables> & ({ variables: Types.GetOrganizationDomainTagsByOrgIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrganizationDomainTagsByOrgIdsQuery, Types.GetOrganizationDomainTagsByOrgIdsQueryVariables>(GetOrganizationDomainTagsByOrgIdsDocument, options);
      }
export function useGetOrganizationDomainTagsByOrgIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrganizationDomainTagsByOrgIdsQuery, Types.GetOrganizationDomainTagsByOrgIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrganizationDomainTagsByOrgIdsQuery, Types.GetOrganizationDomainTagsByOrgIdsQueryVariables>(GetOrganizationDomainTagsByOrgIdsDocument, options);
        }
// @ts-ignore
export function useGetOrganizationDomainTagsByOrgIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrganizationDomainTagsByOrgIdsQuery, Types.GetOrganizationDomainTagsByOrgIdsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrganizationDomainTagsByOrgIdsQuery, Types.GetOrganizationDomainTagsByOrgIdsQueryVariables>;
export function useGetOrganizationDomainTagsByOrgIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrganizationDomainTagsByOrgIdsQuery, Types.GetOrganizationDomainTagsByOrgIdsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrganizationDomainTagsByOrgIdsQuery | undefined, Types.GetOrganizationDomainTagsByOrgIdsQueryVariables>;
export function useGetOrganizationDomainTagsByOrgIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrganizationDomainTagsByOrgIdsQuery, Types.GetOrganizationDomainTagsByOrgIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrganizationDomainTagsByOrgIdsQuery, Types.GetOrganizationDomainTagsByOrgIdsQueryVariables>(GetOrganizationDomainTagsByOrgIdsDocument, options);
        }
export type GetOrganizationDomainTagsByOrgIdsQueryHookResult = ReturnType<typeof useGetOrganizationDomainTagsByOrgIdsQuery>;
export type GetOrganizationDomainTagsByOrgIdsLazyQueryHookResult = ReturnType<typeof useGetOrganizationDomainTagsByOrgIdsLazyQuery>;
export type GetOrganizationDomainTagsByOrgIdsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationDomainTagsByOrgIdsSuspenseQuery>;
export type GetOrganizationDomainTagsByOrgIdsQueryResult = Apollo.QueryResult<Types.GetOrganizationDomainTagsByOrgIdsQuery, Types.GetOrganizationDomainTagsByOrgIdsQueryVariables>;
export const AddOrganizationUserDocument = gql`
    mutation addOrganizationUser($org_id: uuid!, $user_id: uuid) {
  insert_organization_user(
    objects: [{org_id: $org_id, user_id: $user_id}]
    on_conflict: {constraint: organization_user_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddOrganizationUserMutationFn = Apollo.MutationFunction<Types.AddOrganizationUserMutation, Types.AddOrganizationUserMutationVariables>;

/**
 * __useAddOrganizationUserMutation__
 *
 * To run a mutation, you first call `useAddOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationUserMutation, { data, loading, error }] = useAddOrganizationUserMutation({
 *   variables: {
 *      org_id: // value for 'org_id'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useAddOrganizationUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddOrganizationUserMutation, Types.AddOrganizationUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddOrganizationUserMutation, Types.AddOrganizationUserMutationVariables>(AddOrganizationUserDocument, options);
      }
export type AddOrganizationUserMutationHookResult = ReturnType<typeof useAddOrganizationUserMutation>;
export type AddOrganizationUserMutationResult = Apollo.MutationResult<Types.AddOrganizationUserMutation>;
export type AddOrganizationUserMutationOptions = Apollo.BaseMutationOptions<Types.AddOrganizationUserMutation, Types.AddOrganizationUserMutationVariables>;
export const AddOrganizationUsersDocument = gql`
    mutation addOrganizationUsers($objects: [organization_user_insert_input!]!) {
  insert_organization_user(
    objects: $objects
    on_conflict: {constraint: organization_user_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddOrganizationUsersMutationFn = Apollo.MutationFunction<Types.AddOrganizationUsersMutation, Types.AddOrganizationUsersMutationVariables>;

/**
 * __useAddOrganizationUsersMutation__
 *
 * To run a mutation, you first call `useAddOrganizationUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationUsersMutation, { data, loading, error }] = useAddOrganizationUsersMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddOrganizationUsersMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddOrganizationUsersMutation, Types.AddOrganizationUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddOrganizationUsersMutation, Types.AddOrganizationUsersMutationVariables>(AddOrganizationUsersDocument, options);
      }
export type AddOrganizationUsersMutationHookResult = ReturnType<typeof useAddOrganizationUsersMutation>;
export type AddOrganizationUsersMutationResult = Apollo.MutationResult<Types.AddOrganizationUsersMutation>;
export type AddOrganizationUsersMutationOptions = Apollo.BaseMutationOptions<Types.AddOrganizationUsersMutation, Types.AddOrganizationUsersMutationVariables>;
export const DeleteOrganizationUserDocument = gql`
    mutation deleteOrganizationUser($id: uuid!) {
  delete_organization_user(where: {org_user_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteOrganizationUserMutationFn = Apollo.MutationFunction<Types.DeleteOrganizationUserMutation, Types.DeleteOrganizationUserMutationVariables>;

/**
 * __useDeleteOrganizationUserMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationUserMutation, { data, loading, error }] = useDeleteOrganizationUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrganizationUserMutation, Types.DeleteOrganizationUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrganizationUserMutation, Types.DeleteOrganizationUserMutationVariables>(DeleteOrganizationUserDocument, options);
      }
export type DeleteOrganizationUserMutationHookResult = ReturnType<typeof useDeleteOrganizationUserMutation>;
export type DeleteOrganizationUserMutationResult = Apollo.MutationResult<Types.DeleteOrganizationUserMutation>;
export type DeleteOrganizationUserMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrganizationUserMutation, Types.DeleteOrganizationUserMutationVariables>;
export const DeleteOrganizationUserByOrgIdAndUserIdDocument = gql`
    mutation deleteOrganizationUserByOrgIdAndUserId($org_id: uuid!, $user_id: uuid!) {
  delete_organization_user(
    where: {org_id: {_eq: $org_id}, user_id: {_eq: $user_id}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteOrganizationUserByOrgIdAndUserIdMutationFn = Apollo.MutationFunction<Types.DeleteOrganizationUserByOrgIdAndUserIdMutation, Types.DeleteOrganizationUserByOrgIdAndUserIdMutationVariables>;

/**
 * __useDeleteOrganizationUserByOrgIdAndUserIdMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationUserByOrgIdAndUserIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationUserByOrgIdAndUserIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationUserByOrgIdAndUserIdMutation, { data, loading, error }] = useDeleteOrganizationUserByOrgIdAndUserIdMutation({
 *   variables: {
 *      org_id: // value for 'org_id'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useDeleteOrganizationUserByOrgIdAndUserIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrganizationUserByOrgIdAndUserIdMutation, Types.DeleteOrganizationUserByOrgIdAndUserIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrganizationUserByOrgIdAndUserIdMutation, Types.DeleteOrganizationUserByOrgIdAndUserIdMutationVariables>(DeleteOrganizationUserByOrgIdAndUserIdDocument, options);
      }
export type DeleteOrganizationUserByOrgIdAndUserIdMutationHookResult = ReturnType<typeof useDeleteOrganizationUserByOrgIdAndUserIdMutation>;
export type DeleteOrganizationUserByOrgIdAndUserIdMutationResult = Apollo.MutationResult<Types.DeleteOrganizationUserByOrgIdAndUserIdMutation>;
export type DeleteOrganizationUserByOrgIdAndUserIdMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrganizationUserByOrgIdAndUserIdMutation, Types.DeleteOrganizationUserByOrgIdAndUserIdMutationVariables>;
export const GetOrgUsersDocument = gql`
    query getOrgUsers {
  organization_user {
    org_user_id
    org_id
    user_id
  }
}
    `;

/**
 * __useGetOrgUsersQuery__
 *
 * To run a query within a React component, call `useGetOrgUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrgUsersQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetOrgUsersQuery, Types.GetOrgUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrgUsersQuery, Types.GetOrgUsersQueryVariables>(GetOrgUsersDocument, options);
      }
export function useGetOrgUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrgUsersQuery, Types.GetOrgUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrgUsersQuery, Types.GetOrgUsersQueryVariables>(GetOrgUsersDocument, options);
        }
// @ts-ignore
export function useGetOrgUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrgUsersQuery, Types.GetOrgUsersQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgUsersQuery, Types.GetOrgUsersQueryVariables>;
export function useGetOrgUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgUsersQuery, Types.GetOrgUsersQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgUsersQuery | undefined, Types.GetOrgUsersQueryVariables>;
export function useGetOrgUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgUsersQuery, Types.GetOrgUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrgUsersQuery, Types.GetOrgUsersQueryVariables>(GetOrgUsersDocument, options);
        }
export type GetOrgUsersQueryHookResult = ReturnType<typeof useGetOrgUsersQuery>;
export type GetOrgUsersLazyQueryHookResult = ReturnType<typeof useGetOrgUsersLazyQuery>;
export type GetOrgUsersSuspenseQueryHookResult = ReturnType<typeof useGetOrgUsersSuspenseQuery>;
export type GetOrgUsersQueryResult = Apollo.QueryResult<Types.GetOrgUsersQuery, Types.GetOrgUsersQueryVariables>;
export const GetOrgUsersByOrgDocument = gql`
    query getOrgUsersByOrg($orgId: uuid!) {
  organization_user(where: {org_id: {_eq: $orgId}}) {
    org_user_id
    org_id
    user_id
    user {
      user_id
      email
      role
      name
      picture_url
    }
  }
}
    `;

/**
 * __useGetOrgUsersByOrgQuery__
 *
 * To run a query within a React component, call `useGetOrgUsersByOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgUsersByOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgUsersByOrgQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrgUsersByOrgQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOrgUsersByOrgQuery, Types.GetOrgUsersByOrgQueryVariables> & ({ variables: Types.GetOrgUsersByOrgQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrgUsersByOrgQuery, Types.GetOrgUsersByOrgQueryVariables>(GetOrgUsersByOrgDocument, options);
      }
export function useGetOrgUsersByOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrgUsersByOrgQuery, Types.GetOrgUsersByOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrgUsersByOrgQuery, Types.GetOrgUsersByOrgQueryVariables>(GetOrgUsersByOrgDocument, options);
        }
// @ts-ignore
export function useGetOrgUsersByOrgSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrgUsersByOrgQuery, Types.GetOrgUsersByOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgUsersByOrgQuery, Types.GetOrgUsersByOrgQueryVariables>;
export function useGetOrgUsersByOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgUsersByOrgQuery, Types.GetOrgUsersByOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetOrgUsersByOrgQuery | undefined, Types.GetOrgUsersByOrgQueryVariables>;
export function useGetOrgUsersByOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetOrgUsersByOrgQuery, Types.GetOrgUsersByOrgQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrgUsersByOrgQuery, Types.GetOrgUsersByOrgQueryVariables>(GetOrgUsersByOrgDocument, options);
        }
export type GetOrgUsersByOrgQueryHookResult = ReturnType<typeof useGetOrgUsersByOrgQuery>;
export type GetOrgUsersByOrgLazyQueryHookResult = ReturnType<typeof useGetOrgUsersByOrgLazyQuery>;
export type GetOrgUsersByOrgSuspenseQueryHookResult = ReturnType<typeof useGetOrgUsersByOrgSuspenseQuery>;
export type GetOrgUsersByOrgQueryResult = Apollo.QueryResult<Types.GetOrgUsersByOrgQuery, Types.GetOrgUsersByOrgQueryVariables>;
export const AddPinnedResourceDocument = gql`
    mutation addPinnedResource($resourceId: uuid!, $userId: uuid) {
  insert_pinned_resource(
    objects: [{resource_id: $resourceId, user_id: $userId}]
    on_conflict: {constraint: pinned_resource_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddPinnedResourceMutationFn = Apollo.MutationFunction<Types.AddPinnedResourceMutation, Types.AddPinnedResourceMutationVariables>;

/**
 * __useAddPinnedResourceMutation__
 *
 * To run a mutation, you first call `useAddPinnedResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPinnedResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPinnedResourceMutation, { data, loading, error }] = useAddPinnedResourceMutation({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddPinnedResourceMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddPinnedResourceMutation, Types.AddPinnedResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddPinnedResourceMutation, Types.AddPinnedResourceMutationVariables>(AddPinnedResourceDocument, options);
      }
export type AddPinnedResourceMutationHookResult = ReturnType<typeof useAddPinnedResourceMutation>;
export type AddPinnedResourceMutationResult = Apollo.MutationResult<Types.AddPinnedResourceMutation>;
export type AddPinnedResourceMutationOptions = Apollo.BaseMutationOptions<Types.AddPinnedResourceMutation, Types.AddPinnedResourceMutationVariables>;
export const DeletePinnedResourceDocument = gql`
    mutation deletePinnedResource($id: uuid!) {
  delete_pinned_resource(where: {pinned_resource_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeletePinnedResourceMutationFn = Apollo.MutationFunction<Types.DeletePinnedResourceMutation, Types.DeletePinnedResourceMutationVariables>;

/**
 * __useDeletePinnedResourceMutation__
 *
 * To run a mutation, you first call `useDeletePinnedResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePinnedResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePinnedResourceMutation, { data, loading, error }] = useDeletePinnedResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePinnedResourceMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeletePinnedResourceMutation, Types.DeletePinnedResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeletePinnedResourceMutation, Types.DeletePinnedResourceMutationVariables>(DeletePinnedResourceDocument, options);
      }
export type DeletePinnedResourceMutationHookResult = ReturnType<typeof useDeletePinnedResourceMutation>;
export type DeletePinnedResourceMutationResult = Apollo.MutationResult<Types.DeletePinnedResourceMutation>;
export type DeletePinnedResourceMutationOptions = Apollo.BaseMutationOptions<Types.DeletePinnedResourceMutation, Types.DeletePinnedResourceMutationVariables>;
export const DeletePinnedResourceByTagAndResourceDocument = gql`
    mutation deletePinnedResourceByTagAndResource($resourceId: uuid!, $userId: uuid!) {
  delete_pinned_resource(
    where: {resource_id: {_eq: $resourceId}, user_id: {_eq: $userId}}
  ) {
    affected_rows
  }
}
    `;
export type DeletePinnedResourceByTagAndResourceMutationFn = Apollo.MutationFunction<Types.DeletePinnedResourceByTagAndResourceMutation, Types.DeletePinnedResourceByTagAndResourceMutationVariables>;

/**
 * __useDeletePinnedResourceByTagAndResourceMutation__
 *
 * To run a mutation, you first call `useDeletePinnedResourceByTagAndResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePinnedResourceByTagAndResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePinnedResourceByTagAndResourceMutation, { data, loading, error }] = useDeletePinnedResourceByTagAndResourceMutation({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeletePinnedResourceByTagAndResourceMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeletePinnedResourceByTagAndResourceMutation, Types.DeletePinnedResourceByTagAndResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeletePinnedResourceByTagAndResourceMutation, Types.DeletePinnedResourceByTagAndResourceMutationVariables>(DeletePinnedResourceByTagAndResourceDocument, options);
      }
export type DeletePinnedResourceByTagAndResourceMutationHookResult = ReturnType<typeof useDeletePinnedResourceByTagAndResourceMutation>;
export type DeletePinnedResourceByTagAndResourceMutationResult = Apollo.MutationResult<Types.DeletePinnedResourceByTagAndResourceMutation>;
export type DeletePinnedResourceByTagAndResourceMutationOptions = Apollo.BaseMutationOptions<Types.DeletePinnedResourceByTagAndResourceMutation, Types.DeletePinnedResourceByTagAndResourceMutationVariables>;
export const GetPinnedResourceDocument = gql`
    query getPinnedResource {
  pinned_resource {
    pinned_resource_id
    user_id
    resource_id
  }
}
    `;

/**
 * __useGetPinnedResourceQuery__
 *
 * To run a query within a React component, call `useGetPinnedResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPinnedResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPinnedResourceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPinnedResourceQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetPinnedResourceQuery, Types.GetPinnedResourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPinnedResourceQuery, Types.GetPinnedResourceQueryVariables>(GetPinnedResourceDocument, options);
      }
export function useGetPinnedResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPinnedResourceQuery, Types.GetPinnedResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPinnedResourceQuery, Types.GetPinnedResourceQueryVariables>(GetPinnedResourceDocument, options);
        }
// @ts-ignore
export function useGetPinnedResourceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetPinnedResourceQuery, Types.GetPinnedResourceQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetPinnedResourceQuery, Types.GetPinnedResourceQueryVariables>;
export function useGetPinnedResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetPinnedResourceQuery, Types.GetPinnedResourceQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetPinnedResourceQuery | undefined, Types.GetPinnedResourceQueryVariables>;
export function useGetPinnedResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetPinnedResourceQuery, Types.GetPinnedResourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPinnedResourceQuery, Types.GetPinnedResourceQueryVariables>(GetPinnedResourceDocument, options);
        }
export type GetPinnedResourceQueryHookResult = ReturnType<typeof useGetPinnedResourceQuery>;
export type GetPinnedResourceLazyQueryHookResult = ReturnType<typeof useGetPinnedResourceLazyQuery>;
export type GetPinnedResourceSuspenseQueryHookResult = ReturnType<typeof useGetPinnedResourceSuspenseQuery>;
export type GetPinnedResourceQueryResult = Apollo.QueryResult<Types.GetPinnedResourceQuery, Types.GetPinnedResourceQueryVariables>;
export const GetPinnedResourcesByUserIdDocument = gql`
    query getPinnedResourcesByUserId($userId: uuid!) {
  pinned_resource(where: {user_id: {_eq: $userId}}) {
    pinned_resource_id
    resource {
      description
      name
      resource_id
      url
    }
  }
}
    `;

/**
 * __useGetPinnedResourcesByUserIdQuery__
 *
 * To run a query within a React component, call `useGetPinnedResourcesByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPinnedResourcesByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPinnedResourcesByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetPinnedResourcesByUserIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPinnedResourcesByUserIdQuery, Types.GetPinnedResourcesByUserIdQueryVariables> & ({ variables: Types.GetPinnedResourcesByUserIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPinnedResourcesByUserIdQuery, Types.GetPinnedResourcesByUserIdQueryVariables>(GetPinnedResourcesByUserIdDocument, options);
      }
export function useGetPinnedResourcesByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPinnedResourcesByUserIdQuery, Types.GetPinnedResourcesByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPinnedResourcesByUserIdQuery, Types.GetPinnedResourcesByUserIdQueryVariables>(GetPinnedResourcesByUserIdDocument, options);
        }
// @ts-ignore
export function useGetPinnedResourcesByUserIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetPinnedResourcesByUserIdQuery, Types.GetPinnedResourcesByUserIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetPinnedResourcesByUserIdQuery, Types.GetPinnedResourcesByUserIdQueryVariables>;
export function useGetPinnedResourcesByUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetPinnedResourcesByUserIdQuery, Types.GetPinnedResourcesByUserIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetPinnedResourcesByUserIdQuery | undefined, Types.GetPinnedResourcesByUserIdQueryVariables>;
export function useGetPinnedResourcesByUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetPinnedResourcesByUserIdQuery, Types.GetPinnedResourcesByUserIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPinnedResourcesByUserIdQuery, Types.GetPinnedResourcesByUserIdQueryVariables>(GetPinnedResourcesByUserIdDocument, options);
        }
export type GetPinnedResourcesByUserIdQueryHookResult = ReturnType<typeof useGetPinnedResourcesByUserIdQuery>;
export type GetPinnedResourcesByUserIdLazyQueryHookResult = ReturnType<typeof useGetPinnedResourcesByUserIdLazyQuery>;
export type GetPinnedResourcesByUserIdSuspenseQueryHookResult = ReturnType<typeof useGetPinnedResourcesByUserIdSuspenseQuery>;
export type GetPinnedResourcesByUserIdQueryResult = Apollo.QueryResult<Types.GetPinnedResourcesByUserIdQuery, Types.GetPinnedResourcesByUserIdQueryVariables>;
export const AddPostDocument = gql`
    mutation addPost($object: post_insert_input!) {
  insert_post_one(object: $object) {
    post_id
    org_id
    author_id
    parent_post_id
    title
    body
    audience_role
    created_at
    updated_at
  }
}
    `;
export type AddPostMutationFn = Apollo.MutationFunction<Types.AddPostMutation, Types.AddPostMutationVariables>;

/**
 * __useAddPostMutation__
 *
 * To run a mutation, you first call `useAddPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPostMutation, { data, loading, error }] = useAddPostMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAddPostMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddPostMutation, Types.AddPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddPostMutation, Types.AddPostMutationVariables>(AddPostDocument, options);
      }
export type AddPostMutationHookResult = ReturnType<typeof useAddPostMutation>;
export type AddPostMutationResult = Apollo.MutationResult<Types.AddPostMutation>;
export type AddPostMutationOptions = Apollo.BaseMutationOptions<Types.AddPostMutation, Types.AddPostMutationVariables>;
export const AddPostTagsDocument = gql`
    mutation addPostTags($objects: [post_tag_insert_input!]!) {
  insert_post_tag(
    objects: $objects
    on_conflict: {constraint: post_tag_post_id_tag_id_key, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddPostTagsMutationFn = Apollo.MutationFunction<Types.AddPostTagsMutation, Types.AddPostTagsMutationVariables>;

/**
 * __useAddPostTagsMutation__
 *
 * To run a mutation, you first call `useAddPostTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPostTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPostTagsMutation, { data, loading, error }] = useAddPostTagsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddPostTagsMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddPostTagsMutation, Types.AddPostTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddPostTagsMutation, Types.AddPostTagsMutationVariables>(AddPostTagsDocument, options);
      }
export type AddPostTagsMutationHookResult = ReturnType<typeof useAddPostTagsMutation>;
export type AddPostTagsMutationResult = Apollo.MutationResult<Types.AddPostTagsMutation>;
export type AddPostTagsMutationOptions = Apollo.BaseMutationOptions<Types.AddPostTagsMutation, Types.AddPostTagsMutationVariables>;
export const DeletePostDocument = gql`
    mutation deletePost($postId: uuid!) {
  delete_post_by_pk(post_id: $postId) {
    post_id
  }
}
    `;
export type DeletePostMutationFn = Apollo.MutationFunction<Types.DeletePostMutation, Types.DeletePostMutationVariables>;

/**
 * __useDeletePostMutation__
 *
 * To run a mutation, you first call `useDeletePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostMutation, { data, loading, error }] = useDeletePostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useDeletePostMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeletePostMutation, Types.DeletePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeletePostMutation, Types.DeletePostMutationVariables>(DeletePostDocument, options);
      }
export type DeletePostMutationHookResult = ReturnType<typeof useDeletePostMutation>;
export type DeletePostMutationResult = Apollo.MutationResult<Types.DeletePostMutation>;
export type DeletePostMutationOptions = Apollo.BaseMutationOptions<Types.DeletePostMutation, Types.DeletePostMutationVariables>;
export const GetPostsByOrgDocument = gql`
    query getPostsByOrg($orgId: uuid!, $limit: Int = 10000) {
  post(
    where: {parent_post_id: {_is_null: true}, _or: [{org_id: {_eq: $orgId}}, {tags: {tag: {organization_tags: {org_id: {_eq: $orgId}}}}}]}
    order_by: {created_at: desc}
    limit: $limit
  ) {
    post_id
    org_id
    author_id
    title
    body
    audience_role
    created_at
    updated_at
    organization {
      org_id
      name
    }
    author {
      user_id
      name
      email
      picture_url
      role
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    tags {
      post_tag_id
      tag_id
      tag {
        tag_id
        name
        type
      }
    }
    answers_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetPostsByOrgQuery__
 *
 * To run a query within a React component, call `useGetPostsByOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsByOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsByOrgQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPostsByOrgQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPostsByOrgQuery, Types.GetPostsByOrgQueryVariables> & ({ variables: Types.GetPostsByOrgQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPostsByOrgQuery, Types.GetPostsByOrgQueryVariables>(GetPostsByOrgDocument, options);
      }
export function useGetPostsByOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPostsByOrgQuery, Types.GetPostsByOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPostsByOrgQuery, Types.GetPostsByOrgQueryVariables>(GetPostsByOrgDocument, options);
        }
// @ts-ignore
export function useGetPostsByOrgSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetPostsByOrgQuery, Types.GetPostsByOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetPostsByOrgQuery, Types.GetPostsByOrgQueryVariables>;
export function useGetPostsByOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetPostsByOrgQuery, Types.GetPostsByOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetPostsByOrgQuery | undefined, Types.GetPostsByOrgQueryVariables>;
export function useGetPostsByOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetPostsByOrgQuery, Types.GetPostsByOrgQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPostsByOrgQuery, Types.GetPostsByOrgQueryVariables>(GetPostsByOrgDocument, options);
        }
export type GetPostsByOrgQueryHookResult = ReturnType<typeof useGetPostsByOrgQuery>;
export type GetPostsByOrgLazyQueryHookResult = ReturnType<typeof useGetPostsByOrgLazyQuery>;
export type GetPostsByOrgSuspenseQueryHookResult = ReturnType<typeof useGetPostsByOrgSuspenseQuery>;
export type GetPostsByOrgQueryResult = Apollo.QueryResult<Types.GetPostsByOrgQuery, Types.GetPostsByOrgQueryVariables>;
export const GetAllPostsDocument = gql`
    query getAllPosts($limit: Int = 10000) {
  post(
    where: {parent_post_id: {_is_null: true}}
    order_by: {created_at: desc}
    limit: $limit
  ) {
    post_id
    org_id
    author_id
    title
    body
    audience_role
    created_at
    updated_at
    organization {
      org_id
      name
    }
    author {
      user_id
      name
      email
      picture_url
      role
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    tags {
      post_tag_id
      tag_id
      tag {
        tag_id
        name
        type
      }
    }
    answers_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetAllPostsQuery__
 *
 * To run a query within a React component, call `useGetAllPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPostsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAllPostsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllPostsQuery, Types.GetAllPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllPostsQuery, Types.GetAllPostsQueryVariables>(GetAllPostsDocument, options);
      }
export function useGetAllPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllPostsQuery, Types.GetAllPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllPostsQuery, Types.GetAllPostsQueryVariables>(GetAllPostsDocument, options);
        }
// @ts-ignore
export function useGetAllPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAllPostsQuery, Types.GetAllPostsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAllPostsQuery, Types.GetAllPostsQueryVariables>;
export function useGetAllPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAllPostsQuery, Types.GetAllPostsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetAllPostsQuery | undefined, Types.GetAllPostsQueryVariables>;
export function useGetAllPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAllPostsQuery, Types.GetAllPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllPostsQuery, Types.GetAllPostsQueryVariables>(GetAllPostsDocument, options);
        }
export type GetAllPostsQueryHookResult = ReturnType<typeof useGetAllPostsQuery>;
export type GetAllPostsLazyQueryHookResult = ReturnType<typeof useGetAllPostsLazyQuery>;
export type GetAllPostsSuspenseQueryHookResult = ReturnType<typeof useGetAllPostsSuspenseQuery>;
export type GetAllPostsQueryResult = Apollo.QueryResult<Types.GetAllPostsQuery, Types.GetAllPostsQueryVariables>;
export const GetPostByIdDocument = gql`
    query getPostById($postId: uuid!) {
  post_by_pk(post_id: $postId) {
    post_id
    org_id
    author_id
    parent_post_id
    title
    body
    audience_role
    created_at
    updated_at
    author {
      user_id
      name
      email
      picture_url
      role
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
    organization {
      org_id
      name
    }
    tags {
      post_tag_id
      tag_id
      tag {
        tag_id
        name
        type
      }
    }
    answers(order_by: {created_at: asc}) {
      post_id
      org_id
      author_id
      parent_post_id
      body
      created_at
      updated_at
      author {
        user_id
        name
        email
        picture_url
        role
        equipped_store_items(where: {item_type: {_eq: "PET"}}) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPostByIdQuery__
 *
 * To run a query within a React component, call `useGetPostByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostByIdQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPostByIdQuery, Types.GetPostByIdQueryVariables> & ({ variables: Types.GetPostByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPostByIdQuery, Types.GetPostByIdQueryVariables>(GetPostByIdDocument, options);
      }
export function useGetPostByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPostByIdQuery, Types.GetPostByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPostByIdQuery, Types.GetPostByIdQueryVariables>(GetPostByIdDocument, options);
        }
// @ts-ignore
export function useGetPostByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetPostByIdQuery, Types.GetPostByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetPostByIdQuery, Types.GetPostByIdQueryVariables>;
export function useGetPostByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetPostByIdQuery, Types.GetPostByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetPostByIdQuery | undefined, Types.GetPostByIdQueryVariables>;
export function useGetPostByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetPostByIdQuery, Types.GetPostByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPostByIdQuery, Types.GetPostByIdQueryVariables>(GetPostByIdDocument, options);
        }
export type GetPostByIdQueryHookResult = ReturnType<typeof useGetPostByIdQuery>;
export type GetPostByIdLazyQueryHookResult = ReturnType<typeof useGetPostByIdLazyQuery>;
export type GetPostByIdSuspenseQueryHookResult = ReturnType<typeof useGetPostByIdSuspenseQuery>;
export type GetPostByIdQueryResult = Apollo.QueryResult<Types.GetPostByIdQuery, Types.GetPostByIdQueryVariables>;
export const AddProgramDocument = gql`
    mutation addProgram($orgId: uuid) {
  insert_program(
    objects: [{org_id: $orgId}]
    on_conflict: {constraint: program_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddProgramMutationFn = Apollo.MutationFunction<Types.AddProgramMutation, Types.AddProgramMutationVariables>;

/**
 * __useAddProgramMutation__
 *
 * To run a mutation, you first call `useAddProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProgramMutation, { data, loading, error }] = useAddProgramMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useAddProgramMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddProgramMutation, Types.AddProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddProgramMutation, Types.AddProgramMutationVariables>(AddProgramDocument, options);
      }
export type AddProgramMutationHookResult = ReturnType<typeof useAddProgramMutation>;
export type AddProgramMutationResult = Apollo.MutationResult<Types.AddProgramMutation>;
export type AddProgramMutationOptions = Apollo.BaseMutationOptions<Types.AddProgramMutation, Types.AddProgramMutationVariables>;
export const UpdateProgramDocument = gql`
    mutation updateProgram($id: uuid!, $program: program_set_input!) {
  update_program(where: {program_id: {_eq: $id}}, _set: $program) {
    affected_rows
  }
}
    `;
export type UpdateProgramMutationFn = Apollo.MutationFunction<Types.UpdateProgramMutation, Types.UpdateProgramMutationVariables>;

/**
 * __useUpdateProgramMutation__
 *
 * To run a mutation, you first call `useUpdateProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramMutation, { data, loading, error }] = useUpdateProgramMutation({
 *   variables: {
 *      id: // value for 'id'
 *      program: // value for 'program'
 *   },
 * });
 */
export function useUpdateProgramMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateProgramMutation, Types.UpdateProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateProgramMutation, Types.UpdateProgramMutationVariables>(UpdateProgramDocument, options);
      }
export type UpdateProgramMutationHookResult = ReturnType<typeof useUpdateProgramMutation>;
export type UpdateProgramMutationResult = Apollo.MutationResult<Types.UpdateProgramMutation>;
export type UpdateProgramMutationOptions = Apollo.BaseMutationOptions<Types.UpdateProgramMutation, Types.UpdateProgramMutationVariables>;
export const DeleteProgramDocument = gql`
    mutation deleteProgram($id: uuid!) {
  delete_program(where: {program_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteProgramMutationFn = Apollo.MutationFunction<Types.DeleteProgramMutation, Types.DeleteProgramMutationVariables>;

/**
 * __useDeleteProgramMutation__
 *
 * To run a mutation, you first call `useDeleteProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProgramMutation, { data, loading, error }] = useDeleteProgramMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProgramMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteProgramMutation, Types.DeleteProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteProgramMutation, Types.DeleteProgramMutationVariables>(DeleteProgramDocument, options);
      }
export type DeleteProgramMutationHookResult = ReturnType<typeof useDeleteProgramMutation>;
export type DeleteProgramMutationResult = Apollo.MutationResult<Types.DeleteProgramMutation>;
export type DeleteProgramMutationOptions = Apollo.BaseMutationOptions<Types.DeleteProgramMutation, Types.DeleteProgramMutationVariables>;
export const GetProgramsDocument = gql`
    query getPrograms {
  program {
    program_id
  }
}
    `;

/**
 * __useGetProgramsQuery__
 *
 * To run a query within a React component, call `useGetProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProgramsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetProgramsQuery, Types.GetProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetProgramsQuery, Types.GetProgramsQueryVariables>(GetProgramsDocument, options);
      }
export function useGetProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetProgramsQuery, Types.GetProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetProgramsQuery, Types.GetProgramsQueryVariables>(GetProgramsDocument, options);
        }
// @ts-ignore
export function useGetProgramsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetProgramsQuery, Types.GetProgramsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetProgramsQuery, Types.GetProgramsQueryVariables>;
export function useGetProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetProgramsQuery, Types.GetProgramsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetProgramsQuery | undefined, Types.GetProgramsQueryVariables>;
export function useGetProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetProgramsQuery, Types.GetProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetProgramsQuery, Types.GetProgramsQueryVariables>(GetProgramsDocument, options);
        }
export type GetProgramsQueryHookResult = ReturnType<typeof useGetProgramsQuery>;
export type GetProgramsLazyQueryHookResult = ReturnType<typeof useGetProgramsLazyQuery>;
export type GetProgramsSuspenseQueryHookResult = ReturnType<typeof useGetProgramsSuspenseQuery>;
export type GetProgramsQueryResult = Apollo.QueryResult<Types.GetProgramsQuery, Types.GetProgramsQueryVariables>;
export const GetProgramsByOrgDocument = gql`
    query getProgramsByOrg($orgId: uuid!) {
  program(where: {org_id: {_eq: $orgId}}) {
    program_id
  }
}
    `;

/**
 * __useGetProgramsByOrgQuery__
 *
 * To run a query within a React component, call `useGetProgramsByOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramsByOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramsByOrgQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetProgramsByOrgQuery(baseOptions: Apollo.QueryHookOptions<Types.GetProgramsByOrgQuery, Types.GetProgramsByOrgQueryVariables> & ({ variables: Types.GetProgramsByOrgQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetProgramsByOrgQuery, Types.GetProgramsByOrgQueryVariables>(GetProgramsByOrgDocument, options);
      }
export function useGetProgramsByOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetProgramsByOrgQuery, Types.GetProgramsByOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetProgramsByOrgQuery, Types.GetProgramsByOrgQueryVariables>(GetProgramsByOrgDocument, options);
        }
// @ts-ignore
export function useGetProgramsByOrgSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetProgramsByOrgQuery, Types.GetProgramsByOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetProgramsByOrgQuery, Types.GetProgramsByOrgQueryVariables>;
export function useGetProgramsByOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetProgramsByOrgQuery, Types.GetProgramsByOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetProgramsByOrgQuery | undefined, Types.GetProgramsByOrgQueryVariables>;
export function useGetProgramsByOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetProgramsByOrgQuery, Types.GetProgramsByOrgQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetProgramsByOrgQuery, Types.GetProgramsByOrgQueryVariables>(GetProgramsByOrgDocument, options);
        }
export type GetProgramsByOrgQueryHookResult = ReturnType<typeof useGetProgramsByOrgQuery>;
export type GetProgramsByOrgLazyQueryHookResult = ReturnType<typeof useGetProgramsByOrgLazyQuery>;
export type GetProgramsByOrgSuspenseQueryHookResult = ReturnType<typeof useGetProgramsByOrgSuspenseQuery>;
export type GetProgramsByOrgQueryResult = Apollo.QueryResult<Types.GetProgramsByOrgQuery, Types.GetProgramsByOrgQueryVariables>;
export const GetProgramByIdDocument = gql`
    query getProgramById($programId: uuid!) {
  program_by_pk(program_id: $programId) {
    program_id
  }
}
    `;

/**
 * __useGetProgramByIdQuery__
 *
 * To run a query within a React component, call `useGetProgramByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramByIdQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useGetProgramByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetProgramByIdQuery, Types.GetProgramByIdQueryVariables> & ({ variables: Types.GetProgramByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetProgramByIdQuery, Types.GetProgramByIdQueryVariables>(GetProgramByIdDocument, options);
      }
export function useGetProgramByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetProgramByIdQuery, Types.GetProgramByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetProgramByIdQuery, Types.GetProgramByIdQueryVariables>(GetProgramByIdDocument, options);
        }
// @ts-ignore
export function useGetProgramByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetProgramByIdQuery, Types.GetProgramByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetProgramByIdQuery, Types.GetProgramByIdQueryVariables>;
export function useGetProgramByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetProgramByIdQuery, Types.GetProgramByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetProgramByIdQuery | undefined, Types.GetProgramByIdQueryVariables>;
export function useGetProgramByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetProgramByIdQuery, Types.GetProgramByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetProgramByIdQuery, Types.GetProgramByIdQueryVariables>(GetProgramByIdDocument, options);
        }
export type GetProgramByIdQueryHookResult = ReturnType<typeof useGetProgramByIdQuery>;
export type GetProgramByIdLazyQueryHookResult = ReturnType<typeof useGetProgramByIdLazyQuery>;
export type GetProgramByIdSuspenseQueryHookResult = ReturnType<typeof useGetProgramByIdSuspenseQuery>;
export type GetProgramByIdQueryResult = Apollo.QueryResult<Types.GetProgramByIdQuery, Types.GetProgramByIdQueryVariables>;
export const AddQuestionDocument = gql`
    mutation addQuestion($title: String!, $type: String, $body: String, $order: Int) {
  insert_question(
    objects: [{title: $title, type: $type, body: $body, order: $order}]
    on_conflict: {constraint: question_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      question_id
    }
  }
}
    `;
export type AddQuestionMutationFn = Apollo.MutationFunction<Types.AddQuestionMutation, Types.AddQuestionMutationVariables>;

/**
 * __useAddQuestionMutation__
 *
 * To run a mutation, you first call `useAddQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQuestionMutation, { data, loading, error }] = useAddQuestionMutation({
 *   variables: {
 *      title: // value for 'title'
 *      type: // value for 'type'
 *      body: // value for 'body'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAddQuestionMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddQuestionMutation, Types.AddQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddQuestionMutation, Types.AddQuestionMutationVariables>(AddQuestionDocument, options);
      }
export type AddQuestionMutationHookResult = ReturnType<typeof useAddQuestionMutation>;
export type AddQuestionMutationResult = Apollo.MutationResult<Types.AddQuestionMutation>;
export type AddQuestionMutationOptions = Apollo.BaseMutationOptions<Types.AddQuestionMutation, Types.AddQuestionMutationVariables>;
export const UpdateQuestionDocument = gql`
    mutation updateQuestion($id: uuid!, $question: question_set_input!) {
  update_question(where: {question_id: {_eq: $id}}, _set: $question) {
    affected_rows
  }
}
    `;
export type UpdateQuestionMutationFn = Apollo.MutationFunction<Types.UpdateQuestionMutation, Types.UpdateQuestionMutationVariables>;

/**
 * __useUpdateQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionMutation, { data, loading, error }] = useUpdateQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      question: // value for 'question'
 *   },
 * });
 */
export function useUpdateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateQuestionMutation, Types.UpdateQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateQuestionMutation, Types.UpdateQuestionMutationVariables>(UpdateQuestionDocument, options);
      }
export type UpdateQuestionMutationHookResult = ReturnType<typeof useUpdateQuestionMutation>;
export type UpdateQuestionMutationResult = Apollo.MutationResult<Types.UpdateQuestionMutation>;
export type UpdateQuestionMutationOptions = Apollo.BaseMutationOptions<Types.UpdateQuestionMutation, Types.UpdateQuestionMutationVariables>;
export const DeleteQuestionDocument = gql`
    mutation deleteQuestion($id: uuid!) {
  delete_question(where: {question_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteQuestionMutationFn = Apollo.MutationFunction<Types.DeleteQuestionMutation, Types.DeleteQuestionMutationVariables>;

/**
 * __useDeleteQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuestionMutation, { data, loading, error }] = useDeleteQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQuestionMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteQuestionMutation, Types.DeleteQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteQuestionMutation, Types.DeleteQuestionMutationVariables>(DeleteQuestionDocument, options);
      }
export type DeleteQuestionMutationHookResult = ReturnType<typeof useDeleteQuestionMutation>;
export type DeleteQuestionMutationResult = Apollo.MutationResult<Types.DeleteQuestionMutation>;
export type DeleteQuestionMutationOptions = Apollo.BaseMutationOptions<Types.DeleteQuestionMutation, Types.DeleteQuestionMutationVariables>;
export const GetQuestionsDocument = gql`
    query getQuestions {
  question {
    question_id
    title
    type
    body
    order
    options {
      option_id
      order
      text
    }
    answers {
      answer_id
      answer
      question_id
    }
  }
}
    `;

/**
 * __useGetQuestionsQuery__
 *
 * To run a query within a React component, call `useGetQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetQuestionsQuery, Types.GetQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetQuestionsQuery, Types.GetQuestionsQueryVariables>(GetQuestionsDocument, options);
      }
export function useGetQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetQuestionsQuery, Types.GetQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetQuestionsQuery, Types.GetQuestionsQueryVariables>(GetQuestionsDocument, options);
        }
// @ts-ignore
export function useGetQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetQuestionsQuery, Types.GetQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetQuestionsQuery, Types.GetQuestionsQueryVariables>;
export function useGetQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetQuestionsQuery, Types.GetQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetQuestionsQuery | undefined, Types.GetQuestionsQueryVariables>;
export function useGetQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetQuestionsQuery, Types.GetQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetQuestionsQuery, Types.GetQuestionsQueryVariables>(GetQuestionsDocument, options);
        }
export type GetQuestionsQueryHookResult = ReturnType<typeof useGetQuestionsQuery>;
export type GetQuestionsLazyQueryHookResult = ReturnType<typeof useGetQuestionsLazyQuery>;
export type GetQuestionsSuspenseQueryHookResult = ReturnType<typeof useGetQuestionsSuspenseQuery>;
export type GetQuestionsQueryResult = Apollo.QueryResult<Types.GetQuestionsQuery, Types.GetQuestionsQueryVariables>;
export const GetQuestionByIdDocument = gql`
    query getQuestionById($questionId: uuid!) {
  question_by_pk(question_id: $questionId) {
    question_id
    title
    type
    body
    order
    options {
      option_id
      order
      text
    }
    answers {
      answer_id
      answer
      question_id
    }
  }
}
    `;

/**
 * __useGetQuestionByIdQuery__
 *
 * To run a query within a React component, call `useGetQuestionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionByIdQuery({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useGetQuestionByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetQuestionByIdQuery, Types.GetQuestionByIdQueryVariables> & ({ variables: Types.GetQuestionByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetQuestionByIdQuery, Types.GetQuestionByIdQueryVariables>(GetQuestionByIdDocument, options);
      }
export function useGetQuestionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetQuestionByIdQuery, Types.GetQuestionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetQuestionByIdQuery, Types.GetQuestionByIdQueryVariables>(GetQuestionByIdDocument, options);
        }
// @ts-ignore
export function useGetQuestionByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetQuestionByIdQuery, Types.GetQuestionByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetQuestionByIdQuery, Types.GetQuestionByIdQueryVariables>;
export function useGetQuestionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetQuestionByIdQuery, Types.GetQuestionByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetQuestionByIdQuery | undefined, Types.GetQuestionByIdQueryVariables>;
export function useGetQuestionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetQuestionByIdQuery, Types.GetQuestionByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetQuestionByIdQuery, Types.GetQuestionByIdQueryVariables>(GetQuestionByIdDocument, options);
        }
export type GetQuestionByIdQueryHookResult = ReturnType<typeof useGetQuestionByIdQuery>;
export type GetQuestionByIdLazyQueryHookResult = ReturnType<typeof useGetQuestionByIdLazyQuery>;
export type GetQuestionByIdSuspenseQueryHookResult = ReturnType<typeof useGetQuestionByIdSuspenseQuery>;
export type GetQuestionByIdQueryResult = Apollo.QueryResult<Types.GetQuestionByIdQuery, Types.GetQuestionByIdQueryVariables>;
export const GetQuestionsByTypeDocument = gql`
    query getQuestionsByType($type: String!) {
  question(where: {type: {_eq: $type}}) {
    question_id
    title
    type
    body
    order
    options {
      option_id
      order
      text
    }
    answers {
      answer_id
      answer
      question_id
    }
  }
}
    `;

/**
 * __useGetQuestionsByTypeQuery__
 *
 * To run a query within a React component, call `useGetQuestionsByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionsByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionsByTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetQuestionsByTypeQuery(baseOptions: Apollo.QueryHookOptions<Types.GetQuestionsByTypeQuery, Types.GetQuestionsByTypeQueryVariables> & ({ variables: Types.GetQuestionsByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetQuestionsByTypeQuery, Types.GetQuestionsByTypeQueryVariables>(GetQuestionsByTypeDocument, options);
      }
export function useGetQuestionsByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetQuestionsByTypeQuery, Types.GetQuestionsByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetQuestionsByTypeQuery, Types.GetQuestionsByTypeQueryVariables>(GetQuestionsByTypeDocument, options);
        }
// @ts-ignore
export function useGetQuestionsByTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetQuestionsByTypeQuery, Types.GetQuestionsByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetQuestionsByTypeQuery, Types.GetQuestionsByTypeQueryVariables>;
export function useGetQuestionsByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetQuestionsByTypeQuery, Types.GetQuestionsByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetQuestionsByTypeQuery | undefined, Types.GetQuestionsByTypeQueryVariables>;
export function useGetQuestionsByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetQuestionsByTypeQuery, Types.GetQuestionsByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetQuestionsByTypeQuery, Types.GetQuestionsByTypeQueryVariables>(GetQuestionsByTypeDocument, options);
        }
export type GetQuestionsByTypeQueryHookResult = ReturnType<typeof useGetQuestionsByTypeQuery>;
export type GetQuestionsByTypeLazyQueryHookResult = ReturnType<typeof useGetQuestionsByTypeLazyQuery>;
export type GetQuestionsByTypeSuspenseQueryHookResult = ReturnType<typeof useGetQuestionsByTypeSuspenseQuery>;
export type GetQuestionsByTypeQueryResult = Apollo.QueryResult<Types.GetQuestionsByTypeQuery, Types.GetQuestionsByTypeQueryVariables>;
export const AddRequirementDocument = gql`
    mutation addRequirement($name: String!, $description: String, $task_time: String, $animal_size: String, $type: String, $overview: String, $requirement_type: String, $min_performance: Int, $min_score: Int, $species_id: uuid, $min_small_animals_count: Int, $min_large_animals_count: Int) {
  insert_requirement(
    objects: [{name: $name, description: $description, task_time: $task_time, animal_size: $animal_size, type: $type, overview: $overview, requirement_type: $requirement_type, min_performance: $min_performance, min_score: $min_score, species_id: $species_id, min_small_animals_count: $min_small_animals_count, min_large_animals_count: $min_large_animals_count}]
    on_conflict: {constraint: requirement_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      requirement_id
    }
  }
}
    `;
export type AddRequirementMutationFn = Apollo.MutationFunction<Types.AddRequirementMutation, Types.AddRequirementMutationVariables>;

/**
 * __useAddRequirementMutation__
 *
 * To run a mutation, you first call `useAddRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRequirementMutation, { data, loading, error }] = useAddRequirementMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      task_time: // value for 'task_time'
 *      animal_size: // value for 'animal_size'
 *      type: // value for 'type'
 *      overview: // value for 'overview'
 *      requirement_type: // value for 'requirement_type'
 *      min_performance: // value for 'min_performance'
 *      min_score: // value for 'min_score'
 *      species_id: // value for 'species_id'
 *      min_small_animals_count: // value for 'min_small_animals_count'
 *      min_large_animals_count: // value for 'min_large_animals_count'
 *   },
 * });
 */
export function useAddRequirementMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddRequirementMutation, Types.AddRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddRequirementMutation, Types.AddRequirementMutationVariables>(AddRequirementDocument, options);
      }
export type AddRequirementMutationHookResult = ReturnType<typeof useAddRequirementMutation>;
export type AddRequirementMutationResult = Apollo.MutationResult<Types.AddRequirementMutation>;
export type AddRequirementMutationOptions = Apollo.BaseMutationOptions<Types.AddRequirementMutation, Types.AddRequirementMutationVariables>;
export const UpdateRequirementDocument = gql`
    mutation updateRequirement($id: uuid!, $requirement: requirement_set_input!) {
  update_requirement(where: {requirement_id: {_eq: $id}}, _set: $requirement) {
    affected_rows
  }
}
    `;
export type UpdateRequirementMutationFn = Apollo.MutationFunction<Types.UpdateRequirementMutation, Types.UpdateRequirementMutationVariables>;

/**
 * __useUpdateRequirementMutation__
 *
 * To run a mutation, you first call `useUpdateRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRequirementMutation, { data, loading, error }] = useUpdateRequirementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      requirement: // value for 'requirement'
 *   },
 * });
 */
export function useUpdateRequirementMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateRequirementMutation, Types.UpdateRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateRequirementMutation, Types.UpdateRequirementMutationVariables>(UpdateRequirementDocument, options);
      }
export type UpdateRequirementMutationHookResult = ReturnType<typeof useUpdateRequirementMutation>;
export type UpdateRequirementMutationResult = Apollo.MutationResult<Types.UpdateRequirementMutation>;
export type UpdateRequirementMutationOptions = Apollo.BaseMutationOptions<Types.UpdateRequirementMutation, Types.UpdateRequirementMutationVariables>;
export const DeleteRequirementDocument = gql`
    mutation deleteRequirement($id: uuid!) {
  delete_requirement(where: {requirement_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteRequirementMutationFn = Apollo.MutationFunction<Types.DeleteRequirementMutation, Types.DeleteRequirementMutationVariables>;

/**
 * __useDeleteRequirementMutation__
 *
 * To run a mutation, you first call `useDeleteRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRequirementMutation, { data, loading, error }] = useDeleteRequirementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRequirementMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteRequirementMutation, Types.DeleteRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteRequirementMutation, Types.DeleteRequirementMutationVariables>(DeleteRequirementDocument, options);
      }
export type DeleteRequirementMutationHookResult = ReturnType<typeof useDeleteRequirementMutation>;
export type DeleteRequirementMutationResult = Apollo.MutationResult<Types.DeleteRequirementMutation>;
export type DeleteRequirementMutationOptions = Apollo.BaseMutationOptions<Types.DeleteRequirementMutation, Types.DeleteRequirementMutationVariables>;
export const GetRequirementsDocument = gql`
    query getRequirements {
  requirement {
    requirement_id
    name
    description
    task_time
    animal_size
    type
    overview
    requirement_type
    min_performance
    min_score
    min_small_animals_count
    min_large_animals_count
    domains {
      relation
      domain {
        requirement_domain_id
        name
        code
        color_hex
        sort_order
      }
    }
    competencies {
      competency {
        requirement_id
        name
        type
        domains {
          relation
          domain {
            requirement_domain_id
            name
            code
            color_hex
            sort_order
          }
        }
      }
    }
    resources {
      requirement_resource_id
      resource {
        resource_id
        name
        description
      }
    }
    species {
      name
      species_id
    }
  }
}
    `;

/**
 * __useGetRequirementsQuery__
 *
 * To run a query within a React component, call `useGetRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequirementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRequirementsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetRequirementsQuery, Types.GetRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetRequirementsQuery, Types.GetRequirementsQueryVariables>(GetRequirementsDocument, options);
      }
export function useGetRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRequirementsQuery, Types.GetRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetRequirementsQuery, Types.GetRequirementsQueryVariables>(GetRequirementsDocument, options);
        }
// @ts-ignore
export function useGetRequirementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetRequirementsQuery, Types.GetRequirementsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementsQuery, Types.GetRequirementsQueryVariables>;
export function useGetRequirementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementsQuery, Types.GetRequirementsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementsQuery | undefined, Types.GetRequirementsQueryVariables>;
export function useGetRequirementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementsQuery, Types.GetRequirementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetRequirementsQuery, Types.GetRequirementsQueryVariables>(GetRequirementsDocument, options);
        }
export type GetRequirementsQueryHookResult = ReturnType<typeof useGetRequirementsQuery>;
export type GetRequirementsLazyQueryHookResult = ReturnType<typeof useGetRequirementsLazyQuery>;
export type GetRequirementsSuspenseQueryHookResult = ReturnType<typeof useGetRequirementsSuspenseQuery>;
export type GetRequirementsQueryResult = Apollo.QueryResult<Types.GetRequirementsQuery, Types.GetRequirementsQueryVariables>;
export const GetRequirementByIdDocument = gql`
    query getRequirementById($requirementId: uuid!) {
  requirement_by_pk(requirement_id: $requirementId) {
    requirement_id
    name
    description
    task_time
    animal_size
    type
    overview
    requirement_type
    min_performance
    min_score
    min_small_animals_count
    min_large_animals_count
    domains {
      relation
      domain {
        requirement_domain_id
        name
        code
        color_hex
        sort_order
      }
    }
    competencies {
      competency {
        requirement_id
        name
        description
        overview
        type
        domains {
          relation
          domain {
            requirement_domain_id
            name
            code
            color_hex
            sort_order
          }
        }
        evaluation_metrics {
          evaluation_metric_id
          skill_level
          description
          target_achievement_time
          skill_level_label
          target_achievement_time_label
        }
      }
    }
    resources {
      requirement_resource_id
      resource {
        resource_id
        name
        description
        url
      }
    }
    species {
      name
      species_id
    }
    evaluation_metrics {
      evaluation_metric_id
      skill_level
      description
      target_achievement_time
      skill_level_label
      target_achievement_time_label
    }
    tags {
      requirement_tag_id
      tag {
        tag_id
        name
        type
      }
    }
  }
  requirement_competency(where: {requirement_id: {_eq: $requirementId}}) {
    requirement_competency_id
    competency {
      requirement_id
      type
      name
      overview
      description
      domains {
        relation
        domain {
          requirement_domain_id
          name
          code
          color_hex
          sort_order
        }
      }
    }
  }
}
    `;

/**
 * __useGetRequirementByIdQuery__
 *
 * To run a query within a React component, call `useGetRequirementByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequirementByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequirementByIdQuery({
 *   variables: {
 *      requirementId: // value for 'requirementId'
 *   },
 * });
 */
export function useGetRequirementByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetRequirementByIdQuery, Types.GetRequirementByIdQueryVariables> & ({ variables: Types.GetRequirementByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetRequirementByIdQuery, Types.GetRequirementByIdQueryVariables>(GetRequirementByIdDocument, options);
      }
export function useGetRequirementByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRequirementByIdQuery, Types.GetRequirementByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetRequirementByIdQuery, Types.GetRequirementByIdQueryVariables>(GetRequirementByIdDocument, options);
        }
// @ts-ignore
export function useGetRequirementByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetRequirementByIdQuery, Types.GetRequirementByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementByIdQuery, Types.GetRequirementByIdQueryVariables>;
export function useGetRequirementByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementByIdQuery, Types.GetRequirementByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementByIdQuery | undefined, Types.GetRequirementByIdQueryVariables>;
export function useGetRequirementByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementByIdQuery, Types.GetRequirementByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetRequirementByIdQuery, Types.GetRequirementByIdQueryVariables>(GetRequirementByIdDocument, options);
        }
export type GetRequirementByIdQueryHookResult = ReturnType<typeof useGetRequirementByIdQuery>;
export type GetRequirementByIdLazyQueryHookResult = ReturnType<typeof useGetRequirementByIdLazyQuery>;
export type GetRequirementByIdSuspenseQueryHookResult = ReturnType<typeof useGetRequirementByIdSuspenseQuery>;
export type GetRequirementByIdQueryResult = Apollo.QueryResult<Types.GetRequirementByIdQuery, Types.GetRequirementByIdQueryVariables>;
export const GetRequirementsByTypeDocument = gql`
    query GetRequirementsByType($reqType: String!) {
  requirement(where: {type: {_eq: $reqType}}) {
    requirement_id
    name
    description
    task_time
    animal_size
    type
    overview
    requirement_type
    min_performance
    min_score
    min_small_animals_count
    min_large_animals_count
    domains {
      relation
      domain {
        requirement_domain_id
        name
        code
        color_hex
        sort_order
      }
    }
    evaluation_metrics {
      evaluation_metric_id
      skill_level
      description
      target_achievement_time
      skill_level_label
      target_achievement_time_label
    }
    competencies {
      competency {
        requirement_id
        name
        type
        domains {
          relation
          domain {
            requirement_domain_id
            name
            code
            color_hex
            sort_order
          }
        }
      }
    }
    resources {
      resource {
        resource_id
        name
        description
      }
    }
    species {
      name
      species_id
    }
    tags {
      tag {
        tag_id
        name
        type
      }
    }
  }
}
    `;

/**
 * __useGetRequirementsByTypeQuery__
 *
 * To run a query within a React component, call `useGetRequirementsByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequirementsByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequirementsByTypeQuery({
 *   variables: {
 *      reqType: // value for 'reqType'
 *   },
 * });
 */
export function useGetRequirementsByTypeQuery(baseOptions: Apollo.QueryHookOptions<Types.GetRequirementsByTypeQuery, Types.GetRequirementsByTypeQueryVariables> & ({ variables: Types.GetRequirementsByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetRequirementsByTypeQuery, Types.GetRequirementsByTypeQueryVariables>(GetRequirementsByTypeDocument, options);
      }
export function useGetRequirementsByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRequirementsByTypeQuery, Types.GetRequirementsByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetRequirementsByTypeQuery, Types.GetRequirementsByTypeQueryVariables>(GetRequirementsByTypeDocument, options);
        }
// @ts-ignore
export function useGetRequirementsByTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetRequirementsByTypeQuery, Types.GetRequirementsByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementsByTypeQuery, Types.GetRequirementsByTypeQueryVariables>;
export function useGetRequirementsByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementsByTypeQuery, Types.GetRequirementsByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementsByTypeQuery | undefined, Types.GetRequirementsByTypeQueryVariables>;
export function useGetRequirementsByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementsByTypeQuery, Types.GetRequirementsByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetRequirementsByTypeQuery, Types.GetRequirementsByTypeQueryVariables>(GetRequirementsByTypeDocument, options);
        }
export type GetRequirementsByTypeQueryHookResult = ReturnType<typeof useGetRequirementsByTypeQuery>;
export type GetRequirementsByTypeLazyQueryHookResult = ReturnType<typeof useGetRequirementsByTypeLazyQuery>;
export type GetRequirementsByTypeSuspenseQueryHookResult = ReturnType<typeof useGetRequirementsByTypeSuspenseQuery>;
export type GetRequirementsByTypeQueryResult = Apollo.QueryResult<Types.GetRequirementsByTypeQuery, Types.GetRequirementsByTypeQueryVariables>;
export const GetRequirementsCurrentAcademicYearByStudentIdDocument = gql`
    query GetRequirementsCurrentAcademicYearByStudentId($studentId: uuid!) {
  graduation_class(where: {students: {student_id: {_eq: $studentId}}}) {
    current_academic_year {
      requirements {
        academic_year_requirement_id
        requirement_id
        requirement {
          requirement_id
          name
          description
          task_time
          animal_size
          type
          overview
          requirement_type
          min_performance
          min_score
          min_small_animals_count
          min_large_animals_count
          domains {
            relation
            domain {
              requirement_domain_id
              name
              code
              color_hex
              sort_order
            }
          }
          competencies {
            competency {
              requirement_id
              name
              description
              task_time
              animal_size
              type
              overview
              requirement_type
              min_performance
              min_score
              min_small_animals_count
              min_large_animals_count
              domains {
                relation
                domain {
                  requirement_domain_id
                  name
                  code
                  color_hex
                  sort_order
                }
              }
            }
          }
          resources {
            resource {
              description
              name
              resource_id
              url
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetRequirementsCurrentAcademicYearByStudentIdQuery__
 *
 * To run a query within a React component, call `useGetRequirementsCurrentAcademicYearByStudentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequirementsCurrentAcademicYearByStudentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequirementsCurrentAcademicYearByStudentIdQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetRequirementsCurrentAcademicYearByStudentIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetRequirementsCurrentAcademicYearByStudentIdQuery, Types.GetRequirementsCurrentAcademicYearByStudentIdQueryVariables> & ({ variables: Types.GetRequirementsCurrentAcademicYearByStudentIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetRequirementsCurrentAcademicYearByStudentIdQuery, Types.GetRequirementsCurrentAcademicYearByStudentIdQueryVariables>(GetRequirementsCurrentAcademicYearByStudentIdDocument, options);
      }
export function useGetRequirementsCurrentAcademicYearByStudentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRequirementsCurrentAcademicYearByStudentIdQuery, Types.GetRequirementsCurrentAcademicYearByStudentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetRequirementsCurrentAcademicYearByStudentIdQuery, Types.GetRequirementsCurrentAcademicYearByStudentIdQueryVariables>(GetRequirementsCurrentAcademicYearByStudentIdDocument, options);
        }
// @ts-ignore
export function useGetRequirementsCurrentAcademicYearByStudentIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetRequirementsCurrentAcademicYearByStudentIdQuery, Types.GetRequirementsCurrentAcademicYearByStudentIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementsCurrentAcademicYearByStudentIdQuery, Types.GetRequirementsCurrentAcademicYearByStudentIdQueryVariables>;
export function useGetRequirementsCurrentAcademicYearByStudentIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementsCurrentAcademicYearByStudentIdQuery, Types.GetRequirementsCurrentAcademicYearByStudentIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementsCurrentAcademicYearByStudentIdQuery | undefined, Types.GetRequirementsCurrentAcademicYearByStudentIdQueryVariables>;
export function useGetRequirementsCurrentAcademicYearByStudentIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementsCurrentAcademicYearByStudentIdQuery, Types.GetRequirementsCurrentAcademicYearByStudentIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetRequirementsCurrentAcademicYearByStudentIdQuery, Types.GetRequirementsCurrentAcademicYearByStudentIdQueryVariables>(GetRequirementsCurrentAcademicYearByStudentIdDocument, options);
        }
export type GetRequirementsCurrentAcademicYearByStudentIdQueryHookResult = ReturnType<typeof useGetRequirementsCurrentAcademicYearByStudentIdQuery>;
export type GetRequirementsCurrentAcademicYearByStudentIdLazyQueryHookResult = ReturnType<typeof useGetRequirementsCurrentAcademicYearByStudentIdLazyQuery>;
export type GetRequirementsCurrentAcademicYearByStudentIdSuspenseQueryHookResult = ReturnType<typeof useGetRequirementsCurrentAcademicYearByStudentIdSuspenseQuery>;
export type GetRequirementsCurrentAcademicYearByStudentIdQueryResult = Apollo.QueryResult<Types.GetRequirementsCurrentAcademicYearByStudentIdQuery, Types.GetRequirementsCurrentAcademicYearByStudentIdQueryVariables>;
export const AddRequirementCompetencyDocument = gql`
    mutation addRequirementCompetency($requirementId: uuid!, $competencyId: uuid) {
  insert_requirement_competency(
    objects: [{requirement_id: $requirementId, competency_id: $competencyId}]
    on_conflict: {constraint: requirement_competency_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddRequirementCompetencyMutationFn = Apollo.MutationFunction<Types.AddRequirementCompetencyMutation, Types.AddRequirementCompetencyMutationVariables>;

/**
 * __useAddRequirementCompetencyMutation__
 *
 * To run a mutation, you first call `useAddRequirementCompetencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRequirementCompetencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRequirementCompetencyMutation, { data, loading, error }] = useAddRequirementCompetencyMutation({
 *   variables: {
 *      requirementId: // value for 'requirementId'
 *      competencyId: // value for 'competencyId'
 *   },
 * });
 */
export function useAddRequirementCompetencyMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddRequirementCompetencyMutation, Types.AddRequirementCompetencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddRequirementCompetencyMutation, Types.AddRequirementCompetencyMutationVariables>(AddRequirementCompetencyDocument, options);
      }
export type AddRequirementCompetencyMutationHookResult = ReturnType<typeof useAddRequirementCompetencyMutation>;
export type AddRequirementCompetencyMutationResult = Apollo.MutationResult<Types.AddRequirementCompetencyMutation>;
export type AddRequirementCompetencyMutationOptions = Apollo.BaseMutationOptions<Types.AddRequirementCompetencyMutation, Types.AddRequirementCompetencyMutationVariables>;
export const AddRequirementCompetenciesDocument = gql`
    mutation addRequirementCompetencies($objects: [requirement_competency_insert_input!]!) {
  insert_requirement_competency(
    objects: $objects
    on_conflict: {constraint: requirement_competency_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddRequirementCompetenciesMutationFn = Apollo.MutationFunction<Types.AddRequirementCompetenciesMutation, Types.AddRequirementCompetenciesMutationVariables>;

/**
 * __useAddRequirementCompetenciesMutation__
 *
 * To run a mutation, you first call `useAddRequirementCompetenciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRequirementCompetenciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRequirementCompetenciesMutation, { data, loading, error }] = useAddRequirementCompetenciesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddRequirementCompetenciesMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddRequirementCompetenciesMutation, Types.AddRequirementCompetenciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddRequirementCompetenciesMutation, Types.AddRequirementCompetenciesMutationVariables>(AddRequirementCompetenciesDocument, options);
      }
export type AddRequirementCompetenciesMutationHookResult = ReturnType<typeof useAddRequirementCompetenciesMutation>;
export type AddRequirementCompetenciesMutationResult = Apollo.MutationResult<Types.AddRequirementCompetenciesMutation>;
export type AddRequirementCompetenciesMutationOptions = Apollo.BaseMutationOptions<Types.AddRequirementCompetenciesMutation, Types.AddRequirementCompetenciesMutationVariables>;
export const DeleteRequirementCompetencyDocument = gql`
    mutation deleteRequirementCompetency($id: uuid!) {
  delete_requirement_competency(where: {requirement_competency_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteRequirementCompetencyMutationFn = Apollo.MutationFunction<Types.DeleteRequirementCompetencyMutation, Types.DeleteRequirementCompetencyMutationVariables>;

/**
 * __useDeleteRequirementCompetencyMutation__
 *
 * To run a mutation, you first call `useDeleteRequirementCompetencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRequirementCompetencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRequirementCompetencyMutation, { data, loading, error }] = useDeleteRequirementCompetencyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRequirementCompetencyMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteRequirementCompetencyMutation, Types.DeleteRequirementCompetencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteRequirementCompetencyMutation, Types.DeleteRequirementCompetencyMutationVariables>(DeleteRequirementCompetencyDocument, options);
      }
export type DeleteRequirementCompetencyMutationHookResult = ReturnType<typeof useDeleteRequirementCompetencyMutation>;
export type DeleteRequirementCompetencyMutationResult = Apollo.MutationResult<Types.DeleteRequirementCompetencyMutation>;
export type DeleteRequirementCompetencyMutationOptions = Apollo.BaseMutationOptions<Types.DeleteRequirementCompetencyMutation, Types.DeleteRequirementCompetencyMutationVariables>;
export const GetRequirementCompetenciesDocument = gql`
    query getRequirementCompetencies {
  requirement_competency {
    requirement_competency_id
    requirement_id
    competency_id
  }
}
    `;

/**
 * __useGetRequirementCompetenciesQuery__
 *
 * To run a query within a React component, call `useGetRequirementCompetenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequirementCompetenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequirementCompetenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRequirementCompetenciesQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetRequirementCompetenciesQuery, Types.GetRequirementCompetenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetRequirementCompetenciesQuery, Types.GetRequirementCompetenciesQueryVariables>(GetRequirementCompetenciesDocument, options);
      }
export function useGetRequirementCompetenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRequirementCompetenciesQuery, Types.GetRequirementCompetenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetRequirementCompetenciesQuery, Types.GetRequirementCompetenciesQueryVariables>(GetRequirementCompetenciesDocument, options);
        }
// @ts-ignore
export function useGetRequirementCompetenciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetRequirementCompetenciesQuery, Types.GetRequirementCompetenciesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementCompetenciesQuery, Types.GetRequirementCompetenciesQueryVariables>;
export function useGetRequirementCompetenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementCompetenciesQuery, Types.GetRequirementCompetenciesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementCompetenciesQuery | undefined, Types.GetRequirementCompetenciesQueryVariables>;
export function useGetRequirementCompetenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementCompetenciesQuery, Types.GetRequirementCompetenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetRequirementCompetenciesQuery, Types.GetRequirementCompetenciesQueryVariables>(GetRequirementCompetenciesDocument, options);
        }
export type GetRequirementCompetenciesQueryHookResult = ReturnType<typeof useGetRequirementCompetenciesQuery>;
export type GetRequirementCompetenciesLazyQueryHookResult = ReturnType<typeof useGetRequirementCompetenciesLazyQuery>;
export type GetRequirementCompetenciesSuspenseQueryHookResult = ReturnType<typeof useGetRequirementCompetenciesSuspenseQuery>;
export type GetRequirementCompetenciesQueryResult = Apollo.QueryResult<Types.GetRequirementCompetenciesQuery, Types.GetRequirementCompetenciesQueryVariables>;
export const AddRequirementDomainDocument = gql`
    mutation addRequirementDomain($org_id: uuid, $name: String!, $description: String, $code: String, $sort_order: Int, $color_hex: String) {
  insert_requirement_domain_one(
    object: {org_id: $org_id, name: $name, description: $description, code: $code, sort_order: $sort_order, color_hex: $color_hex}
  ) {
    requirement_domain_id
    code
    name
  }
}
    `;
export type AddRequirementDomainMutationFn = Apollo.MutationFunction<Types.AddRequirementDomainMutation, Types.AddRequirementDomainMutationVariables>;

/**
 * __useAddRequirementDomainMutation__
 *
 * To run a mutation, you first call `useAddRequirementDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRequirementDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRequirementDomainMutation, { data, loading, error }] = useAddRequirementDomainMutation({
 *   variables: {
 *      org_id: // value for 'org_id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      code: // value for 'code'
 *      sort_order: // value for 'sort_order'
 *      color_hex: // value for 'color_hex'
 *   },
 * });
 */
export function useAddRequirementDomainMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddRequirementDomainMutation, Types.AddRequirementDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddRequirementDomainMutation, Types.AddRequirementDomainMutationVariables>(AddRequirementDomainDocument, options);
      }
export type AddRequirementDomainMutationHookResult = ReturnType<typeof useAddRequirementDomainMutation>;
export type AddRequirementDomainMutationResult = Apollo.MutationResult<Types.AddRequirementDomainMutation>;
export type AddRequirementDomainMutationOptions = Apollo.BaseMutationOptions<Types.AddRequirementDomainMutation, Types.AddRequirementDomainMutationVariables>;
export const UpdateRequirementDomainDocument = gql`
    mutation updateRequirementDomain($id: uuid!, $name: String!, $description: String, $code: String, $sort_order: Int, $color_hex: String) {
  update_requirement_domain_by_pk(
    pk_columns: {requirement_domain_id: $id}
    _set: {name: $name, description: $description, code: $code, sort_order: $sort_order, color_hex: $color_hex}
  ) {
    requirement_domain_id
    name
    code
    color_hex
  }
}
    `;
export type UpdateRequirementDomainMutationFn = Apollo.MutationFunction<Types.UpdateRequirementDomainMutation, Types.UpdateRequirementDomainMutationVariables>;

/**
 * __useUpdateRequirementDomainMutation__
 *
 * To run a mutation, you first call `useUpdateRequirementDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRequirementDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRequirementDomainMutation, { data, loading, error }] = useUpdateRequirementDomainMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      code: // value for 'code'
 *      sort_order: // value for 'sort_order'
 *      color_hex: // value for 'color_hex'
 *   },
 * });
 */
export function useUpdateRequirementDomainMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateRequirementDomainMutation, Types.UpdateRequirementDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateRequirementDomainMutation, Types.UpdateRequirementDomainMutationVariables>(UpdateRequirementDomainDocument, options);
      }
export type UpdateRequirementDomainMutationHookResult = ReturnType<typeof useUpdateRequirementDomainMutation>;
export type UpdateRequirementDomainMutationResult = Apollo.MutationResult<Types.UpdateRequirementDomainMutation>;
export type UpdateRequirementDomainMutationOptions = Apollo.BaseMutationOptions<Types.UpdateRequirementDomainMutation, Types.UpdateRequirementDomainMutationVariables>;
export const DeleteRequirementDomainDocument = gql`
    mutation deleteRequirementDomain($id: uuid!) {
  delete_requirement_domain_by_pk(requirement_domain_id: $id) {
    requirement_domain_id
  }
}
    `;
export type DeleteRequirementDomainMutationFn = Apollo.MutationFunction<Types.DeleteRequirementDomainMutation, Types.DeleteRequirementDomainMutationVariables>;

/**
 * __useDeleteRequirementDomainMutation__
 *
 * To run a mutation, you first call `useDeleteRequirementDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRequirementDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRequirementDomainMutation, { data, loading, error }] = useDeleteRequirementDomainMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRequirementDomainMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteRequirementDomainMutation, Types.DeleteRequirementDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteRequirementDomainMutation, Types.DeleteRequirementDomainMutationVariables>(DeleteRequirementDomainDocument, options);
      }
export type DeleteRequirementDomainMutationHookResult = ReturnType<typeof useDeleteRequirementDomainMutation>;
export type DeleteRequirementDomainMutationResult = Apollo.MutationResult<Types.DeleteRequirementDomainMutation>;
export type DeleteRequirementDomainMutationOptions = Apollo.BaseMutationOptions<Types.DeleteRequirementDomainMutation, Types.DeleteRequirementDomainMutationVariables>;
export const AddRequirementDomainRequirementsDocument = gql`
    mutation addRequirementDomainRequirements($objects: [requirement_domain_requirement_insert_input!]!) {
  insert_requirement_domain_requirement(objects: $objects) {
    affected_rows
  }
}
    `;
export type AddRequirementDomainRequirementsMutationFn = Apollo.MutationFunction<Types.AddRequirementDomainRequirementsMutation, Types.AddRequirementDomainRequirementsMutationVariables>;

/**
 * __useAddRequirementDomainRequirementsMutation__
 *
 * To run a mutation, you first call `useAddRequirementDomainRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRequirementDomainRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRequirementDomainRequirementsMutation, { data, loading, error }] = useAddRequirementDomainRequirementsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddRequirementDomainRequirementsMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddRequirementDomainRequirementsMutation, Types.AddRequirementDomainRequirementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddRequirementDomainRequirementsMutation, Types.AddRequirementDomainRequirementsMutationVariables>(AddRequirementDomainRequirementsDocument, options);
      }
export type AddRequirementDomainRequirementsMutationHookResult = ReturnType<typeof useAddRequirementDomainRequirementsMutation>;
export type AddRequirementDomainRequirementsMutationResult = Apollo.MutationResult<Types.AddRequirementDomainRequirementsMutation>;
export type AddRequirementDomainRequirementsMutationOptions = Apollo.BaseMutationOptions<Types.AddRequirementDomainRequirementsMutation, Types.AddRequirementDomainRequirementsMutationVariables>;
export const GetRequirementDomainsDocument = gql`
    query getRequirementDomains($where: requirement_domain_bool_exp!) {
  requirement_domain(
    where: $where
    order_by: [{sort_order: asc_nulls_last}, {name: asc}]
  ) {
    requirement_domain_id
    org_id
    name
    code
    color_hex
    sort_order
    description
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetRequirementDomainsQuery__
 *
 * To run a query within a React component, call `useGetRequirementDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequirementDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequirementDomainsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetRequirementDomainsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetRequirementDomainsQuery, Types.GetRequirementDomainsQueryVariables> & ({ variables: Types.GetRequirementDomainsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetRequirementDomainsQuery, Types.GetRequirementDomainsQueryVariables>(GetRequirementDomainsDocument, options);
      }
export function useGetRequirementDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRequirementDomainsQuery, Types.GetRequirementDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetRequirementDomainsQuery, Types.GetRequirementDomainsQueryVariables>(GetRequirementDomainsDocument, options);
        }
// @ts-ignore
export function useGetRequirementDomainsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetRequirementDomainsQuery, Types.GetRequirementDomainsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementDomainsQuery, Types.GetRequirementDomainsQueryVariables>;
export function useGetRequirementDomainsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementDomainsQuery, Types.GetRequirementDomainsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementDomainsQuery | undefined, Types.GetRequirementDomainsQueryVariables>;
export function useGetRequirementDomainsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementDomainsQuery, Types.GetRequirementDomainsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetRequirementDomainsQuery, Types.GetRequirementDomainsQueryVariables>(GetRequirementDomainsDocument, options);
        }
export type GetRequirementDomainsQueryHookResult = ReturnType<typeof useGetRequirementDomainsQuery>;
export type GetRequirementDomainsLazyQueryHookResult = ReturnType<typeof useGetRequirementDomainsLazyQuery>;
export type GetRequirementDomainsSuspenseQueryHookResult = ReturnType<typeof useGetRequirementDomainsSuspenseQuery>;
export type GetRequirementDomainsQueryResult = Apollo.QueryResult<Types.GetRequirementDomainsQuery, Types.GetRequirementDomainsQueryVariables>;
export const GetRequirementDomainByIdDocument = gql`
    query getRequirementDomainById($requirementDomainId: uuid!) {
  requirement_domain_by_pk(requirement_domain_id: $requirementDomainId) {
    requirement_domain_id
    org_id
    name
    code
    color_hex
    sort_order
    description
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetRequirementDomainByIdQuery__
 *
 * To run a query within a React component, call `useGetRequirementDomainByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequirementDomainByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequirementDomainByIdQuery({
 *   variables: {
 *      requirementDomainId: // value for 'requirementDomainId'
 *   },
 * });
 */
export function useGetRequirementDomainByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetRequirementDomainByIdQuery, Types.GetRequirementDomainByIdQueryVariables> & ({ variables: Types.GetRequirementDomainByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetRequirementDomainByIdQuery, Types.GetRequirementDomainByIdQueryVariables>(GetRequirementDomainByIdDocument, options);
      }
export function useGetRequirementDomainByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRequirementDomainByIdQuery, Types.GetRequirementDomainByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetRequirementDomainByIdQuery, Types.GetRequirementDomainByIdQueryVariables>(GetRequirementDomainByIdDocument, options);
        }
// @ts-ignore
export function useGetRequirementDomainByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetRequirementDomainByIdQuery, Types.GetRequirementDomainByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementDomainByIdQuery, Types.GetRequirementDomainByIdQueryVariables>;
export function useGetRequirementDomainByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementDomainByIdQuery, Types.GetRequirementDomainByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementDomainByIdQuery | undefined, Types.GetRequirementDomainByIdQueryVariables>;
export function useGetRequirementDomainByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementDomainByIdQuery, Types.GetRequirementDomainByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetRequirementDomainByIdQuery, Types.GetRequirementDomainByIdQueryVariables>(GetRequirementDomainByIdDocument, options);
        }
export type GetRequirementDomainByIdQueryHookResult = ReturnType<typeof useGetRequirementDomainByIdQuery>;
export type GetRequirementDomainByIdLazyQueryHookResult = ReturnType<typeof useGetRequirementDomainByIdLazyQuery>;
export type GetRequirementDomainByIdSuspenseQueryHookResult = ReturnType<typeof useGetRequirementDomainByIdSuspenseQuery>;
export type GetRequirementDomainByIdQueryResult = Apollo.QueryResult<Types.GetRequirementDomainByIdQuery, Types.GetRequirementDomainByIdQueryVariables>;
export const AddRequirementResourceDocument = gql`
    mutation addRequirementResource($requirementId: uuid!, $resourceId: uuid) {
  insert_requirement_resource(
    objects: [{requirement_id: $requirementId, resource_id: $resourceId}]
    on_conflict: {constraint: requirement_resource_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddRequirementResourceMutationFn = Apollo.MutationFunction<Types.AddRequirementResourceMutation, Types.AddRequirementResourceMutationVariables>;

/**
 * __useAddRequirementResourceMutation__
 *
 * To run a mutation, you first call `useAddRequirementResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRequirementResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRequirementResourceMutation, { data, loading, error }] = useAddRequirementResourceMutation({
 *   variables: {
 *      requirementId: // value for 'requirementId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useAddRequirementResourceMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddRequirementResourceMutation, Types.AddRequirementResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddRequirementResourceMutation, Types.AddRequirementResourceMutationVariables>(AddRequirementResourceDocument, options);
      }
export type AddRequirementResourceMutationHookResult = ReturnType<typeof useAddRequirementResourceMutation>;
export type AddRequirementResourceMutationResult = Apollo.MutationResult<Types.AddRequirementResourceMutation>;
export type AddRequirementResourceMutationOptions = Apollo.BaseMutationOptions<Types.AddRequirementResourceMutation, Types.AddRequirementResourceMutationVariables>;
export const AddRequirementResourcesDocument = gql`
    mutation addRequirementResources($objects: [requirement_resource_insert_input!]!) {
  insert_requirement_resource(
    objects: $objects
    on_conflict: {constraint: requirement_resource_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddRequirementResourcesMutationFn = Apollo.MutationFunction<Types.AddRequirementResourcesMutation, Types.AddRequirementResourcesMutationVariables>;

/**
 * __useAddRequirementResourcesMutation__
 *
 * To run a mutation, you first call `useAddRequirementResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRequirementResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRequirementResourcesMutation, { data, loading, error }] = useAddRequirementResourcesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddRequirementResourcesMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddRequirementResourcesMutation, Types.AddRequirementResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddRequirementResourcesMutation, Types.AddRequirementResourcesMutationVariables>(AddRequirementResourcesDocument, options);
      }
export type AddRequirementResourcesMutationHookResult = ReturnType<typeof useAddRequirementResourcesMutation>;
export type AddRequirementResourcesMutationResult = Apollo.MutationResult<Types.AddRequirementResourcesMutation>;
export type AddRequirementResourcesMutationOptions = Apollo.BaseMutationOptions<Types.AddRequirementResourcesMutation, Types.AddRequirementResourcesMutationVariables>;
export const DeleteRequirementResourceDocument = gql`
    mutation deleteRequirementResource($id: uuid!) {
  delete_requirement_resource(where: {requirement_resource_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteRequirementResourceMutationFn = Apollo.MutationFunction<Types.DeleteRequirementResourceMutation, Types.DeleteRequirementResourceMutationVariables>;

/**
 * __useDeleteRequirementResourceMutation__
 *
 * To run a mutation, you first call `useDeleteRequirementResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRequirementResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRequirementResourceMutation, { data, loading, error }] = useDeleteRequirementResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRequirementResourceMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteRequirementResourceMutation, Types.DeleteRequirementResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteRequirementResourceMutation, Types.DeleteRequirementResourceMutationVariables>(DeleteRequirementResourceDocument, options);
      }
export type DeleteRequirementResourceMutationHookResult = ReturnType<typeof useDeleteRequirementResourceMutation>;
export type DeleteRequirementResourceMutationResult = Apollo.MutationResult<Types.DeleteRequirementResourceMutation>;
export type DeleteRequirementResourceMutationOptions = Apollo.BaseMutationOptions<Types.DeleteRequirementResourceMutation, Types.DeleteRequirementResourceMutationVariables>;
export const DeleteRequirementResourceByTagAndResourceDocument = gql`
    mutation deleteRequirementResourceByTagAndResource($requirementId: uuid!, $resourceId: uuid!) {
  delete_requirement_resource(
    where: {requirement_id: {_eq: $requirementId}, resource_id: {_eq: $resourceId}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteRequirementResourceByTagAndResourceMutationFn = Apollo.MutationFunction<Types.DeleteRequirementResourceByTagAndResourceMutation, Types.DeleteRequirementResourceByTagAndResourceMutationVariables>;

/**
 * __useDeleteRequirementResourceByTagAndResourceMutation__
 *
 * To run a mutation, you first call `useDeleteRequirementResourceByTagAndResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRequirementResourceByTagAndResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRequirementResourceByTagAndResourceMutation, { data, loading, error }] = useDeleteRequirementResourceByTagAndResourceMutation({
 *   variables: {
 *      requirementId: // value for 'requirementId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useDeleteRequirementResourceByTagAndResourceMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteRequirementResourceByTagAndResourceMutation, Types.DeleteRequirementResourceByTagAndResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteRequirementResourceByTagAndResourceMutation, Types.DeleteRequirementResourceByTagAndResourceMutationVariables>(DeleteRequirementResourceByTagAndResourceDocument, options);
      }
export type DeleteRequirementResourceByTagAndResourceMutationHookResult = ReturnType<typeof useDeleteRequirementResourceByTagAndResourceMutation>;
export type DeleteRequirementResourceByTagAndResourceMutationResult = Apollo.MutationResult<Types.DeleteRequirementResourceByTagAndResourceMutation>;
export type DeleteRequirementResourceByTagAndResourceMutationOptions = Apollo.BaseMutationOptions<Types.DeleteRequirementResourceByTagAndResourceMutation, Types.DeleteRequirementResourceByTagAndResourceMutationVariables>;
export const GetRequirementResourceDocument = gql`
    query getRequirementResource {
  requirement_resource {
    requirement_resource_id
    requirement_id
    resource_id
  }
}
    `;

/**
 * __useGetRequirementResourceQuery__
 *
 * To run a query within a React component, call `useGetRequirementResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequirementResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequirementResourceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRequirementResourceQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetRequirementResourceQuery, Types.GetRequirementResourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetRequirementResourceQuery, Types.GetRequirementResourceQueryVariables>(GetRequirementResourceDocument, options);
      }
export function useGetRequirementResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRequirementResourceQuery, Types.GetRequirementResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetRequirementResourceQuery, Types.GetRequirementResourceQueryVariables>(GetRequirementResourceDocument, options);
        }
// @ts-ignore
export function useGetRequirementResourceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetRequirementResourceQuery, Types.GetRequirementResourceQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementResourceQuery, Types.GetRequirementResourceQueryVariables>;
export function useGetRequirementResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementResourceQuery, Types.GetRequirementResourceQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementResourceQuery | undefined, Types.GetRequirementResourceQueryVariables>;
export function useGetRequirementResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementResourceQuery, Types.GetRequirementResourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetRequirementResourceQuery, Types.GetRequirementResourceQueryVariables>(GetRequirementResourceDocument, options);
        }
export type GetRequirementResourceQueryHookResult = ReturnType<typeof useGetRequirementResourceQuery>;
export type GetRequirementResourceLazyQueryHookResult = ReturnType<typeof useGetRequirementResourceLazyQuery>;
export type GetRequirementResourceSuspenseQueryHookResult = ReturnType<typeof useGetRequirementResourceSuspenseQuery>;
export type GetRequirementResourceQueryResult = Apollo.QueryResult<Types.GetRequirementResourceQuery, Types.GetRequirementResourceQueryVariables>;
export const AddRequirementTagDocument = gql`
    mutation addRequirementTag($requirementId: uuid!, $tagId: uuid) {
  insert_requirement_tag(
    objects: [{requirement_id: $requirementId, tag_id: $tagId}]
    on_conflict: {constraint: requirement_tag_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddRequirementTagMutationFn = Apollo.MutationFunction<Types.AddRequirementTagMutation, Types.AddRequirementTagMutationVariables>;

/**
 * __useAddRequirementTagMutation__
 *
 * To run a mutation, you first call `useAddRequirementTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRequirementTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRequirementTagMutation, { data, loading, error }] = useAddRequirementTagMutation({
 *   variables: {
 *      requirementId: // value for 'requirementId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useAddRequirementTagMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddRequirementTagMutation, Types.AddRequirementTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddRequirementTagMutation, Types.AddRequirementTagMutationVariables>(AddRequirementTagDocument, options);
      }
export type AddRequirementTagMutationHookResult = ReturnType<typeof useAddRequirementTagMutation>;
export type AddRequirementTagMutationResult = Apollo.MutationResult<Types.AddRequirementTagMutation>;
export type AddRequirementTagMutationOptions = Apollo.BaseMutationOptions<Types.AddRequirementTagMutation, Types.AddRequirementTagMutationVariables>;
export const AddRequirementTagsDocument = gql`
    mutation addRequirementTags($objects: [requirement_tag_insert_input!]!) {
  insert_requirement_tag(
    objects: $objects
    on_conflict: {constraint: requirement_tag_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddRequirementTagsMutationFn = Apollo.MutationFunction<Types.AddRequirementTagsMutation, Types.AddRequirementTagsMutationVariables>;

/**
 * __useAddRequirementTagsMutation__
 *
 * To run a mutation, you first call `useAddRequirementTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRequirementTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRequirementTagsMutation, { data, loading, error }] = useAddRequirementTagsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddRequirementTagsMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddRequirementTagsMutation, Types.AddRequirementTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddRequirementTagsMutation, Types.AddRequirementTagsMutationVariables>(AddRequirementTagsDocument, options);
      }
export type AddRequirementTagsMutationHookResult = ReturnType<typeof useAddRequirementTagsMutation>;
export type AddRequirementTagsMutationResult = Apollo.MutationResult<Types.AddRequirementTagsMutation>;
export type AddRequirementTagsMutationOptions = Apollo.BaseMutationOptions<Types.AddRequirementTagsMutation, Types.AddRequirementTagsMutationVariables>;
export const DeleteRequirementTagDocument = gql`
    mutation deleteRequirementTag($id: uuid!) {
  delete_requirement_tag(where: {requirement_tag_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteRequirementTagMutationFn = Apollo.MutationFunction<Types.DeleteRequirementTagMutation, Types.DeleteRequirementTagMutationVariables>;

/**
 * __useDeleteRequirementTagMutation__
 *
 * To run a mutation, you first call `useDeleteRequirementTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRequirementTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRequirementTagMutation, { data, loading, error }] = useDeleteRequirementTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRequirementTagMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteRequirementTagMutation, Types.DeleteRequirementTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteRequirementTagMutation, Types.DeleteRequirementTagMutationVariables>(DeleteRequirementTagDocument, options);
      }
export type DeleteRequirementTagMutationHookResult = ReturnType<typeof useDeleteRequirementTagMutation>;
export type DeleteRequirementTagMutationResult = Apollo.MutationResult<Types.DeleteRequirementTagMutation>;
export type DeleteRequirementTagMutationOptions = Apollo.BaseMutationOptions<Types.DeleteRequirementTagMutation, Types.DeleteRequirementTagMutationVariables>;
export const DeleteRequirementTagByTagAndRequirementDocument = gql`
    mutation deleteRequirementTagByTagAndRequirement($requirementId: uuid!, $tagId: uuid!) {
  delete_requirement_tag(
    where: {requirement_id: {_eq: $requirementId}, tag_id: {_eq: $tagId}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteRequirementTagByTagAndRequirementMutationFn = Apollo.MutationFunction<Types.DeleteRequirementTagByTagAndRequirementMutation, Types.DeleteRequirementTagByTagAndRequirementMutationVariables>;

/**
 * __useDeleteRequirementTagByTagAndRequirementMutation__
 *
 * To run a mutation, you first call `useDeleteRequirementTagByTagAndRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRequirementTagByTagAndRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRequirementTagByTagAndRequirementMutation, { data, loading, error }] = useDeleteRequirementTagByTagAndRequirementMutation({
 *   variables: {
 *      requirementId: // value for 'requirementId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useDeleteRequirementTagByTagAndRequirementMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteRequirementTagByTagAndRequirementMutation, Types.DeleteRequirementTagByTagAndRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteRequirementTagByTagAndRequirementMutation, Types.DeleteRequirementTagByTagAndRequirementMutationVariables>(DeleteRequirementTagByTagAndRequirementDocument, options);
      }
export type DeleteRequirementTagByTagAndRequirementMutationHookResult = ReturnType<typeof useDeleteRequirementTagByTagAndRequirementMutation>;
export type DeleteRequirementTagByTagAndRequirementMutationResult = Apollo.MutationResult<Types.DeleteRequirementTagByTagAndRequirementMutation>;
export type DeleteRequirementTagByTagAndRequirementMutationOptions = Apollo.BaseMutationOptions<Types.DeleteRequirementTagByTagAndRequirementMutation, Types.DeleteRequirementTagByTagAndRequirementMutationVariables>;
export const GetRequirementTagsDocument = gql`
    query getRequirementTags {
  requirement_tag {
    requirement_tag_id
    tag_id
    requirement_id
  }
}
    `;

/**
 * __useGetRequirementTagsQuery__
 *
 * To run a query within a React component, call `useGetRequirementTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequirementTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequirementTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRequirementTagsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetRequirementTagsQuery, Types.GetRequirementTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetRequirementTagsQuery, Types.GetRequirementTagsQueryVariables>(GetRequirementTagsDocument, options);
      }
export function useGetRequirementTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRequirementTagsQuery, Types.GetRequirementTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetRequirementTagsQuery, Types.GetRequirementTagsQueryVariables>(GetRequirementTagsDocument, options);
        }
// @ts-ignore
export function useGetRequirementTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetRequirementTagsQuery, Types.GetRequirementTagsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementTagsQuery, Types.GetRequirementTagsQueryVariables>;
export function useGetRequirementTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementTagsQuery, Types.GetRequirementTagsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetRequirementTagsQuery | undefined, Types.GetRequirementTagsQueryVariables>;
export function useGetRequirementTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRequirementTagsQuery, Types.GetRequirementTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetRequirementTagsQuery, Types.GetRequirementTagsQueryVariables>(GetRequirementTagsDocument, options);
        }
export type GetRequirementTagsQueryHookResult = ReturnType<typeof useGetRequirementTagsQuery>;
export type GetRequirementTagsLazyQueryHookResult = ReturnType<typeof useGetRequirementTagsLazyQuery>;
export type GetRequirementTagsSuspenseQueryHookResult = ReturnType<typeof useGetRequirementTagsSuspenseQuery>;
export type GetRequirementTagsQueryResult = Apollo.QueryResult<Types.GetRequirementTagsQuery, Types.GetRequirementTagsQueryVariables>;
export const AddResourceDocument = gql`
    mutation addResource($name: String!, $description: String, $url: String) {
  insert_resource(
    objects: [{name: $name, description: $description, url: $url}]
    on_conflict: {constraint: resource_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddResourceMutationFn = Apollo.MutationFunction<Types.AddResourceMutation, Types.AddResourceMutationVariables>;

/**
 * __useAddResourceMutation__
 *
 * To run a mutation, you first call `useAddResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addResourceMutation, { data, loading, error }] = useAddResourceMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useAddResourceMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddResourceMutation, Types.AddResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddResourceMutation, Types.AddResourceMutationVariables>(AddResourceDocument, options);
      }
export type AddResourceMutationHookResult = ReturnType<typeof useAddResourceMutation>;
export type AddResourceMutationResult = Apollo.MutationResult<Types.AddResourceMutation>;
export type AddResourceMutationOptions = Apollo.BaseMutationOptions<Types.AddResourceMutation, Types.AddResourceMutationVariables>;
export const UpdateResourceDocument = gql`
    mutation updateResource($id: uuid!, $resource: resource_set_input!) {
  update_resource(where: {resource_id: {_eq: $id}}, _set: $resource) {
    affected_rows
  }
}
    `;
export type UpdateResourceMutationFn = Apollo.MutationFunction<Types.UpdateResourceMutation, Types.UpdateResourceMutationVariables>;

/**
 * __useUpdateResourceMutation__
 *
 * To run a mutation, you first call `useUpdateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceMutation, { data, loading, error }] = useUpdateResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      resource: // value for 'resource'
 *   },
 * });
 */
export function useUpdateResourceMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateResourceMutation, Types.UpdateResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateResourceMutation, Types.UpdateResourceMutationVariables>(UpdateResourceDocument, options);
      }
export type UpdateResourceMutationHookResult = ReturnType<typeof useUpdateResourceMutation>;
export type UpdateResourceMutationResult = Apollo.MutationResult<Types.UpdateResourceMutation>;
export type UpdateResourceMutationOptions = Apollo.BaseMutationOptions<Types.UpdateResourceMutation, Types.UpdateResourceMutationVariables>;
export const DeleteResourceDocument = gql`
    mutation deleteResource($id: uuid!) {
  delete_resource(where: {resource_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteResourceMutationFn = Apollo.MutationFunction<Types.DeleteResourceMutation, Types.DeleteResourceMutationVariables>;

/**
 * __useDeleteResourceMutation__
 *
 * To run a mutation, you first call `useDeleteResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourceMutation, { data, loading, error }] = useDeleteResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteResourceMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteResourceMutation, Types.DeleteResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteResourceMutation, Types.DeleteResourceMutationVariables>(DeleteResourceDocument, options);
      }
export type DeleteResourceMutationHookResult = ReturnType<typeof useDeleteResourceMutation>;
export type DeleteResourceMutationResult = Apollo.MutationResult<Types.DeleteResourceMutation>;
export type DeleteResourceMutationOptions = Apollo.BaseMutationOptions<Types.DeleteResourceMutation, Types.DeleteResourceMutationVariables>;
export const GetResourcesDocument = gql`
    query getResources {
  resource {
    resource_id
    name
    description
    url
    tags {
      tag {
        tag_id
        name
        type
      }
    }
  }
}
    `;

/**
 * __useGetResourcesQuery__
 *
 * To run a query within a React component, call `useGetResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetResourcesQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetResourcesQuery, Types.GetResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetResourcesQuery, Types.GetResourcesQueryVariables>(GetResourcesDocument, options);
      }
export function useGetResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetResourcesQuery, Types.GetResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetResourcesQuery, Types.GetResourcesQueryVariables>(GetResourcesDocument, options);
        }
// @ts-ignore
export function useGetResourcesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetResourcesQuery, Types.GetResourcesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetResourcesQuery, Types.GetResourcesQueryVariables>;
export function useGetResourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetResourcesQuery, Types.GetResourcesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetResourcesQuery | undefined, Types.GetResourcesQueryVariables>;
export function useGetResourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetResourcesQuery, Types.GetResourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetResourcesQuery, Types.GetResourcesQueryVariables>(GetResourcesDocument, options);
        }
export type GetResourcesQueryHookResult = ReturnType<typeof useGetResourcesQuery>;
export type GetResourcesLazyQueryHookResult = ReturnType<typeof useGetResourcesLazyQuery>;
export type GetResourcesSuspenseQueryHookResult = ReturnType<typeof useGetResourcesSuspenseQuery>;
export type GetResourcesQueryResult = Apollo.QueryResult<Types.GetResourcesQuery, Types.GetResourcesQueryVariables>;
export const GetResourceByIdDocument = gql`
    query getResourceById($resourceId: uuid!) {
  resource_by_pk(resource_id: $resourceId) {
    resource_id
    name
    description
    url
    tags {
      tag {
        tag_id
        name
        type
      }
    }
  }
}
    `;

/**
 * __useGetResourceByIdQuery__
 *
 * To run a query within a React component, call `useGetResourceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceByIdQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useGetResourceByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetResourceByIdQuery, Types.GetResourceByIdQueryVariables> & ({ variables: Types.GetResourceByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetResourceByIdQuery, Types.GetResourceByIdQueryVariables>(GetResourceByIdDocument, options);
      }
export function useGetResourceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetResourceByIdQuery, Types.GetResourceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetResourceByIdQuery, Types.GetResourceByIdQueryVariables>(GetResourceByIdDocument, options);
        }
// @ts-ignore
export function useGetResourceByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetResourceByIdQuery, Types.GetResourceByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetResourceByIdQuery, Types.GetResourceByIdQueryVariables>;
export function useGetResourceByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetResourceByIdQuery, Types.GetResourceByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetResourceByIdQuery | undefined, Types.GetResourceByIdQueryVariables>;
export function useGetResourceByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetResourceByIdQuery, Types.GetResourceByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetResourceByIdQuery, Types.GetResourceByIdQueryVariables>(GetResourceByIdDocument, options);
        }
export type GetResourceByIdQueryHookResult = ReturnType<typeof useGetResourceByIdQuery>;
export type GetResourceByIdLazyQueryHookResult = ReturnType<typeof useGetResourceByIdLazyQuery>;
export type GetResourceByIdSuspenseQueryHookResult = ReturnType<typeof useGetResourceByIdSuspenseQuery>;
export type GetResourceByIdQueryResult = Apollo.QueryResult<Types.GetResourceByIdQuery, Types.GetResourceByIdQueryVariables>;
export const AddResourceTagDocument = gql`
    mutation addResourceTag($resourceId: uuid!, $tagId: uuid) {
  insert_resource_tag(
    objects: [{resource_id: $resourceId, tag_id: $tagId}]
    on_conflict: {constraint: resource_tag_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddResourceTagMutationFn = Apollo.MutationFunction<Types.AddResourceTagMutation, Types.AddResourceTagMutationVariables>;

/**
 * __useAddResourceTagMutation__
 *
 * To run a mutation, you first call `useAddResourceTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddResourceTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addResourceTagMutation, { data, loading, error }] = useAddResourceTagMutation({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useAddResourceTagMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddResourceTagMutation, Types.AddResourceTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddResourceTagMutation, Types.AddResourceTagMutationVariables>(AddResourceTagDocument, options);
      }
export type AddResourceTagMutationHookResult = ReturnType<typeof useAddResourceTagMutation>;
export type AddResourceTagMutationResult = Apollo.MutationResult<Types.AddResourceTagMutation>;
export type AddResourceTagMutationOptions = Apollo.BaseMutationOptions<Types.AddResourceTagMutation, Types.AddResourceTagMutationVariables>;
export const DeleteResourceTagDocument = gql`
    mutation deleteResourceTag($id: uuid!) {
  delete_resource_tag(where: {resource_tag_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteResourceTagMutationFn = Apollo.MutationFunction<Types.DeleteResourceTagMutation, Types.DeleteResourceTagMutationVariables>;

/**
 * __useDeleteResourceTagMutation__
 *
 * To run a mutation, you first call `useDeleteResourceTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourceTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourceTagMutation, { data, loading, error }] = useDeleteResourceTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteResourceTagMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteResourceTagMutation, Types.DeleteResourceTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteResourceTagMutation, Types.DeleteResourceTagMutationVariables>(DeleteResourceTagDocument, options);
      }
export type DeleteResourceTagMutationHookResult = ReturnType<typeof useDeleteResourceTagMutation>;
export type DeleteResourceTagMutationResult = Apollo.MutationResult<Types.DeleteResourceTagMutation>;
export type DeleteResourceTagMutationOptions = Apollo.BaseMutationOptions<Types.DeleteResourceTagMutation, Types.DeleteResourceTagMutationVariables>;
export const DeleteResourceTagByTagAndResourceDocument = gql`
    mutation deleteResourceTagByTagAndResource($resourceId: uuid!, $tagId: uuid!) {
  delete_resource_tag(
    where: {resource_id: {_eq: $resourceId}, tag_id: {_eq: $tagId}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteResourceTagByTagAndResourceMutationFn = Apollo.MutationFunction<Types.DeleteResourceTagByTagAndResourceMutation, Types.DeleteResourceTagByTagAndResourceMutationVariables>;

/**
 * __useDeleteResourceTagByTagAndResourceMutation__
 *
 * To run a mutation, you first call `useDeleteResourceTagByTagAndResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourceTagByTagAndResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourceTagByTagAndResourceMutation, { data, loading, error }] = useDeleteResourceTagByTagAndResourceMutation({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useDeleteResourceTagByTagAndResourceMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteResourceTagByTagAndResourceMutation, Types.DeleteResourceTagByTagAndResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteResourceTagByTagAndResourceMutation, Types.DeleteResourceTagByTagAndResourceMutationVariables>(DeleteResourceTagByTagAndResourceDocument, options);
      }
export type DeleteResourceTagByTagAndResourceMutationHookResult = ReturnType<typeof useDeleteResourceTagByTagAndResourceMutation>;
export type DeleteResourceTagByTagAndResourceMutationResult = Apollo.MutationResult<Types.DeleteResourceTagByTagAndResourceMutation>;
export type DeleteResourceTagByTagAndResourceMutationOptions = Apollo.BaseMutationOptions<Types.DeleteResourceTagByTagAndResourceMutation, Types.DeleteResourceTagByTagAndResourceMutationVariables>;
export const GetResourceTagsDocument = gql`
    query getResourceTags {
  resource_tag {
    resource_tag_id
    tag_id
    resource_id
  }
}
    `;

/**
 * __useGetResourceTagsQuery__
 *
 * To run a query within a React component, call `useGetResourceTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetResourceTagsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetResourceTagsQuery, Types.GetResourceTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetResourceTagsQuery, Types.GetResourceTagsQueryVariables>(GetResourceTagsDocument, options);
      }
export function useGetResourceTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetResourceTagsQuery, Types.GetResourceTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetResourceTagsQuery, Types.GetResourceTagsQueryVariables>(GetResourceTagsDocument, options);
        }
// @ts-ignore
export function useGetResourceTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetResourceTagsQuery, Types.GetResourceTagsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetResourceTagsQuery, Types.GetResourceTagsQueryVariables>;
export function useGetResourceTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetResourceTagsQuery, Types.GetResourceTagsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetResourceTagsQuery | undefined, Types.GetResourceTagsQueryVariables>;
export function useGetResourceTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetResourceTagsQuery, Types.GetResourceTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetResourceTagsQuery, Types.GetResourceTagsQueryVariables>(GetResourceTagsDocument, options);
        }
export type GetResourceTagsQueryHookResult = ReturnType<typeof useGetResourceTagsQuery>;
export type GetResourceTagsLazyQueryHookResult = ReturnType<typeof useGetResourceTagsLazyQuery>;
export type GetResourceTagsSuspenseQueryHookResult = ReturnType<typeof useGetResourceTagsSuspenseQuery>;
export type GetResourceTagsQueryResult = Apollo.QueryResult<Types.GetResourceTagsQuery, Types.GetResourceTagsQueryVariables>;
export const AddSiteDocument = gql`
    mutation addSite($name: String, $address: uuid!) {
  insert_site(
    objects: [{name: $name, address_id: $address}]
    on_conflict: {constraint: site_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddSiteMutationFn = Apollo.MutationFunction<Types.AddSiteMutation, Types.AddSiteMutationVariables>;

/**
 * __useAddSiteMutation__
 *
 * To run a mutation, you first call `useAddSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSiteMutation, { data, loading, error }] = useAddSiteMutation({
 *   variables: {
 *      name: // value for 'name'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useAddSiteMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddSiteMutation, Types.AddSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddSiteMutation, Types.AddSiteMutationVariables>(AddSiteDocument, options);
      }
export type AddSiteMutationHookResult = ReturnType<typeof useAddSiteMutation>;
export type AddSiteMutationResult = Apollo.MutationResult<Types.AddSiteMutation>;
export type AddSiteMutationOptions = Apollo.BaseMutationOptions<Types.AddSiteMutation, Types.AddSiteMutationVariables>;
export const UpdateSiteDocument = gql`
    mutation updateSite($id: uuid!, $site: site_set_input!) {
  update_site(where: {site_id: {_eq: $id}}, _set: $site) {
    affected_rows
  }
}
    `;
export type UpdateSiteMutationFn = Apollo.MutationFunction<Types.UpdateSiteMutation, Types.UpdateSiteMutationVariables>;

/**
 * __useUpdateSiteMutation__
 *
 * To run a mutation, you first call `useUpdateSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteMutation, { data, loading, error }] = useUpdateSiteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      site: // value for 'site'
 *   },
 * });
 */
export function useUpdateSiteMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSiteMutation, Types.UpdateSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSiteMutation, Types.UpdateSiteMutationVariables>(UpdateSiteDocument, options);
      }
export type UpdateSiteMutationHookResult = ReturnType<typeof useUpdateSiteMutation>;
export type UpdateSiteMutationResult = Apollo.MutationResult<Types.UpdateSiteMutation>;
export type UpdateSiteMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSiteMutation, Types.UpdateSiteMutationVariables>;
export const DeleteSiteDocument = gql`
    mutation deleteSite($id: uuid!) {
  delete_site(where: {site_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteSiteMutationFn = Apollo.MutationFunction<Types.DeleteSiteMutation, Types.DeleteSiteMutationVariables>;

/**
 * __useDeleteSiteMutation__
 *
 * To run a mutation, you first call `useDeleteSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSiteMutation, { data, loading, error }] = useDeleteSiteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSiteMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteSiteMutation, Types.DeleteSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteSiteMutation, Types.DeleteSiteMutationVariables>(DeleteSiteDocument, options);
      }
export type DeleteSiteMutationHookResult = ReturnType<typeof useDeleteSiteMutation>;
export type DeleteSiteMutationResult = Apollo.MutationResult<Types.DeleteSiteMutation>;
export type DeleteSiteMutationOptions = Apollo.BaseMutationOptions<Types.DeleteSiteMutation, Types.DeleteSiteMutationVariables>;
export const GetSitesDocument = gql`
    query getSites {
  site {
    site_id
    name
    address {
      address_id
      address_line_1
      address_line_2
      city
      state
      country
      zip_code
    }
  }
}
    `;

/**
 * __useGetSitesQuery__
 *
 * To run a query within a React component, call `useGetSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSitesQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetSitesQuery, Types.GetSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSitesQuery, Types.GetSitesQueryVariables>(GetSitesDocument, options);
      }
export function useGetSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSitesQuery, Types.GetSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSitesQuery, Types.GetSitesQueryVariables>(GetSitesDocument, options);
        }
// @ts-ignore
export function useGetSitesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetSitesQuery, Types.GetSitesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSitesQuery, Types.GetSitesQueryVariables>;
export function useGetSitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSitesQuery, Types.GetSitesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSitesQuery | undefined, Types.GetSitesQueryVariables>;
export function useGetSitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSitesQuery, Types.GetSitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetSitesQuery, Types.GetSitesQueryVariables>(GetSitesDocument, options);
        }
export type GetSitesQueryHookResult = ReturnType<typeof useGetSitesQuery>;
export type GetSitesLazyQueryHookResult = ReturnType<typeof useGetSitesLazyQuery>;
export type GetSitesSuspenseQueryHookResult = ReturnType<typeof useGetSitesSuspenseQuery>;
export type GetSitesQueryResult = Apollo.QueryResult<Types.GetSitesQuery, Types.GetSitesQueryVariables>;
export const GetSiteByIdDocument = gql`
    query getSiteById($siteId: uuid!) {
  site_by_pk(site_id: $siteId) {
    site_id
    name
    address {
      address_id
      address_line_1
      address_line_2
      city
      state
      country
      zip_code
    }
  }
}
    `;

/**
 * __useGetSiteByIdQuery__
 *
 * To run a query within a React component, call `useGetSiteByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteByIdQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetSiteByIdQuery, Types.GetSiteByIdQueryVariables> & ({ variables: Types.GetSiteByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSiteByIdQuery, Types.GetSiteByIdQueryVariables>(GetSiteByIdDocument, options);
      }
export function useGetSiteByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSiteByIdQuery, Types.GetSiteByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSiteByIdQuery, Types.GetSiteByIdQueryVariables>(GetSiteByIdDocument, options);
        }
// @ts-ignore
export function useGetSiteByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetSiteByIdQuery, Types.GetSiteByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSiteByIdQuery, Types.GetSiteByIdQueryVariables>;
export function useGetSiteByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSiteByIdQuery, Types.GetSiteByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSiteByIdQuery | undefined, Types.GetSiteByIdQueryVariables>;
export function useGetSiteByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSiteByIdQuery, Types.GetSiteByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetSiteByIdQuery, Types.GetSiteByIdQueryVariables>(GetSiteByIdDocument, options);
        }
export type GetSiteByIdQueryHookResult = ReturnType<typeof useGetSiteByIdQuery>;
export type GetSiteByIdLazyQueryHookResult = ReturnType<typeof useGetSiteByIdLazyQuery>;
export type GetSiteByIdSuspenseQueryHookResult = ReturnType<typeof useGetSiteByIdSuspenseQuery>;
export type GetSiteByIdQueryResult = Apollo.QueryResult<Types.GetSiteByIdQuery, Types.GetSiteByIdQueryVariables>;
export const AddSpeciesDocument = gql`
    mutation addSpecies($name: String!) {
  insert_species(
    objects: [{name: $name}]
    on_conflict: {constraint: species_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddSpeciesMutationFn = Apollo.MutationFunction<Types.AddSpeciesMutation, Types.AddSpeciesMutationVariables>;

/**
 * __useAddSpeciesMutation__
 *
 * To run a mutation, you first call `useAddSpeciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSpeciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSpeciesMutation, { data, loading, error }] = useAddSpeciesMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAddSpeciesMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddSpeciesMutation, Types.AddSpeciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddSpeciesMutation, Types.AddSpeciesMutationVariables>(AddSpeciesDocument, options);
      }
export type AddSpeciesMutationHookResult = ReturnType<typeof useAddSpeciesMutation>;
export type AddSpeciesMutationResult = Apollo.MutationResult<Types.AddSpeciesMutation>;
export type AddSpeciesMutationOptions = Apollo.BaseMutationOptions<Types.AddSpeciesMutation, Types.AddSpeciesMutationVariables>;
export const UpdateSpeciesDocument = gql`
    mutation updateSpecies($id: uuid!, $species: species_set_input!) {
  update_species(where: {species_id: {_eq: $id}}, _set: $species) {
    affected_rows
  }
}
    `;
export type UpdateSpeciesMutationFn = Apollo.MutationFunction<Types.UpdateSpeciesMutation, Types.UpdateSpeciesMutationVariables>;

/**
 * __useUpdateSpeciesMutation__
 *
 * To run a mutation, you first call `useUpdateSpeciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpeciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpeciesMutation, { data, loading, error }] = useUpdateSpeciesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      species: // value for 'species'
 *   },
 * });
 */
export function useUpdateSpeciesMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSpeciesMutation, Types.UpdateSpeciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSpeciesMutation, Types.UpdateSpeciesMutationVariables>(UpdateSpeciesDocument, options);
      }
export type UpdateSpeciesMutationHookResult = ReturnType<typeof useUpdateSpeciesMutation>;
export type UpdateSpeciesMutationResult = Apollo.MutationResult<Types.UpdateSpeciesMutation>;
export type UpdateSpeciesMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSpeciesMutation, Types.UpdateSpeciesMutationVariables>;
export const DeleteSpeciesDocument = gql`
    mutation deleteSpecies($id: uuid!) {
  delete_species(where: {species_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteSpeciesMutationFn = Apollo.MutationFunction<Types.DeleteSpeciesMutation, Types.DeleteSpeciesMutationVariables>;

/**
 * __useDeleteSpeciesMutation__
 *
 * To run a mutation, you first call `useDeleteSpeciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpeciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpeciesMutation, { data, loading, error }] = useDeleteSpeciesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSpeciesMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteSpeciesMutation, Types.DeleteSpeciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteSpeciesMutation, Types.DeleteSpeciesMutationVariables>(DeleteSpeciesDocument, options);
      }
export type DeleteSpeciesMutationHookResult = ReturnType<typeof useDeleteSpeciesMutation>;
export type DeleteSpeciesMutationResult = Apollo.MutationResult<Types.DeleteSpeciesMutation>;
export type DeleteSpeciesMutationOptions = Apollo.BaseMutationOptions<Types.DeleteSpeciesMutation, Types.DeleteSpeciesMutationVariables>;
export const GetSpeciesDocument = gql`
    query getSpecies {
  species {
    species_id
    name
  }
}
    `;

/**
 * __useGetSpeciesQuery__
 *
 * To run a query within a React component, call `useGetSpeciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpeciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpeciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSpeciesQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetSpeciesQuery, Types.GetSpeciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSpeciesQuery, Types.GetSpeciesQueryVariables>(GetSpeciesDocument, options);
      }
export function useGetSpeciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSpeciesQuery, Types.GetSpeciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSpeciesQuery, Types.GetSpeciesQueryVariables>(GetSpeciesDocument, options);
        }
// @ts-ignore
export function useGetSpeciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetSpeciesQuery, Types.GetSpeciesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSpeciesQuery, Types.GetSpeciesQueryVariables>;
export function useGetSpeciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSpeciesQuery, Types.GetSpeciesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSpeciesQuery | undefined, Types.GetSpeciesQueryVariables>;
export function useGetSpeciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSpeciesQuery, Types.GetSpeciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetSpeciesQuery, Types.GetSpeciesQueryVariables>(GetSpeciesDocument, options);
        }
export type GetSpeciesQueryHookResult = ReturnType<typeof useGetSpeciesQuery>;
export type GetSpeciesLazyQueryHookResult = ReturnType<typeof useGetSpeciesLazyQuery>;
export type GetSpeciesSuspenseQueryHookResult = ReturnType<typeof useGetSpeciesSuspenseQuery>;
export type GetSpeciesQueryResult = Apollo.QueryResult<Types.GetSpeciesQuery, Types.GetSpeciesQueryVariables>;
export const GetSpeciesByIdDocument = gql`
    query getSpeciesById($speciesId: uuid!) {
  species_by_pk(species_id: $speciesId) {
    species_id
    name
  }
}
    `;

/**
 * __useGetSpeciesByIdQuery__
 *
 * To run a query within a React component, call `useGetSpeciesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpeciesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpeciesByIdQuery({
 *   variables: {
 *      speciesId: // value for 'speciesId'
 *   },
 * });
 */
export function useGetSpeciesByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetSpeciesByIdQuery, Types.GetSpeciesByIdQueryVariables> & ({ variables: Types.GetSpeciesByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSpeciesByIdQuery, Types.GetSpeciesByIdQueryVariables>(GetSpeciesByIdDocument, options);
      }
export function useGetSpeciesByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSpeciesByIdQuery, Types.GetSpeciesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSpeciesByIdQuery, Types.GetSpeciesByIdQueryVariables>(GetSpeciesByIdDocument, options);
        }
// @ts-ignore
export function useGetSpeciesByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetSpeciesByIdQuery, Types.GetSpeciesByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSpeciesByIdQuery, Types.GetSpeciesByIdQueryVariables>;
export function useGetSpeciesByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSpeciesByIdQuery, Types.GetSpeciesByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSpeciesByIdQuery | undefined, Types.GetSpeciesByIdQueryVariables>;
export function useGetSpeciesByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSpeciesByIdQuery, Types.GetSpeciesByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetSpeciesByIdQuery, Types.GetSpeciesByIdQueryVariables>(GetSpeciesByIdDocument, options);
        }
export type GetSpeciesByIdQueryHookResult = ReturnType<typeof useGetSpeciesByIdQuery>;
export type GetSpeciesByIdLazyQueryHookResult = ReturnType<typeof useGetSpeciesByIdLazyQuery>;
export type GetSpeciesByIdSuspenseQueryHookResult = ReturnType<typeof useGetSpeciesByIdSuspenseQuery>;
export type GetSpeciesByIdQueryResult = Apollo.QueryResult<Types.GetSpeciesByIdQuery, Types.GetSpeciesByIdQueryVariables>;
export const AddSurveyDocument = gql`
    mutation addSurvey($name: String!, $orgId: uuid) {
  insert_survey(
    objects: [{name: $name, org_id: $orgId}]
    on_conflict: {constraint: survey_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      survey_id
    }
  }
}
    `;
export type AddSurveyMutationFn = Apollo.MutationFunction<Types.AddSurveyMutation, Types.AddSurveyMutationVariables>;

/**
 * __useAddSurveyMutation__
 *
 * To run a mutation, you first call `useAddSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSurveyMutation, { data, loading, error }] = useAddSurveyMutation({
 *   variables: {
 *      name: // value for 'name'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useAddSurveyMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddSurveyMutation, Types.AddSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddSurveyMutation, Types.AddSurveyMutationVariables>(AddSurveyDocument, options);
      }
export type AddSurveyMutationHookResult = ReturnType<typeof useAddSurveyMutation>;
export type AddSurveyMutationResult = Apollo.MutationResult<Types.AddSurveyMutation>;
export type AddSurveyMutationOptions = Apollo.BaseMutationOptions<Types.AddSurveyMutation, Types.AddSurveyMutationVariables>;
export const UpdateSurveyDocument = gql`
    mutation updateSurvey($id: uuid!, $survey: survey_set_input!) {
  update_survey(where: {survey_id: {_eq: $id}}, _set: $survey) {
    affected_rows
  }
}
    `;
export type UpdateSurveyMutationFn = Apollo.MutationFunction<Types.UpdateSurveyMutation, Types.UpdateSurveyMutationVariables>;

/**
 * __useUpdateSurveyMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyMutation, { data, loading, error }] = useUpdateSurveyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      survey: // value for 'survey'
 *   },
 * });
 */
export function useUpdateSurveyMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSurveyMutation, Types.UpdateSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSurveyMutation, Types.UpdateSurveyMutationVariables>(UpdateSurveyDocument, options);
      }
export type UpdateSurveyMutationHookResult = ReturnType<typeof useUpdateSurveyMutation>;
export type UpdateSurveyMutationResult = Apollo.MutationResult<Types.UpdateSurveyMutation>;
export type UpdateSurveyMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSurveyMutation, Types.UpdateSurveyMutationVariables>;
export const DeleteSurveyDocument = gql`
    mutation deleteSurvey($id: uuid!) {
  delete_survey(where: {survey_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteSurveyMutationFn = Apollo.MutationFunction<Types.DeleteSurveyMutation, Types.DeleteSurveyMutationVariables>;

/**
 * __useDeleteSurveyMutation__
 *
 * To run a mutation, you first call `useDeleteSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSurveyMutation, { data, loading, error }] = useDeleteSurveyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSurveyMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteSurveyMutation, Types.DeleteSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteSurveyMutation, Types.DeleteSurveyMutationVariables>(DeleteSurveyDocument, options);
      }
export type DeleteSurveyMutationHookResult = ReturnType<typeof useDeleteSurveyMutation>;
export type DeleteSurveyMutationResult = Apollo.MutationResult<Types.DeleteSurveyMutation>;
export type DeleteSurveyMutationOptions = Apollo.BaseMutationOptions<Types.DeleteSurveyMutation, Types.DeleteSurveyMutationVariables>;
export const GetSurveysDocument = gql`
    query getSurveys {
  survey {
    survey_id
    name
    org_id
    questions {
      survey_question_id
      question {
        question_id
        title
        type
        body
        order
        options {
          option_id
          order
          text
        }
      }
    }
  }
}
    `;

/**
 * __useGetSurveysQuery__
 *
 * To run a query within a React component, call `useGetSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSurveysQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetSurveysQuery, Types.GetSurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSurveysQuery, Types.GetSurveysQueryVariables>(GetSurveysDocument, options);
      }
export function useGetSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSurveysQuery, Types.GetSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSurveysQuery, Types.GetSurveysQueryVariables>(GetSurveysDocument, options);
        }
// @ts-ignore
export function useGetSurveysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetSurveysQuery, Types.GetSurveysQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSurveysQuery, Types.GetSurveysQueryVariables>;
export function useGetSurveysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSurveysQuery, Types.GetSurveysQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSurveysQuery | undefined, Types.GetSurveysQueryVariables>;
export function useGetSurveysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSurveysQuery, Types.GetSurveysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetSurveysQuery, Types.GetSurveysQueryVariables>(GetSurveysDocument, options);
        }
export type GetSurveysQueryHookResult = ReturnType<typeof useGetSurveysQuery>;
export type GetSurveysLazyQueryHookResult = ReturnType<typeof useGetSurveysLazyQuery>;
export type GetSurveysSuspenseQueryHookResult = ReturnType<typeof useGetSurveysSuspenseQuery>;
export type GetSurveysQueryResult = Apollo.QueryResult<Types.GetSurveysQuery, Types.GetSurveysQueryVariables>;
export const GetSurveyByIdDocument = gql`
    query getSurveyById($surveyId: uuid!) {
  survey_by_pk(survey_id: $surveyId) {
    survey_id
    name
    org_id
    questions {
      survey_question_id
      question {
        question_id
        title
        type
        body
        order
        options {
          option_id
          order
          text
        }
      }
    }
  }
}
    `;

/**
 * __useGetSurveyByIdQuery__
 *
 * To run a query within a React component, call `useGetSurveyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyByIdQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useGetSurveyByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetSurveyByIdQuery, Types.GetSurveyByIdQueryVariables> & ({ variables: Types.GetSurveyByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSurveyByIdQuery, Types.GetSurveyByIdQueryVariables>(GetSurveyByIdDocument, options);
      }
export function useGetSurveyByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSurveyByIdQuery, Types.GetSurveyByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSurveyByIdQuery, Types.GetSurveyByIdQueryVariables>(GetSurveyByIdDocument, options);
        }
// @ts-ignore
export function useGetSurveyByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetSurveyByIdQuery, Types.GetSurveyByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSurveyByIdQuery, Types.GetSurveyByIdQueryVariables>;
export function useGetSurveyByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSurveyByIdQuery, Types.GetSurveyByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSurveyByIdQuery | undefined, Types.GetSurveyByIdQueryVariables>;
export function useGetSurveyByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSurveyByIdQuery, Types.GetSurveyByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetSurveyByIdQuery, Types.GetSurveyByIdQueryVariables>(GetSurveyByIdDocument, options);
        }
export type GetSurveyByIdQueryHookResult = ReturnType<typeof useGetSurveyByIdQuery>;
export type GetSurveyByIdLazyQueryHookResult = ReturnType<typeof useGetSurveyByIdLazyQuery>;
export type GetSurveyByIdSuspenseQueryHookResult = ReturnType<typeof useGetSurveyByIdSuspenseQuery>;
export type GetSurveyByIdQueryResult = Apollo.QueryResult<Types.GetSurveyByIdQuery, Types.GetSurveyByIdQueryVariables>;
export const GetSurveysByOrgIdDocument = gql`
    query getSurveysByOrgId($orgId: uuid!) {
  survey(where: {org_id: {_eq: $orgId}}) {
    survey_id
    name
    org_id
    questions {
      survey_question_id
      question {
        question_id
        title
        type
        body
        order
        options {
          option_id
          order
          text
        }
      }
    }
  }
}
    `;

/**
 * __useGetSurveysByOrgIdQuery__
 *
 * To run a query within a React component, call `useGetSurveysByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveysByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveysByOrgIdQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetSurveysByOrgIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetSurveysByOrgIdQuery, Types.GetSurveysByOrgIdQueryVariables> & ({ variables: Types.GetSurveysByOrgIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSurveysByOrgIdQuery, Types.GetSurveysByOrgIdQueryVariables>(GetSurveysByOrgIdDocument, options);
      }
export function useGetSurveysByOrgIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSurveysByOrgIdQuery, Types.GetSurveysByOrgIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSurveysByOrgIdQuery, Types.GetSurveysByOrgIdQueryVariables>(GetSurveysByOrgIdDocument, options);
        }
// @ts-ignore
export function useGetSurveysByOrgIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetSurveysByOrgIdQuery, Types.GetSurveysByOrgIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSurveysByOrgIdQuery, Types.GetSurveysByOrgIdQueryVariables>;
export function useGetSurveysByOrgIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSurveysByOrgIdQuery, Types.GetSurveysByOrgIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSurveysByOrgIdQuery | undefined, Types.GetSurveysByOrgIdQueryVariables>;
export function useGetSurveysByOrgIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSurveysByOrgIdQuery, Types.GetSurveysByOrgIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetSurveysByOrgIdQuery, Types.GetSurveysByOrgIdQueryVariables>(GetSurveysByOrgIdDocument, options);
        }
export type GetSurveysByOrgIdQueryHookResult = ReturnType<typeof useGetSurveysByOrgIdQuery>;
export type GetSurveysByOrgIdLazyQueryHookResult = ReturnType<typeof useGetSurveysByOrgIdLazyQuery>;
export type GetSurveysByOrgIdSuspenseQueryHookResult = ReturnType<typeof useGetSurveysByOrgIdSuspenseQuery>;
export type GetSurveysByOrgIdQueryResult = Apollo.QueryResult<Types.GetSurveysByOrgIdQuery, Types.GetSurveysByOrgIdQueryVariables>;
export const GetSurveysWithNoOrgDocument = gql`
    query getSurveysWithNoOrg {
  survey(where: {org_id: {_is_null: true}}) {
    survey_id
    name
    org_id
    questions {
      survey_question_id
      question {
        question_id
        title
        type
        body
        order
        options {
          option_id
          order
          text
        }
      }
    }
  }
}
    `;

/**
 * __useGetSurveysWithNoOrgQuery__
 *
 * To run a query within a React component, call `useGetSurveysWithNoOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveysWithNoOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveysWithNoOrgQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSurveysWithNoOrgQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetSurveysWithNoOrgQuery, Types.GetSurveysWithNoOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSurveysWithNoOrgQuery, Types.GetSurveysWithNoOrgQueryVariables>(GetSurveysWithNoOrgDocument, options);
      }
export function useGetSurveysWithNoOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSurveysWithNoOrgQuery, Types.GetSurveysWithNoOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSurveysWithNoOrgQuery, Types.GetSurveysWithNoOrgQueryVariables>(GetSurveysWithNoOrgDocument, options);
        }
// @ts-ignore
export function useGetSurveysWithNoOrgSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetSurveysWithNoOrgQuery, Types.GetSurveysWithNoOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSurveysWithNoOrgQuery, Types.GetSurveysWithNoOrgQueryVariables>;
export function useGetSurveysWithNoOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSurveysWithNoOrgQuery, Types.GetSurveysWithNoOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSurveysWithNoOrgQuery | undefined, Types.GetSurveysWithNoOrgQueryVariables>;
export function useGetSurveysWithNoOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSurveysWithNoOrgQuery, Types.GetSurveysWithNoOrgQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetSurveysWithNoOrgQuery, Types.GetSurveysWithNoOrgQueryVariables>(GetSurveysWithNoOrgDocument, options);
        }
export type GetSurveysWithNoOrgQueryHookResult = ReturnType<typeof useGetSurveysWithNoOrgQuery>;
export type GetSurveysWithNoOrgLazyQueryHookResult = ReturnType<typeof useGetSurveysWithNoOrgLazyQuery>;
export type GetSurveysWithNoOrgSuspenseQueryHookResult = ReturnType<typeof useGetSurveysWithNoOrgSuspenseQuery>;
export type GetSurveysWithNoOrgQueryResult = Apollo.QueryResult<Types.GetSurveysWithNoOrgQuery, Types.GetSurveysWithNoOrgQueryVariables>;
export const AddSurveyQuestionDocument = gql`
    mutation addSurveyQuestion($questionId: uuid!, $surveyId: uuid!) {
  insert_survey_question(
    objects: [{question_id: $questionId, survey_id: $surveyId}]
    on_conflict: {constraint: survey_question_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      survey_question_id
    }
  }
}
    `;
export type AddSurveyQuestionMutationFn = Apollo.MutationFunction<Types.AddSurveyQuestionMutation, Types.AddSurveyQuestionMutationVariables>;

/**
 * __useAddSurveyQuestionMutation__
 *
 * To run a mutation, you first call `useAddSurveyQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSurveyQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSurveyQuestionMutation, { data, loading, error }] = useAddSurveyQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useAddSurveyQuestionMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddSurveyQuestionMutation, Types.AddSurveyQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddSurveyQuestionMutation, Types.AddSurveyQuestionMutationVariables>(AddSurveyQuestionDocument, options);
      }
export type AddSurveyQuestionMutationHookResult = ReturnType<typeof useAddSurveyQuestionMutation>;
export type AddSurveyQuestionMutationResult = Apollo.MutationResult<Types.AddSurveyQuestionMutation>;
export type AddSurveyQuestionMutationOptions = Apollo.BaseMutationOptions<Types.AddSurveyQuestionMutation, Types.AddSurveyQuestionMutationVariables>;
export const UpdateSurveyQuestionDocument = gql`
    mutation updateSurveyQuestion($id: uuid!, $surveyQuestion: survey_question_set_input!) {
  update_survey_question(
    where: {survey_question_id: {_eq: $id}}
    _set: $surveyQuestion
  ) {
    affected_rows
  }
}
    `;
export type UpdateSurveyQuestionMutationFn = Apollo.MutationFunction<Types.UpdateSurveyQuestionMutation, Types.UpdateSurveyQuestionMutationVariables>;

/**
 * __useUpdateSurveyQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyQuestionMutation, { data, loading, error }] = useUpdateSurveyQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      surveyQuestion: // value for 'surveyQuestion'
 *   },
 * });
 */
export function useUpdateSurveyQuestionMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSurveyQuestionMutation, Types.UpdateSurveyQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSurveyQuestionMutation, Types.UpdateSurveyQuestionMutationVariables>(UpdateSurveyQuestionDocument, options);
      }
export type UpdateSurveyQuestionMutationHookResult = ReturnType<typeof useUpdateSurveyQuestionMutation>;
export type UpdateSurveyQuestionMutationResult = Apollo.MutationResult<Types.UpdateSurveyQuestionMutation>;
export type UpdateSurveyQuestionMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSurveyQuestionMutation, Types.UpdateSurveyQuestionMutationVariables>;
export const DeleteSurveyQuestionDocument = gql`
    mutation deleteSurveyQuestion($id: uuid!) {
  delete_survey_question(where: {survey_question_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteSurveyQuestionMutationFn = Apollo.MutationFunction<Types.DeleteSurveyQuestionMutation, Types.DeleteSurveyQuestionMutationVariables>;

/**
 * __useDeleteSurveyQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteSurveyQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSurveyQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSurveyQuestionMutation, { data, loading, error }] = useDeleteSurveyQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSurveyQuestionMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteSurveyQuestionMutation, Types.DeleteSurveyQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteSurveyQuestionMutation, Types.DeleteSurveyQuestionMutationVariables>(DeleteSurveyQuestionDocument, options);
      }
export type DeleteSurveyQuestionMutationHookResult = ReturnType<typeof useDeleteSurveyQuestionMutation>;
export type DeleteSurveyQuestionMutationResult = Apollo.MutationResult<Types.DeleteSurveyQuestionMutation>;
export type DeleteSurveyQuestionMutationOptions = Apollo.BaseMutationOptions<Types.DeleteSurveyQuestionMutation, Types.DeleteSurveyQuestionMutationVariables>;
export const GetSurveyQuestionsDocument = gql`
    query getSurveyQuestions {
  survey_question {
    survey_question_id
    question_id
    survey_id
    question {
      question_id
      title
      type
      body
      order
      options {
        option_id
        order
        text
      }
    }
    survey {
      survey_id
      name
      org_id
    }
  }
}
    `;

/**
 * __useGetSurveyQuestionsQuery__
 *
 * To run a query within a React component, call `useGetSurveyQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyQuestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSurveyQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetSurveyQuestionsQuery, Types.GetSurveyQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSurveyQuestionsQuery, Types.GetSurveyQuestionsQueryVariables>(GetSurveyQuestionsDocument, options);
      }
export function useGetSurveyQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSurveyQuestionsQuery, Types.GetSurveyQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSurveyQuestionsQuery, Types.GetSurveyQuestionsQueryVariables>(GetSurveyQuestionsDocument, options);
        }
// @ts-ignore
export function useGetSurveyQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetSurveyQuestionsQuery, Types.GetSurveyQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSurveyQuestionsQuery, Types.GetSurveyQuestionsQueryVariables>;
export function useGetSurveyQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSurveyQuestionsQuery, Types.GetSurveyQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSurveyQuestionsQuery | undefined, Types.GetSurveyQuestionsQueryVariables>;
export function useGetSurveyQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSurveyQuestionsQuery, Types.GetSurveyQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetSurveyQuestionsQuery, Types.GetSurveyQuestionsQueryVariables>(GetSurveyQuestionsDocument, options);
        }
export type GetSurveyQuestionsQueryHookResult = ReturnType<typeof useGetSurveyQuestionsQuery>;
export type GetSurveyQuestionsLazyQueryHookResult = ReturnType<typeof useGetSurveyQuestionsLazyQuery>;
export type GetSurveyQuestionsSuspenseQueryHookResult = ReturnType<typeof useGetSurveyQuestionsSuspenseQuery>;
export type GetSurveyQuestionsQueryResult = Apollo.QueryResult<Types.GetSurveyQuestionsQuery, Types.GetSurveyQuestionsQueryVariables>;
export const GetSurveyQuestionByIdDocument = gql`
    query getSurveyQuestionById($surveyQuestionId: uuid!) {
  survey_question_by_pk(survey_question_id: $surveyQuestionId) {
    survey_question_id
    question_id
    survey_id
    question {
      question_id
      title
      type
      body
      order
      options {
        option_id
        order
        text
      }
    }
    survey {
      survey_id
      name
      org_id
    }
  }
}
    `;

/**
 * __useGetSurveyQuestionByIdQuery__
 *
 * To run a query within a React component, call `useGetSurveyQuestionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyQuestionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyQuestionByIdQuery({
 *   variables: {
 *      surveyQuestionId: // value for 'surveyQuestionId'
 *   },
 * });
 */
export function useGetSurveyQuestionByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetSurveyQuestionByIdQuery, Types.GetSurveyQuestionByIdQueryVariables> & ({ variables: Types.GetSurveyQuestionByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSurveyQuestionByIdQuery, Types.GetSurveyQuestionByIdQueryVariables>(GetSurveyQuestionByIdDocument, options);
      }
export function useGetSurveyQuestionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSurveyQuestionByIdQuery, Types.GetSurveyQuestionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSurveyQuestionByIdQuery, Types.GetSurveyQuestionByIdQueryVariables>(GetSurveyQuestionByIdDocument, options);
        }
// @ts-ignore
export function useGetSurveyQuestionByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetSurveyQuestionByIdQuery, Types.GetSurveyQuestionByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSurveyQuestionByIdQuery, Types.GetSurveyQuestionByIdQueryVariables>;
export function useGetSurveyQuestionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSurveyQuestionByIdQuery, Types.GetSurveyQuestionByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSurveyQuestionByIdQuery | undefined, Types.GetSurveyQuestionByIdQueryVariables>;
export function useGetSurveyQuestionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSurveyQuestionByIdQuery, Types.GetSurveyQuestionByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetSurveyQuestionByIdQuery, Types.GetSurveyQuestionByIdQueryVariables>(GetSurveyQuestionByIdDocument, options);
        }
export type GetSurveyQuestionByIdQueryHookResult = ReturnType<typeof useGetSurveyQuestionByIdQuery>;
export type GetSurveyQuestionByIdLazyQueryHookResult = ReturnType<typeof useGetSurveyQuestionByIdLazyQuery>;
export type GetSurveyQuestionByIdSuspenseQueryHookResult = ReturnType<typeof useGetSurveyQuestionByIdSuspenseQuery>;
export type GetSurveyQuestionByIdQueryResult = Apollo.QueryResult<Types.GetSurveyQuestionByIdQuery, Types.GetSurveyQuestionByIdQueryVariables>;
export const GetSurveyQuestionsBySurveyIdDocument = gql`
    query getSurveyQuestionsBySurveyId($surveyId: uuid!) {
  survey_question(where: {survey_id: {_eq: $surveyId}}) {
    survey_question_id
    question_id
    survey_id
    question {
      question_id
      title
      type
      body
      order
      options {
        option_id
        order
        text
      }
    }
    survey {
      survey_id
      name
      org_id
    }
  }
}
    `;

/**
 * __useGetSurveyQuestionsBySurveyIdQuery__
 *
 * To run a query within a React component, call `useGetSurveyQuestionsBySurveyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyQuestionsBySurveyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyQuestionsBySurveyIdQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useGetSurveyQuestionsBySurveyIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetSurveyQuestionsBySurveyIdQuery, Types.GetSurveyQuestionsBySurveyIdQueryVariables> & ({ variables: Types.GetSurveyQuestionsBySurveyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSurveyQuestionsBySurveyIdQuery, Types.GetSurveyQuestionsBySurveyIdQueryVariables>(GetSurveyQuestionsBySurveyIdDocument, options);
      }
export function useGetSurveyQuestionsBySurveyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSurveyQuestionsBySurveyIdQuery, Types.GetSurveyQuestionsBySurveyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSurveyQuestionsBySurveyIdQuery, Types.GetSurveyQuestionsBySurveyIdQueryVariables>(GetSurveyQuestionsBySurveyIdDocument, options);
        }
// @ts-ignore
export function useGetSurveyQuestionsBySurveyIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetSurveyQuestionsBySurveyIdQuery, Types.GetSurveyQuestionsBySurveyIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSurveyQuestionsBySurveyIdQuery, Types.GetSurveyQuestionsBySurveyIdQueryVariables>;
export function useGetSurveyQuestionsBySurveyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSurveyQuestionsBySurveyIdQuery, Types.GetSurveyQuestionsBySurveyIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSurveyQuestionsBySurveyIdQuery | undefined, Types.GetSurveyQuestionsBySurveyIdQueryVariables>;
export function useGetSurveyQuestionsBySurveyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSurveyQuestionsBySurveyIdQuery, Types.GetSurveyQuestionsBySurveyIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetSurveyQuestionsBySurveyIdQuery, Types.GetSurveyQuestionsBySurveyIdQueryVariables>(GetSurveyQuestionsBySurveyIdDocument, options);
        }
export type GetSurveyQuestionsBySurveyIdQueryHookResult = ReturnType<typeof useGetSurveyQuestionsBySurveyIdQuery>;
export type GetSurveyQuestionsBySurveyIdLazyQueryHookResult = ReturnType<typeof useGetSurveyQuestionsBySurveyIdLazyQuery>;
export type GetSurveyQuestionsBySurveyIdSuspenseQueryHookResult = ReturnType<typeof useGetSurveyQuestionsBySurveyIdSuspenseQuery>;
export type GetSurveyQuestionsBySurveyIdQueryResult = Apollo.QueryResult<Types.GetSurveyQuestionsBySurveyIdQuery, Types.GetSurveyQuestionsBySurveyIdQueryVariables>;
export const GetSurveyQuestionsByQuestionIdDocument = gql`
    query getSurveyQuestionsByQuestionId($questionId: uuid!) {
  survey_question(where: {question_id: {_eq: $questionId}}) {
    survey_question_id
    question_id
    survey_id
    question {
      question_id
      title
      type
      body
      order
      options {
        option_id
        order
        text
      }
    }
    survey {
      survey_id
      name
      org_id
    }
  }
}
    `;

/**
 * __useGetSurveyQuestionsByQuestionIdQuery__
 *
 * To run a query within a React component, call `useGetSurveyQuestionsByQuestionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyQuestionsByQuestionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyQuestionsByQuestionIdQuery({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useGetSurveyQuestionsByQuestionIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetSurveyQuestionsByQuestionIdQuery, Types.GetSurveyQuestionsByQuestionIdQueryVariables> & ({ variables: Types.GetSurveyQuestionsByQuestionIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSurveyQuestionsByQuestionIdQuery, Types.GetSurveyQuestionsByQuestionIdQueryVariables>(GetSurveyQuestionsByQuestionIdDocument, options);
      }
export function useGetSurveyQuestionsByQuestionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSurveyQuestionsByQuestionIdQuery, Types.GetSurveyQuestionsByQuestionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSurveyQuestionsByQuestionIdQuery, Types.GetSurveyQuestionsByQuestionIdQueryVariables>(GetSurveyQuestionsByQuestionIdDocument, options);
        }
// @ts-ignore
export function useGetSurveyQuestionsByQuestionIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetSurveyQuestionsByQuestionIdQuery, Types.GetSurveyQuestionsByQuestionIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSurveyQuestionsByQuestionIdQuery, Types.GetSurveyQuestionsByQuestionIdQueryVariables>;
export function useGetSurveyQuestionsByQuestionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSurveyQuestionsByQuestionIdQuery, Types.GetSurveyQuestionsByQuestionIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetSurveyQuestionsByQuestionIdQuery | undefined, Types.GetSurveyQuestionsByQuestionIdQueryVariables>;
export function useGetSurveyQuestionsByQuestionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetSurveyQuestionsByQuestionIdQuery, Types.GetSurveyQuestionsByQuestionIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetSurveyQuestionsByQuestionIdQuery, Types.GetSurveyQuestionsByQuestionIdQueryVariables>(GetSurveyQuestionsByQuestionIdDocument, options);
        }
export type GetSurveyQuestionsByQuestionIdQueryHookResult = ReturnType<typeof useGetSurveyQuestionsByQuestionIdQuery>;
export type GetSurveyQuestionsByQuestionIdLazyQueryHookResult = ReturnType<typeof useGetSurveyQuestionsByQuestionIdLazyQuery>;
export type GetSurveyQuestionsByQuestionIdSuspenseQueryHookResult = ReturnType<typeof useGetSurveyQuestionsByQuestionIdSuspenseQuery>;
export type GetSurveyQuestionsByQuestionIdQueryResult = Apollo.QueryResult<Types.GetSurveyQuestionsByQuestionIdQuery, Types.GetSurveyQuestionsByQuestionIdQueryVariables>;
export const AddTagDocument = gql`
    mutation addTag($name: String!, $type: String) {
  insert_tag(
    objects: [{name: $name, type: $type}]
    on_conflict: {constraint: tag_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      tag_id
      name
      type
    }
  }
}
    `;
export type AddTagMutationFn = Apollo.MutationFunction<Types.AddTagMutation, Types.AddTagMutationVariables>;

/**
 * __useAddTagMutation__
 *
 * To run a mutation, you first call `useAddTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagMutation, { data, loading, error }] = useAddTagMutation({
 *   variables: {
 *      name: // value for 'name'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAddTagMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddTagMutation, Types.AddTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddTagMutation, Types.AddTagMutationVariables>(AddTagDocument, options);
      }
export type AddTagMutationHookResult = ReturnType<typeof useAddTagMutation>;
export type AddTagMutationResult = Apollo.MutationResult<Types.AddTagMutation>;
export type AddTagMutationOptions = Apollo.BaseMutationOptions<Types.AddTagMutation, Types.AddTagMutationVariables>;
export const UpdateTagDocument = gql`
    mutation updateTag($id: uuid!, $tag: tag_set_input!) {
  update_tag(where: {tag_id: {_eq: $id}}, _set: $tag) {
    affected_rows
  }
}
    `;
export type UpdateTagMutationFn = Apollo.MutationFunction<Types.UpdateTagMutation, Types.UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateTagMutation, Types.UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateTagMutation, Types.UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<Types.UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<Types.UpdateTagMutation, Types.UpdateTagMutationVariables>;
export const DeleteTagDocument = gql`
    mutation deleteTag($id: uuid!) {
  delete_tag(where: {tag_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteTagMutationFn = Apollo.MutationFunction<Types.DeleteTagMutation, Types.DeleteTagMutationVariables>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteTagMutation, Types.DeleteTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteTagMutation, Types.DeleteTagMutationVariables>(DeleteTagDocument, options);
      }
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = Apollo.MutationResult<Types.DeleteTagMutation>;
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<Types.DeleteTagMutation, Types.DeleteTagMutationVariables>;
export const GetTagsDocument = gql`
    query getTags {
  tag {
    tag_id
    name
    type
  }
}
    `;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetTagsQuery, Types.GetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetTagsQuery, Types.GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTagsQuery, Types.GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetTagsQuery, Types.GetTagsQueryVariables>(GetTagsDocument, options);
        }
// @ts-ignore
export function useGetTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetTagsQuery, Types.GetTagsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetTagsQuery, Types.GetTagsQueryVariables>;
export function useGetTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetTagsQuery, Types.GetTagsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetTagsQuery | undefined, Types.GetTagsQueryVariables>;
export function useGetTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetTagsQuery, Types.GetTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetTagsQuery, Types.GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsSuspenseQueryHookResult = ReturnType<typeof useGetTagsSuspenseQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<Types.GetTagsQuery, Types.GetTagsQueryVariables>;
export const GetTagByIdDocument = gql`
    query getTagById($tagId: uuid!) {
  tag_by_pk(tag_id: $tagId) {
    tag_id
    name
    type
  }
}
    `;

/**
 * __useGetTagByIdQuery__
 *
 * To run a query within a React component, call `useGetTagByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagByIdQuery({
 *   variables: {
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useGetTagByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetTagByIdQuery, Types.GetTagByIdQueryVariables> & ({ variables: Types.GetTagByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetTagByIdQuery, Types.GetTagByIdQueryVariables>(GetTagByIdDocument, options);
      }
export function useGetTagByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTagByIdQuery, Types.GetTagByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetTagByIdQuery, Types.GetTagByIdQueryVariables>(GetTagByIdDocument, options);
        }
// @ts-ignore
export function useGetTagByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetTagByIdQuery, Types.GetTagByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetTagByIdQuery, Types.GetTagByIdQueryVariables>;
export function useGetTagByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetTagByIdQuery, Types.GetTagByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetTagByIdQuery | undefined, Types.GetTagByIdQueryVariables>;
export function useGetTagByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetTagByIdQuery, Types.GetTagByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetTagByIdQuery, Types.GetTagByIdQueryVariables>(GetTagByIdDocument, options);
        }
export type GetTagByIdQueryHookResult = ReturnType<typeof useGetTagByIdQuery>;
export type GetTagByIdLazyQueryHookResult = ReturnType<typeof useGetTagByIdLazyQuery>;
export type GetTagByIdSuspenseQueryHookResult = ReturnType<typeof useGetTagByIdSuspenseQuery>;
export type GetTagByIdQueryResult = Apollo.QueryResult<Types.GetTagByIdQuery, Types.GetTagByIdQueryVariables>;
export const GetTagsByTypeDocument = gql`
    query getTagsByType($type: String!) {
  tag(where: {type: {_eq: $type}}) {
    tag_id
    name
    type
  }
}
    `;

/**
 * __useGetTagsByTypeQuery__
 *
 * To run a query within a React component, call `useGetTagsByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsByTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetTagsByTypeQuery(baseOptions: Apollo.QueryHookOptions<Types.GetTagsByTypeQuery, Types.GetTagsByTypeQueryVariables> & ({ variables: Types.GetTagsByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetTagsByTypeQuery, Types.GetTagsByTypeQueryVariables>(GetTagsByTypeDocument, options);
      }
export function useGetTagsByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTagsByTypeQuery, Types.GetTagsByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetTagsByTypeQuery, Types.GetTagsByTypeQueryVariables>(GetTagsByTypeDocument, options);
        }
// @ts-ignore
export function useGetTagsByTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetTagsByTypeQuery, Types.GetTagsByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetTagsByTypeQuery, Types.GetTagsByTypeQueryVariables>;
export function useGetTagsByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetTagsByTypeQuery, Types.GetTagsByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetTagsByTypeQuery | undefined, Types.GetTagsByTypeQueryVariables>;
export function useGetTagsByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetTagsByTypeQuery, Types.GetTagsByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetTagsByTypeQuery, Types.GetTagsByTypeQueryVariables>(GetTagsByTypeDocument, options);
        }
export type GetTagsByTypeQueryHookResult = ReturnType<typeof useGetTagsByTypeQuery>;
export type GetTagsByTypeLazyQueryHookResult = ReturnType<typeof useGetTagsByTypeLazyQuery>;
export type GetTagsByTypeSuspenseQueryHookResult = ReturnType<typeof useGetTagsByTypeSuspenseQuery>;
export type GetTagsByTypeQueryResult = Apollo.QueryResult<Types.GetTagsByTypeQuery, Types.GetTagsByTypeQueryVariables>;
export const AddUserDocument = gql`
    mutation addUser($user_id: uuid, $email: String!, $name: String!, $role: String!, $picture_url: String, $org_id: uuid) {
  insert_user(
    objects: [{user_id: $user_id, email: $email, name: $name, role: $role, picture_url: $picture_url, org_id: $org_id}]
    on_conflict: {constraint: user_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddUserMutationFn = Apollo.MutationFunction<Types.AddUserMutation, Types.AddUserMutationVariables>;

/**
 * __useAddUserMutation__
 *
 * To run a mutation, you first call `useAddUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserMutation, { data, loading, error }] = useAddUserMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      role: // value for 'role'
 *      picture_url: // value for 'picture_url'
 *      org_id: // value for 'org_id'
 *   },
 * });
 */
export function useAddUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddUserMutation, Types.AddUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddUserMutation, Types.AddUserMutationVariables>(AddUserDocument, options);
      }
export type AddUserMutationHookResult = ReturnType<typeof useAddUserMutation>;
export type AddUserMutationResult = Apollo.MutationResult<Types.AddUserMutation>;
export type AddUserMutationOptions = Apollo.BaseMutationOptions<Types.AddUserMutation, Types.AddUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($id: uuid!, $user: user_set_input!) {
  update_user(where: {user_id: {_eq: $id}}, _set: $user) {
    affected_rows
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<Types.UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($id: uuid!) {
  delete_user(where: {user_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<Types.DeleteUserMutation, Types.DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteUserMutation, Types.DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteUserMutation, Types.DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<Types.DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<Types.DeleteUserMutation, Types.DeleteUserMutationVariables>;
export const GetUsersDocument = gql`
    query getUsers {
  organizations: organization {
    org_id
    name
    type
  }
  user {
    user_id
    email
    role
    name
    accepted_terms_of_use
    updated_at
    created_at
    picture_url
    org_id
    organization {
      organization {
        name
        org_id
        type
      }
    }
    tags {
      tag {
        tag_id
        name
        type
      }
    }
    equipped_store_items(where: {item_type: {_eq: "PET"}}) {
      item_type
      store_item {
        store_item_id
        name
        slug
        type
        rarity
        asset_key
      }
    }
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetUsersQuery, Types.GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetUsersQuery, Types.GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUsersQuery, Types.GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetUsersQuery, Types.GetUsersQueryVariables>(GetUsersDocument, options);
        }
// @ts-ignore
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetUsersQuery, Types.GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUsersQuery, Types.GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUsersQuery, Types.GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUsersQuery | undefined, Types.GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUsersQuery, Types.GetUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetUsersQuery, Types.GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<Types.GetUsersQuery, Types.GetUsersQueryVariables>;
export const GetUserByRoleDocument = gql`
    query getUserByRole($role: String!) {
  user(where: {role: {_eq: $role}}) {
    user_id
    email
    role
    name
    accepted_terms_of_use
    updated_at
    created_at
    picture_url
  }
}
    `;

/**
 * __useGetUserByRoleQuery__
 *
 * To run a query within a React component, call `useGetUserByRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByRoleQuery({
 *   variables: {
 *      role: // value for 'role'
 *   },
 * });
 */
export function useGetUserByRoleQuery(baseOptions: Apollo.QueryHookOptions<Types.GetUserByRoleQuery, Types.GetUserByRoleQueryVariables> & ({ variables: Types.GetUserByRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetUserByRoleQuery, Types.GetUserByRoleQueryVariables>(GetUserByRoleDocument, options);
      }
export function useGetUserByRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUserByRoleQuery, Types.GetUserByRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetUserByRoleQuery, Types.GetUserByRoleQueryVariables>(GetUserByRoleDocument, options);
        }
// @ts-ignore
export function useGetUserByRoleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetUserByRoleQuery, Types.GetUserByRoleQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUserByRoleQuery, Types.GetUserByRoleQueryVariables>;
export function useGetUserByRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUserByRoleQuery, Types.GetUserByRoleQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUserByRoleQuery | undefined, Types.GetUserByRoleQueryVariables>;
export function useGetUserByRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUserByRoleQuery, Types.GetUserByRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetUserByRoleQuery, Types.GetUserByRoleQueryVariables>(GetUserByRoleDocument, options);
        }
export type GetUserByRoleQueryHookResult = ReturnType<typeof useGetUserByRoleQuery>;
export type GetUserByRoleLazyQueryHookResult = ReturnType<typeof useGetUserByRoleLazyQuery>;
export type GetUserByRoleSuspenseQueryHookResult = ReturnType<typeof useGetUserByRoleSuspenseQuery>;
export type GetUserByRoleQueryResult = Apollo.QueryResult<Types.GetUserByRoleQuery, Types.GetUserByRoleQueryVariables>;
export const GetUsersByOrgIdAndRoleDocument = gql`
    query getUsersByOrgIdAndRole($orgId: uuid!, $role: String!) {
  organization_user(where: {org_id: {_eq: $orgId}, user: {role: {_eq: $role}}}) {
    org_id
    user {
      user_id
      role
      name
      email
      picture_url
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
  }
}
    `;

/**
 * __useGetUsersByOrgIdAndRoleQuery__
 *
 * To run a query within a React component, call `useGetUsersByOrgIdAndRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByOrgIdAndRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersByOrgIdAndRoleQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useGetUsersByOrgIdAndRoleQuery(baseOptions: Apollo.QueryHookOptions<Types.GetUsersByOrgIdAndRoleQuery, Types.GetUsersByOrgIdAndRoleQueryVariables> & ({ variables: Types.GetUsersByOrgIdAndRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetUsersByOrgIdAndRoleQuery, Types.GetUsersByOrgIdAndRoleQueryVariables>(GetUsersByOrgIdAndRoleDocument, options);
      }
export function useGetUsersByOrgIdAndRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUsersByOrgIdAndRoleQuery, Types.GetUsersByOrgIdAndRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetUsersByOrgIdAndRoleQuery, Types.GetUsersByOrgIdAndRoleQueryVariables>(GetUsersByOrgIdAndRoleDocument, options);
        }
// @ts-ignore
export function useGetUsersByOrgIdAndRoleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetUsersByOrgIdAndRoleQuery, Types.GetUsersByOrgIdAndRoleQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUsersByOrgIdAndRoleQuery, Types.GetUsersByOrgIdAndRoleQueryVariables>;
export function useGetUsersByOrgIdAndRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUsersByOrgIdAndRoleQuery, Types.GetUsersByOrgIdAndRoleQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUsersByOrgIdAndRoleQuery | undefined, Types.GetUsersByOrgIdAndRoleQueryVariables>;
export function useGetUsersByOrgIdAndRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUsersByOrgIdAndRoleQuery, Types.GetUsersByOrgIdAndRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetUsersByOrgIdAndRoleQuery, Types.GetUsersByOrgIdAndRoleQueryVariables>(GetUsersByOrgIdAndRoleDocument, options);
        }
export type GetUsersByOrgIdAndRoleQueryHookResult = ReturnType<typeof useGetUsersByOrgIdAndRoleQuery>;
export type GetUsersByOrgIdAndRoleLazyQueryHookResult = ReturnType<typeof useGetUsersByOrgIdAndRoleLazyQuery>;
export type GetUsersByOrgIdAndRoleSuspenseQueryHookResult = ReturnType<typeof useGetUsersByOrgIdAndRoleSuspenseQuery>;
export type GetUsersByOrgIdAndRoleQueryResult = Apollo.QueryResult<Types.GetUsersByOrgIdAndRoleQuery, Types.GetUsersByOrgIdAndRoleQueryVariables>;
export const GetUserByEmailDocument = gql`
    query getUserByEmail($email: String!) {
  user(where: {email: {_eq: $email}}) {
    user_id
    email
    role
    name
    accepted_terms_of_use
    updated_at
    created_at
    picture_url
    tags {
      tag {
        tag_id
        name
        type
      }
    }
  }
}
    `;

/**
 * __useGetUserByEmailQuery__
 *
 * To run a query within a React component, call `useGetUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetUserByEmailQuery(baseOptions: Apollo.QueryHookOptions<Types.GetUserByEmailQuery, Types.GetUserByEmailQueryVariables> & ({ variables: Types.GetUserByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetUserByEmailQuery, Types.GetUserByEmailQueryVariables>(GetUserByEmailDocument, options);
      }
export function useGetUserByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUserByEmailQuery, Types.GetUserByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetUserByEmailQuery, Types.GetUserByEmailQueryVariables>(GetUserByEmailDocument, options);
        }
// @ts-ignore
export function useGetUserByEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetUserByEmailQuery, Types.GetUserByEmailQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUserByEmailQuery, Types.GetUserByEmailQueryVariables>;
export function useGetUserByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUserByEmailQuery, Types.GetUserByEmailQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUserByEmailQuery | undefined, Types.GetUserByEmailQueryVariables>;
export function useGetUserByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUserByEmailQuery, Types.GetUserByEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetUserByEmailQuery, Types.GetUserByEmailQueryVariables>(GetUserByEmailDocument, options);
        }
export type GetUserByEmailQueryHookResult = ReturnType<typeof useGetUserByEmailQuery>;
export type GetUserByEmailLazyQueryHookResult = ReturnType<typeof useGetUserByEmailLazyQuery>;
export type GetUserByEmailSuspenseQueryHookResult = ReturnType<typeof useGetUserByEmailSuspenseQuery>;
export type GetUserByEmailQueryResult = Apollo.QueryResult<Types.GetUserByEmailQuery, Types.GetUserByEmailQueryVariables>;
export const GetUserByIdDocument = gql`
    query getUserById($userId: uuid!) {
  user_by_pk(user_id: $userId) {
    user_id
    email
    role
    name
    accepted_terms_of_use
    sms_opt_in
    updated_at
    picture_url
    phone
    org_id
    tags {
      tag {
        tag_id
        name
        type
      }
    }
    badges {
      user_badge_id
      badge_id
      badge {
        badge_id
        name
        description
        icon_url
        criteria_type
        criteria_value
      }
    }
    organization {
      organization {
        org_id
        name
        logo_url
      }
    }
  }
  graduation_class_student(where: {student_id: {_eq: $userId}}) {
    graduation_class {
      name
      graduation_class_id
      program {
        org_id
        organization {
          org_id
          name
        }
      }
    }
  }
  mentoring(where: {mentee_id: {_eq: $userId}}) {
    mentoring_id
    mentor {
      user_id
      name
      email
      picture_url
      role
      org_id
    }
  }
}
    `;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetUserByIdQuery, Types.GetUserByIdQueryVariables> & ({ variables: Types.GetUserByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetUserByIdQuery, Types.GetUserByIdQueryVariables>(GetUserByIdDocument, options);
      }
export function useGetUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUserByIdQuery, Types.GetUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetUserByIdQuery, Types.GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
// @ts-ignore
export function useGetUserByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetUserByIdQuery, Types.GetUserByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUserByIdQuery, Types.GetUserByIdQueryVariables>;
export function useGetUserByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUserByIdQuery, Types.GetUserByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUserByIdQuery | undefined, Types.GetUserByIdQueryVariables>;
export function useGetUserByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUserByIdQuery, Types.GetUserByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetUserByIdQuery, Types.GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>;
export type GetUserByIdSuspenseQueryHookResult = ReturnType<typeof useGetUserByIdSuspenseQuery>;
export type GetUserByIdQueryResult = Apollo.QueryResult<Types.GetUserByIdQuery, Types.GetUserByIdQueryVariables>;
export const GetUserProfileStudentDocument = gql`
    query getUserProfileStudent($userId: uuid!) {
  graduation_class_student(where: {student_id: {_eq: $userId}}) {
    graduation_class {
      program {
        organization {
          name
          type
          org_id
          logo_url
        }
      }
      current_academic_year {
        name
        academic_year_id
        end_date
      }
      name
      graduation_class_id
      current_academic_year_id
    }
    student {
      name
      email
      picture_url
      role
      sms_opt_in
      phone
    }
  }
}
    `;

/**
 * __useGetUserProfileStudentQuery__
 *
 * To run a query within a React component, call `useGetUserProfileStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileStudentQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserProfileStudentQuery(baseOptions: Apollo.QueryHookOptions<Types.GetUserProfileStudentQuery, Types.GetUserProfileStudentQueryVariables> & ({ variables: Types.GetUserProfileStudentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetUserProfileStudentQuery, Types.GetUserProfileStudentQueryVariables>(GetUserProfileStudentDocument, options);
      }
export function useGetUserProfileStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUserProfileStudentQuery, Types.GetUserProfileStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetUserProfileStudentQuery, Types.GetUserProfileStudentQueryVariables>(GetUserProfileStudentDocument, options);
        }
// @ts-ignore
export function useGetUserProfileStudentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetUserProfileStudentQuery, Types.GetUserProfileStudentQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUserProfileStudentQuery, Types.GetUserProfileStudentQueryVariables>;
export function useGetUserProfileStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUserProfileStudentQuery, Types.GetUserProfileStudentQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUserProfileStudentQuery | undefined, Types.GetUserProfileStudentQueryVariables>;
export function useGetUserProfileStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUserProfileStudentQuery, Types.GetUserProfileStudentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetUserProfileStudentQuery, Types.GetUserProfileStudentQueryVariables>(GetUserProfileStudentDocument, options);
        }
export type GetUserProfileStudentQueryHookResult = ReturnType<typeof useGetUserProfileStudentQuery>;
export type GetUserProfileStudentLazyQueryHookResult = ReturnType<typeof useGetUserProfileStudentLazyQuery>;
export type GetUserProfileStudentSuspenseQueryHookResult = ReturnType<typeof useGetUserProfileStudentSuspenseQuery>;
export type GetUserProfileStudentQueryResult = Apollo.QueryResult<Types.GetUserProfileStudentQuery, Types.GetUserProfileStudentQueryVariables>;
export const GetLearnersByOrgIdDocument = gql`
    query getLearnersByOrgId($orgId: uuid!) {
  graduation_class(where: {program: {org_id: {_eq: $orgId}}}) {
    graduation_class_id
    name
    students {
      student {
        user_id
        email
        role
        name
        accepted_terms_of_use
        updated_at
        created_at
        picture_url
        org_id
        equipped_store_items(where: {item_type: {_eq: "PET"}}) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetLearnersByOrgIdQuery__
 *
 * To run a query within a React component, call `useGetLearnersByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearnersByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearnersByOrgIdQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetLearnersByOrgIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetLearnersByOrgIdQuery, Types.GetLearnersByOrgIdQueryVariables> & ({ variables: Types.GetLearnersByOrgIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetLearnersByOrgIdQuery, Types.GetLearnersByOrgIdQueryVariables>(GetLearnersByOrgIdDocument, options);
      }
export function useGetLearnersByOrgIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetLearnersByOrgIdQuery, Types.GetLearnersByOrgIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetLearnersByOrgIdQuery, Types.GetLearnersByOrgIdQueryVariables>(GetLearnersByOrgIdDocument, options);
        }
// @ts-ignore
export function useGetLearnersByOrgIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetLearnersByOrgIdQuery, Types.GetLearnersByOrgIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetLearnersByOrgIdQuery, Types.GetLearnersByOrgIdQueryVariables>;
export function useGetLearnersByOrgIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetLearnersByOrgIdQuery, Types.GetLearnersByOrgIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetLearnersByOrgIdQuery | undefined, Types.GetLearnersByOrgIdQueryVariables>;
export function useGetLearnersByOrgIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetLearnersByOrgIdQuery, Types.GetLearnersByOrgIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetLearnersByOrgIdQuery, Types.GetLearnersByOrgIdQueryVariables>(GetLearnersByOrgIdDocument, options);
        }
export type GetLearnersByOrgIdQueryHookResult = ReturnType<typeof useGetLearnersByOrgIdQuery>;
export type GetLearnersByOrgIdLazyQueryHookResult = ReturnType<typeof useGetLearnersByOrgIdLazyQuery>;
export type GetLearnersByOrgIdSuspenseQueryHookResult = ReturnType<typeof useGetLearnersByOrgIdSuspenseQuery>;
export type GetLearnersByOrgIdQueryResult = Apollo.QueryResult<Types.GetLearnersByOrgIdQuery, Types.GetLearnersByOrgIdQueryVariables>;
export const GetStudentsByHomeOrgDocument = gql`
    query getStudentsByHomeOrg($orgId: uuid!) {
  user(where: {role: {_eq: "student"}, org_id: {_eq: $orgId}}) {
    user_id
    email
    role
    name
    picture_url
    updated_at
    created_at
    org_id
    equipped_store_items(where: {item_type: {_eq: "PET"}}) {
      item_type
      store_item {
        store_item_id
        name
        slug
        type
        rarity
        asset_key
      }
    }
  }
}
    `;

/**
 * __useGetStudentsByHomeOrgQuery__
 *
 * To run a query within a React component, call `useGetStudentsByHomeOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentsByHomeOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentsByHomeOrgQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetStudentsByHomeOrgQuery(baseOptions: Apollo.QueryHookOptions<Types.GetStudentsByHomeOrgQuery, Types.GetStudentsByHomeOrgQueryVariables> & ({ variables: Types.GetStudentsByHomeOrgQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetStudentsByHomeOrgQuery, Types.GetStudentsByHomeOrgQueryVariables>(GetStudentsByHomeOrgDocument, options);
      }
export function useGetStudentsByHomeOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetStudentsByHomeOrgQuery, Types.GetStudentsByHomeOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetStudentsByHomeOrgQuery, Types.GetStudentsByHomeOrgQueryVariables>(GetStudentsByHomeOrgDocument, options);
        }
// @ts-ignore
export function useGetStudentsByHomeOrgSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetStudentsByHomeOrgQuery, Types.GetStudentsByHomeOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetStudentsByHomeOrgQuery, Types.GetStudentsByHomeOrgQueryVariables>;
export function useGetStudentsByHomeOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetStudentsByHomeOrgQuery, Types.GetStudentsByHomeOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetStudentsByHomeOrgQuery | undefined, Types.GetStudentsByHomeOrgQueryVariables>;
export function useGetStudentsByHomeOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetStudentsByHomeOrgQuery, Types.GetStudentsByHomeOrgQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetStudentsByHomeOrgQuery, Types.GetStudentsByHomeOrgQueryVariables>(GetStudentsByHomeOrgDocument, options);
        }
export type GetStudentsByHomeOrgQueryHookResult = ReturnType<typeof useGetStudentsByHomeOrgQuery>;
export type GetStudentsByHomeOrgLazyQueryHookResult = ReturnType<typeof useGetStudentsByHomeOrgLazyQuery>;
export type GetStudentsByHomeOrgSuspenseQueryHookResult = ReturnType<typeof useGetStudentsByHomeOrgSuspenseQuery>;
export type GetStudentsByHomeOrgQueryResult = Apollo.QueryResult<Types.GetStudentsByHomeOrgQuery, Types.GetStudentsByHomeOrgQueryVariables>;
export const GetUsersRoleByOrgDocument = gql`
    query getUsersRoleByOrg($orgId: uuid!, $role: String!) {
  organization_user(where: {org_id: {_eq: $orgId}, user: {role: {_eq: $role}}}) {
    user {
      user_id
      email
      role
      name
      picture_url
      updated_at
      created_at
      equipped_store_items(where: {item_type: {_eq: "PET"}}) {
        item_type
        store_item {
          store_item_id
          name
          slug
          type
          rarity
          asset_key
        }
      }
    }
  }
}
    `;

/**
 * __useGetUsersRoleByOrgQuery__
 *
 * To run a query within a React component, call `useGetUsersRoleByOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersRoleByOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersRoleByOrgQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useGetUsersRoleByOrgQuery(baseOptions: Apollo.QueryHookOptions<Types.GetUsersRoleByOrgQuery, Types.GetUsersRoleByOrgQueryVariables> & ({ variables: Types.GetUsersRoleByOrgQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetUsersRoleByOrgQuery, Types.GetUsersRoleByOrgQueryVariables>(GetUsersRoleByOrgDocument, options);
      }
export function useGetUsersRoleByOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUsersRoleByOrgQuery, Types.GetUsersRoleByOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetUsersRoleByOrgQuery, Types.GetUsersRoleByOrgQueryVariables>(GetUsersRoleByOrgDocument, options);
        }
// @ts-ignore
export function useGetUsersRoleByOrgSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetUsersRoleByOrgQuery, Types.GetUsersRoleByOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUsersRoleByOrgQuery, Types.GetUsersRoleByOrgQueryVariables>;
export function useGetUsersRoleByOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUsersRoleByOrgQuery, Types.GetUsersRoleByOrgQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUsersRoleByOrgQuery | undefined, Types.GetUsersRoleByOrgQueryVariables>;
export function useGetUsersRoleByOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUsersRoleByOrgQuery, Types.GetUsersRoleByOrgQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetUsersRoleByOrgQuery, Types.GetUsersRoleByOrgQueryVariables>(GetUsersRoleByOrgDocument, options);
        }
export type GetUsersRoleByOrgQueryHookResult = ReturnType<typeof useGetUsersRoleByOrgQuery>;
export type GetUsersRoleByOrgLazyQueryHookResult = ReturnType<typeof useGetUsersRoleByOrgLazyQuery>;
export type GetUsersRoleByOrgSuspenseQueryHookResult = ReturnType<typeof useGetUsersRoleByOrgSuspenseQuery>;
export type GetUsersRoleByOrgQueryResult = Apollo.QueryResult<Types.GetUsersRoleByOrgQuery, Types.GetUsersRoleByOrgQueryVariables>;
export const AddUserTagDocument = gql`
    mutation addUserTag($userId: uuid!, $tagId: uuid) {
  insert_user_tag(
    objects: [{user_id: $userId, tag_id: $tagId}]
    on_conflict: {constraint: user_tag_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddUserTagMutationFn = Apollo.MutationFunction<Types.AddUserTagMutation, Types.AddUserTagMutationVariables>;

/**
 * __useAddUserTagMutation__
 *
 * To run a mutation, you first call `useAddUserTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserTagMutation, { data, loading, error }] = useAddUserTagMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useAddUserTagMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddUserTagMutation, Types.AddUserTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddUserTagMutation, Types.AddUserTagMutationVariables>(AddUserTagDocument, options);
      }
export type AddUserTagMutationHookResult = ReturnType<typeof useAddUserTagMutation>;
export type AddUserTagMutationResult = Apollo.MutationResult<Types.AddUserTagMutation>;
export type AddUserTagMutationOptions = Apollo.BaseMutationOptions<Types.AddUserTagMutation, Types.AddUserTagMutationVariables>;
export const AddUserTagsDocument = gql`
    mutation addUserTags($objects: [user_tag_insert_input!]!) {
  insert_user_tag(
    objects: $objects
    on_conflict: {constraint: user_tag_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddUserTagsMutationFn = Apollo.MutationFunction<Types.AddUserTagsMutation, Types.AddUserTagsMutationVariables>;

/**
 * __useAddUserTagsMutation__
 *
 * To run a mutation, you first call `useAddUserTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserTagsMutation, { data, loading, error }] = useAddUserTagsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddUserTagsMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddUserTagsMutation, Types.AddUserTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddUserTagsMutation, Types.AddUserTagsMutationVariables>(AddUserTagsDocument, options);
      }
export type AddUserTagsMutationHookResult = ReturnType<typeof useAddUserTagsMutation>;
export type AddUserTagsMutationResult = Apollo.MutationResult<Types.AddUserTagsMutation>;
export type AddUserTagsMutationOptions = Apollo.BaseMutationOptions<Types.AddUserTagsMutation, Types.AddUserTagsMutationVariables>;
export const DeleteUserTagDocument = gql`
    mutation deleteUserTag($id: uuid!) {
  delete_user_tag(where: {user_tag_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteUserTagMutationFn = Apollo.MutationFunction<Types.DeleteUserTagMutation, Types.DeleteUserTagMutationVariables>;

/**
 * __useDeleteUserTagMutation__
 *
 * To run a mutation, you first call `useDeleteUserTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserTagMutation, { data, loading, error }] = useDeleteUserTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserTagMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteUserTagMutation, Types.DeleteUserTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteUserTagMutation, Types.DeleteUserTagMutationVariables>(DeleteUserTagDocument, options);
      }
export type DeleteUserTagMutationHookResult = ReturnType<typeof useDeleteUserTagMutation>;
export type DeleteUserTagMutationResult = Apollo.MutationResult<Types.DeleteUserTagMutation>;
export type DeleteUserTagMutationOptions = Apollo.BaseMutationOptions<Types.DeleteUserTagMutation, Types.DeleteUserTagMutationVariables>;
export const DeleteUserTagByTagAndUserDocument = gql`
    mutation deleteUserTagByTagAndUser($userId: uuid!, $tagId: uuid!) {
  delete_user_tag(where: {user_id: {_eq: $userId}, tag_id: {_eq: $tagId}}) {
    affected_rows
  }
}
    `;
export type DeleteUserTagByTagAndUserMutationFn = Apollo.MutationFunction<Types.DeleteUserTagByTagAndUserMutation, Types.DeleteUserTagByTagAndUserMutationVariables>;

/**
 * __useDeleteUserTagByTagAndUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserTagByTagAndUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserTagByTagAndUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserTagByTagAndUserMutation, { data, loading, error }] = useDeleteUserTagByTagAndUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useDeleteUserTagByTagAndUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteUserTagByTagAndUserMutation, Types.DeleteUserTagByTagAndUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteUserTagByTagAndUserMutation, Types.DeleteUserTagByTagAndUserMutationVariables>(DeleteUserTagByTagAndUserDocument, options);
      }
export type DeleteUserTagByTagAndUserMutationHookResult = ReturnType<typeof useDeleteUserTagByTagAndUserMutation>;
export type DeleteUserTagByTagAndUserMutationResult = Apollo.MutationResult<Types.DeleteUserTagByTagAndUserMutation>;
export type DeleteUserTagByTagAndUserMutationOptions = Apollo.BaseMutationOptions<Types.DeleteUserTagByTagAndUserMutation, Types.DeleteUserTagByTagAndUserMutationVariables>;
export const GetUserTagsDocument = gql`
    query getUserTags {
  user_tag {
    user_tag_id
    tag_id
    user_id
  }
}
    `;

/**
 * __useGetUserTagsQuery__
 *
 * To run a query within a React component, call `useGetUserTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserTagsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetUserTagsQuery, Types.GetUserTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetUserTagsQuery, Types.GetUserTagsQueryVariables>(GetUserTagsDocument, options);
      }
export function useGetUserTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUserTagsQuery, Types.GetUserTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetUserTagsQuery, Types.GetUserTagsQueryVariables>(GetUserTagsDocument, options);
        }
// @ts-ignore
export function useGetUserTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetUserTagsQuery, Types.GetUserTagsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUserTagsQuery, Types.GetUserTagsQueryVariables>;
export function useGetUserTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUserTagsQuery, Types.GetUserTagsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUserTagsQuery | undefined, Types.GetUserTagsQueryVariables>;
export function useGetUserTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUserTagsQuery, Types.GetUserTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetUserTagsQuery, Types.GetUserTagsQueryVariables>(GetUserTagsDocument, options);
        }
export type GetUserTagsQueryHookResult = ReturnType<typeof useGetUserTagsQuery>;
export type GetUserTagsLazyQueryHookResult = ReturnType<typeof useGetUserTagsLazyQuery>;
export type GetUserTagsSuspenseQueryHookResult = ReturnType<typeof useGetUserTagsSuspenseQuery>;
export type GetUserTagsQueryResult = Apollo.QueryResult<Types.GetUserTagsQuery, Types.GetUserTagsQueryVariables>;
export const UpsertUserVetcoinBalanceDocument = gql`
    mutation upsertUserVetcoinBalance($user_id: uuid!, $balance: Int!) {
  insert_user_vetcoin_balance(
    objects: [{user_id: $user_id, balance: $balance}]
    on_conflict: {constraint: user_vetcoin_balance_user_id_key, update_columns: [balance, updated_at]}
  ) {
    affected_rows
    returning {
      user_vetcoin_balance_id
      user_id
      balance
      updated_at
    }
  }
}
    `;
export type UpsertUserVetcoinBalanceMutationFn = Apollo.MutationFunction<Types.UpsertUserVetcoinBalanceMutation, Types.UpsertUserVetcoinBalanceMutationVariables>;

/**
 * __useUpsertUserVetcoinBalanceMutation__
 *
 * To run a mutation, you first call `useUpsertUserVetcoinBalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserVetcoinBalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserVetcoinBalanceMutation, { data, loading, error }] = useUpsertUserVetcoinBalanceMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      balance: // value for 'balance'
 *   },
 * });
 */
export function useUpsertUserVetcoinBalanceMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpsertUserVetcoinBalanceMutation, Types.UpsertUserVetcoinBalanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpsertUserVetcoinBalanceMutation, Types.UpsertUserVetcoinBalanceMutationVariables>(UpsertUserVetcoinBalanceDocument, options);
      }
export type UpsertUserVetcoinBalanceMutationHookResult = ReturnType<typeof useUpsertUserVetcoinBalanceMutation>;
export type UpsertUserVetcoinBalanceMutationResult = Apollo.MutationResult<Types.UpsertUserVetcoinBalanceMutation>;
export type UpsertUserVetcoinBalanceMutationOptions = Apollo.BaseMutationOptions<Types.UpsertUserVetcoinBalanceMutation, Types.UpsertUserVetcoinBalanceMutationVariables>;
export const AddVetcoinTransactionDocument = gql`
    mutation addVetcoinTransaction($user_id: uuid!, $action_type: String!, $direction: String!, $amount: Int!, $source_feedback_id: uuid, $source_post_id: uuid, $store_item_id: uuid, $metadata: jsonb) {
  insert_vetcoin_transaction(
    objects: [{user_id: $user_id, action_type: $action_type, direction: $direction, amount: $amount, source_feedback_id: $source_feedback_id, source_post_id: $source_post_id, store_item_id: $store_item_id, metadata: $metadata}]
    on_conflict: {constraint: vetcoin_transaction_user_id_action_type_source_feedback_id_key, update_columns: []}
  ) {
    affected_rows
    returning {
      vetcoin_transaction_id
      user_id
      amount
      direction
      action_type
      source_feedback_id
      source_post_id
    }
  }
}
    `;
export type AddVetcoinTransactionMutationFn = Apollo.MutationFunction<Types.AddVetcoinTransactionMutation, Types.AddVetcoinTransactionMutationVariables>;

/**
 * __useAddVetcoinTransactionMutation__
 *
 * To run a mutation, you first call `useAddVetcoinTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVetcoinTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVetcoinTransactionMutation, { data, loading, error }] = useAddVetcoinTransactionMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      action_type: // value for 'action_type'
 *      direction: // value for 'direction'
 *      amount: // value for 'amount'
 *      source_feedback_id: // value for 'source_feedback_id'
 *      source_post_id: // value for 'source_post_id'
 *      store_item_id: // value for 'store_item_id'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useAddVetcoinTransactionMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddVetcoinTransactionMutation, Types.AddVetcoinTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddVetcoinTransactionMutation, Types.AddVetcoinTransactionMutationVariables>(AddVetcoinTransactionDocument, options);
      }
export type AddVetcoinTransactionMutationHookResult = ReturnType<typeof useAddVetcoinTransactionMutation>;
export type AddVetcoinTransactionMutationResult = Apollo.MutationResult<Types.AddVetcoinTransactionMutation>;
export type AddVetcoinTransactionMutationOptions = Apollo.BaseMutationOptions<Types.AddVetcoinTransactionMutation, Types.AddVetcoinTransactionMutationVariables>;
export const AddVetcoinTransactionForPostDocument = gql`
    mutation addVetcoinTransactionForPost($user_id: uuid!, $action_type: String!, $direction: String!, $amount: Int!, $source_post_id: uuid!, $metadata: jsonb) {
  insert_vetcoin_transaction(
    objects: [{user_id: $user_id, action_type: $action_type, direction: $direction, amount: $amount, source_post_id: $source_post_id, metadata: $metadata}]
    on_conflict: {constraint: vetcoin_transaction_user_id_action_type_source_post_id_key, update_columns: []}
  ) {
    affected_rows
    returning {
      vetcoin_transaction_id
      user_id
      amount
      direction
      action_type
      source_post_id
    }
  }
}
    `;
export type AddVetcoinTransactionForPostMutationFn = Apollo.MutationFunction<Types.AddVetcoinTransactionForPostMutation, Types.AddVetcoinTransactionForPostMutationVariables>;

/**
 * __useAddVetcoinTransactionForPostMutation__
 *
 * To run a mutation, you first call `useAddVetcoinTransactionForPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVetcoinTransactionForPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVetcoinTransactionForPostMutation, { data, loading, error }] = useAddVetcoinTransactionForPostMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      action_type: // value for 'action_type'
 *      direction: // value for 'direction'
 *      amount: // value for 'amount'
 *      source_post_id: // value for 'source_post_id'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useAddVetcoinTransactionForPostMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddVetcoinTransactionForPostMutation, Types.AddVetcoinTransactionForPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddVetcoinTransactionForPostMutation, Types.AddVetcoinTransactionForPostMutationVariables>(AddVetcoinTransactionForPostDocument, options);
      }
export type AddVetcoinTransactionForPostMutationHookResult = ReturnType<typeof useAddVetcoinTransactionForPostMutation>;
export type AddVetcoinTransactionForPostMutationResult = Apollo.MutationResult<Types.AddVetcoinTransactionForPostMutation>;
export type AddVetcoinTransactionForPostMutationOptions = Apollo.BaseMutationOptions<Types.AddVetcoinTransactionForPostMutation, Types.AddVetcoinTransactionForPostMutationVariables>;
export const BuyStoreItemDocument = gql`
    mutation buyStoreItem($user_id: uuid!, $store_item_id: uuid!) {
  insert_user_store_item(
    objects: [{user_id: $user_id, store_item_id: $store_item_id}]
    on_conflict: {constraint: user_store_item_user_id_store_item_id_key, update_columns: []}
  ) {
    affected_rows
    returning {
      user_store_item_id
      user_id
      store_item_id
    }
  }
}
    `;
export type BuyStoreItemMutationFn = Apollo.MutationFunction<Types.BuyStoreItemMutation, Types.BuyStoreItemMutationVariables>;

/**
 * __useBuyStoreItemMutation__
 *
 * To run a mutation, you first call `useBuyStoreItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyStoreItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyStoreItemMutation, { data, loading, error }] = useBuyStoreItemMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      store_item_id: // value for 'store_item_id'
 *   },
 * });
 */
export function useBuyStoreItemMutation(baseOptions?: Apollo.MutationHookOptions<Types.BuyStoreItemMutation, Types.BuyStoreItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.BuyStoreItemMutation, Types.BuyStoreItemMutationVariables>(BuyStoreItemDocument, options);
      }
export type BuyStoreItemMutationHookResult = ReturnType<typeof useBuyStoreItemMutation>;
export type BuyStoreItemMutationResult = Apollo.MutationResult<Types.BuyStoreItemMutation>;
export type BuyStoreItemMutationOptions = Apollo.BaseMutationOptions<Types.BuyStoreItemMutation, Types.BuyStoreItemMutationVariables>;
export const EquipStoreItemDocument = gql`
    mutation equipStoreItem($user_id: uuid!, $store_item_id: uuid!, $item_type: String!) {
  insert_user_equipped_item(
    objects: [{user_id: $user_id, store_item_id: $store_item_id, item_type: $item_type}]
    on_conflict: {constraint: user_equipped_item_user_id_item_type_key, update_columns: [store_item_id, updated_at]}
  ) {
    affected_rows
    returning {
      user_equipped_item_id
      user_id
      item_type
      store_item_id
    }
  }
}
    `;
export type EquipStoreItemMutationFn = Apollo.MutationFunction<Types.EquipStoreItemMutation, Types.EquipStoreItemMutationVariables>;

/**
 * __useEquipStoreItemMutation__
 *
 * To run a mutation, you first call `useEquipStoreItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEquipStoreItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [equipStoreItemMutation, { data, loading, error }] = useEquipStoreItemMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      store_item_id: // value for 'store_item_id'
 *      item_type: // value for 'item_type'
 *   },
 * });
 */
export function useEquipStoreItemMutation(baseOptions?: Apollo.MutationHookOptions<Types.EquipStoreItemMutation, Types.EquipStoreItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.EquipStoreItemMutation, Types.EquipStoreItemMutationVariables>(EquipStoreItemDocument, options);
      }
export type EquipStoreItemMutationHookResult = ReturnType<typeof useEquipStoreItemMutation>;
export type EquipStoreItemMutationResult = Apollo.MutationResult<Types.EquipStoreItemMutation>;
export type EquipStoreItemMutationOptions = Apollo.BaseMutationOptions<Types.EquipStoreItemMutation, Types.EquipStoreItemMutationVariables>;
export const GetStoreItemsDocument = gql`
    query getStoreItems {
  store_item(where: {is_active: {_eq: true}}, order_by: {cost: asc}) {
    store_item_id
    name
    slug
    description
    presentation
    type
    rarity
    cost
    asset_key
    is_active
  }
}
    `;

/**
 * __useGetStoreItemsQuery__
 *
 * To run a query within a React component, call `useGetStoreItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoreItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoreItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStoreItemsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetStoreItemsQuery, Types.GetStoreItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetStoreItemsQuery, Types.GetStoreItemsQueryVariables>(GetStoreItemsDocument, options);
      }
export function useGetStoreItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetStoreItemsQuery, Types.GetStoreItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetStoreItemsQuery, Types.GetStoreItemsQueryVariables>(GetStoreItemsDocument, options);
        }
// @ts-ignore
export function useGetStoreItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetStoreItemsQuery, Types.GetStoreItemsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetStoreItemsQuery, Types.GetStoreItemsQueryVariables>;
export function useGetStoreItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetStoreItemsQuery, Types.GetStoreItemsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetStoreItemsQuery | undefined, Types.GetStoreItemsQueryVariables>;
export function useGetStoreItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetStoreItemsQuery, Types.GetStoreItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetStoreItemsQuery, Types.GetStoreItemsQueryVariables>(GetStoreItemsDocument, options);
        }
export type GetStoreItemsQueryHookResult = ReturnType<typeof useGetStoreItemsQuery>;
export type GetStoreItemsLazyQueryHookResult = ReturnType<typeof useGetStoreItemsLazyQuery>;
export type GetStoreItemsSuspenseQueryHookResult = ReturnType<typeof useGetStoreItemsSuspenseQuery>;
export type GetStoreItemsQueryResult = Apollo.QueryResult<Types.GetStoreItemsQuery, Types.GetStoreItemsQueryVariables>;
export const GetUserVetcoinProfileDocument = gql`
    query getUserVetcoinProfile($userId: uuid!) {
  user_vetcoin_balance(where: {user_id: {_eq: $userId}}, limit: 1) {
    user_id
    balance
    updated_at
  }
  user_store_item(where: {user_id: {_eq: $userId}}) {
    user_store_item_id
    user_id
    store_item_id
    purchased_at
    store_item {
      store_item_id
      name
      slug
      presentation
      type
      rarity
      cost
      asset_key
    }
  }
  user_equipped_item(where: {user_id: {_eq: $userId}}) {
    user_equipped_item_id
    user_id
    item_type
    store_item_id
    store_item {
      store_item_id
      name
      slug
      presentation
      type
      rarity
      asset_key
    }
  }
}
    `;

/**
 * __useGetUserVetcoinProfileQuery__
 *
 * To run a query within a React component, call `useGetUserVetcoinProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserVetcoinProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserVetcoinProfileQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserVetcoinProfileQuery(baseOptions: Apollo.QueryHookOptions<Types.GetUserVetcoinProfileQuery, Types.GetUserVetcoinProfileQueryVariables> & ({ variables: Types.GetUserVetcoinProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetUserVetcoinProfileQuery, Types.GetUserVetcoinProfileQueryVariables>(GetUserVetcoinProfileDocument, options);
      }
export function useGetUserVetcoinProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUserVetcoinProfileQuery, Types.GetUserVetcoinProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetUserVetcoinProfileQuery, Types.GetUserVetcoinProfileQueryVariables>(GetUserVetcoinProfileDocument, options);
        }
// @ts-ignore
export function useGetUserVetcoinProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetUserVetcoinProfileQuery, Types.GetUserVetcoinProfileQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUserVetcoinProfileQuery, Types.GetUserVetcoinProfileQueryVariables>;
export function useGetUserVetcoinProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUserVetcoinProfileQuery, Types.GetUserVetcoinProfileQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetUserVetcoinProfileQuery | undefined, Types.GetUserVetcoinProfileQueryVariables>;
export function useGetUserVetcoinProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetUserVetcoinProfileQuery, Types.GetUserVetcoinProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetUserVetcoinProfileQuery, Types.GetUserVetcoinProfileQueryVariables>(GetUserVetcoinProfileDocument, options);
        }
export type GetUserVetcoinProfileQueryHookResult = ReturnType<typeof useGetUserVetcoinProfileQuery>;
export type GetUserVetcoinProfileLazyQueryHookResult = ReturnType<typeof useGetUserVetcoinProfileLazyQuery>;
export type GetUserVetcoinProfileSuspenseQueryHookResult = ReturnType<typeof useGetUserVetcoinProfileSuspenseQuery>;
export type GetUserVetcoinProfileQueryResult = Apollo.QueryResult<Types.GetUserVetcoinProfileQuery, Types.GetUserVetcoinProfileQueryVariables>;
export const AddWellnessResourceDocument = gql`
    mutation addWellnessResource($name: String!, $description: String, $link: String) {
  insert_wellness_resource(
    objects: [{name: $name, description: $description, link: $link}]
    on_conflict: {constraint: wellness_resource_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type AddWellnessResourceMutationFn = Apollo.MutationFunction<Types.AddWellnessResourceMutation, Types.AddWellnessResourceMutationVariables>;

/**
 * __useAddWellnessResourceMutation__
 *
 * To run a mutation, you first call `useAddWellnessResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWellnessResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWellnessResourceMutation, { data, loading, error }] = useAddWellnessResourceMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      link: // value for 'link'
 *   },
 * });
 */
export function useAddWellnessResourceMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddWellnessResourceMutation, Types.AddWellnessResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddWellnessResourceMutation, Types.AddWellnessResourceMutationVariables>(AddWellnessResourceDocument, options);
      }
export type AddWellnessResourceMutationHookResult = ReturnType<typeof useAddWellnessResourceMutation>;
export type AddWellnessResourceMutationResult = Apollo.MutationResult<Types.AddWellnessResourceMutation>;
export type AddWellnessResourceMutationOptions = Apollo.BaseMutationOptions<Types.AddWellnessResourceMutation, Types.AddWellnessResourceMutationVariables>;
export const UpdateWellnessResourceDocument = gql`
    mutation updateWellnessResource($id: uuid!, $wellness_resource: wellness_resource_set_input!) {
  update_wellness_resource(
    where: {wellness_resource_id: {_eq: $id}}
    _set: $wellness_resource
  ) {
    affected_rows
  }
}
    `;
export type UpdateWellnessResourceMutationFn = Apollo.MutationFunction<Types.UpdateWellnessResourceMutation, Types.UpdateWellnessResourceMutationVariables>;

/**
 * __useUpdateWellnessResourceMutation__
 *
 * To run a mutation, you first call `useUpdateWellnessResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWellnessResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWellnessResourceMutation, { data, loading, error }] = useUpdateWellnessResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      wellness_resource: // value for 'wellness_resource'
 *   },
 * });
 */
export function useUpdateWellnessResourceMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateWellnessResourceMutation, Types.UpdateWellnessResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateWellnessResourceMutation, Types.UpdateWellnessResourceMutationVariables>(UpdateWellnessResourceDocument, options);
      }
export type UpdateWellnessResourceMutationHookResult = ReturnType<typeof useUpdateWellnessResourceMutation>;
export type UpdateWellnessResourceMutationResult = Apollo.MutationResult<Types.UpdateWellnessResourceMutation>;
export type UpdateWellnessResourceMutationOptions = Apollo.BaseMutationOptions<Types.UpdateWellnessResourceMutation, Types.UpdateWellnessResourceMutationVariables>;
export const DeleteWellnessResourceDocument = gql`
    mutation deleteWellnessResource($id: uuid!) {
  delete_wellness_resource(where: {wellness_resource_id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteWellnessResourceMutationFn = Apollo.MutationFunction<Types.DeleteWellnessResourceMutation, Types.DeleteWellnessResourceMutationVariables>;

/**
 * __useDeleteWellnessResourceMutation__
 *
 * To run a mutation, you first call `useDeleteWellnessResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWellnessResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWellnessResourceMutation, { data, loading, error }] = useDeleteWellnessResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWellnessResourceMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteWellnessResourceMutation, Types.DeleteWellnessResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteWellnessResourceMutation, Types.DeleteWellnessResourceMutationVariables>(DeleteWellnessResourceDocument, options);
      }
export type DeleteWellnessResourceMutationHookResult = ReturnType<typeof useDeleteWellnessResourceMutation>;
export type DeleteWellnessResourceMutationResult = Apollo.MutationResult<Types.DeleteWellnessResourceMutation>;
export type DeleteWellnessResourceMutationOptions = Apollo.BaseMutationOptions<Types.DeleteWellnessResourceMutation, Types.DeleteWellnessResourceMutationVariables>;
export const GetWellnessResourceDocument = gql`
    query getWellnessResource {
  wellness_resource {
    wellness_resource_id
    name
    description
    link
  }
}
    `;

/**
 * __useGetWellnessResourceQuery__
 *
 * To run a query within a React component, call `useGetWellnessResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWellnessResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWellnessResourceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWellnessResourceQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetWellnessResourceQuery, Types.GetWellnessResourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetWellnessResourceQuery, Types.GetWellnessResourceQueryVariables>(GetWellnessResourceDocument, options);
      }
export function useGetWellnessResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetWellnessResourceQuery, Types.GetWellnessResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetWellnessResourceQuery, Types.GetWellnessResourceQueryVariables>(GetWellnessResourceDocument, options);
        }
// @ts-ignore
export function useGetWellnessResourceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetWellnessResourceQuery, Types.GetWellnessResourceQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetWellnessResourceQuery, Types.GetWellnessResourceQueryVariables>;
export function useGetWellnessResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetWellnessResourceQuery, Types.GetWellnessResourceQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetWellnessResourceQuery | undefined, Types.GetWellnessResourceQueryVariables>;
export function useGetWellnessResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetWellnessResourceQuery, Types.GetWellnessResourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetWellnessResourceQuery, Types.GetWellnessResourceQueryVariables>(GetWellnessResourceDocument, options);
        }
export type GetWellnessResourceQueryHookResult = ReturnType<typeof useGetWellnessResourceQuery>;
export type GetWellnessResourceLazyQueryHookResult = ReturnType<typeof useGetWellnessResourceLazyQuery>;
export type GetWellnessResourceSuspenseQueryHookResult = ReturnType<typeof useGetWellnessResourceSuspenseQuery>;
export type GetWellnessResourceQueryResult = Apollo.QueryResult<Types.GetWellnessResourceQuery, Types.GetWellnessResourceQueryVariables>;
export const GetWellnessResourceByIdDocument = gql`
    query getWellnessResourceById($wellness_resource_id: uuid!) {
  wellness_resource_by_pk(wellness_resource_id: $wellness_resource_id) {
    wellness_resource_id
    name
    description
    link
  }
}
    `;

/**
 * __useGetWellnessResourceByIdQuery__
 *
 * To run a query within a React component, call `useGetWellnessResourceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWellnessResourceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWellnessResourceByIdQuery({
 *   variables: {
 *      wellness_resource_id: // value for 'wellness_resource_id'
 *   },
 * });
 */
export function useGetWellnessResourceByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetWellnessResourceByIdQuery, Types.GetWellnessResourceByIdQueryVariables> & ({ variables: Types.GetWellnessResourceByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetWellnessResourceByIdQuery, Types.GetWellnessResourceByIdQueryVariables>(GetWellnessResourceByIdDocument, options);
      }
export function useGetWellnessResourceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetWellnessResourceByIdQuery, Types.GetWellnessResourceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetWellnessResourceByIdQuery, Types.GetWellnessResourceByIdQueryVariables>(GetWellnessResourceByIdDocument, options);
        }
// @ts-ignore
export function useGetWellnessResourceByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetWellnessResourceByIdQuery, Types.GetWellnessResourceByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetWellnessResourceByIdQuery, Types.GetWellnessResourceByIdQueryVariables>;
export function useGetWellnessResourceByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetWellnessResourceByIdQuery, Types.GetWellnessResourceByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.GetWellnessResourceByIdQuery | undefined, Types.GetWellnessResourceByIdQueryVariables>;
export function useGetWellnessResourceByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetWellnessResourceByIdQuery, Types.GetWellnessResourceByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetWellnessResourceByIdQuery, Types.GetWellnessResourceByIdQueryVariables>(GetWellnessResourceByIdDocument, options);
        }
export type GetWellnessResourceByIdQueryHookResult = ReturnType<typeof useGetWellnessResourceByIdQuery>;
export type GetWellnessResourceByIdLazyQueryHookResult = ReturnType<typeof useGetWellnessResourceByIdLazyQuery>;
export type GetWellnessResourceByIdSuspenseQueryHookResult = ReturnType<typeof useGetWellnessResourceByIdSuspenseQuery>;
export type GetWellnessResourceByIdQueryResult = Apollo.QueryResult<Types.GetWellnessResourceByIdQuery, Types.GetWellnessResourceByIdQueryVariables>;